// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
* {
  padding: 0px;
  margin: 0px;
}

body {
  background: #efeeee;
  counter-reset: my-sec-counter;
}

/* ── Preview dialog scroll ────────────────────────────────────────────────
   Strategy: surface = fixed 80vh clip (overflow:hidden in styles.scss).
   view-flow fills surface with flex-column; header is shrink-0;
   container1 is the ONE scrollable element (flex:1; overflow-y:auto).
   This guarantees the scrollbar is always visible whenever content
   overflows — even for short flows.
   ─────────────────────────────────────────────────────────────────────── */
/* view-flow fills the surface height exactly via flex-column */
.view-flow.dialog-scroll-wrapper.preview-mode {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  max-height: none !important;
  overflow: hidden !important;
}

/* Sticky header — fixed height, never shrinks */
.view-flow.dialog-scroll-wrapper.preview-mode .preview-dialog-header {
  flex-shrink: 0 !important;
  position: static !important; /* no sticky needed — header is pinned by flex */
}

/* container1 — THE scroll host, consumes all remaining height */
.view-flow.dialog-scroll-wrapper.preview-mode .container1 {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  height: 0 !important; /* forces flex child to not exceed its flex allocation */
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding-bottom: 64px !important;
}

/* Inner layout wrappers — no overflow traps */
.view-flow.dialog-scroll-wrapper.preview-mode .flow-layout-container,
.view-flow.dialog-scroll-wrapper.preview-mode .flow-main-grid,
.view-flow.dialog-scroll-wrapper.preview-mode .flow-main-content,
.view-flow.dialog-scroll-wrapper.preview-mode .flow-sidebar {
  overflow: visible !important;
}

/* Always show full description — no 60px collapse in preview */
.view-flow.dialog-scroll-wrapper.preview-mode .description-content {
  max-height: none !important;
  overflow: visible !important;
}

/* Fallback for dialog-scroll-wrapper used outside preview-mode */
.dialog-scroll-wrapper:not(.preview-mode) {
  max-height: 80vh;
  overflow-y: auto;
}

.preview-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: #ffffff;
  position: sticky;
  top: 0;
  z-index: 20;
}
.preview-dialog-header .header-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
  padding-right: 48px;
}
.preview-dialog-header h2 {
  margin: 0;
  font-size: 20px !important;
  font-weight: 600;
  color: #212427;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.preview-dialog-header .version-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background-color: #5ea1d8;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  width: -moz-fit-content;
  width: fit-content;
}
.preview-dialog-header .version-badge mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #fff;
}
.preview-dialog-header .preview-unique-code {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  margin-top: 2px;
  font-size: 13px;
  color: #666;
  max-width: 100%;
}
.preview-dialog-header .preview-unique-code .preview-unique-code-label {
  font-weight: 600;
  color: #212427;
}
.preview-dialog-header .preview-unique-code .preview-unique-code-value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
  word-break: break-all;
  color: #212427;
}
.preview-dialog-header .close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #666;
}
.preview-dialog-header .close-button mat-icon {
  color: #666;
}

@media (max-width: 640px) {
  .preview-dialog-header {
    padding: 16px;
  }
  .preview-dialog-header h2 {
    font-size: 18px !important;
  }
  .preview-dialog-header .header-content {
    padding-right: 40px;
  }
  .preview-dialog-header .version-badge {
    font-size: 12px;
    padding: 3px 10px;
  }
  .preview-dialog-header .version-badge mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
  .preview-dialog-header .close-button {
    top: 8px;
    right: 8px;
  }
}
.view-flow {
  background: #efeeee;
  min-height: 100vh;
  padding-top: 0;
  width: 100%;
  overflow-x: hidden;
  /*description wrapper starts here*/
}
.view-flow .view-build-link {
  color: #e91e63 !important;
  text-decoration: underline !important;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer !important;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.view-flow .view-build-link:hover {
  color: #c2185b !important;
  opacity: 0.85;
}
.view-flow .view-build-link:active, .view-flow .view-build-link:visited {
  color: #e91e63 !important;
}
.view-flow .container1 {
  max-width: 100%;
  width: 100%;
  margin: 0px auto;
  background: transparent;
  padding-bottom: 30px;
  padding: 0px;
}
.view-flow .container1 .user-sec {
  display: flex;
  padding: 20px 24px;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin: 0px;
  border-radius: 0;
  position: relative;
  border-left: none;
  border-right: none;
}
.view-flow .container1 .user-sec .user-details {
  flex: 1;
  display: flex;
}
.view-flow .container1 .user-sec .user-details .user-ico {
  flex: 1;
  display: none !important;
}
.view-flow .container1 .user-sec .user-details .user-ico img {
  width: 180px !important;
  height: 180px;
  border-radius: 100%;
  object-fit: cover;
  max-width: 200px;
}
.view-flow .container1 .user-sec .user-details .ico-details {
  flex: 4;
  padding-left: 0px;
  display: flex;
  flex-direction: column;
}
.view-flow .container1 .user-sec .user-details .ico-details p {
  margin-bottom: 20px !important;
  margin-top: 0px !important;
  justify-content: flex-end !important;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner {
  max-width: 500px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner > div {
  width: auto;
  margin-right: 20px;
  display: block;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner > div:last-child span {
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner > div:last-child span .mat-icon {
  color: rgba(0, 0, 0, 0.54) !important;
  font-size: 18px;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .u-ico {
  margin-right: 15px;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .qrcode {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .qrcode span {
  font-weight: 400 !important;
  color: #212427;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic p {
  margin: 0px !important;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic > div:last-child {
  margin-right: 0px;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic img {
  border-radius: 50%;
  cursor: pointer;
}
.view-flow .container1 .user-sec .user-details .ico-details .like {
  max-width: 100%;
  margin-bottom: 0px;
  display: flex;
}
.view-flow .container1 .user-sec .user-details .ico-details .like ul {
  max-width: 500px;
  width: 100%;
  display: flex;
  margin-left: -17px;
}
.view-flow .container1 .user-sec .user-details .ico-details .like ul li {
  height: 100%;
  justify-content: flex-start;
}
.view-flow .container1 .user-sec .user-details .ico-details .like ul li i {
  font-size: 25px;
  color: gray;
  text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
  margin-bottom: 5px;
}
.view-flow .container1 .user-sec .user-details .ico-details .like ul li span {
  font-size: 10px;
  font-weight: 600;
  text-align: center;
  color: #212427 !important;
  padding: 0px !important;
  min-height: 30px;
  margin-left: 0px;
}
.view-flow .container1 .user-sec .user-details .ico-details .like div {
  flex: 1;
  text-align: right;
}
.view-flow .container1 .flow-layout-container {
  width: 100%;
  padding: 0;
  margin: 0;
}
.view-flow .container1 .flow-layout-container .flow-main-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 402px;
  gap: 24px;
  max-width: 100%;
  margin: 0;
  padding: 16px 24px;
  background: #f6f7f9;
}
@media (min-width: 1920px) {
  .view-flow .container1 .flow-layout-container .flow-main-grid {
    max-width: 1920px;
    margin: 0 auto;
    padding: 24px 48px;
  }
}
@media (max-width: 1024px) {
  .view-flow .container1 .flow-layout-container .flow-main-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
    background: transparent;
  }
}
@media (max-width: 768px) {
  .view-flow .container1 .flow-layout-container .flow-main-grid {
    padding: 12px;
    gap: 12px;
  }
}
.view-flow .container1 .flow-main-content {
  min-width: 0;
  /* Sticky Flow Title Bar */
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile {
  background: transparent;
  border-radius: 12px;
  margin: 3px 0 4px 0;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .completion-progress-bar-mobile {
  width: 100%;
  height: 24px;
  background: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .completion-progress-bar-mobile .completion-progress-fill-mobile {
  height: 100%;
  background: linear-gradient(90deg, #5ea1d8 0%, #6bb3e8 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .completion-progress-bar-mobile .completion-progress-fill-mobile .progress-bar-percentage-mobile {
  color: white;
  font-size: 12px;
  font-weight: 600;
  padding: 0 8px;
  white-space: nowrap;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .completion-progress-bar-mobile .progress-bar-percentage-empty-mobile {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #606060;
  font-size: 12px;
  font-weight: 600;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .autoplay-toggle-mobile {
  flex-shrink: 0;
  margin-left: auto;
  padding: 0;
  display: inline-flex;
  align-items: center;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 999px;
  transition: opacity 0.2s ease;
  outline: none;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .autoplay-toggle-mobile:hover {
  opacity: 0.9;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .autoplay-toggle-mobile:focus, .view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .autoplay-toggle-mobile:focus-visible, .view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .autoplay-toggle-mobile:active {
  outline: none;
  border: none;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .autoplay-toggle-mobile .toggle-track {
  position: relative;
  width: 60px;
  height: 28px;
  border-radius: 28px;
  background: #dadce0;
  display: inline-block;
  transition: background 0.25s ease;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .autoplay-toggle-mobile .toggle-track.active {
  background: #e83e8c;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .autoplay-toggle-mobile .toggle-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.25s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .autoplay-toggle-mobile .toggle-thumb.active {
  transform: translateX(32px);
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .autoplay-toggle-mobile .toggle-thumb.active .thumb-icon {
  color: #5ea1d8;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .autoplay-toggle-mobile .thumb-icon {
  font-size: 16px;
  color: #5ea1d8;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin: 0;
  padding: 0;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .progress-step-info-mobile {
  font-size: 12px;
  color: #606060;
  line-height: 1.2;
  text-align: left;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile .completion-progress-content-mobile .progress-step-row-mobile .progress-step-info-mobile .completion-code-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: #f0f4fa;
  color: #3b4a60;
  font-size: 10px;
  font-weight: 600;
}
.view-flow .container1 .flow-main-content .completion-progress-card-mobile.restarted .completion-progress-bar-mobile {
  background: #e3f2fd;
}
.view-flow .container1 .flow-main-content .flow-title-sticky {
  top: 88px; /* mobile: below header + filters/tabs */
  z-index: 0; /* always below sidebar */
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
  pointer-events: auto;
  flex-direction: row;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  direction: ltr;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .dialog-close-button {
  margin-right: 8px;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .version-history-button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  background: #5ea1d8;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  min-width: auto;
  height: auto;
  line-height: 1.4;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .version-history-button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #fff;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .version-history-button span {
  color: #fff;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .version-history-button:hover {
  background: #4a90c6;
}
@media (max-width: 1024px) {
  .view-flow .container1 .flow-main-content .flow-title-sticky {
    border-radius: 0;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
    border-bottom: 1px solid #e0e0e0;
    padding: 8px 0 0 0;
    margin-bottom: 0;
  }
}
.view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-toggle {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px 4px 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 999px;
  transition: opacity 0.2s ease;
  outline: none;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-toggle:hover {
  opacity: 0.9;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-toggle:focus, .view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-toggle:focus-visible, .view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-toggle:active {
  outline: none;
  border: none;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-toggle .toggle-track {
  position: relative;
  width: 60px;
  height: 28px;
  border-radius: 28px;
  background: #dadce0;
  display: inline-block;
  transition: background 0.25s ease;
  margin-right: 4px;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-toggle .toggle-track.active {
  background: #e83e8c;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-toggle .toggle-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.25s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-toggle .toggle-thumb.active {
  transform: translateX(32px);
}
.view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-toggle .toggle-thumb.active .thumb-icon {
  color: #5ea1d8;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-toggle .thumb-icon {
  font-size: 16px;
  color: #5ea1d8;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin: 0;
  padding: 0;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-toggle .toggle-label {
  font-size: 12px;
  font-weight: 600;
  color: #202124;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .autoplay-tooltip-mobile {
  margin-top: 4px;
  padding: 6px 10px;
  background: rgba(0, 0, 0, 0.85);
  color: #ffffff;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.4;
  max-width: 240px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  display: inline-flex;
  align-items: center;
}
.view-flow .container1 .flow-main-content .flow-title-sticky .video-title-sticky {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  color: #0f0f0f;
  margin: 0;
  font-family: "Raleway", sans-serif;
  flex: 1;
  min-width: 0;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  direction: ltr;
  transform: none;
}
.view-flow .container1 .flow-main-content .flow-info-panel {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
  flex-direction: row;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  direction: ltr;
}
@media (max-width: 1024px) {
  .view-flow .container1 .flow-main-content .flow-info-panel {
    background: #f9f9f9;
    border-radius: 8px;
    box-shadow: none;
  }
}
.view-flow .container1 .flow-main-content .flow-info-panel::-webkit-scrollbar {
  height: 6px;
}
.view-flow .container1 .flow-main-content .flow-info-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.view-flow .container1 .flow-main-content .flow-info-panel::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
.view-flow .container1 .flow-main-content .flow-info-panel::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  color: #0f0f0f;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 4px 12px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: -moz-fit-content;
  min-width: fit-content;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  direction: ltr;
  transform: none;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge:hover {
  background: #f5f5f5;
  border-color: #5ea1d8;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge.active {
  background: #5ea1d8;
  color: #0f0f0f;
  border-color: #5ea1d8;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  transform: none;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge.active .info-icon,
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge.active .info-label,
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge.active .info-step-title {
  color: #0f0f0f;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge .info-badge-bookmark-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  margin-left: 2px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #666666;
  cursor: pointer;
  line-height: 1;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge .info-badge-bookmark-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge .info-badge-bookmark-btn mat-icon.bookmarked {
  color: #5ea1d8;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge .info-badge-bookmark-btn:hover {
  background: rgba(94, 161, 216, 0.12);
  color: #5ea1d8;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge.active .info-badge-bookmark-btn {
  color: #0f0f0f;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge.active .info-badge-bookmark-btn mat-icon.bookmarked {
  color: #ffffff;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge.active .info-badge-bookmark-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge .info-icon {
  font-size: 14px;
  flex-shrink: 0;
  line-height: 1;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge .info-label {
  font-family: "Raleway", sans-serif;
  flex-shrink: 0;
  font-size: 13px;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
}
.view-flow .container1 .flow-main-content .flow-info-panel .info-badge .info-step-title {
  font-size: 11px;
  color: #606060;
  margin-left: 4px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Raleway", sans-serif;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
}
@media (max-width: 768px) {
  .view-flow .container1 .flow-main-content .flow-info-panel .info-badge .info-step-title {
    display: none;
  }
}
@media (max-width: 768px) {
  .view-flow .container1 .flow-main-content .flow-info-panel {
    gap: 6px;
    padding: 10px 12px;
  }
  .view-flow .container1 .flow-main-content .flow-info-panel .info-badge {
    font-size: 12px;
    padding: 3px 10px;
    font-family: "Raleway", sans-serif;
  }
  .view-flow .container1 .flow-main-content .flow-info-panel .info-badge .info-icon {
    font-size: 12px;
  }
}
.view-flow .container1 .flow-main-content .video-player-section {
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  position: relative;
}
.view-flow .container1 .flow-main-content .video-player-section .img-wrap {
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  background: #000;
}
.view-flow .container1 .flow-main-content .video-player-section .img-wrap img,
.view-flow .container1 .flow-main-content .video-player-section .img-wrap video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}
.view-flow .container1 .flow-main-content .video-player-section .img-wrap .main-video-player {
  width: 100%;
  height: 100%;
}
.view-flow .container1 .flow-main-content .video-player-section .item {
  padding: 20px;
  background: #fff;
  width: 100%;
  min-height: 400px;
}
.view-flow .container1 .flow-main-content .video-player-section .clickarrow {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  pointer-events: none;
}
.view-flow .container1 .flow-main-content .video-player-section .clickarrow .owl-prev,
.view-flow .container1 .flow-main-content .video-player-section .clickarrow .owl-next {
  pointer-events: all;
  background: rgba(0, 0, 0, 0.65);
  color: white;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
  font-size: 26px;
  font-weight: bold;
  padding: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  margin: 0;
}
.view-flow .container1 .flow-main-content .video-player-section .clickarrow .owl-prev:hover:not(:disabled),
.view-flow .container1 .flow-main-content .video-player-section .clickarrow .owl-next:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.8);
  transform: translateY(-1px);
}
.view-flow .container1 .flow-main-content .video-player-section .clickarrow .owl-prev:disabled, .view-flow .container1 .flow-main-content .video-player-section .clickarrow .owl-prev[hidden],
.view-flow .container1 .flow-main-content .video-player-section .clickarrow .owl-next:disabled,
.view-flow .container1 .flow-main-content .video-player-section .clickarrow .owl-next[hidden] {
  display: none;
}
.view-flow .container1 .flow-main-content .video-player-section .clickarrow .owl-prev span,
.view-flow .container1 .flow-main-content .video-player-section .clickarrow .owl-next span {
  font-size: 30px;
  line-height: 1;
  font-weight: bold;
}
.view-flow .container1 .flow-main-content .video-player-section .clickarrow .owl-prev {
  margin-right: auto;
  margin-left: 0;
}
.view-flow .container1 .flow-main-content .video-player-section .clickarrow .owl-next {
  margin-left: auto;
  margin-right: 0;
}
.view-flow .container1 .flow-main-content .video-metadata {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
}
@media (max-width: 1024px) {
  .view-flow .container1 .flow-main-content .video-metadata {
    padding: 16px 0;
    background: transparent;
    border-radius: 0;
    box-shadow: none;
    border-bottom: 1px solid #e0e0e0;
  }
}
.view-flow .container1 .flow-main-content .video-metadata .step-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.view-flow .container1 .flow-main-content .video-metadata .step-header .step-header-main {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}
.view-flow .container1 .flow-main-content .video-metadata .step-header .step-header-main span.safety-step-icon {
  color: #d32f2f;
  font-size: 22px;
  line-height: 1;
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
}
.view-flow .container1 .flow-main-content .video-metadata .step-header .s-num {
  flex-shrink: 0;
}
.view-flow .container1 .flow-main-content .video-metadata .step-header .video-title {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #0f0f0f;
  margin: 0;
  flex: 1;
  min-width: 0;
}
.view-flow .container1 .flow-main-content .video-metadata .step-header .video-title.video-title--active-step {
  color: #0f0f0f;
}
.view-flow .container1 .flow-main-content .video-metadata .step-header .share-icon {
  cursor: pointer;
  color: #606060;
  flex-shrink: 0;
}
.view-flow .container1 .flow-main-content .video-metadata .flow-unique-code {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 0 0 10px;
  font-size: 13px;
  color: #666666;
  max-width: 100%;
}
.view-flow .container1 .flow-main-content .video-metadata .flow-unique-code .flow-unique-code-value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
  word-break: break-all;
  color: #5ea1d8;
}
.view-flow .container1 .flow-main-content .video-metadata .flow-unique-code .flow-category-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef4fb;
  color: #1d67a3;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.view-flow .container1 .flow-main-content .video-metadata .flow-unique-code .flow-category-badge mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar::-webkit-scrollbar {
  height: 6px;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar .action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  width: max-content;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 18px;
  cursor: pointer;
  transition: background 0.2s;
  background: #f2f2f2;
  flex: 0 0 auto;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item:hover:not(.disabled) {
  background: #e5e5e5;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar .action-buttons.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar .action-buttons.delete-action {
  background: #ffebee;
  color: #d32f2f;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar .action-buttons.delete-action:hover {
  background: #ffcdd2;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar .action-buttons.delete-action mat-icon {
  color: #d32f2f;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar .action-buttons.delete-action span {
  color: #d32f2f;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar .action-buttons mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #000000;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar .action-buttons mat-icon[style*="#5ea1d8"] {
  color: #5ea1d8 !important;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar .action-buttons span {
  font-size: 14px;
  font-weight: 500;
  color: #212427;
}
.view-flow .container1 .flow-main-content .video-metadata .video-actions-bar .action-buttons mat-slide-toggle {
  margin: 0;
}
.view-flow .container1 .channel-info-section {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
}
@media (max-width: 1024px) {
  .view-flow .container1 .channel-info-section {
    padding: 16px 0;
    background: transparent;
    border-radius: 0;
    box-shadow: none;
    border-bottom: 1px solid #e0e0e0;
  }
}
.view-flow .container1 .channel-info-section .channel-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
@media (max-width: 768px) {
  .view-flow .container1 .channel-info-section .channel-header {
    gap: 12px;
    align-items: flex-start;
  }
}
.view-flow .container1 .channel-info-section .channel-header .avatar-stack-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
.view-flow .container1 .channel-info-section .channel-header .avatar-stack {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
}
.view-flow .container1 .channel-info-section .channel-header .avatar-stack .video-avatar {
  position: relative;
  z-index: 1;
}
.view-flow .container1 .channel-info-section .channel-header .avatar-stack .video-avatar .channel-avatar-img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}
@media (max-width: 768px) {
  .view-flow .container1 .channel-info-section .channel-header .avatar-stack .video-avatar .channel-avatar-img {
    width: 40px;
    height: 40px;
  }
}
.view-flow .container1 .channel-info-section .channel-header .avatar-stack .video-avatar .channel-avatar-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #606060;
}
@media (max-width: 768px) {
  .view-flow .container1 .channel-info-section .channel-header .avatar-stack .video-avatar .channel-avatar-icon {
    font-size: 40px;
    width: 40px;
    height: 40px;
  }
}
.view-flow .container1 .channel-info-section .channel-header .avatar-stack .collab-avatar-overlap {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  object-fit: cover;
  margin-left: -10px;
  border: 2px solid #fff;
  z-index: 2;
  position: relative;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .view-flow .container1 .channel-info-section .channel-header .avatar-stack .collab-avatar-overlap {
    width: 22px;
    height: 22px;
    margin-left: -8px;
  }
}
.view-flow .container1 .channel-info-section .channel-header .avatar-stack .collab-avatar-extra {
  position: relative;
  width: 26px;
  height: 26px;
  margin-left: -10px;
  z-index: 3;
  flex-shrink: 0;
  cursor: pointer;
}
.view-flow .container1 .channel-info-section .channel-header .avatar-stack .collab-avatar-extra .collab-extra-img {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  display: block;
}
.view-flow .container1 .channel-info-section .channel-header .avatar-stack .collab-avatar-extra .collab-extra-badge {
  position: absolute;
  bottom: -3px;
  right: -4px;
  background: #3b82f6;
  color: #fff;
  font-size: 7px;
  font-weight: 700;
  border-radius: 8px;
  padding: 1px 3px;
  line-height: 1.2;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .view-flow .container1 .channel-info-section .channel-header .avatar-stack .collab-avatar-extra {
    width: 22px;
    height: 22px;
    margin-left: -8px;
  }
  .view-flow .container1 .channel-info-section .channel-header .avatar-stack .collab-avatar-extra .collab-extra-img {
    width: 22px;
    height: 22px;
  }
}
.view-flow .container1 .channel-info-section .channel-header .avatar-stack.collab-stack-clickable {
  cursor: pointer;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details {
  flex: 1;
  min-width: 0;
  max-width: 100%;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-name {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-name .owner-name-link {
  cursor: pointer;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-name .owner-name-link:hover {
  text-decoration: underline;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-name .collab-sep {
  color: #888;
  font-weight: 400;
  font-size: 13px;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-name .collab-coname {
  font-weight: 500;
  cursor: pointer;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-name .collab-coname:hover {
  text-decoration: underline;
}
@media (max-width: 768px) {
  .view-flow .container1 .channel-info-section .channel-header .channel-details .channel-name {
    font-size: 15px;
    margin-bottom: 6px;
  }
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-name:hover {
  color: #606060;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 14px;
  color: #606060;
  line-height: 1.4;
  margin-top: 2px;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  line-height: 1.4;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin: 0;
  flex-shrink: 0;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta .textbodycolor {
  color: #606060;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta .price-tag {
  color: #e83e8c;
  cursor: pointer;
  font-weight: 500;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta .price-tag:hover {
  text-decoration: underline;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta .purchased-tag {
  color: #606060;
  background: #f2f2f2;
  padding: 2px 8px;
  border-radius: 4px;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta .version-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #5ea1d8;
  background: #f0f0f0;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta .version-tag mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  color: #5ea1d8;
}
.view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta .version-tag:hover {
  background: #e5e5e5;
}
@media (max-width: 768px) {
  .view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta {
    gap: 8px;
    font-size: 13px;
    flex-wrap: wrap;
    align-items: center;
  }
  .view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta span {
    gap: 3px;
    font-size: 13px;
  }
  .view-flow .container1 .channel-info-section .channel-header .channel-details .channel-meta mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
}
.view-flow .container1 .channel-info-section .channel-header .channel-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-shrink: 0;
  align-items: flex-end;
}
.view-flow .container1 .channel-info-section .channel-header .channel-actions .follow-btn {
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  font-size: 14px;
  font-family: "Raleway", sans-serif;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-align: center;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.view-flow .container1 .channel-info-section .channel-header .channel-actions .follow-btn.following {
  background: #f0f0f0;
  color: #5ea1d8;
  border: 1px solid #5ea1d8;
}
.view-flow .container1 .channel-info-section .channel-header .channel-actions .follow-btn.following:hover {
  background: rgba(94, 161, 216, 0.1);
}
.view-flow .container1 .channel-info-section .channel-header .channel-actions .follow-btn:not(.following) {
  background: #5ea1d8;
  color: #ffffff;
}
.view-flow .container1 .channel-info-section .channel-header .channel-actions .follow-btn:not(.following):hover {
  background: #4a8fc4;
}
.view-flow .container1 .channel-info-section .channel-header .channel-actions .purchase-btn {
  padding: 10px 16px;
  border-radius: 18px;
  border: none;
  background: #e83e8c;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  width: 100%;
  text-align: center;
}
.view-flow .container1 .channel-info-section .channel-header .channel-actions .purchase-btn:hover {
  background: #d0307a;
}
.view-flow .container1 .channel-info-section .actions-list-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list-title {
  font-size: 18px;
  font-weight: 500;
  color: #0f0f0f;
  margin-bottom: 12px;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list .action-list-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  color: #0f0f0f;
  text-align: left;
  width: 100%;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list .action-list-item:hover:not(.disabled):not(.action-list-header) {
  background: #f5f5f5;
  border-color: #5ea1d8;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list .action-list-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list .action-list-item.delete-action {
  color: #d32f2f;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list .action-list-item.delete-action:hover:not(.disabled) {
  background: #ffebee;
  border-color: #d32f2f;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list .action-list-item.action-list-header {
  font-weight: 500;
  background: #f5f5f5;
  cursor: default;
  margin-bottom: 4px;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list .action-list-item mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #606060;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list .action-list-item span {
  flex: 1;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list .edit-access-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list .edit-access-section .access-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 32px;
}
.view-flow .container1 .channel-info-section .actions-list-section .actions-list .edit-access-section .access-options .access-option {
  padding: 10px 16px;
  font-size: 13px;
}
@media (max-width: 768px) {
  .view-flow .container1 .channel-info-section .actions-list-section .actions-list-title {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .view-flow .container1 .channel-info-section .actions-list-section .actions-list {
    gap: 6px;
  }
  .view-flow .container1 .channel-info-section .actions-list-section .actions-list .action-list-item {
    padding: 10px 12px;
    font-size: 13px;
  }
  .view-flow .container1 .channel-info-section .actions-list-section .actions-list .action-list-item mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .view-flow .container1 .channel-info-section .actions-list-section .actions-list .edit-access-section .access-options {
    margin-left: 24px;
  }
  .view-flow .container1 .channel-info-section .actions-list-section .actions-list .edit-access-section .access-options .access-option {
    padding: 8px 12px;
    font-size: 12px;
  }
}
.view-flow .container1 .description-section {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
}
@media (max-width: 1024px) {
  .view-flow .container1 .description-section {
    background: #f9f9f9;
    border-radius: 12px;
    box-shadow: none;
  }
}
.view-flow .container1 .description-section .description-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: -16px !important;
  position: relative;
}
.view-flow .container1 .description-section .description-header h3 {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}
.view-flow .container1 .description-section .description-header h3 .duration-timer {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #606060;
  white-space: nowrap;
  margin-left: auto;
}
.view-flow .container1 .description-section .description-header h3 .duration-timer mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin: 0;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .view-flow .container1 .description-section .description-header h3 .duration-timer {
    font-size: 13px;
  }
  .view-flow .container1 .description-section .description-header h3 .duration-timer mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
}
.view-flow .container1 .description-section .description-content {
  font-size: 14px;
  line-height: 20px;
  color: #0f0f0f;
  max-height: 60px;
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.view-flow .container1 .description-section .description-content.expanded {
  max-height: none;
}
.view-flow .container1 .description-section .description-content .supporting-docs-link {
  margin-top: 12px;
}
.view-flow .container1 .description-section .description-content .supporting-docs-link a {
  color: #5ea1d8;
  text-decoration: none;
  font-weight: 500;
}
.view-flow .container1 .description-section .description-content .supporting-docs-link a:hover {
  text-decoration: underline;
}
.view-flow .container1 .description-section .expand-description-btn {
  margin-top: 8px;
  background: none;
  border: none;
  color: #606060;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
}
.view-flow .container1 .description-section .expand-description-btn:hover {
  color: #0f0f0f;
}
.view-flow .container1 .supporting-docs-section {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
}
@media (max-width: 1024px) {
  .view-flow .container1 .supporting-docs-section {
    background: #f9f9f9;
    border-radius: 12px;
    box-shadow: none;
  }
}
.view-flow .container1 .supporting-docs-section .supporting-docs-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.view-flow .container1 .supporting-docs-section .supporting-docs-header h3 {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.view-flow .container1 .supporting-docs-section .supporting-docs-header h3 .supporting-docs-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  color: #606060;
}
.view-flow .container1 .supporting-docs-section .supporting-docs-scroll {
  max-height: 220px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 4px;
}
.view-flow .container1 .supporting-docs-section .supporting-docs-scroll::-webkit-scrollbar {
  width: 4px;
}
.view-flow .container1 .supporting-docs-section .supporting-docs-scroll::-webkit-scrollbar-thumb {
  background: #d0d0d0;
  border-radius: 4px;
}
.view-flow .container1 .supporting-docs-section .supporting-doc-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #0f0f0f;
  transition: background 0.15s;
}
.view-flow .container1 .supporting-docs-section .supporting-doc-item:hover {
  background: #f2f2f2;
}
.view-flow .container1 .supporting-docs-section .supporting-doc-item--link {
  color: #5ea1d8;
}
.view-flow .container1 .supporting-docs-section .supporting-doc-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  flex-shrink: 0;
  color: #606060;
}
.view-flow .container1 .supporting-docs-section .supporting-doc-icon--link {
  color: #5ea1d8;
}
.view-flow .container1 .supporting-docs-section .supporting-doc-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.view-flow .container1 .supporting-docs-section .supportingdoc {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #5ea1d8;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  padding: 6px 0;
  cursor: pointer;
}
.view-flow .container1 .supporting-docs-section .supportingdoc mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  vertical-align: middle;
}
.view-flow .container1 .supporting-docs-section .supportingdoc:hover {
  text-decoration: underline;
}
.view-flow .container1 .featured-in-blogs-section {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
  width: 100%;
  box-sizing: border-box;
  border-top: none;
}
@media (max-width: 1024px) {
  .view-flow .container1 .featured-in-blogs-section {
    background: #f9f9f9;
    border-radius: 12px;
  }
}
.view-flow .container1 .featured-in-blogs-section h2 {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0 0 12px;
}
.view-flow .container1 .featured-in-blogs-section .recommendations-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.view-flow .container1 .featured-in-blogs-section .recommendation-item {
  display: flex;
  gap: 10px;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background 0.15s;
  overflow: hidden;
}
.view-flow .container1 .featured-in-blogs-section .recommendation-item:hover {
  background: #f2f2f2;
}
.view-flow .container1 .featured-in-blogs-section .recommendation-thumbnail {
  width: 96px;
  height: 54px;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
  background: #e5e7eb;
}
.view-flow .container1 .featured-in-blogs-section .recommendation-thumbnail img,
.view-flow .container1 .featured-in-blogs-section .recommendation-thumbnail video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.view-flow .container1 .featured-in-blogs-section .recommendation-info {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.view-flow .container1 .featured-in-blogs-section .recommendation-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f0f0f;
  line-height: 1.35;
}
.view-flow .container1 .featured-in-blogs-section .recommendation-meta,
.view-flow .container1 .featured-in-blogs-section .recommendation-creator {
  font-size: 12px;
  color: #606060;
}
.view-flow .container1 .comments-section {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
}
@media (max-width: 1024px) {
  .view-flow .container1 .comments-section {
    padding: 16px 0;
    background: transparent;
    border-radius: 0;
    box-shadow: none;
  }
}
.view-flow .container1 .comments-section h3 {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin-bottom: 24px;
}
.view-flow .container1 .comments-section .comment-input-section {
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
}
.view-flow .container1 .comments-section .comment-input-section .comment-avatar {
  flex-shrink: 0;
}
.view-flow .container1 .comments-section .comment-input-section .comment-avatar img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.view-flow .container1 .comments-section .comment-input-section .comment-avatar .material-icons {
  font-size: 40px;
  width: 40px;
  height: 40px;
  color: #606060;
}
.view-flow .container1 .comments-section .comment-input-section .comment-form-wrapper {
  flex: 1;
  position: relative;
}
.view-flow .container1 .comments-section .comment-input-section .comment-form-wrapper form {
  display: flex;
  align-items: center;
  gap: 8px;
}
.view-flow .container1 .comments-section .comment-input-section .comment-form-wrapper .comment-input {
  flex: 1;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
  color: #0f0f0f;
  background: transparent;
}
.view-flow .container1 .comments-section .comment-input-section .comment-form-wrapper .comment-input:focus {
  outline: none;
  border-bottom-color: #5ea1d8;
}
.view-flow .container1 .comments-section .comment-input-section .comment-form-wrapper .comment-input::placeholder {
  color: #909090;
}
.view-flow .container1 .comments-section .comment-input-section .comment-form-wrapper .comment-send-btn {
  flex-shrink: 0;
  background: transparent;
  border: none;
  color: #5ea1d8;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}
.view-flow .container1 .comments-section .comment-input-section .comment-form-wrapper .comment-send-btn:hover:not(:disabled) {
  background: #f0f0f0;
  color: #4a8fc4;
}
.view-flow .container1 .comments-section .comment-input-section .comment-form-wrapper .comment-send-btn:disabled {
  color: #ccc;
  cursor: not-allowed;
}
.view-flow .container1 .comments-section .comment-input-section .comment-form-wrapper .comment-send-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.view-flow .container1 .comments-section .comment-login-prompt {
  padding: 16px;
  background: #f9f9f9;
  border-radius: 8px;
  text-align: center;
}
.view-flow .container1 .comments-section .comment-login-prompt p {
  margin: 0;
  font-size: 14px;
  color: #606060;
}
.view-flow .container1 .comments-section .comment-login-prompt p a {
  color: #5ea1d8;
  cursor: pointer;
  text-decoration: none;
}
.view-flow .container1 .comments-section .comment-login-prompt p a:hover {
  text-decoration: underline;
}
.view-flow .container1 .comments-section .comments-list {
  margin-top: 24px;
}
.view-flow .container1 .comments-section .comments-list .comment-item {
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
}
.view-flow .container1 .comments-section .comments-list .comment-item:last-child {
  border-bottom: none;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-header .comment-author {
  display: flex;
  align-items: center;
  gap: 8px;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-header .comment-author .comment-avatar-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-header .comment-author .comment-avatar-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
  color: #606060;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-header .comment-author .comment-author-name {
  font-size: 14px;
  font-weight: 500;
  color: #0f0f0f;
  font-family: "Raleway", sans-serif;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-header .comment-date {
  font-size: 12px;
  color: #606060;
  font-family: "Raleway", sans-serif;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-text {
  font-size: 14px;
  line-height: 20px;
  color: #0f0f0f;
  margin-bottom: 8px;
  font-family: "Raleway", sans-serif;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none; /* IE/Edge */
  scrollbar-width: thin;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-actions::-webkit-scrollbar {
  height: 4px;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-actions::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-actions .comment-action-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
  background: none;
  border: none;
  color: #606060;
  cursor: pointer;
  font-size: 14px;
  font-family: "Raleway", sans-serif;
  padding: 4px 8px;
  border-radius: 18px;
  transition: background 0.2s;
  height: auto;
  min-height: 28px; /* Consistent height for icon + count */
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-actions .comment-action-btn mat-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  vertical-align: middle;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-actions .comment-action-btn .like-count {
  font-size: 12px;
  line-height: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin: 0;
  padding: 0;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-actions .comment-action-btn:hover {
  background: #f5f5f5;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-actions .comment-action-btn.liked {
  color: #ff4d4d;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-actions .comment-action-btn.liked mat-icon {
  color: #ff4d4d;
}
.view-flow .container1 .comments-section .comments-list .comment-item .comment-actions .comment-action-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.view-flow .container1 .comments-section .comments-list .comment-item .reply-form {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 8px 0;
}
.view-flow .container1 .comments-section .comments-list .comment-item .reply-form .reply-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  font-size: 14px;
  color: #0f0f0f;
  background: #f9f9f9;
  font-family: "Raleway", sans-serif;
}
.view-flow .container1 .comments-section .comments-list .comment-item .reply-form .reply-input:focus {
  outline: none;
  border-color: #5ea1d8;
  background: #fff;
}
.view-flow .container1 .comments-section .comments-list .comment-item .reply-form .reply-input::placeholder {
  color: #909090;
}
.view-flow .container1 .comments-section .comments-list .comment-item .reply-form .reply-send-btn {
  flex-shrink: 0;
  background: #5ea1d8;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  transition: all 0.2s;
  font-size: 20px;
}
.view-flow .container1 .comments-section .comments-list .comment-item .reply-form .reply-send-btn:hover:not(:disabled) {
  background: #4a8fc4;
  transform: scale(1.05);
}
.view-flow .container1 .comments-section .comments-list .comment-item .reply-form .reply-send-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
}
.view-flow .container1 .comments-section .comments-list .comment-item .child-comments {
  margin-left: 56px;
  margin-top: 16px;
  padding-left: 16px;
  border-left: 2px solid #e0e0e0;
}
.view-flow .container1 .comments-section .comments-list .comment-item .child-comments .child-comment {
  padding: 12px 0;
}
.view-flow .container1 .comments-section .comments-list .comment-item .child-comments .child-comment .comment-header .comment-author .comment-avatar-img,
.view-flow .container1 .comments-section .comments-list .comment-item .child-comments .child-comment .comment-header .comment-author .comment-avatar-icon {
  width: 32px;
  height: 32px;
}
.view-flow .container1 .comments-section .comments-list .comment-item .child-comments .child-comment .comment-header .comment-author .comment-author-name {
  font-size: 13px;
}
.view-flow .container1 .comments-section .comments-list .comment-item .child-comments .child-comment .comment-text {
  font-size: 13px;
}
.view-flow .container1 .comments-section .no-comments {
  padding: 32px;
  text-align: center;
  color: #606060;
  font-family: "Raleway", sans-serif;
}
.view-flow .container1 .comments-section .view-build-section {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
  text-align: center;
}
.view-flow .container1 .comments-section .view-build-section .view-build-link {
  color: #e91e63 !important;
  text-decoration: underline !important;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer !important;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.view-flow .container1 .comments-section .view-build-section .view-build-link:hover {
  color: #c2185b !important;
  text-decoration: underline !important;
  opacity: 0.8;
}
.view-flow .container1 .comments-section .view-build-section .view-build-link:active {
  color: #ad1457 !important;
}
.view-flow .container1 .comments-section .view-build-section .view-build-link:visited {
  color: #e91e63 !important;
}
.view-flow .container1 .comments-section .view-build-section p {
  margin: 0;
  font-size: 14px;
}
.view-flow .flow-sidebar {
  width: 402px;
  min-width: 402px;
  max-width: 402px;
  position: relative;
  z-index: 10; /* ensure sidebar stays above sticky title */
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .view-flow .flow-sidebar {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
}
.view-flow .flow-sidebar .step-navigation {
  margin-bottom: 24px;
  flex: 0 0 auto; /* Don't shrink, but allow growth if needed */
  min-height: 0; /* Allow flex child to shrink */
}
.view-flow .flow-sidebar .step-navigation .step-scroll {
  /* Match video player section height - video uses 16:9 (56.25% padding-bottom) */
  /* Video width calculation:
     When left sidebar is OPEN:
       - Main content has margin-left: 240px, so effective viewport: 100vw - 240px
       - Grid padding: 24px left + 24px right = 48px
       - Right sidebar: 402px
       - Grid gap: 24px
       - Video width (1fr): (100vw - 240px - 48px - 402px - 24px)
     When left sidebar is CLOSED:
       - No margin-left, so viewport: 100vw
       - Grid padding: 48px
       - Right sidebar: 402px
       - Grid gap: 24px
       - Video width (1fr): (100vw - 48px - 402px - 24px)
     Video height = width * 0.5625 (16:9 aspect ratio)
  */
  /* Default: when left sidebar is open - extend slightly beyond video height */
  max-height: calc((100vw - 240px - 48px - 402px - 24px) * 0.5625 + 80px);
  /* For larger screens with max-width constraint */
  /* Tablet/mobile: single column, full width */
  /* When left sidebar is collapsed (closed), no margin-left */
  /* Fallback using :host-context if ::ng-deep doesn't work */
  overflow-y: auto;
  overflow-x: hidden;
  display: block;
  width: 100%;
  padding-right: 8px;
}
@media (min-width: 1920px) {
  .view-flow .flow-sidebar .step-navigation .step-scroll {
    max-height: 731.375px;
  }
}
@media (max-width: 1024px) {
  .view-flow .flow-sidebar .step-navigation .step-scroll {
    max-height: calc((100vw - 32px) * 0.5625);
  }
}
::ng-deep .flow-main-content.sidebar-collapsed .view-flow .flow-sidebar .step-navigation .step-scroll {
  max-height: calc((100vw - 48px - 402px - 24px) * 0.5625 + 80px);
}
@media (min-width: 1920px) {
  ::ng-deep .flow-main-content.sidebar-collapsed .view-flow .flow-sidebar .step-navigation .step-scroll {
    max-height: 866.375px;
  }
}
:host-context(.flow-main-content.sidebar-collapsed) .view-flow .flow-sidebar .step-navigation .step-scroll {
  max-height: calc((100vw - 48px - 402px - 24px) * 0.5625 + 80px);
}
@media (min-width: 1920px) {
  :host-context(.flow-main-content.sidebar-collapsed) .view-flow .flow-sidebar .step-navigation .step-scroll {
    max-height: 866.375px;
  }
}
.view-flow .flow-sidebar .step-navigation .step-scroll::-webkit-scrollbar {
  width: 8px;
}
.view-flow .flow-sidebar .step-navigation .step-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.view-flow .flow-sidebar .step-navigation .step-scroll::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.view-flow .flow-sidebar .step-navigation .step-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.view-flow .flow-sidebar .step-navigation .steps-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  align-items: stretch;
  /* Expansion-panel behavior WITHOUT changing existing button styling:
     - keep \`.step-btn\` look as-is
     - when selected, only change header background and add a body below */
}
.view-flow .flow-sidebar .step-navigation .steps-list.cover-not-shown {
  min-height: -moz-fit-content;
  min-height: fit-content;
  height: auto;
  transition: none;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-btn {
  /* Dynamic spacing: scales with current font-size */
  padding-block: 1em; /* top & bottom scale with text */
  padding-inline: 1.125em; /* left & right ~18px at 16px base */
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #0f0f0f;
  text-align: left;
  transition: all 0.2s;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  height: auto; /* allow dynamic height based on content */
  min-height: auto;
  white-space: normal;
  word-break: break-word;
  overflow: visible; /* show all text */
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-btn .step-text-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 auto;
  min-width: 0;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-btn:hover:not(.active) {
  background: #f9f9f9;
  border-color: #c0c0c0;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-btn.active {
  /* Selected step: Flowchest blue with black text - no transition delay */
  background: #5ea1d8 !important;
  color: #0f0f0f !important;
  border: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important;
  outline: none !important;
  box-shadow: none !important;
  transition: none !important;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-btn.active .step-number,
.view-flow .flow-sidebar .step-navigation .steps-list .step-btn.active .step-title-text {
  color: #0f0f0f !important;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-btn.active:hover {
  border: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important;
  outline: none !important;
  box-shadow: none !important;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-btn .step-number {
  display: flex;
  font-size: 13px;
  font-weight: 600;
  font-family: "Raleway", sans-serif;
  flex-shrink: 0;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-btn .step-title-text {
  font-size: 13px;
  font-weight: 400;
  font-family: "Raleway", sans-serif;
  line-height: 1.4;
  word-wrap: break-word;
  overflow: visible; /* show all text */
  text-overflow: clip;
  display: block;
  -webkit-line-clamp: initial;
  line-clamp: initial;
  -webkit-box-orient: initial;
  flex: 1 1 auto;
  white-space: normal;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-btn .step-description {
  font-size: 13px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif;
  line-height: 1.4;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-btn .step-description :where(p, span, div) {
  margin: 0;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-panel {
  display: block;
  width: 100%;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-header-row {
  display: flex;
  align-items: stretch;
  width: 100%;
  gap: 4px;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-panel .step-btn {
  flex: 1;
  width: auto;
  min-width: 0;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-bookmark-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #ffffff;
  color: #666666;
  cursor: pointer;
  padding: 0;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-bookmark-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-bookmark-btn mat-icon.bookmarked {
  color: #5ea1d8;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-bookmark-btn:hover {
  background: #f5f8fb;
  border-color: #5ea1d8;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-panel.active .step-header-row .step-bookmark-btn {
  border-color: #5ea1d8;
  background: #ffffff;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-panel.active .step-btn {
  background: #5ea1d8 !important;
  color: #0f0f0f !important;
  border: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important;
  outline: none !important;
  box-shadow: none !important;
  transition: none !important;
  /* Attach body to header (like mat-expansion-panel) */
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-panel.active .step-btn .step-number,
.view-flow .flow-sidebar .step-navigation .steps-list .step-panel.active .step-btn .step-title-text {
  color: #0f0f0f !important;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-panel.active .step-btn:hover {
  background: #5ea1d8 !important;
  border: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important;
  outline: none !important;
  box-shadow: none !important;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-panel-body {
  border: 1px solid #e0e0e0;
  border-top: 0;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  background: #ffffff;
  padding: 12px;
  margin-top: 0;
  width: 100%;
  box-sizing: border-box;
}
.view-flow .flow-sidebar .step-navigation .steps-list .step-panel.active .step-panel-body {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.view-flow .flow-sidebar .recommendations-section {
  flex: 0 0 auto; /* Keep recommendations visible below steps */
  padding-top: 0; /* Will be set dynamically by JavaScript to align with title */
  border-top: 1px solid #e0e0e0; /* Visual separator */
  align-self: flex-start; /* Prevent being pushed to bottom */
  width: 100%; /* Ensure full width */
}
.view-flow .flow-sidebar .recommendations-section h2 {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin-bottom: 16px;
}
.view-flow .flow-sidebar .recommendations-section .recommendations-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-x: hidden;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item {
  display: flex;
  gap: 8px;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background 0.2s;
  overflow: hidden;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item:hover {
  background: #f9f9f9;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail {
  flex-shrink: 0;
  width: 168px;
  height: 94px;
  border-radius: 4px;
  overflow: hidden;
  background: #000;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail img,
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info {
  flex: 1;
  min-width: 0;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-title {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0 0 4px 0;
  line-height: 20px;
  white-space: normal;
  word-break: break-word;
  overflow: hidden;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  color: #606060;
  flex-wrap: wrap;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta .recommendation-creator {
  color: #606060;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta .recommendation-id {
  color: #909090;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta .collab-sep {
  color: #888;
  font-weight: 400;
  font-size: 11px;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta .rec-owner-name {
  cursor: pointer;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta .rec-owner-name:hover {
  text-decoration: underline;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta .collab-coname {
  font-weight: 500;
  cursor: pointer;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta .collab-coname:hover {
  text-decoration: underline;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-price {
  display: block;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #e83e8c;
}
@media (max-width: 1024px) {
  .view-flow .flow-sidebar .recommendations-section {
    display: none !important;
  }
}
.view-flow .recommendations-section-mobile {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;
}
.view-flow .recommendations-section-mobile h2 {
  font-size: 18px;
  font-weight: 500;
  color: #0f0f0f;
  margin-bottom: 16px;
}
.view-flow .recommendations-section-mobile .recommendations-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-x: hidden;
}
.view-flow .recommendations-section-mobile .recommendation-item {
  display: flex;
  gap: 12px;
  cursor: pointer;
  padding: 12px;
  border-radius: 8px;
  transition: background 0.2s;
  overflow: hidden;
  background: #f9f9f9;
}
.view-flow .recommendations-section-mobile .recommendation-item:hover {
  background: #f0f0f0;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-thumbnail {
  flex-shrink: 0;
  width: 168px;
  height: 94px;
  border-radius: 4px;
  overflow: hidden;
  background: #000;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-thumbnail img,
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-thumbnail video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info {
  flex: 1;
  min-width: 0;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-title {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0 0 4px 0;
  line-height: 20px;
  white-space: normal;
  word-break: break-word;
  overflow: hidden;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  color: #606060;
  flex-wrap: wrap;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta .recommendation-creator {
  color: #606060;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta .recommendation-id {
  color: #909090;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta .collab-sep {
  color: #888;
  font-weight: 400;
  font-size: 11px;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta .rec-owner-name {
  cursor: pointer;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta .rec-owner-name:hover {
  text-decoration: underline;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta .collab-coname {
  font-weight: 500;
  cursor: pointer;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta .collab-coname:hover {
  text-decoration: underline;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-price {
  display: block;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #e83e8c;
}
@media (min-width: 1025px) {
  .view-flow .recommendations-section-mobile {
    display: none !important;
  }
}
.view-flow .viewflow-step {
  width: calc(100% - 40px);
  display: flex;
  padding: 20px 20px;
  padding: 20px 10px 20px;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  position: relative;
  border-radius: 10px;
  flex-wrap: wrap;
  display: flex;
  background: #fff;
  margin: 10px 20px 10px 20px;
}
.view-flow .viewflow-step .des-item {
  border-radius: 0px;
  border-right: 1px solid lightgray;
  max-width: calc(50% - 20px);
  padding-right: 10px;
  flex-basis: calc(50% - 20px);
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
}
.view-flow .viewflow-step .des-item .des {
  box-shadow: none;
  border: 0px;
  padding: 0px 0px;
  flex: 1;
  border: 1px solid #ddd;
  border: 0px !important;
  margin-bottom: 0px;
  border-radius: 0px;
  padding: 0px 0px;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  box-shadow: none !important;
}
.view-flow .viewflow-step .des-item .des > div {
  flex: none;
  color: #212427;
  display: flex;
  flex-wrap: wrap;
}
.view-flow .viewflow-step .des-item .des p {
  max-height: 287px;
  padding-right: 10px;
}
.view-flow .viewflow-step .des-item .des .s-num {
  font-size: 16px;
  width: 30px;
  height: 30px;
  color: #fff;
  border: 0px solid #f3f3f3;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  font-weight: 600;
  margin-top: 0px;
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
}
.view-flow .viewflow-step .des-item .des .s-num:before {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: 50%;
  left: 0px;
  top: 0px;
  position: absolute;
  background: lightgray;
  z-index: -1;
}
.view-flow .viewflow-step .des-item .btm-btn {
  display: flex;
  align-items: center;
}
.view-flow .viewflow-step .des-item .btm-btn > div {
  flex: 1;
}
.view-flow .viewflow-step .des-item .btm-btn > div:first-child {
  justify-content: flex-start;
}
.view-flow .viewflow-step .des-item .btm-btn > div:last-child {
  justify-content: right;
  text-align: end;
}
.view-flow .viewflow-step .des-item .btm-btn .lock {
  display: flex;
  align-items: center;
}
.view-flow .viewflow-step .des-item .btm-btn .lock > span {
  display: flex;
  align-items: center;
}
.view-flow .viewflow-step .step-sec {
  box-shadow: none;
  border: 0px;
  padding: 0px 0px 0px 0px;
  margin-left: 10px;
  width: 50%;
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 40px;
}
.view-flow .viewflow-step .step-sec .progressbar {
  border: 2px solid lightgray;
  margin-bottom: 20px;
  background: #fff;
  border-radius: 10px;
  padding: 5px;
}
.view-flow .viewflow-step .step-sec .progressbar .w3-round {
  height: 7px;
  background: #5ea1d8;
  background: lightgrey;
}
.view-flow .viewflow-step .step-sec .img-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.view-flow .viewflow-step .step-sec .img-wrap img {
  max-width: 100% !important;
  height: 100%;
  object-fit: cover;
  margin: 0px auto;
  width: 100% !important;
}
.view-flow .viewflow-step .step-sec .img-wrap + .item {
  width: calc(100% - 0px) !important;
  margin: 17px 0px !important;
  border: 0px !important;
}
@media (min-width: 993px) {
  .view-flow .flow-title-sticky {
    top: 112px; /* desktop: header + filters */
  }
}
.view-flow .clickarrow {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  pointer-events: none;
}
.view-flow .clickarrow button.owl-prev,
.view-flow .clickarrow button.owl-next {
  pointer-events: all;
  background: rgba(0, 0, 0, 0.65);
  color: #fff !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.view-flow .clickarrow button.owl-prev span,
.view-flow .clickarrow button.owl-next span {
  font-size: 30px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  font-weight: 600 !important;
  color: inherit;
}
.view-flow .clickarrow button.owl-prev:hover:not(:disabled),
.view-flow .clickarrow button.owl-next:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.85);
  transform: translateY(-1px);
}
.view-flow .clickarrow button.owl-prev {
  margin-right: auto;
  margin-left: 0;
}
.view-flow .clickarrow button.owl-next {
  margin-left: auto;
  margin-right: 0;
}
.view-flow .partOfBundle {
  padding: 0px 20px 20px;
  background: #fff;
  background: transparent;
  margin: 0px 20px 0px 0px;
  border-radius: 10px;
  overflow-x: scroll;
}
.view-flow .partOfBundle h2 {
  margin-top: 0px;
  margin-bottom: 0px !important;
}
.view-flow .partOfBundle .row {
  flex-wrap: nowrap !important;
  width: -moz-fit-content;
  width: fit-content;
  margin-top: 10px !important;
}
.view-flow .partOfBundle .item {
  background: #fff;
  margin-left: 0px;
  width: 170px !important;
  padding: 10px;
  margin-right: 10px;
  position: relative;
}
.view-flow .partOfBundle .item > div:first-child img {
  height: 150px !important;
}
.view-flow .partOfBundle .item > div:last-child p {
  height: 25px !important;
}
.view-flow .qr-ico {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
  position: absolute;
  right: 20px;
}
.view-flow .qr-ico i {
  flex: 1;
  font-size: 25px;
  color: grey;
}
.view-flow .qr-ico p {
  font-weight: 600;
}
.view-flow .material-icons,
.view-flow .align-items-center {
  font-weight: normal !important;
  cursor: pointer;
  display: flex;
}
.view-flow img {
  width: 100%;
}
.view-flow p {
  font-size: 12px !important;
  line-height: 20px;
}
.view-flow button {
  padding: 3px 10px;
  border: 0px;
  font-size: 15px;
  border-radius: 15px;
}
.view-flow button.active {
  background: #5ea1d8;
  color: white;
}
.view-flow h2 {
  margin-bottom: 20px;
}
.view-flow h2 a {
  color: #212427 !important;
}
.view-flow h3 {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}
.view-flow ul {
  display: flex;
  list-style: none;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.view-flow li {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.view-flow .like .qrcode {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.view-flow .description-wrapper .des-item .des {
  /*max-height:200px;*/
}
.view-flow .description-wrapper .des-item .des p {
  max-height: 100px;
  overflow-y: auto;
}
.view-flow .des-item .des > div span {
  flex: 1;
}
.view-flow .des-item .des > div span.material-icons.ng-star-inserted {
  max-width: 30px;
}
.view-flow .des-item .des > div span:first-child {
  align-items: flex-start;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.view-flow .des-item .des > div span:last-child {
  text-align: flex-end;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.view-flow .des-item .des > div span i {
  margin-right: 5px;
}
.view-flow .des-item .item {
  flex: 1;
  border: 1px solid #ddd;
  border-radius: 40px;
  padding: 40px 20px;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin-top: 20px;
}
.view-flow .des-item .item .list {
  display: flex;
  /* padding: 20px 0px; */
  max-height: 150px;
  overflow-y: auto;
  align-items: flex-start;
}
.view-flow .des-item .item .list ul {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 0px 0px 20px;
  padding: 5px;
}
.view-flow .des-item .item .list ul li {
  font-size: 14px;
  line-height: 28px;
  word-break: break-all;
  position: relative;
  padding-left: 17px;
}
.view-flow .des-item .item .list ul li:before {
  content: "";
  width: 8px;
  height: 8px;
  background: grey;
  position: absolute;
  left: 0px;
  top: 10px;
  border-radius: 50%;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}
.view-flow .des-item .item .list ul li:first-child {
  padding-left: 0px;
}
.view-flow .des-item .item .list ul li:first-child:before {
  display: none;
}
.view-flow .des-item .item .list ul li:first-child {
  font-weight: 600;
}
.view-flow video {
  max-width: 100% !important;
  margin: 0px auto;
  width: 100% !important;
}
.view-flow:empty {
  display: none !important;
}
.view-flow .comment-guidelines-helper {
  color: #606060;
  font-size: 13px;
  margin-top: 6px;
}
.view-flow .comment-guidelines-link {
  color: #1976d2 !important;
  text-decoration: underline !important;
  cursor: pointer;
}
.view-flow .comment-guidelines-link:hover {
  color: #1565c0 !important;
}

.toggled-view {
  padding: 20px;
}

.favorite-toggle-icon {
  color: #000000 !important;
  transition: color 0.2s ease;
}
.favorite-toggle-icon.liked {
  color: #ff4d4d !important;
}

.action-item .favorite-toggle-icon.liked {
  color: #ff4d4d !important;
}

@media (max-width: 1024px) {
  .mobile-stacked-view {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 20px;
    background: #f6f7f9;
  }
  .mobile-top-panel {
    position: sticky;
    top: 76px;
    z-index: 3;
    padding: 12px 0 4px;
    background: linear-gradient(180deg, rgba(246, 247, 249, 0.98) 0%, rgba(246, 247, 249, 0.9) 60%, rgba(246, 247, 249, 0) 100%);
    -webkit-backdrop-filter: blur(8px);
            backdrop-filter: blur(8px);
  }
  .mobile-info-panel {
    padding: 0 12px;
    display: flex;
    overflow-x: auto;
    gap: 12px;
  }
  .mobile-info-panel .info-badge {
    flex: 0 0 auto;
  }
  .mobile-info-panel::-webkit-scrollbar {
    display: none;
  }
  .mobile-section {
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    scroll-margin-top: 140px;
  }
  .mobile-media {
    background: #000;
  }
  .mobile-media img,
  .mobile-media video {
    width: 100%;
    display: block;
    max-height: 260px;
    object-fit: cover;
  }
  .mobile-media-video {
    width: 100%;
    max-height: 260px;
    background: #000;
    border: 0;
  }
  .mobile-section-body {
    padding: 20px 20px 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .mobile-section-title {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    color: #1f2f46;
  }
  .mobile-section-description {
    color: #4a5568;
    line-height: 1.6;
  }
  .mobile-section-description p {
    margin-bottom: 12px;
  }
  .mobile-step-card {
    display: flex;
    gap: 16px;
    flex-direction: column;
  }
  .mobile-step-media {
    background: #000;
    border-radius: 12px;
    overflow: hidden;
  }
  .mobile-step-media img,
  .mobile-step-media video {
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
  }
  .mobile-step-content {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .mobile-step-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
  }
  .mobile-step-header h3 {
    margin: 0;
    font-size: 18px;
    color: #1f2f46;
    font-weight: 600;
  }
  .mobile-step-header h3 span {
    font-size: 16px;
    font-weight: 500;
    color: #5a6a85;
  }
  .mobile-share-btn {
    height: 32px;
    width: 32px;
    min-width: 32px;
  }
  .mobile-step-description {
    color: #4a5568;
    line-height: 1.6;
    font-size: 15px;
  }
  .mobile-step-description p {
    margin-bottom: 10px;
  }
  .mobile-meta-row {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #5ea1d8;
  }
  .mobile-meta-row mat-icon {
    font-size: 18px;
    height: 18px;
    width: 18px;
  }
  .mobile-supporting-doc {
    align-self: flex-start;
    color: #5ea1d8;
    font-weight: 500;
    padding: 0;
  }
  .mobile-items-list {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .mobile-items-list .example-box {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid #edf2f7;
  }
  .mobile-items-list .example-box:last-child {
    border-bottom: none;
  }
  .mobile-items-list .example-box mat-checkbox {
    margin-left: auto;
  }
  .mobile-item-thumb {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    object-fit: cover;
  }
}
/* Skeleton Loader Styles for View Flow - Matches Exact Page Structure */
.skeleton-viewflow-container {
  --skeleton-gradient: linear-gradient(
    110deg,
    #f6f7f8 8%,
    #eceef1 18%,
    #f6f7f8 33%
  );
  background: #efeeee;
  min-height: 100vh;
  padding-top: 0;
  width: 100%;
  overflow-x: hidden;
  pointer-events: none;
}
.skeleton-viewflow-container .container1 {
  max-width: 100%;
  width: 100%;
  margin: 0px auto;
  background: transparent;
  padding-bottom: 30px;
  padding: 0px;
}
.skeleton-viewflow-container .container1 .flow-layout-container {
  width: 100%;
  padding: 0;
  margin: 0;
}
.skeleton-viewflow-container .container1 .flow-layout-container .flow-main-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 402px;
  gap: 24px;
  max-width: 100%;
  margin: 0;
  padding: 16px 24px;
}
@media (min-width: 1920px) {
  .skeleton-viewflow-container .container1 .flow-layout-container .flow-main-grid {
    max-width: 1920px;
    margin: 0 auto;
    padding: 24px 48px;
  }
}
@media (max-width: 1024px) {
  .skeleton-viewflow-container .container1 .flow-layout-container .flow-main-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }
}
@media (max-width: 768px) {
  .skeleton-viewflow-container .container1 .flow-layout-container .flow-main-grid {
    padding: 12px;
    gap: 12px;
  }
}
.skeleton-viewflow-container .skeleton-text,
.skeleton-viewflow-container .skeleton-avatar,
.skeleton-viewflow-container .skeleton-icon,
.skeleton-viewflow-container .skeleton-image {
  background-image: var(--skeleton-gradient);
  background-size: 220% 100%;
  animation: skeleton-shimmer 1.35s linear infinite, skeleton-pulse 2s ease-in-out infinite;
  background-color: #e0e0e0;
}
.skeleton-viewflow-container .skeleton-text {
  border-radius: 4px;
  height: 16px;
  margin: 6px 0;
  display: block;
}
.skeleton-viewflow-container .skeleton-text.skeleton-title {
  height: 24px;
  width: 60%;
}
.skeleton-viewflow-container .skeleton-text.skeleton-subtitle {
  height: 16px;
  width: 40%;
}
.skeleton-viewflow-container .skeleton-text.skeleton-badge-text {
  height: 14px;
  width: 80px;
}
.skeleton-viewflow-container .skeleton-text.short {
  width: 40%;
}
.skeleton-viewflow-container .skeleton-text.skeleton-description {
  height: 14px;
  width: 100%;
  margin: 8px 0;
}
.skeleton-viewflow-container .skeleton-text.skeleton-description.short {
  width: 70%;
}
.skeleton-viewflow-container .skeleton-text.skeleton-action-text {
  height: 14px;
  width: 60px;
  margin: 0;
}
.skeleton-viewflow-container .skeleton-text.skeleton-small {
  height: 12px;
  width: 50%;
}
.skeleton-viewflow-container .skeleton-text.skeleton-follow {
  width: 120px;
  height: 32px;
  border-radius: 16px;
  margin: 0;
}
.skeleton-viewflow-container .skeleton-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
}
.skeleton-viewflow-container .skeleton-avatar.skeleton-channel-avatar {
  width: 48px;
  height: 48px;
}
.skeleton-viewflow-container .skeleton-icon {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  margin-right: 8px;
  flex-shrink: 0;
}
.skeleton-viewflow-container .skeleton-icon.small {
  width: 18px;
  height: 18px;
}
.skeleton-viewflow-container .skeleton-icon.skeleton-share-icon {
  width: 20px;
  height: 20px;
  margin-left: auto;
  margin-right: 0;
}
.skeleton-viewflow-container .skeleton-icon.thumb-icon {
  width: 16px;
  height: 16px;
}
.skeleton-viewflow-container .skeleton-image {
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
}
.skeleton-viewflow-container .skeleton-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: var(--skeleton-gradient);
  background-size: 220% 100%;
  animation: skeleton-shimmer 1.35s linear infinite, skeleton-pulse 2s ease-in-out infinite;
  background-color: #e0e0e0;
}
.skeleton-viewflow-container .skeleton-image.large {
  padding-bottom: 56.25%;
}
.skeleton-viewflow-container .skeleton-image.small {
  width: 120px;
  height: 72px;
  padding-bottom: 0;
  border-radius: 12px;
  flex-shrink: 0;
}
.skeleton-viewflow-container .skeleton-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.skeleton-viewflow-container .skeleton-flow-header {
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 0 8px 0;
  margin-bottom: 8px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
  border-radius: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.skeleton-viewflow-container .skeleton-flow-header .video-title-sticky {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  margin: 4px;
  font-family: "Raleway", sans-serif;
  flex: 1;
  min-width: 0;
  height: 28px;
  width: 60%;
}
.skeleton-viewflow-container .skeleton-flow-header .autoplay-toggle {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px 4px 4px;
  border: none;
  background: transparent;
  border-radius: 999px;
  cursor: default;
  pointer-events: none;
}
.skeleton-viewflow-container .skeleton-flow-header .autoplay-toggle .toggle-track {
  position: relative;
  width: 60px;
  height: 28px;
  border-radius: 28px;
  background: #dadce0;
  display: inline-block;
  margin-right: 4px;
}
.skeleton-viewflow-container .skeleton-flow-header .autoplay-toggle .toggle-track .toggle-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.skeleton-viewflow-container .skeleton-flow-header .autoplay-toggle .toggle-track .toggle-thumb .thumb-icon {
  width: 16px;
  height: 16px;
}
.skeleton-viewflow-container .skeleton-flow-header.skeleton-info-panel {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  border-radius: 8px;
}
.skeleton-viewflow-container .skeleton-flow-header.skeleton-info-panel .info-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 4px 12px;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.skeleton-viewflow-container .skeleton-flow-header.skeleton-info-panel .info-badge .info-icon {
  font-size: 14px;
  flex-shrink: 0;
  line-height: 1;
  width: 14px;
  height: 14px;
}
.skeleton-viewflow-container .skeleton-flow-header.skeleton-info-panel .info-badge .info-label {
  font-family: "Raleway", sans-serif;
  flex-shrink: 0;
  font-size: 13px;
  width: 60px;
  height: 14px;
  margin: 0;
}
@media (max-width: 768px) {
  .skeleton-viewflow-container .skeleton-flow-header.skeleton-info-panel {
    gap: 6px;
    padding: 10px 12px;
  }
  .skeleton-viewflow-container .skeleton-flow-header.skeleton-info-panel .info-badge {
    font-size: 12px;
    padding: 3px 10px;
  }
  .skeleton-viewflow-container .skeleton-flow-header.skeleton-info-panel .info-badge .info-icon {
    font-size: 12px;
    width: 12px;
    height: 12px;
  }
}
.skeleton-viewflow-container .video-player-section {
  background: transparent !important;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  position: relative;
  padding: 0 !important;
  box-shadow: none !important;
}
.skeleton-viewflow-container .video-player-section .img-wrap {
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  background: transparent;
}
.skeleton-viewflow-container .video-player-section .img-wrap .skeleton-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 0;
  border-radius: 12px;
}
.skeleton-viewflow-container .video-metadata {
  margin-bottom: 16px;
}
.skeleton-viewflow-container .video-metadata .step-header {
  margin-bottom: 16px;
}
.skeleton-viewflow-container .video-metadata .step-header .step-header-main {
  display: flex;
  align-items: center;
  gap: 14px;
}
.skeleton-viewflow-container .video-metadata .step-header .step-header-main .s-num {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  flex-shrink: 0;
}
.skeleton-viewflow-container .video-metadata .step-header .step-header-main .video-title {
  flex: 1;
  height: 28px;
  margin: 0;
  border-radius: 8px;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
}
.skeleton-viewflow-container .video-metadata .step-header .step-header-main .share-icon {
  width: 20px;
  height: 20px;
  margin-left: auto;
  margin-right: 0;
}
.skeleton-viewflow-container .video-metadata .video-actions-bar {
  margin-top: 20px;
  padding-bottom: 12px;
}
.skeleton-viewflow-container .video-metadata .video-actions-bar .action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}
.skeleton-viewflow-container .video-metadata .video-actions-bar .action-buttons .skeleton-action-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  min-width: 80px;
}
.skeleton-viewflow-container .video-metadata .video-actions-bar .action-buttons .skeleton-action-item mat-icon {
  width: 24px;
  height: 24px;
  font-size: 24px;
}
.skeleton-viewflow-container .video-metadata .video-actions-bar .action-buttons .skeleton-action-item span {
  font-size: 14px;
  height: 16px;
  width: 60px;
  margin: 0;
}
@media (max-width: 768px) {
  .skeleton-viewflow-container .video-metadata .video-actions-bar {
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 16px 12px 16px;
  }
  .skeleton-viewflow-container .video-metadata .video-actions-bar .action-buttons {
    gap: 12px;
  }
}
.skeleton-viewflow-container .channel-info-section {
  margin-bottom: 16px;
}
.skeleton-viewflow-container .channel-info-section .channel-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
}
.skeleton-viewflow-container .channel-info-section .channel-header .channel-avatar {
  flex-shrink: 0;
}
.skeleton-viewflow-container .channel-info-section .channel-header .channel-avatar .skeleton-avatar {
  width: 48px;
  height: 48px;
}
.skeleton-viewflow-container .channel-info-section .channel-header .channel-details {
  flex: 1;
  min-width: 0;
}
.skeleton-viewflow-container .channel-info-section .channel-header .channel-details .channel-name {
  height: 20px;
  width: 40%;
  margin-bottom: 8px;
}
.skeleton-viewflow-container .channel-info-section .channel-header .channel-details .channel-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}
.skeleton-viewflow-container .channel-info-section .channel-header .channel-details .channel-meta span {
  height: 16px;
  width: 80px;
  margin: 0;
}
.skeleton-viewflow-container .channel-info-section .channel-header .channel-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.skeleton-viewflow-container .channel-info-section .channel-header .channel-actions .follow-btn {
  width: 120px;
  height: 36px;
  border-radius: 18px;
  margin: 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section {
  margin-bottom: 48px !important;
  padding: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section * {
  box-sizing: border-box;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-header {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 48px;
}
@media (min-width: 768px) {
  .skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-header {
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-header .feedback-header-left .feedback-title {
  font-size: 36px;
  font-weight: 800;
  line-height: 1.2;
  margin: 0 0 8px 0;
  color: #0f172a;
  letter-spacing: -0.02em;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-header .feedback-header-left .feedback-subtitle {
  font-size: 18px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-header .feedback-header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-header .feedback-header-actions .feedback-btn-secondary {
  padding: 12px 24px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  color: #0f172a;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-header .feedback-header-actions .feedback-btn-secondary:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-header .feedback-header-actions .feedback-btn-primary {
  padding: 12px 24px;
  background: #f59e0b;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 6px rgba(245, 158, 11, 0.2);
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-header .feedback-header-actions .feedback-btn-primary:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 6px 8px rgba(245, 158, 11, 0.3);
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-header .feedback-header-actions .feedback-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 32px !important;
  margin-bottom: 64px !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  visibility: visible !important;
  opacity: 1 !important;
}
@media (min-width: 1024px) {
  .skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid {
    grid-template-columns: 1fr 2fr !important;
    display: grid !important;
  }
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card {
  padding: 32px !important;
  background: #fff !important;
  border-radius: 20px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #f1f5f9 !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  width: 100% !important;
  box-sizing: border-box !important;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-number {
  font-size: 60px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-stars {
  display: flex;
  gap: 2px;
  margin-bottom: 4px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-stars .star-wrapper {
  position: relative;
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-stars .star-wrapper .rating-star-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: #cbd5e1;
  line-height: 1;
  display: block;
  position: relative;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-stars .star-wrapper .rating-star-icon.filled-star {
  color: #f59e0b;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-stars .star-wrapper .rating-star-icon.partial-star {
  color: #f59e0b;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-stars .star-wrapper .rating-star-icon.star-empty-overlay {
  position: absolute;
  top: 0;
  left: 0;
  color: #cbd5e1;
  z-index: 1;
  pointer-events: none;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-count-text {
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  margin: 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  font-weight: 500;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item .rating-label {
  width: 48px;
  color: #475569;
  flex-shrink: 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item .rating-bar-bg {
  flex: 1;
  height: 10px;
  background: #f1f5f9;
  border-radius: 9999px;
  overflow: hidden;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item .rating-bar-bg .rating-bar-progress {
  height: 100%;
  background: #f59e0b;
  border-radius: 9999px;
  transition: width 0.3s ease;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item .rating-percent {
  width: 32px;
  text-align: right;
  color: #64748b;
  flex-shrink: 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .ratings-info-btn {
  width: 100%;
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0;
  background: none;
  border: none;
  color: #f59e0b;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .ratings-info-btn:hover {
  text-decoration: underline;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .rating-summary-card .ratings-info-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card {
  position: relative !important;
  height: 100% !important;
  background: linear-gradient(135deg, #eef2ff 0%, #fff 100%) !important;
  padding: 32px !important;
  border-radius: 20px !important;
  border: 1px solid #c7d2fe !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  width: 100% !important;
  box-sizing: border-box !important;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content {
  position: relative;
  z-index: 10;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-highlights-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-highlights-header .ai-icon-wrapper {
  padding: 8px;
  background: #4f46e5;
  color: #fff;
  border-radius: 8px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-highlights-header .ai-icon-wrapper .ai-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-highlights-header .ai-highlights-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-summary-text {
  color: #334155;
  font-size: 18px;
  line-height: 1.7;
  margin: 0 0 32px 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}
@media (min-width: 768px) {
  .skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid {
    grid-template-columns: 1fr 1fr;
  }
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  margin: 0 0 12px 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid;
  cursor: pointer;
  transition: all 0.2s;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag .tag-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag.positive {
  background: #d1fae5;
  color: #065f46;
  border-color: #a7f3d0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag.positive .tag-icon {
  color: #059669;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag.negative {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag.negative .tag-icon {
  color: #dc2626;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-gradient-bg {
  position: absolute;
  top: -96px;
  right: -96px;
  width: 256px;
  height: 256px;
  background: rgba(79, 70, 229, 0.1);
  border-radius: 50%;
  filter: blur(100px);
  z-index: 1;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section {
  margin-bottom: 64px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .reviews-images-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .reviews-images-header .reviews-images-title {
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .reviews-images-header .see-all-photos-link {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #f59e0b;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .reviews-images-header .see-all-photos-link:hover {
  text-decoration: underline;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .reviews-images-header .see-all-photos-link mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .masonry-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 200px);
  gap: 16px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .masonry-grid .masonry-item {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  cursor: pointer;
  transition: transform 0.5s;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .masonry-grid .masonry-item:hover {
  transform: scale(1.05);
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .masonry-grid .masonry-item:hover .masonry-overlay {
  opacity: 1;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .masonry-grid .masonry-item.masonry-item-large {
  grid-column: span 2;
  grid-row: span 2;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .masonry-grid .masonry-item .masonry-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .masonry-grid .masonry-item .masonry-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
  opacity: 0;
  transition: opacity 0.3s;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .masonry-grid .masonry-item.masonry-item-more .masonry-more-overlay {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .reviews-images-section .masonry-grid .masonry-item.masonry-item-more .masonry-more-overlay .masonry-more-text {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section {
  padding: 0 16px;
}
@media (max-width: 768px) {
  .skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section {
    padding: 0 12px;
  }
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-header .top-reviews-title {
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-header .top-reviews-sort {
  display: flex;
  align-items: center;
  gap: 8px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-header .top-reviews-sort .sort-label {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-header .top-reviews-sort .sort-select {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  cursor: pointer;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-header .top-reviews-sort .sort-select:focus {
  outline: none;
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card {
  padding: 32px;
  background: #fff;
  border-radius: 20px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group {
  display: flex;
  align-items: center;
  gap: 16px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-avatar-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  color: #4f46e5;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-name {
  font-weight: 700;
  font-size: 18px;
  color: #0f172a;
  margin: 0 0 4px 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group {
  display: flex;
  align-items: center;
  gap: 8px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .review-stars {
  display: flex;
  gap: 2px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .review-stars .review-star-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #cbd5e1;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .review-stars .review-star-icon.filled-star {
  color: #f59e0b;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .verified-badge {
  font-size: 12px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .review-date {
  font-size: 14px;
  color: #94a3b8;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 12px 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-text {
  color: #475569;
  line-height: 1.7;
  margin: 0 0 24px 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-media {
  margin: 24px 0;
  border-radius: 8px;
  overflow: hidden;
  max-width: 300px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-media .review-media-image,
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-media .review-media-video {
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
  border-radius: 8px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section {
  margin-top: 24px;
  padding: 16px;
  background: #fff7ed;
  border-left: 3px solid #f59e0b;
  border-radius: 8px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issues-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issues-header .issues-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #f59e0b;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issues-header strong {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item {
  margin-bottom: 16px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item:last-child {
  margin-bottom: 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item .issue-header {
  margin-bottom: 8px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item .issue-header strong {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item .issue-description {
  font-size: 13px;
  color: #475569;
  line-height: 1.5;
  margin: 0 0 8px 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item .issue-media {
  margin: 12px 0;
  border-radius: 8px;
  overflow: hidden;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item .issue-media img,
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item .issue-media video {
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .creator-response-box {
  margin-top: 24px;
  padding: 16px;
  background: #eff6ff;
  border-left: 3px solid #3b82f6;
  border-radius: 8px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .creator-response-box .response-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .creator-response-box .response-header .response-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #3b82f6;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .creator-response-box .response-header strong {
  font-size: 13px;
  font-weight: 700;
  color: #1e40af;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .creator-response-box .response-text {
  font-size: 13px;
  color: #1e40af;
  line-height: 1.5;
  margin: 0 0 4px 0;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .creator-response-box .response-date {
  font-size: 12px;
  color: #64748b;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 24px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .helpful-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  font-weight: 700;
  font-size: 14px;
  color: #0f172a;
  cursor: pointer;
  transition: all 0.2s;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .helpful-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .helpful-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .report-btn {
  font-size: 14px;
  font-weight: 700;
  color: #94a3b8;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .report-btn:hover {
  color: #475569;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .load-more-section {
  text-align: center;
  padding-top: 32px;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .load-more-section .load-more-btn {
  padding: 16px 32px;
  background: #0f172a;
  color: #fff;
  border: none;
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.skeleton-viewflow-container .channel-info-section .customer-feedback-section .top-reviews-section .load-more-section .load-more-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.skeleton-viewflow-container .description-section {
  margin-bottom: 16px;
}
.skeleton-viewflow-container .description-section .description-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.skeleton-viewflow-container .description-section .description-header h3 {
  font-size: 16px;
  font-weight: 600;
  height: 20px;
  width: 120px;
  margin: 0;
}
.skeleton-viewflow-container .description-section .description-content .skeleton-text {
  height: 16px;
  margin: 8px 0;
}
.skeleton-viewflow-container .comments-section {
  margin-bottom: 16px;
}
.skeleton-viewflow-container .comments-section .comments-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.skeleton-viewflow-container .comments-section h3 {
  font-size: 16px;
  font-weight: 600;
  height: 24px;
  width: 150px;
  margin-bottom: 16px;
}
.skeleton-viewflow-container .comments-section .comment-input-section {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 24px;
}
.skeleton-viewflow-container .comments-section .comment-input-section .comment-avatar {
  flex-shrink: 0;
}
.skeleton-viewflow-container .comments-section .comment-input-section .comment-avatar .skeleton-avatar {
  width: 40px;
  height: 40px;
}
.skeleton-viewflow-container .comments-section .comment-input-section .comment-form-wrapper {
  flex: 1;
}
.skeleton-viewflow-container .comments-section .comment-input-section .comment-form-wrapper .comment-input {
  width: 100%;
  height: 40px;
  border-radius: 20px;
  margin: 0;
}
.skeleton-viewflow-container .comments-section .comment-input-section .comment-form-wrapper .comment-guidelines-helper {
  font-size: 13px;
  margin-top: 6px;
}
.skeleton-viewflow-container .comments-section .comments-list .comment-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
}
.skeleton-viewflow-container .comments-section .comments-list .comment-item:last-child {
  border-bottom: none;
}
.skeleton-viewflow-container .comments-section .comments-list .comment-item .comment-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.skeleton-viewflow-container .comments-section .comments-list .comment-item .comment-header .comment-author {
  display: flex;
  align-items: center;
  gap: 8px;
}
.skeleton-viewflow-container .comments-section .comments-list .comment-item .comment-header .comment-author .comment-avatar-img {
  width: 32px;
  height: 32px;
}
.skeleton-viewflow-container .comments-section .comments-list .comment-item .comment-header .comment-author .comment-author-name {
  height: 16px;
  width: 100px;
  margin: 0;
}
.skeleton-viewflow-container .comments-section .comments-list .comment-item .comment-header .comment-date {
  height: 14px;
  width: 80px;
  margin: 0;
}
.skeleton-viewflow-container .comments-section .comments-list .comment-item .comment-text {
  height: 16px;
  width: 100%;
  margin: 8px 0;
}
.skeleton-viewflow-container .comments-section .comments-list .comment-item .comment-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.skeleton-viewflow-container .comments-section .comments-list .comment-item .comment-actions .comment-action-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: default;
  pointer-events: none;
}
.skeleton-viewflow-container .comments-section .leave-review-inline {
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}
.skeleton-viewflow-container .comments-section .leave-review-text {
  color: #555;
}
.skeleton-viewflow-container .comments-section .leave-review-button {
  border: 1px solid #5ea1d8;
  background-color: #ffffff;
  color: #5ea1d8;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.skeleton-viewflow-container .comments-section .leave-review-button:hover {
  background-color: #e3f1fb;
}
.skeleton-viewflow-container .flow-sidebar {
  width: 402px;
  min-width: 402px;
  max-width: 402px;
  position: relative;
  align-self: flex-start;
}
@media (max-width: 1024px) {
  .skeleton-viewflow-container .flow-sidebar {
    display: none;
  }
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card-desktop {
  background: transparent !important;
  border-radius: 12px !important;
  margin: 4px 4px !important;
  margin-bottom: 16px !important;
  display: flex !important;
  justify-content: flex-start !important;
  align-items: center !important;
  width: 100% !important;
  visibility: visible !important;
  opacity: 1 !important;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card-desktop .completion-progress-content-desktop {
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  width: 100% !important;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card-desktop .completion-progress-content-desktop .completion-progress-bar-desktop {
  width: 100% !important;
  height: 24px !important;
  min-height: 24px !important;
  max-height: 24px !important;
  background-color: #e0e0e0 !important;
  background: #e0e0e0 !important;
  border-radius: 4px !important;
  overflow: hidden !important;
  position: relative !important;
  display: block !important;
  box-sizing: border-box !important;
  visibility: visible !important;
  opacity: 1 !important;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card-desktop .completion-progress-content-desktop .completion-progress-bar-desktop .completion-progress-fill-desktop {
  height: 24px !important;
  min-height: 24px !important;
  background-color: #5ea1d8 !important;
  background: linear-gradient(90deg, #5ea1d8 0%, #6bb3e8 100%) !important;
  border-radius: 4px !important;
  transition: width 0.3s ease !important;
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-width: -moz-fit-content !important;
  min-width: fit-content !important;
  box-sizing: border-box !important;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card-desktop .completion-progress-content-desktop .completion-progress-bar-desktop .completion-progress-fill-desktop .progress-bar-percentage-desktop {
  color: white !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  padding: 0 8px !important;
  white-space: nowrap !important;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card-desktop .completion-progress-content-desktop .completion-progress-bar-desktop .progress-bar-percentage-empty-desktop {
  position: absolute !important;
  left: 8px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  color: #606060 !important;
  font-size: 12px !important;
  font-weight: 600 !important;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card-desktop .completion-progress-content-desktop .progress-step-info-desktop {
  font-size: 12px !important;
  color: #606060 !important;
  line-height: 1.2 !important;
  text-align: left !important;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card-desktop .completion-progress-content-desktop .progress-step-info-desktop .completion-code-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: #f0f4fa;
  color: #3b4a60;
  font-size: 11px;
  font-weight: 600;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card-desktop.restarted .completion-progress-bar-desktop {
  background-color: #e3f2fd !important;
  background: #e3f2fd !important;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card .completion-progress-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 14px;
  color: #0f0f0f;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card .completion-progress-header .completion-progress-title {
  flex: 1;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card .completion-progress-content .completion-progress-top {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 12px;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card .completion-progress-content .completion-progress-top .completion-percentage {
  font-size: 32px;
  font-weight: 700;
  color: #4caf50;
  line-height: 1;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card .completion-progress-content .completion-progress-top .completion-stats {
  font-size: 13px;
  color: #606060;
  align-self: center;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card .completion-progress-content .completion-progress-bar {
  width: 100%;
  height: 24px;
  background: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card .completion-progress-content .completion-progress-bar .completion-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4caf50 0%, #66bb6a 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card .completion-progress-content .completion-progress-bar .completion-progress-fill .progress-bar-percentage {
  color: white;
  font-size: 12px;
  font-weight: 600;
  padding: 0 8px;
  white-space: nowrap;
}
.skeleton-viewflow-container .flow-sidebar .completion-progress-card .completion-progress-content .completion-progress-bar .progress-bar-percentage-empty {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #606060;
  font-size: 12px;
  font-weight: 600;
}
.skeleton-viewflow-container .flow-sidebar .step-navigation {
  margin-bottom: 24px;
}
.skeleton-viewflow-container .flow-sidebar .step-navigation .step-scroll {
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
}
.skeleton-viewflow-container .flow-sidebar .step-navigation .steps-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.skeleton-viewflow-container .flow-sidebar .step-navigation .step-btn {
  border: none;
  background: rgba(240, 240, 240, 0.8);
  padding: 10px 16px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: default;
  pointer-events: none;
  width: 100%;
}
.skeleton-viewflow-container .flow-sidebar .step-navigation .step-btn .skeleton-icon {
  width: 20px;
  height: 20px;
  margin: 0;
}
.skeleton-viewflow-container .flow-sidebar .step-navigation .step-btn .skeleton-step-pill {
  flex: 1;
  height: 16px;
  margin: 0;
}
.skeleton-viewflow-container .flow-sidebar .recommendations-section {
  margin-top: 24px;
}
.skeleton-viewflow-container .flow-sidebar .recommendations-section h2 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  height: 24px;
  width: 180px;
}
.skeleton-viewflow-container .flow-sidebar .recommendations-section .recommendations-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.skeleton-viewflow-container .flow-sidebar .recommendations-section .recommendation-item {
  display: flex;
  gap: 12px;
  cursor: default;
  pointer-events: none;
}
.skeleton-viewflow-container .flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail {
  flex-shrink: 0;
}
.skeleton-viewflow-container .flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail .skeleton-image {
  width: 120px;
  height: 72px;
  padding-bottom: 0;
}
.skeleton-viewflow-container .flow-sidebar .recommendations-section .recommendation-item .recommendation-info {
  flex: 1;
  min-width: 0;
}
.skeleton-viewflow-container .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-title {
  height: 16px;
  width: 100%;
  margin-bottom: 8px;
}
.skeleton-viewflow-container .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta {
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
}
.skeleton-viewflow-container .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta span {
  height: 12px;
  width: 60px;
  margin: 0;
}
.skeleton-viewflow-container .recommendations-section-mobile {
  margin-top: 24px;
  margin-bottom: 16px;
}
.skeleton-viewflow-container .recommendations-section-mobile h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  height: 24px;
  width: 200px;
}
.skeleton-viewflow-container .recommendations-section-mobile .recommendations-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.skeleton-viewflow-container .recommendations-section-mobile .recommendation-item {
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}
.skeleton-viewflow-container .recommendations-section-mobile .recommendation-item:last-child {
  border-bottom: none;
}
.skeleton-viewflow-container .recommendations-section-mobile .recommendation-item .recommendation-thumbnail {
  flex-shrink: 0;
}
.skeleton-viewflow-container .recommendations-section-mobile .recommendation-item .recommendation-thumbnail .skeleton-image {
  width: 120px;
  height: 72px;
  padding-bottom: 0;
}
.skeleton-viewflow-container .recommendations-section-mobile .recommendation-item .recommendation-info {
  flex: 1;
  min-width: 0;
}
.skeleton-viewflow-container .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-title {
  height: 16px;
  width: 100%;
  margin-bottom: 8px;
}
.skeleton-viewflow-container .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta {
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
}
.skeleton-viewflow-container .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta span {
  height: 12px;
  width: 60px;
  margin: 0;
}
.skeleton-viewflow-container.mobile .container1 .flow-layout-container .flow-main-grid {
  grid-template-columns: 1fr !important;
  gap: 0 !important;
  padding: 0 !important;
}
.skeleton-viewflow-container.mobile .container1 .flow-layout-container .flow-main-content .flow-title-sticky {
  padding: 8px 16px 0 !important;
  margin: 0 !important;
}
.skeleton-viewflow-container.mobile .container1 .flow-layout-container .flow-main-content .completion-progress-card-mobile {
  padding: 0 !important;
  margin: 3px 0 4px 0 !important;
}
.skeleton-viewflow-container.mobile .container1 .flow-layout-container .flow-main-content .completion-progress-card-mobile .progress-step-row-mobile {
  padding: 0 16px !important;
}
.skeleton-viewflow-container.mobile .container1 .flow-layout-container .flow-main-content .video-title-sticky {
  margin: 0 !important;
}
.skeleton-viewflow-container.mobile .container1 .flow-layout-container .flow-main-content .video-actions-bar {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 16px 12px 16px !important;
}
.skeleton-viewflow-container.mobile .flow-sidebar {
  display: none !important;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
@keyframes skeleton-pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.65;
  }
  100% {
    opacity: 1;
  }
}
/* Dark mode skeleton palette (view-flow) */
:host-context(body.theme-dark) .skeleton-viewflow-container {
  --skeleton-gradient: linear-gradient(
    110deg,
    #1f2937 8%,
    #334155 18%,
    #1f2937 33%
  );
  background: #0a0c10 !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-text,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-avatar,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-icon,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-image {
  background-color: #1f2937 !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-image::after {
  background-color: #1f2937 !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-card,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-flow-header {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .video-player-section,
:host-context(body.theme-dark) .skeleton-viewflow-container .video-player-section .img-wrap,
:host-context(body.theme-dark) .skeleton-viewflow-container .video-player-section .img-wrap img,
:host-context(body.theme-dark) .skeleton-viewflow-container .video-player-section .img-wrap video,
:host-context(body.theme-dark) .skeleton-viewflow-container .mobile-media,
:host-context(body.theme-dark) .skeleton-viewflow-container .mobile-media img,
:host-context(body.theme-dark) .skeleton-viewflow-container .mobile-media video,
:host-context(body.theme-dark) .skeleton-viewflow-container .mobile-media-video {
  background: #020617 !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .info-badge,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-pill {
  background: rgba(148, 163, 184, 0.16) !important;
}

.step-sec .img-wrap:after {
  content: "›";
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: absolute;
  right: -49px;
  top: calc(50% - 20px);
  font-size: 35px;
  margin-top: -8px;
  display: none;
}

.step-sec .img-wrap:before {
  content: "‹";
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: absolute;
  left: -49px;
  top: calc(50% - 20px);
  font-size: 35px;
  margin-top: -8px;
  display: none;
}

.des-item .des p::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}

.des-item .des p::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.des-item .des p::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.des-item .item .list::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}

.des-item .item .list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.des-item .item .list::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.step-sec {
  text-align: center;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}

.progressbar ul {
  display: flex;
  flex-basis: 100%;
}

.progressbar ul li {
  flex: 1;
  display: flex;
  align-items: center;
}

.progressbar ul li a {
  width: 20px;
  height: 20px;
  background: #5ea1d8;
  border-radius: 50%;
  color: #fff;
  text-decoration: none;
  text-align: center;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progressbar ul li a:before {
  counter-increment: my-sec-counter;
  content: "" counter(my-sec-counter) "";
}

img {
  max-width: 100%;
}

@media only screen and (max-width: 1025px) and (min-width: 320px) {
  .view-flow h2 {
    font-size: 22px !important;
  }
}
@media only screen and (max-width: 992px) and (min-width: 320px) {
  .view-flow .container1 {
    display: flex;
    flex-direction: column;
    padding: 0px 15px 20px;
  }
  .view-flow .container1 .user-sec {
    flex-direction: column;
  }
  .view-flow .container1 .user-sec .user-details {
    flex-direction: column;
    order: 2;
  }
  .view-flow .container1 .user-sec .user-details .user-ico {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .view-flow .container1 .user-sec .user-details .ico-details {
    padding: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 14px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like {
    display: flex;
    margin-left: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul {
    margin-left: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul li i {
    font-size: 20px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like .qrcode span {
    margin-right: 0px !important;
  }
  .view-flow .container1 .user-sec .qr-code {
    padding: 10px 0px;
  }
  .view-flow .description-wrapper {
    flex-direction: column;
    margin: 0px;
    margin-bottom: 20px;
  }
  .view-flow .description-wrapper .des-item {
    margin-right: 0px;
    margin-bottom: 20px;
    flex-basis: 100%;
    max-width: unset;
    border-right: 0px;
    padding-right: 0px;
  }
  .view-flow .description-wrapper .des-item .des > div span:first-child {
    justify-content: flex-start;
  }
  .view-flow .description-wrapper .des-item .des .timer-wrap {
    display: flex;
    flex-direction: column;
    flex: none;
    color: #212427;
  }
  .view-flow .description-wrapper .des-item .des .timer-wrap > * {
    margin-right: 10px;
  }
  .view-flow .viewflow-step {
    width: 100%;
    margin: 0px auto 20px;
  }
  .view-flow .viewflow-step .des-item {
    flex-basis: 100%;
    max-width: unset;
    border-bottom: 2px solid lightgrey;
    padding-bottom: 20px;
  }
  .view-flow .viewflow-step .des-item .des {
    padding-bottom: 20px;
    border-radius: 0px;
  }
  .view-flow .viewflow-step .step-sec {
    padding: 0px;
    margin-left: 0px;
    width: 100%;
  }
  .view-flow .viewflow-step .clickarrow {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .view-flow .viewflow-step .clickarrow button {
    width: 25px;
    height: 25px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-prev {
    margin-right: auto;
    margin-left: 0;
  }
  .view-flow .viewflow-step .clickarrow button.owl-next {
    margin-left: auto;
    margin-right: 0;
  }
  .view-flow .ico-details .profilepic {
    flex-wrap: nowrap;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner {
    width: 100% !important;
    flex-basis: 100% !important;
    max-width: 100% !important;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner + .qrcode {
    width: 100%;
    justify-content: flex-end;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic + .like-list {
    flex-direction: column;
  }
  .view-flow .container1 .viewflow-step .step-sec {
    width: 100%;
    margin: 0px;
  }
  .supportingdoc {
    position: relative !important;
    padding: 10px 10px 10px 0px !important;
  }
}
/*table struture starts here*/
.table-wrap {
  max-height: 260px;
  overflow-y: auto;
  padding-right: 7px;
}
.table-wrap::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.table-wrap::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.table-wrap::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

table {
  padding-right: 20px;
  width: 100%;
}
table tr {
  display: flex;
  width: 100%;
  flex-flow: row wrap;
  justify-content: space-between;
}
table tr th {
  font-weight: 600 !important;
  font-size: 16px !important;
  width: 48%;
  word-break: break-all;
  margin-bottom: 15px;
  line-height: 25px;
}
table tr td {
  width: 100%;
  word-break: break-all;
  margin-bottom: 15px;
  font-weight: 400;
  line-height: 25px;
  font-size: 13px;
  position: relative;
  padding-left: 15px;
  display: flex;
}
table tr td > span {
  width: 48%;
  overflow-wrap: break-word;
}
table tr td > span:first-child {
  margin-right: 4%;
}
table tr td:before {
  content: "";
  width: 8px;
  height: 8px;
  background: grey;
  position: absolute;
  left: 0px;
  top: 8px;
  border-radius: 50%;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}

.like-list .fashion-btn {
  display: block;
}

.qr-code .lock,
.qr-code .fashion-btn {
  display: none;
}

@media only screen and (max-width: 992px) and (min-width: 461px) {
  .view-flow .container1 .user-sec .user-details {
    flex-direction: row;
  }
  .view-flow .container1 .user-sec .user-details .ico-details {
    padding-left: 15px;
    max-width: 100%;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul {
    margin-left: -15px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like .qrcode span {
    margin-right: 15px !important;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 14px !important;
  }
  .view-flow .container1 .description-wrapper {
    width: auto;
    margin: 10px 20px;
  }
  .view-flow .container1 .description-wrapper .step-sec .img-wrap {
    max-height: unset;
  }
  .view-flow .container1 .viewflow-step .des-item .des {
    padding-bottom: 20px;
    border-radius: 0px;
  }
  .view-flow .container1 .viewflow-step .clickarrow {
    padding: 12px 16px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .view-flow .container1 .viewflow-step .clickarrow button {
    width: 44px;
    height: 44px;
  }
  .view-flow .container1 .viewflow-step .clickarrow button.owl-prev {
    margin-right: auto;
    margin-left: 0;
  }
  .view-flow .container1 .viewflow-step .clickarrow button.owl-next {
    margin-left: auto;
    margin-right: 0;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .view-flow .viewflow-step .clickarrow {
    padding: 12px 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .view-flow .viewflow-step .clickarrow button {
    width: 42px;
    height: 42px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-prev {
    margin-right: auto;
    margin-left: 0;
  }
  .view-flow .viewflow-step .clickarrow button.owl-next {
    margin-left: auto;
    margin-right: 0;
  }
}
@media only screen and (max-width: 460px) and (min-width: 320px) {
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 11px !important;
  }
  .ico-details .profilepic > div:last-child span {
    font-size: 11px;
  }
  .view-flow .viewflow-step .clickarrow {
    padding: 12px 12px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .view-flow .viewflow-step .clickarrow button {
    width: 40px;
    height: 40px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-prev {
    margin-right: auto;
    margin-left: 0;
  }
  .view-flow .viewflow-step .clickarrow button.owl-next {
    margin-left: auto;
    margin-right: 0;
  }
  .view-flow .viewflow-step {
    width: auto;
    margin: 10px 0px;
  }
  .qr-code {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  .qr-code .priceIcon-wp {
    position: relative !important;
    top: -2px;
  }
  .qr-code .lock > span {
    display: flex;
    align-items: center;
  }
  .qr-code .lock,
  .qr-code .fashion-btn {
    display: block;
  }
  .profilepic .lock {
    display: none !important;
  }
  .like-list .fashion-btn {
    display: none !important;
  }
  .view-flow h2 span {
    font-size: 20px !important;
    word-break: break-word;
  }
  .view-flow .container1 .user-sec {
    padding: 10px;
    margin: 0px;
  }
  .ico-details .profilepic .profinner > div {
    margin-right: 5px;
  }
  .ico-details .profilepic > div {
    margin-right: 0px;
  }
  .viewflow-step .des-item .des p {
    max-height: 133px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul li span {
    font-size: 9px;
  }
  .partOfBundle {
    padding: 0px;
    margin-right: 5px;
  }
}
button.common {
  padding: 3px 6px !important;
  background: #5ea1d8 !important;
  border: 0px !important;
  color: #fff !important;
  font-size: 13px !important;
  border-radius: 5px !important;
}

@media (max-width: 500px) {
  .ico-details .profilepic .qrcode {
    justify-content: center;
  }
}
.example-list {
  max-width: 100%;
  height: auto;
  display: flex;
  background: white;
  flex-direction: column;
  overflow-y: auto;
}
.example-list .example-box {
  display: flex;
  padding: 15px 10px;
  border-bottom: 1px solid lightgrey;
  background: white !important;
  flex: 1;
  padding: 15px 10px;
  border-bottom: solid 1px lightgray;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: default;
  background: white;
  font-size: 14px;
}
.example-list .example-box .item-name {
  text-align: left;
  width: 70%;
  cursor: default !important;
}
.example-list .example-box .item-value {
  text-align: left;
  width: 30%;
  cursor: default !important;
}
.example-list .example-box .item-name,
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder,
.example-list .example-box .item-value {
  text-align: left;
  padding: 5px;
  font-size: 14px;
  font-weight: 400 !important;
  overflow-wrap: break-word;
}
.example-list .example-box span:not(a) {
  cursor: default !important;
}
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder {
  float: right;
  cursor: pointer;
  font-size: 20px;
  width: 10%;
}
.example-list .example-box:last-child {
  border-bottom: 0px;
}
.example-list .example-box img {
  border-bottom: 0px;
  width: 40px !important;
  max-width: 40px;
  height: 40px !important;
  object-fit: cover;
}
.example-list .example-box > * {
  flex: 1;
  color: #212427 !important;
  font-weight: normal !important;
}
.example-list .example-box a {
  color: #007bff !important;
}
.example-list::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.example-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.example-list::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.example-box {
  padding: 15px 10px;
  border-bottom: solid 1px lightgray;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: default;
  background: white;
  font-size: 14px;
}
.example-box .item-value {
  cursor: default !important;
}
.example-box span:not(a) {
  cursor: default !important;
}
.example-box > div {
  width: 50%;
  display: flex !important;
}
.example-box > div:first-child {
  width: 80%;
}
.example-box > div:last-child {
  width: 17%;
}
.example-box > div > span {
  text-align: left;
  word-break: keep-all;
  display: flex;
  align-items: center;
}
.example-box > div > span:first-child {
  flex: 1;
  width: 50%;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}
.example-box > div > span:last-child {
  width: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: end;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}

.itemremove span:first-child {
  width: 90% !important;
}
.img-div-left {
  position: fixed;
  z-index: 9999999 !important;
  height: 100px;
  width: 100px;
  overflow: visible;
  margin: auto;
  top: 5% !important;
  left: 0;
  bottom: 0;
  right: 0;
}
.img-div-left img {
  width: 100%;
  height: 100%;
  position: absolute !important;
  top: 0% !important;
}

/*new design starts here*/
.viewbundle .step-sec + .row {
  margin-top: 40px !important;
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
.viewbundle .step-sec + .row > div {
  width: 25% !important;
}
.viewbundle .step-sec + .row > div .item {
  box-shadow: none !important;
}
.viewbundle .step-sec + .row > div .item img {
  width: calc(100% - 20px) !important;
  object-fit: cover;
  margin: 10px !important;
}
.viewbundle .step-sec + .row > div .item p {
  padding-left: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 33px !important;
  white-space: normal;
  word-break: break-word;
}
.viewbundle .step-sec + .row > div .item .with-icon {
  display: flex;
}
.viewbundle .step-sec + .row > div .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 20px !important;
}

.mat-accent {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 460px) {
  .viewbundle .step-sec + .row > div {
    width: 50% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 767px) {
  .viewbundle .step-sec + .row > div {
    width: 33% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
.example-list .example-box .item-name {
  padding-left: 10px !important;
  border-right: 1px solid #ddd;
}
.example-list .example-box .item-value {
  padding-left: 10px !important;
}

.textcolor {
  color: #5ea1d8;
}

.item .img {
  height: 150px !important;
  background-color: lightgray;
}

p {
  margin: 0px;
}

.zoom {
  cursor: pointer;
  width: 100%;
  height: 70%;
  transition: transform 0.1s;
  /* Animation */
}

.zoom:hover {
  border-radius: 5px;
  transform: scale(1.1);
  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.owl-carousel .owl-nav button.owl-next,
.owl-carousel .owl-nav button.owl-prev,
.owl-carousel button.owl-dot {
  font-size: 55px !important;
}

.owl-theme .owl-nav [class*=owl-] {
  font-size: 55px !important;
}

.owl-nav {
  display: none;
}

.with-icon {
  display: flex;
  align-items: center;
}

.mat-badge-content {
  background: #5ea1d8;
}

.div1 {
  height: 50px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: white;
  overflow: hidden;
  z-index: 100;
}

.user-pro .row {
  justify-content: left;
}
.user-pro .ng-star-inserted {
  width: 15.6%;
  margin-right: 1%;
}
.user-pro .item {
  width: 100% !important;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dddddd;
  margin: 0px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.user-pro .item > div {
  margin: 5px;
}
.user-pro .item p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 33px !important;
  white-space: normal;
  word-break: break-word;
}
.user-pro .item p:last-of-type {
  height: auto !important;
}
.user-pro .item .with-icon {
  width: 100%;
  display: flex;
  align-items: center;
}
.user-pro .item .with-icon > div {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-right: 5px;
}
.user-pro .item .with-icon img {
  object-fit: cover;
  height: 40px !important;
  border: 0px;
}
.user-pro .item .zoom {
  margin: 5px;
  width: calc(100% - 10px);
  background-color: transparent;
}
.user-pro .item img {
  height: 150px;
  object-fit: cover;
  width: 100%;
  border: 1px solid #dddddd;
}

@media only screen and (max-width: 1024px) and (min-width: 993px) {
  .user-pro .row {
    justify-content: left;
    text-align: start;
  }
  .user-pro .ng-star-inserted {
    max-width: 18% !important;
    width: 18% !important;
    margin: 1% !important;
  }
  .user-pro .item {
    max-width: 100% !important;
    width: 100% !important;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dddddd;
    margin: 0px;
    margin-right: 0px;
    margin-bottom: 20px;
  }
  .user-pro .item > div {
    margin: 5px;
  }
  .user-pro .item p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px !important;
    white-space: normal;
    word-break: break-word;
  }
  .user-pro .item .with-icon {
    max-width: 100% !important;
    width: 100% !important;
    display: flex;
    align-items: center;
    max-width: 100% !important;
  }
  .user-pro .item .with-icon > div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .user-pro .item .with-icon img {
    object-fit: cover;
    height: 40px !important;
    border: 0px;
  }
  .user-pro .item .zoom {
    margin: 5px;
    width: calc(100% - 10px);
    background-color: transparent;
  }
  .user-pro .item img {
    height: 150px;
    object-fit: cover;
    width: 100%;
    border: 1px solid #dddddd;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .user-pro .row {
    justify-content: left;
    text-align: start;
  }
  .user-pro .ng-star-inserted {
    max-width: 23% !important;
    width: 23% !important;
    margin: 1% !important;
  }
  .user-pro .item {
    max-width: 100% !important;
    width: 100% !important;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dddddd;
    margin: 0px;
    margin-right: 0px;
    margin-bottom: 20px;
  }
  .user-pro .item > div {
    margin: 5px;
  }
  .user-pro .item p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px !important;
    white-space: normal;
    word-break: break-word;
  }
  .user-pro .item .with-icon {
    max-width: 100% !important;
    width: 100% !important;
    display: flex;
    align-items: center;
  }
  .user-pro .item .with-icon > div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .user-pro .item .with-icon img {
    object-fit: cover;
    height: 40px !important;
    border: 0px;
  }
  .user-pro .item .zoom {
    margin: 5px;
    width: calc(100% - 10px);
    background-color: transparent;
  }
  .user-pro .item img {
    height: 150px;
    object-fit: cover;
    width: 100%;
    border: 1px solid #dddddd;
  }
  h3 {
    padding-left: 12px;
  }
}
@media only screen and (max-width: 767px) and (min-width: 461px) {
  .user-pro .row {
    justify-content: left;
    text-align: start;
  }
  .user-pro .ng-star-inserted {
    max-width: 31.3% !important;
    width: 31.3% !important;
    margin: 1%;
  }
  .user-pro .item {
    max-width: 100% !important;
    width: 100% !important;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dddddd;
    margin: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
  }
  .user-pro .item > div {
    margin: 5px;
  }
  .user-pro .item p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px !important;
    white-space: normal;
    word-break: break-word;
  }
  .user-pro .item .with-icon {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .user-pro .item .with-icon > div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .user-pro .item .with-icon img {
    object-fit: cover;
    height: 40px !important;
    border: 0px;
  }
  .user-pro .item .with-icon.ng-star-inserted {
    max-width: 100% !important;
    width: 100% !important;
  }
  .user-pro .item .zoom {
    margin: 5px;
    width: calc(100% - 10px);
    background-color: transparent;
  }
  .user-pro .item img {
    height: 150px;
    object-fit: cover;
    width: 100%;
    border: 1px solid #dddddd;
  }
  h3 {
    padding-left: 12px;
  }
}
@media screen and (max-width: 460px) {
  .user-pro .row {
    justify-content: left;
    text-align: start;
  }
  .user-pro .ng-star-inserted {
    max-width: 48% !important;
    width: 48% !important;
    margin: 1%;
  }
  .user-pro .item {
    max-width: 100% !important;
    width: 100% !important;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dddddd;
    margin: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
  }
  .user-pro .item > div {
    margin: 5px;
  }
  .user-pro .item p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px !important;
    white-space: normal;
    word-break: break-word;
  }
  .user-pro .item .with-icon {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .user-pro .item .with-icon > div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .user-pro .item .with-icon img {
    object-fit: cover;
    height: 40px !important;
    border: 0px;
  }
  .user-pro .item .with-icon.ng-star-inserted {
    max-width: 100% !important;
    width: 100% !important;
  }
  .user-pro .item .zoom {
    margin: 5px;
    width: calc(100% - 10px);
    background-color: transparent;
  }
  .user-pro .item img {
    height: 150px;
    object-fit: cover;
    width: 100%;
    border: 1px solid #dddddd;
  }
  h3 {
    padding-left: 7px;
  }
}
.scroll .item .uni-wrapper .bundleIcon {
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px !important;
  height: 25px !important;
  max-width: 25px !important;
  height: 25px !important;
}
.scroll .item .uni-wrapper .bundleIcon img {
  width: 100% !important;
  height: 20px !important;
  object-fit: contain;
  border: none;
}

.uni-wrapper P {
  flex: 1;
}

/*new design starts here new bundle*/
.viewbundle .step-sec + .row {
  margin-top: 40px !important;
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
.viewbundle .step-sec + .row > div {
  width: 25% !important;
}
.viewbundle .step-sec + .row > div .item {
  box-shadow: none !important;
}
.viewbundle .step-sec + .row > div .item img {
  width: calc(100% - 20px) !important;
  object-fit: cover;
  margin: 10px !important;
}
.viewbundle .step-sec + .row > div .item p {
  padding-left: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 33px !important;
  white-space: normal;
  word-break: break-word;
}
.viewbundle .step-sec + .row > div .item .with-icon {
  display: flex;
}
.viewbundle .step-sec + .row > div .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 20px !important;
}

@media (max-width: 460px) {
  .viewbundle .step-sec + .row > div {
    width: 50% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 767px) {
  .viewbundle .step-sec + .row > div {
    width: 33% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
.bundleIcons {
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px !important;
  height: 25px !important;
  padding-left: 5px;
}
.bundleIcons img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

.partOfBundle .item .uni-wrapper {
  display: flex;
}
.partOfBundle .item .uni-wrapper p {
  justify-content: flex-start !important;
}

.uni-wrapper P {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.viewbundle .step-sec + .row {
  margin-top: 40px !important;
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
.viewbundle .step-sec + .row > div {
  width: 25% !important;
}
.viewbundle .step-sec + .row > div .item {
  box-shadow: none !important;
}
.viewbundle .step-sec + .row > div .item img {
  width: calc(100% - 20px) !important;
  object-fit: cover;
  margin: 10px !important;
}
.viewbundle .step-sec + .row > div .item p {
  padding-left: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 33px !important;
  white-space: normal;
  word-break: break-word;
}
.viewbundle .step-sec + .row > div .item .with-icon {
  display: flex;
}
.viewbundle .step-sec + .row > div .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 20px !important;
}

@media (max-width: 460px) {
  .viewbundle .step-sec + .row > div {
    width: 50% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 767px) {
  .viewbundle .step-sec + .row > div {
    width: 33% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media (max-width: 1024px) {
  .view-flow .container1 .user-sec {
    margin: 0px !important;
  }
  .view-flow .viewflow-step {
    width: 100% !important;
    margin: 10px 0px !important;
  }
  .partOfBundle {
    padding: 0px;
    margin-right: 5px;
  }
}
@media (max-width: 992px) {
  .view-flow .viewflow-step .des-item {
    padding: 0px;
    border: 0px;
    flex-basis: 100% !important;
    max-width: 100% !important;
    margin: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .view-flow .viewflow-step .des-item .des {
    padding: 0px;
    padding: 0px 0px 20px !important;
  }
  .view-flow .viewflow-step .des-item .des p {
    margin: 0px;
  }
  .view-flow .qr-ico {
    position: relative;
    right: 0px;
  }
}
.font16 {
  font-size: 14px !important;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: bold;
}

.priceIcon-p .font16 {
  font-size: 10px !important;
  color: #fff !important;
}

.timer-wrap {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.timer-wrap br {
  display: none;
}
.timer-wrap h6 {
  width: 100%;
  display: block;
  margin-bottom: 15px;
}
.timer-wrap .icon-wrap {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.timer-wrap .icon-wrap .textbodycolor {
  justify-content: flex-start !important;
  padding-left: 10px;
}

.newdesignadd {
  display: block;
  width: 100%;
  color: #212427;
  border: 1px solid lightgray;
  border: 0px !important;
  padding-left: 0px;
}
.newdesignadd .item-name {
  justify-content: flex-start !important;
}
.newdesignadd .item-name a {
  color: #5ea1d8;
}

.timer-wrap + h6 {
  margin-bottom: 15px;
}

.not-draggable {
  -webkit-user-drag: none;
  /* Safari/Chrome */
  /* Firefox */
  /* IE10+ */
  -webkit-user-select: none;
          user-select: none;
  /* Standard syntax */
  cursor: default;
  /* Optional: Change the cursor style */
  transform: translate(0, 0) !important;
}

.divscroll {
  width: 100% !important;
  display: flex;
  flex-direction: row;
  max-height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
}
.divscroll div {
  width: 100% !important;
}

.view-flow .container1 .viewflow-step .step-sec .img-wrap {
  flex: none !important;
}

@media (max-width: 767px) {
  .partOfBundle {
    padding: 0px 0px 20px 0px !important;
    margin-right: 0px !important;
  }
  .partOfBundle h2 {
    margin-top: 0px !important;
  }
  .view-flow .container1 .viewflow-step {
    margin-bottom: 10px !important;
  }
  .view-flow .partOfBundle h2 {
    margin-top: 15px !important;
  }
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner div:nth-child(4) {
  position: relative;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner div:nth-child(4) span {
  position: relative;
}

/*chatbot design*/
.chatbot-wrapper {
  position: fixed;
  bottom: 0px;
  right: 20px;
  padding: 20px;
  display: none;
  padding: 20px 0px 0px;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin: 0px 20px 0px 20px;
  border-radius: 10px 10px 0px 0px;
  max-width: 400px;
  width: 100%;
  box-sizing: border-box;
  z-index: 1002; /* Above translate element (1001) */
  flex-wrap: wrap;
  min-height: 400px;
  max-height: calc(100% - 120px);
  overflow-y: hidden;
  flex-direction: row;
}
.chatbot-wrapper:before {
  content: "";
  width: 100%;
  height: 31%;
  height: 124px;
  background: rgb(94, 161, 216) !important;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -1;
}
.chatbot-wrapper .chatbot-msg {
  padding: 0px 20px;
  width: 100%;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .flora-close {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  margin-bottom: 15px;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .flora-close h5 {
  color: #fff;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .welcome-text {
  color: #fff;
  margin-bottom: 15px;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .welcome-text h2 {
  color: #fff !important;
  font-size: 20px !important;
  margin-bottom: 10px !important;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .welcome-text p {
  color: #fff !important;
  font-weight: 400 !important;
  margin: 0px !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-width: 100%;
  overflow: hidden;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .image {
  margin-bottom: 20px;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .chabot-category {
  display: flex;
  flex-wrap: wrap;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .chabot-category ul {
  margin: 0px;
  margin-top: 10px !important;
  padding: 0px !important;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  background: transparent !important;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .chabot-category ul li {
  padding: 10px;
  background: rgb(94, 161, 216) !important;
  border-radius: 10px;
  border: 1px solid #ddd;
  margin: 0px;
  margin-right: 5px;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .chabot-category ul li a {
  color: #fff !important;
}
.chatbot-wrapper .chatbot-btn {
  width: 100%;
  cursor: pointer;
  margin-bottom: 0px;
  padding: 0px 0px 0px 20px;
  display: flex;
  align-items: end;
  justify-content: flex-end;
  flex: 1;
  margin-bottom: 10px;
}
.chatbot-wrapper .chatbot-btn img {
  width: 80px;
}
.chatbot-wrapper .chatbot-converasation {
  margin-bottom: 20px;
  padding: 0px 20px;
  width: 100%;
}
.chatbot-wrapper .chatbot-converasation .chat-user,
.chatbot-wrapper .chatbot-converasation .new-user {
  max-width: 75%;
  padding: 10px 10px;
  background: #f6f6f6;
  display: inline-flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  align-items: flex-start;
  position: relative;
  margin-left: 35px;
  border-radius: 5px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
}
.chatbot-wrapper .chatbot-converasation .chat-user p,
.chatbot-wrapper .chatbot-converasation .new-user p {
  margin: 0px !important;
}
.chatbot-wrapper .chatbot-converasation .chat-user:before,
.chatbot-wrapper .chatbot-converasation .new-user:before {
  content: "";
  background: url('chat-bot.png');
  background-repeat: no-repeat;
  background-size: contain;
  width: 30px;
  height: 30px;
  position: absolute;
  left: -35px;
  top: 50%;
  transform: translateY(-50%);
}
.chatbot-wrapper .chatbot-converasation .new-user {
  display: flex;
  justify-content: flex-end;
  float: right;
}
.chatbot-wrapper .chatbot-converasation .new-user:before {
  display: none;
}
.chatbot-wrapper .chatbot-stickyfooter {
  width: 100%;
  position: sticky;
  bottom: 0px;
  padding: 5px 20px;
  background: #5ea1d8;
  display: flex;
  height: 50px;
  z-index: 1003; /* Above chatbot wrapper and translate element */
}
.chatbot-wrapper .chatbot-stickyfooter .input {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: 10px;
}
.chatbot-wrapper .chatbot-stickyfooter .input input {
  width: 100%;
  border: 1px solid #000;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  left: 0px;
  height: 40px;
  border: 0px;
  padding-left: 30px;
  outline: none !important;
  z-index: 1004; /* Above everything including icons */
}
.chatbot-wrapper .chatbot-stickyfooter .input i {
  position: absolute;
  z-index: 1005; /* Above input field for clickability */
}
.chatbot-wrapper .chatbot-stickyfooter .mic {
  width: 40px;
  height: 100%;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chatbot-wrapper .no-flow-available {
  max-width: 720px;
  margin: 40px auto;
  padding: 24px 20px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  background: #fafafa;
  text-align: left;
}
.chatbot-wrapper .no-flow-available h2 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 700;
  color: #212427;
}
.chatbot-wrapper .no-flow-available p {
  margin: 0;
  font-size: 14px;
  color: #616161;
}

.scroll-div {
  min-height: 224px !important;
  overflow-y: scroll;
  padding-bottom: 0px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: end;
}

.sticky-chat {
  position: sticky;
  top: -20px;
  z-index: 1001; /* Above translate but below footer */
  padding: 10px;
  width: 100%;
  height: 104px;
}

.sticky-default {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10000;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  cursor: pointer;
}
.sticky-default img {
  width: 80px;
  height: 80px;
  object-fit: contain;
  display: block;
}
@media (max-width: 767px) {
  .sticky-default {
    bottom: 110px;
    right: 16px;
    width: 64px;
    height: 64px;
  }
  .sticky-default img {
    width: 64px;
    height: 64px;
  }
}

.chatbot-msg {
  height: 104px;
}

.scroll-div {
  max-height: 425px;
}
.scroll-div .chatbot-msg {
  height: auto !important;
}
.scroll-div .faq-list {
  padding: 0px 20px;
}

@media (max-width: 767px) {
  .chatbot-wrapper {
    display: none;
    position: fixed;
    bottom: 0px;
    right: 0px;
    padding: 20px;
    display: flex;
    padding: 20px 0px 0px;
    background: #fff;
    border: 1px solid #ddd;
    box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
    margin: 0px 20px 0px 20px;
    border-radius: 10px 10px 0px 0px;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    z-index: 1002 !important; /* Above translate element (1001) */
    flex-wrap: wrap;
    max-height: 90vh;
    /* Limits max height but allows it to expand */
    overflow-y: auto;
    /* Enables scrolling when needed */
    flex-direction: column;
    left: 0px;
    margin: 0px auto;
  }
  .chatbot-wrapper .chatbot-stickyfooter {
    display: flex !important;
    visibility: visible !important;
    position: sticky !important;
    bottom: 0 !important;
    width: 100% !important;
    z-index: 1003 !important; /* Above chatbot wrapper and translate element */
    background: #5ea1d8 !important;
    padding: 5px 20px !important;
    height: 50px !important;
    flex-shrink: 0 !important;
  }
  .chatbot-wrapper .chatbot-stickyfooter .input {
    display: flex !important;
    visibility: visible !important;
    width: 100% !important;
    position: relative !important;
    z-index: 1004 !important; /* Ensure input container is above translate */
  }
  .chatbot-wrapper .chatbot-stickyfooter .input input {
    display: block !important;
    visibility: visible !important;
    width: 100% !important;
    z-index: 1005 !important; /* Input field above everything */
    position: absolute !important; /* Keep absolute positioning for proper layout */
    left: 0px !important;
    height: 40px !important;
    padding-left: 30px !important;
  }
  .chatbot-wrapper .chatbot-stickyfooter .input i {
    z-index: 1006 !important; /* Icons above input for clickability */
    position: absolute !important;
  }
}
.flow-container {
  display: flex;
  gap: 20px;
}

/* Left: Expansion Panel */
.steps-panel {
  width: 100%;
}

mat-expansion-panel {
  background: #f8f9fa;
  margin-bottom: 5px;
}

mat-expansion-panel-header {
  font-weight: bold;
  color: white;
  cursor: pointer;
}

mat-expansion-panel-header:hover {
  background-color: rgba(200, 193, 193, 0.5);
}

/* Right: Step Content */
.step-content {
  width: 100%;
  padding-left: 10px;
}

.step-content h3 {
  margin-bottom: 10px;
}

.step-content video,
.step-content img {
  display: block;
  margin-top: 10px;
  border-radius: 5px;
}

.viewflow-step .flow-container {
  width: 100%;
}
.viewflow-step .description {
  width: 100%;
}

.viewflow-step .step-scroll {
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  display: flex;
}

.viewflow-step .steps-list {
  display: flex;
  gap: 5px;
  margin-bottom: 10px;
}
.viewflow-step .steps-list button {
  white-space: nowrap;
}

.group-header {
  display: flex;
  align-items: center;
  gap: 5px;
  /* Space between icon and text */
  margin-top: 10px;
  margin-left: 7px;
}

.keyword-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.keyword-container.less span {
  flex: unset !important;
}
.keyword-container.less span:nth-child(n+5) {
  display: none;
}
.keyword-container.less span:nth-last-child(-n+2) {
  display: inline;
}
.keyword-container.less .less-btn {
  display: none !important;
  width: 100% !important;
  flex: unset !important;
}
.keyword-container.more span {
  flex: unset !important;
}
.keyword-container.more span:nth-child(n+5) {
  display: inline;
}
.keyword-container.more span:nth-last-child(-n+2) {
  display: inline;
}
.keyword-container.more .more-btn {
  display: none !important;
  width: 100% !important;
  flex: unset !important;
}

.more-btn,
.less-btn {
  width: 100% !important;
  flex: unset !important;
  justify-content: flex-start !important;
}

span.showmore {
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.hashtag {
  font-family: "Montserrat", sans-serif !important;
  font-size: 12px;
  font-weight: bold;
  color: #5ea1d8;
  padding: 2px 6px;
  /* Reduced padding */
  border-radius: 12px;
  /* Optional: Makes it look like a pill */
  background: rgba(94, 161, 216, 0.1);
  /* Light background for visibility */
  display: inline-block;
  margin: 2px;
  /* Minimal spacing between hashtags */
}

.more-btn,
.less-btn {
  font-size: 12px;
  color: #888;
  cursor: pointer;
  margin-left: 4px;
  /* Ensures it stays close to last hashtag */
}

@media (max-width: 767px) {
  .view-flow {
    width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
    background: #ffffff;
  }
  .view-flow .container1,
  .view-flow .flow-layout-container,
  .view-flow .flow-layout-container .flow-main-grid,
  .view-flow .flow-layout-container .flow-main-content {
    width: 100vw !important;
    max-width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .view-flow .container1 .user-sec {
    padding: 16px !important;
    margin: 0 !important;
    border-radius: 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-grid {
    grid-template-columns: 1fr !important;
    gap: 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-content .flow-title-sticky {
    padding: 8px 16px 0 !important;
    margin: 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-content .completion-progress-card-mobile {
    padding: 0 !important;
    margin: 3px 0 4px 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-content .completion-progress-card-mobile .progress-step-row-mobile {
    padding: 0 16px !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-title-sticky {
    margin: 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar {
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 16px 12px 16px !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar .action-buttons {
    flex-wrap: nowrap !important;
    gap: 8px !important;
    width: max-content;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar .action-item {
    flex: 0 0 auto;
    min-width: 100px;
    padding: 6px 10px !important;
    gap: 6px !important;
    border-radius: 14px !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar .action-item mat-icon {
    font-size: 18px !important;
    width: 18px !important;
    height: 18px !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar .action-item span {
    font-size: 13px !important;
    font-weight: 500;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar .action-item .desktop-only-access-label {
    display: none !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar::-webkit-scrollbar {
    height: 4px;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
  .view-flow .flow-layout-container .flow-main-content .flow-info-panel,
  .view-flow .flow-layout-container .flow-main-content .video-metadata,
  .view-flow .flow-layout-container .flow-main-content .channel-info-section,
  .view-flow .flow-layout-container .flow-main-content .description-section,
  .view-flow .flow-layout-container .flow-main-content .comments-section {
    padding: 16px !important;
    margin: 0 !important;
    border-radius: 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-content .access-meta-label {
    font-weight: 600 !important;
    color: #1976d2 !important;
    background: #e8f4fc;
    border-radius: 999px;
    padding: 2px 8px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .view-flow .flow-layout-container .flow-main-content .video-player-section {
    margin: 0 !important;
    border-radius: 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-player-section .img-wrap {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-player-section .item {
    padding: 16px !important;
    margin: 0 !important;
  }
  .view-flow .flow-layout-container .flow-sidebar {
    display: none !important;
  }
}
/* Keep layout usable on common laptop resolutions without manual display scaling changes. */
@media (max-width: 1366px) {
  .view-flow .flow-layout-container .flow-main-grid {
    grid-template-columns: 1fr !important;
  }
  .view-flow .flow-sidebar {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
  }
  .view-flow .flow-sidebar .recommendations-section {
    display: none !important;
  }
  .view-flow .recommendations-section-mobile {
    display: block !important;
  }
}
.follow-btn:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
  animation: follow-spin 0.7s linear infinite;
  vertical-align: middle;
}

@keyframes follow-spin {
  to {
    transform: rotate(360deg);
  }
}
.carousel {
  width: 300px;
  height: 200px;
  background-color: #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  -webkit-user-select: none;
          user-select: none;
}

.slide {
  padding: 20px;
  font-weight: bold;
}

.step-header {
  display: flex;
  align-items: center; /* Vertically center all elements */
  gap: 8px; /* Space between elements */
  width: 100%;
}
.step-header .s-num {
  margin-bottom: 0px !important;
}
.step-header .share-icon {
  align-items: center !important;
}

.s-num {
  font-size: 16px; /* Adjust size as needed */
  font-weight: bold; /* Optional: make step number stand out */
  padding: 4px 8px; /* Optional: padding for better appearance */
}

.share-icon {
  font-size: 16px; /* Match font size for consistency */
  cursor: pointer; /* Indicate clickability */
  margin-left: auto; /* Push icon to the right */
}

mat-panel-title {
  display: flex;
  align-items: center; /* Vertically center elements */
  justify-content: space-between; /* Push share icon to the right */
  width: 100%; /* Ensure full width */
  margin-top: 10px;
}

.step-info {
  margin-top: 5px !important;
  display: flex;
  align-items: center;
  align-items: flex-start; /* Align content to the left */
  gap: 8px; /* Space between step number and title */
}

.step-number {
  display: flex;
  font-size: 16px; /* Adjust as needed */
  font-weight: bold; /* Optional: emphasize step number */
}

.step-title {
  font-size: 16px; /* Match your h3 or desired size */
  flex-grow: 1; /* Allow title to take available space */
  white-space: normal; /* Allow title to wrap to the next line */
  display: block; /* Ensure it takes the full width and moves to the next line */
}

.share-icon {
  font-size: 16px; /* Match text size */
  cursor: pointer; /* Indicate clickability */
  vertical-align: middle; /* Align with text */
}

.copy-link-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  gap: 2px;
}
.copy-link-container .copy-link-text {
  font-size: 9px;
  line-height: 1.2;
  white-space: nowrap;
}
@media (min-width: 769px) {
  .copy-link-container .copy-link-text {
    font-size: 10px;
  }
}

/* Default (light theme) tick colors */
.view-flow .current-step-tick {
  color: #ffffff !important;
}

.view-flow .visited-step-tick {
  color: #5ea1d8 !important;
}

.view-flow .step-bookmark-icon,
.view-flow .flow-info-panel .info-badge-bookmark-btn mat-icon.bookmarked {
  color: #5ea1d8 !important;
}

.view-flow .flow-info-panel .info-badge.active .info-badge-bookmark-btn mat-icon.bookmarked {
  color: #ffffff !important;
}

mat-expansion-panel-header {
  min-height: 48px; /* Default height, but allows growing */
  height: auto; /* Allow dynamic height based on content */
  align-items: flex-start; /* Align content to the top for better wrapping */
  padding: 0 16px; /* Adjust padding if needed (default Material padding) */
}

/* Override mat-expansion-panel-header for both collapsed and expanded states */
:host ::ng-deep mat-expansion-panel-header {
  min-height: 48px; /* Default height, but allows growing */
  height: auto; /* Dynamic height based on content */
  align-items: flex-start; /* Align content to the top */
  padding: 0 16px; /* Default Material padding, adjust if needed */
}

/* Ensure expanded state also respects dynamic height */
:host ::ng-deep .mat-expansion-panel-header.mat-expanded {
  min-height: 48px; /* Allow growing in expanded state */
  height: auto; /* Dynamic height */
  align-items: flex-start; /* Align content to the top */
}

.tagged-items-section {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.tagged-items-section ::ng-deep .mat-mdc-chip-set {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.tagged-items-section ::ng-deep .mat-mdc-chip {
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #e3f2fd !important;
  color: #1d67a3 !important;
  position: relative;
  padding-right: 8px !important;
}
.tagged-items-section ::ng-deep .mat-mdc-chip:hover {
  background-color: #bbdefb !important;
  transform: scale(1.05);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button {
  opacity: 0.7;
  transition: opacity 0.2s ease;
  color: #1d67a3 !important;
  padding: 0 !important;
  margin-left: 4px !important;
}
.tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button:hover {
  opacity: 1;
  background-color: rgba(29, 103, 163, 0.1) !important;
}
.tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button mat-icon {
  color: #1d67a3 !important;
}

/* Version preview: show "not available" message in header/body */
.preview-unavailable {
  margin-top: 6px;
  font-size: 12px;
  color: #b71c1c;
  font-weight: 600;
}

.preview-unavailable-body {
  padding: 16px;
  border: 1px solid rgba(183, 28, 28, 0.2);
  background: rgba(183, 28, 28, 0.05);
  border-radius: 10px;
  margin-bottom: 16px;
}

/* Force dark mode for View Flow page internals */
:host-context(body.theme-dark) {
  /* Requested: keep text black in light/blue boxes on dark mode */
  /* Tick icon colors are controlled inline in template per state:
     current = pink, visited = white */
  /* Dark mode tick colors by panel context */
  /* Keep flow-info-panel ticks in light-mode colors on all viewports in dark mode. */
  /* Right step-list scrollbar styling in dark mode */
  /* Match dark-mode action-panel scrollbar style used on view-bundle */
  /*
   * Items required (#itemsRequired / selectedStepIndex -1): parent
   * .video-player-section forces color: #fff; .example-list stays white so
   * group headers (h6) inherit white-on-white. Rows also fight global .view-flow span { color: #fff }.
   */
  /* Mobile: base \`.view-flow\` block forces white page bg on ≤767px.
     Re-apply dark surfaces so mobile dark mode matches desktop dark mode. */
}
:host-context(body.theme-dark) .view-flow,
:host-context(body.theme-dark) .view-flow .container1,
:host-context(body.theme-dark) .view-flow .flow-layout-container,
:host-context(body.theme-dark) .view-flow .flow-main-grid,
:host-context(body.theme-dark) .view-flow .flow-main-content,
:host-context(body.theme-dark) .view-flow .video-player-section,
:host-context(body.theme-dark) .view-flow .video-metadata,
:host-context(body.theme-dark) .view-flow .channel-info-section,
:host-context(body.theme-dark) .view-flow .description-section,
:host-context(body.theme-dark) .view-flow .supporting-docs-section,
:host-context(body.theme-dark) .view-flow .featured-in-blogs-section,
:host-context(body.theme-dark) .view-flow .comments-section,
:host-context(body.theme-dark) .view-flow .flow-sidebar,
:host-context(body.theme-dark) .view-flow .recommendations-section,
:host-context(body.theme-dark) .view-flow .step-navigation,
:host-context(body.theme-dark) .view-flow .step-scroll,
:host-context(body.theme-dark) .view-flow .steps-list,
:host-context(body.theme-dark) .view-flow .flow-info-panel,
:host-context(body.theme-dark) .view-flow .completion-progress-card-desktop,
:host-context(body.theme-dark) .view-flow .completion-progress-card-mobile {
  background: #0a0c10 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .view-flow .flow-title-sticky,
:host-context(body.theme-dark) .view-flow .flow-info-panel,
:host-context(body.theme-dark) .view-flow .step-panel-body,
:host-context(body.theme-dark) .view-flow .recommendation-item,
:host-context(body.theme-dark) .view-flow .comment-item,
:host-context(body.theme-dark) .view-flow .comment-input,
:host-context(body.theme-dark) .view-flow .reply-input {
  background: #111827 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .view-flow .step-btn {
  background: #111827 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .step-btn.active,
:host-context(body.theme-dark) .view-flow .step-panel.active .step-btn {
  background: #5ea1d8 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow h1,
:host-context(body.theme-dark) .view-flow h2,
:host-context(body.theme-dark) .view-flow h3,
:host-context(body.theme-dark) .view-flow h4,
:host-context(body.theme-dark) .view-flow h5,
:host-context(body.theme-dark) .view-flow p,
:host-context(body.theme-dark) .view-flow span,
:host-context(body.theme-dark) .view-flow label,
:host-context(body.theme-dark) .view-flow a,
:host-context(body.theme-dark) .view-flow .channel-name,
:host-context(body.theme-dark) .view-flow .channel-meta,
:host-context(body.theme-dark) .view-flow .recommendation-title,
:host-context(body.theme-dark) .view-flow .recommendation-meta,
:host-context(body.theme-dark) .view-flow .comment-text,
:host-context(body.theme-dark) .view-flow .comment-author-name,
:host-context(body.theme-dark) .view-flow .comment-date {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .collab-sep {
  color: #6b7280 !important;
}
:host-context(body.theme-dark) .view-flow .collab-coname {
  color: #9ca3af !important;
}
:host-context(body.theme-dark) .view-flow .collab-coname:hover {
  text-decoration: underline;
}
:host-context(body.theme-dark) .view-flow .collab-extra-count-text {
  color: #6b7280 !important;
}
:host-context(body.theme-dark) .view-flow .collab-extra-count-text:hover {
  text-decoration: underline;
}
:host-context(body.theme-dark) .view-flow .rec-owner-name:hover {
  text-decoration: underline;
}
:host-context(body.theme-dark) .view-flow .comment-input::placeholder,
:host-context(body.theme-dark) .view-flow .reply-input::placeholder {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .view-flow .comment-guidelines-helper {
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) .view-flow .comment-guidelines-link {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow .comment-guidelines-link:hover {
  color: #60a5fa !important;
}
:host-context(body.theme-dark) .view-flow .autoplay-toggle .toggle-track {
  background: #334155 !important;
}
:host-context(body.theme-dark) .view-flow .autoplay-toggle .toggle-track.active {
  background: #e83e8c !important;
}
:host-context(body.theme-dark) .view-flow .autoplay-toggle .toggle-thumb {
  background: #f3f4f6 !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5) !important;
}
:host-context(body.theme-dark) .view-flow .autoplay-toggle .toggle-thumb .thumb-icon,
:host-context(body.theme-dark) .view-flow .autoplay-toggle .thumb-icon {
  color: #1e3a5f !important;
}
:host-context(body.theme-dark) .view-flow .flow-info-panel .info-badge,
:host-context(body.theme-dark) .view-flow .flow-info-panel .info-badge .info-label,
:host-context(body.theme-dark) .view-flow .flow-info-panel .info-badge .info-step-title {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .flow-info-panel .info-badge {
  background: #111827 !important;
}
:host-context(body.theme-dark) .view-flow .flow-info-panel .info-badge.active {
  background: #1b2437 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .flow-info-panel .info-badge-bookmark-btn {
  color: #9ca3af !important;
}
:host-context(body.theme-dark) .view-flow .flow-info-panel .info-badge-bookmark-btn mat-icon.bookmarked,
:host-context(body.theme-dark) .view-flow .flow-info-panel .info-badge.active .info-badge-bookmark-btn mat-icon.bookmarked {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .view-flow .flow-info-panel .info-badge-bookmark-btn:hover {
  background: rgba(94, 161, 216, 0.18) !important;
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .view-flow .step-navigation .step-btn,
:host-context(body.theme-dark) .view-flow .step-navigation .step-btn .step-title-text,
:host-context(body.theme-dark) .view-flow .step-navigation .step-btn .step-number,
:host-context(body.theme-dark) .view-flow .step-navigation .step-btn mat-icon {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .step-navigation .step-btn {
  background: #111827 !important;
}
:host-context(body.theme-dark) .view-flow .step-navigation .step-btn.active,
:host-context(body.theme-dark) .view-flow .step-navigation .step-panel.active .step-btn {
  background: #1b2437 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .video-actions-bar .action-item,
:host-context(body.theme-dark) .view-flow .video-actions-bar .action-item > span,
:host-context(body.theme-dark) .view-flow .video-actions-bar .action-item > mat-icon {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .flow-unique-code-value {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .view-flow .video-actions-bar .action-item.delete-action,
:host-context(body.theme-dark) .view-flow .video-actions-bar .action-item.delete-action span,
:host-context(body.theme-dark) .view-flow .video-actions-bar .action-item.delete-action mat-icon {
  color: #d32f2f !important;
}
:host-context(body.theme-dark) .view-flow .video-actions-bar .action-item .favorite-toggle-icon.liked,
:host-context(body.theme-dark) .view-flow .video-actions-bar .action-item.liked .favorite-toggle-icon,
:host-context(body.theme-dark) .view-flow .video-actions-bar .action-item .favorite-toggle-icon.liked mat-icon {
  color: #ff4d4d !important;
}
:host-context(body.theme-dark) .view-flow .video-actions-bar .action-item {
  background: #111827 !important;
  border: 1px solid rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .view-flow .video-actions-bar .action-item:hover {
  background: #1b2437 !important;
}
:host-context(body.theme-dark) .view-flow .step-navigation .current-step-tick {
  color: #e83e8c !important;
}
:host-context(body.theme-dark) .view-flow .step-navigation .visited-step-tick {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .flow-info-panel .current-step-tick {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .flow-info-panel .visited-step-tick {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .view-flow .flow-info-panel .current-step-tick,
:host-context(body.theme-dark) .view-flow .flow-info-panel .visited-step-tick {
  opacity: 1 !important;
  filter: none !important;
}
:host-context(body.theme-dark) .view-flow .step-navigation .step-scroll {
  scrollbar-width: thin;
  scrollbar-color: #5ea1d8 #1f2937;
}
:host-context(body.theme-dark) .view-flow .step-navigation .step-scroll::-webkit-scrollbar {
  width: 10px;
}
:host-context(body.theme-dark) .view-flow .step-navigation .step-scroll::-webkit-scrollbar-track {
  background: #1f2937;
  border-radius: 10px;
}
:host-context(body.theme-dark) .view-flow .step-navigation .step-scroll::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #5ea1d8 0%, #e83e8c 100%);
  border-radius: 10px;
  border: 2px solid #1f2937;
}
:host-context(body.theme-dark) .view-flow .step-navigation .step-scroll::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #4a8fc4 0%, #cf2f79 100%);
}
:host-context(body.theme-dark) .view-flow .video-actions-bar::-webkit-scrollbar-thumb,
:host-context(body.theme-dark) .view-flow .comment-actions::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.55) !important;
}
:host-context(body.theme-dark) .view-flow .video-actions-bar::-webkit-scrollbar-thumb:hover {
  background: rgba(148, 163, 184, 0.75) !important;
}
:host-context(body.theme-dark) .view-flow .video-player-section .item,
:host-context(body.theme-dark) .view-flow .video-player-section .item > div,
:host-context(body.theme-dark) .view-flow .video-player-section .item-table,
:host-context(body.theme-dark) .view-flow .video-player-section .example-list {
  background: #1f2937 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .view-flow .video-player-section .example-list h6,
:host-context(body.theme-dark) .view-flow .video-player-section .example-list .group-header,
:host-context(body.theme-dark) .view-flow .video-player-section .example-list .group-header b {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .view-flow .video-player-section .example-list .group-header mat-icon {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .view-flow .video-player-section .example-list .example-box,
:host-context(body.theme-dark) .view-flow .video-player-section .example-box {
  background: #1f2937 !important;
  border-bottom-color: rgba(148, 163, 184, 0.28) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .view-flow .video-player-section .example-list .example-box > *,
:host-context(body.theme-dark) .view-flow .video-player-section .example-box > * {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .view-flow .video-player-section .example-list .example-box span,
:host-context(body.theme-dark) .view-flow .video-player-section .example-box span,
:host-context(body.theme-dark) .view-flow .video-player-section .example-list .example-box .item-value,
:host-context(body.theme-dark) .view-flow .video-player-section .example-box .item-value {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .view-flow .video-player-section .example-list .example-box a,
:host-context(body.theme-dark) .view-flow .video-player-section .example-box a {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow .video-player-section .example-list .example-box.itemremove span,
:host-context(body.theme-dark) .view-flow .video-player-section .example-box.itemremove span {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .view-flow .video-player-section .item-table hr {
  border-color: rgba(148, 163, 184, 0.28) !important;
}
@media (max-width: 767px) {
  :host-context(body.theme-dark) .view-flow {
    background: #0a0c10 !important;
  }
  :host-context(body.theme-dark) .view-flow .container1,
  :host-context(body.theme-dark) .view-flow .flow-layout-container,
  :host-context(body.theme-dark) .view-flow .flow-main-grid,
  :host-context(body.theme-dark) .view-flow .flow-main-content {
    background: transparent !important;
  }
  :host-context(body.theme-dark) .view-flow .flow-layout-container .flow-main-content .video-metadata,
  :host-context(body.theme-dark) .view-flow .flow-layout-container .flow-main-content .channel-info-section,
  :host-context(body.theme-dark) .view-flow .flow-layout-container .flow-main-content .description-section,
  :host-context(body.theme-dark) .view-flow .flow-layout-container .flow-main-content .supporting-docs-section,
  :host-context(body.theme-dark) .view-flow .flow-layout-container .flow-main-content .featured-in-blogs-section,
  :host-context(body.theme-dark) .view-flow .flow-layout-container .flow-main-content .flow-info-panel,
  :host-context(body.theme-dark) .view-flow .flow-layout-container .flow-main-content .comments-section {
    background: #111827 !important;
  }
  :host-context(body.theme-dark) .view-flow .flow-title-sticky {
    background: #111827 !important;
  }
  :host-context(body.theme-dark) .view-flow .video-player-section,
  :host-context(body.theme-dark) .view-flow .video-player-section .img-wrap {
    background: #020617 !important;
  }
  :host-context(body.theme-dark) .view-flow .video-actions-bar .action-item {
    background: #111827 !important;
    border: 1px solid rgba(148, 163, 184, 0.28) !important;
  }
  :host-context(body.theme-dark) .view-flow .video-actions-bar .action-item > span,
  :host-context(body.theme-dark) .view-flow .video-actions-bar .action-item > mat-icon {
    color: #ffffff !important;
  }
  :host-context(body.theme-dark) .view-flow .video-actions-bar .action-item.delete-action,
  :host-context(body.theme-dark) .view-flow .video-actions-bar .action-item.delete-action span,
  :host-context(body.theme-dark) .view-flow .video-actions-bar .action-item.delete-action mat-icon {
    color: #d32f2f !important;
  }
  :host-context(body.theme-dark) .view-flow .recommendations-section-mobile {
    background: transparent !important;
  }
  :host-context(body.theme-dark) .view-flow .recommendations-section-mobile .recommendation-item {
    background: #111827 !important;
    border: 1px solid rgba(148, 163, 184, 0.24) !important;
    color: #ffffff !important;
  }
  :host-context(body.theme-dark) .view-flow h1,
  :host-context(body.theme-dark) .view-flow h2,
  :host-context(body.theme-dark) .view-flow h3,
  :host-context(body.theme-dark) .view-flow h4,
  :host-context(body.theme-dark) .view-flow h5,
  :host-context(body.theme-dark) .view-flow h6,
  :host-context(body.theme-dark) .view-flow p,
  :host-context(body.theme-dark) .view-flow span,
  :host-context(body.theme-dark) .view-flow label {
    color: #ffffff !important;
  }
}

/* View Flow - section-wise dark mode patch */
:host-context(body.theme-dark) {
  /* Remove unnecessary wrappers backgrounds */
  /* Section-wise cards */
  /* No bundle state: don't paint a block behind "Part of bundle(s)" area */
  /* Keep media panel dark but distinct */
  /* Section headings and text visibility */
  /* Safety step icon — override the generic span white rule above.
     Extra selectors raise specificity above .view-flow span !important */
  /* Access badges — keep kind colors (text + icon) in dark mode */
  /* Description content: explicit color needed because the div has its own
     color: #0f0f0f rule that isn't inherited from the parent's dark override */
  /* Preserve link colours inside description in dark mode */
  /* Description header h3 and duration timer */
  /* Supporting docs section — header and link */
  /* Version tag: light grey bg becomes invisible against dark sections; use dark blue chip. */
  /* Purchased tag: same issue — light grey bg needs a dark surface override. */
  /* Copy-link icon (step / items link) — override grey with white in dark mode */
  /* Version preview dialog header — dark mode */
  /* ── Progress bar — dark mode ─────────────────────────────────────────────
     The track uses both CSS classes and [ngStyle] inline bindings.
     !important beats inline styles, so these overrides cover both paths.
     ─────────────────────────────────────────────────────────────────────── */
  /* Card wrappers */
  /* Progress track (the grey rail) */
  /* Restarted-after-completion — soft blue track becomes a dark blue tint */
  /* Fill bar — keep the blue gradient, it reads well on dark */
  /* Percentage text inside the fill */
  /* "0%" label shown when fill is empty */
  /* "Step X of Y" text below the bar */
  /* Completion code badge (pill) */
  /* Sidebar-card variant header + stats */
  /* Step navigation sidebar — step title text is explicitly #606060 in light
     mode; override it here so it is readable on the dark #111827 button. */
  /* Safety instructions block — keep the red/amber theme in dark mode,
     matching the light-mode appearance (red border, icon, title + warm text). */
  /* Inline amber colour used on the main-view safety description (#856404
     would be unreadable on a dark background). */
  /* Generic dark-text overrides for non-safety elements in the step panel. */
  /* Tagged items chips shown inside the step panel body — Material chip
     defaults keep a light grey background, making white text invisible. */
  /* Mobile step description div (color: #4a5568) is not a span/p so it
     doesn't get covered by the generic span/p white rule. */
  /* step-description inner content — [innerHTML] content may carry inline
     dark colours; override everything inside. */
  /* Follow button — dark mode: keep non-following state as-is (blue), update
     following state so light-grey bg doesn't appear washed out on dark surface. */
  /* ── Rating & Reviews section dark mode ─────────────────────────────────── */
  /* Rating summary card: white background → dark surface */
  /* Keep golden filled stars in dark mode (overrides .view-flow span { color: #fff }) */
  /* Empty/base stars: visible mid-grey instead of white */
  /* "All ratings" info button — keep golden */
  /* Review cards */
  /* Mobile: also restore golden stars in the media-query override block */
}
:host-context(body.theme-dark) .view-flow {
  background: #0a0c10 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .container1,
:host-context(body.theme-dark) .view-flow .flow-layout-container,
:host-context(body.theme-dark) .view-flow .flow-main-grid,
:host-context(body.theme-dark) .view-flow .flow-main-content {
  background: transparent !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .view-flow .flow-title-sticky,
:host-context(body.theme-dark) .view-flow .flow-info-panel,
:host-context(body.theme-dark) .view-flow .video-metadata,
:host-context(body.theme-dark) .view-flow .channel-info-section,
:host-context(body.theme-dark) .view-flow .description-section,
:host-context(body.theme-dark) .view-flow .supporting-docs-section,
:host-context(body.theme-dark) .view-flow .featured-in-blogs-section,
:host-context(body.theme-dark) .view-flow .comments-section,
:host-context(body.theme-dark) .view-flow .flow-sidebar,
:host-context(body.theme-dark) .view-flow .step-navigation,
:host-context(body.theme-dark) .view-flow .recommendations-section,
:host-context(body.theme-dark) .view-flow .recommendation-item,
:host-context(body.theme-dark) .view-flow .comment-item,
:host-context(body.theme-dark) .view-flow .comment-input,
:host-context(body.theme-dark) .view-flow .reply-input,
:host-context(body.theme-dark) .view-flow .step-panel-body {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .view-flow .flow-sidebar,
:host-context(body.theme-dark) .view-flow .recommendations-section:not(.featured-in-blogs-section),
:host-context(body.theme-dark) .view-flow .recommendations-section-mobile {
  background: transparent !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .view-flow .featured-in-blogs-section {
  background: #111827 !important;
}
:host-context(body.theme-dark) .view-flow .featured-in-blogs-section h2,
:host-context(body.theme-dark) .view-flow .featured-in-blogs-section .recommendation-title {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .view-flow .featured-in-blogs-section .recommendation-meta,
:host-context(body.theme-dark) .view-flow .featured-in-blogs-section .recommendation-creator {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .view-flow .featured-in-blogs-section .recommendation-item:hover {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .view-flow .video-player-section,
:host-context(body.theme-dark) .view-flow .video-player-section .img-wrap {
  background: #020617 !important;
}
:host-context(body.theme-dark) .view-flow h1,
:host-context(body.theme-dark) .view-flow h2,
:host-context(body.theme-dark) .view-flow h3,
:host-context(body.theme-dark) .view-flow h4,
:host-context(body.theme-dark) .view-flow h5,
:host-context(body.theme-dark) .view-flow h6,
:host-context(body.theme-dark) .view-flow p,
:host-context(body.theme-dark) .view-flow span,
:host-context(body.theme-dark) .view-flow label,
:host-context(body.theme-dark) .view-flow .channel-name,
:host-context(body.theme-dark) .view-flow .channel-meta,
:host-context(body.theme-dark) .view-flow .video-title,
:host-context(body.theme-dark) .view-flow .video-title-sticky,
:host-context(body.theme-dark) .view-flow .recommendation-title,
:host-context(body.theme-dark) .view-flow .recommendation-meta,
:host-context(body.theme-dark) .view-flow .step-title-text,
:host-context(body.theme-dark) .view-flow .step-description,
:host-context(body.theme-dark) .view-flow .comment-text,
:host-context(body.theme-dark) .view-flow .comment-author-name,
:host-context(body.theme-dark) .view-flow .comment-date {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .video-metadata .step-header-main span.safety-step-icon {
  color: #ef9a9a !important;
}
:host-context(body.theme-dark) .view-flow .flow-access-badge.kind-public,
:host-context(body.theme-dark) .view-flow .flow-access-badge.kind-public mat-icon {
  color: #ccfbf1 !important;
}
:host-context(body.theme-dark) .view-flow .flow-access-badge.kind-public {
  background: #0f766e !important;
}
:host-context(body.theme-dark) .view-flow .flow-access-badge.kind-private,
:host-context(body.theme-dark) .view-flow .flow-access-badge.kind-private mat-icon {
  color: #ffedd5 !important;
}
:host-context(body.theme-dark) .view-flow .flow-access-badge.kind-private {
  background: #9a3412 !important;
}
:host-context(body.theme-dark) .view-flow .flow-access-badge.kind-private-link,
:host-context(body.theme-dark) .view-flow .flow-access-badge.kind-private-link mat-icon {
  color: #dbeafe !important;
}
:host-context(body.theme-dark) .view-flow .flow-access-badge.kind-private-link {
  background: #1d4ed8 !important;
}
:host-context(body.theme-dark) .view-flow .flow-access-badge.kind-restricted,
:host-context(body.theme-dark) .view-flow .flow-access-badge.kind-restricted mat-icon {
  color: #ede9fe !important;
}
:host-context(body.theme-dark) .view-flow .flow-access-badge.kind-restricted {
  background: #6d28d9 !important;
}
:host-context(body.theme-dark) .view-flow .flow-access-badge em {
  color: inherit !important;
  background: rgba(15, 23, 42, 0.45) !important;
}
:host-context(body.theme-dark) .view-flow .description-section .description-content,
:host-context(body.theme-dark) .view-flow .description-section .description-content * {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .view-flow .description-section .description-content a {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow .description-section .description-header h3,
:host-context(body.theme-dark) .view-flow .description-section .description-header .duration-timer {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .view-flow .supporting-docs-section .supporting-docs-header h3,
:host-context(body.theme-dark) .view-flow .supporting-docs-section .supporting-docs-header h3 .supporting-docs-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .view-flow .supporting-docs-section .supportingdoc,
:host-context(body.theme-dark) .view-flow .supporting-docs-section .supportingdoc mat-icon {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow .version-tag {
  background: #1e3a5f !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow .version-tag mat-icon {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow .version-tag:hover {
  background: #243f6a !important;
}
:host-context(body.theme-dark) .view-flow .purchased-tag {
  color: #cbd5e1 !important;
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .view-flow .copy-link-container .share-icon,
:host-context(body.theme-dark) .view-flow .copy-link-container .share-icon svg,
:host-context(body.theme-dark) .view-flow .copy-link-container .share-icon svg path {
  color: #ffffff !important;
  fill: currentColor !important;
}
:host-context(body.theme-dark) .view-flow .copy-link-container .copy-link-text {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .preview-dialog-header,
:host-context(body.theme-dark) .preview-dialog-header {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .view-flow .preview-dialog-header h2,
:host-context(body.theme-dark) .preview-dialog-header h2 {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .view-flow .preview-dialog-header .version-badge,
:host-context(body.theme-dark) .preview-dialog-header .version-badge {
  background-color: #1e3a5f !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow .preview-dialog-header .version-badge mat-icon,
:host-context(body.theme-dark) .preview-dialog-header .version-badge mat-icon {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow .preview-dialog-header .preview-unique-code,
:host-context(body.theme-dark) .preview-dialog-header .preview-unique-code {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .view-flow .preview-dialog-header .preview-unique-code-label,
:host-context(body.theme-dark) .view-flow .preview-dialog-header .preview-unique-code-value,
:host-context(body.theme-dark) .preview-dialog-header .preview-unique-code-label,
:host-context(body.theme-dark) .preview-dialog-header .preview-unique-code-value {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .view-flow .preview-dialog-header .close-button,
:host-context(body.theme-dark) .view-flow .preview-dialog-header .close-button mat-icon,
:host-context(body.theme-dark) .preview-dialog-header .close-button,
:host-context(body.theme-dark) .preview-dialog-header .close-button mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .view-flow .preview-dialog-header .close-button:hover,
:host-context(body.theme-dark) .preview-dialog-header .close-button:hover {
  color: #e2e8f0 !important;
  background: rgba(148, 163, 184, 0.12) !important;
}
:host-context(body.theme-dark) .view-flow .preview-unavailable,
:host-context(body.theme-dark) .preview-unavailable {
  color: #f87171 !important;
}
:host-context(body.theme-dark) .view-flow .completion-progress-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .view-flow .completion-progress-bar-desktop,
:host-context(body.theme-dark) .view-flow .completion-progress-bar-mobile,
:host-context(body.theme-dark) .view-flow .completion-progress-bar {
  background-color: #1f2937 !important;
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .view-flow .completion-progress-card-desktop.restarted .completion-progress-bar-desktop,
:host-context(body.theme-dark) .view-flow .completion-progress-card-mobile.restarted .completion-progress-bar-mobile {
  background-color: #1e3a5f !important;
  background: #1e3a5f !important;
}
:host-context(body.theme-dark) .view-flow .completion-progress-fill-desktop,
:host-context(body.theme-dark) .view-flow .completion-progress-fill-mobile,
:host-context(body.theme-dark) .view-flow .completion-progress-fill {
  background: linear-gradient(90deg, #5ea1d8 0%, #6bb3e8 100%) !important;
}
:host-context(body.theme-dark) .view-flow .progress-bar-percentage-desktop,
:host-context(body.theme-dark) .view-flow .progress-bar-percentage-mobile,
:host-context(body.theme-dark) .view-flow .progress-bar-percentage {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow .progress-bar-percentage-empty-desktop,
:host-context(body.theme-dark) .view-flow .progress-bar-percentage-empty-mobile,
:host-context(body.theme-dark) .view-flow .progress-bar-percentage-empty {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .view-flow .progress-step-info-desktop,
:host-context(body.theme-dark) .view-flow .progress-step-info-mobile {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .view-flow .completion-code-badge {
  background-color: #1e3a5f !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow .completion-progress-header,
:host-context(body.theme-dark) .view-flow .completion-progress-title {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .view-flow .completion-percentage {
  color: #4ade80 !important;
}
:host-context(body.theme-dark) .view-flow .completion-stats {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .view-flow .step-navigation .step-btn .info-step-title,
:host-context(body.theme-dark) .view-flow .step-navigation .step-btn .info-label {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .view-flow .step-panel-body .safety-instructions-description,
:host-context(body.theme-dark) .view-flow .step-panel-body .safety-instructions-description *,
:host-context(body.theme-dark) .view-flow .flow-main-content .safety-instructions-description,
:host-context(body.theme-dark) .view-flow .flow-main-content .safety-instructions-description * {
  color: #ef9a9a !important;
}
:host-context(body.theme-dark) .view-flow .flow-main-content [style*="color: #856404"],
:host-context(body.theme-dark) .view-flow .flow-main-content [style*="color:#856404"] {
  color: #ef9a9a !important;
}
:host-context(body.theme-dark) .view-flow .step-panel-body [style*="color: #333"],
:host-context(body.theme-dark) .view-flow .step-panel-body [style*="color:#333"]:not(.safety-instructions-description) {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .view-flow mat-chip-option,
:host-context(body.theme-dark) .view-flow .mat-mdc-chip.mat-mdc-chip-option {
  --mdc-chip-elevated-container-color: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .view-flow mat-chip-option span,
:host-context(body.theme-dark) .view-flow .mat-mdc-chip.mat-mdc-chip-option span,
:host-context(body.theme-dark) .view-flow .mat-mdc-chip.mat-mdc-chip-option .mat-mdc-chip-action-label,
:host-context(body.theme-dark) .view-flow .mat-mdc-chip.mat-mdc-chip-option mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .view-flow .mobile-step-description,
:host-context(body.theme-dark) .view-flow .mobile-step-description * {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .view-flow .step-panel-body .step-description,
:host-context(body.theme-dark) .view-flow .step-panel-body .step-description * {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .view-flow .channel-actions .follow-btn:not(.following) {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border: none !important;
}
:host-context(body.theme-dark) .view-flow .channel-actions .follow-btn.following {
  background: #1e3a5f !important;
  color: #93c5fd !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .view-flow .rating-summary-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4) !important;
}
:host-context(body.theme-dark) .view-flow .rating-summary-card .rating-number {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .view-flow .rating-summary-card .rating-count-text {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .view-flow .rating-summary-card .rating-label,
:host-context(body.theme-dark) .view-flow .rating-summary-card .rating-percent {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .view-flow .rating-summary-card .rating-bar-bg {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .view-flow .rating-star-icon.filled-star,
:host-context(body.theme-dark) .view-flow .rating-star-icon.partial-star,
:host-context(body.theme-dark) .view-flow .review-star-icon.filled-star {
  color: #ffc107 !important;
}
:host-context(body.theme-dark) .view-flow .rating-star-icon:not(.filled-star):not(.partial-star),
:host-context(body.theme-dark) .view-flow .rating-star-icon.star-empty-overlay,
:host-context(body.theme-dark) .view-flow .review-star-icon:not(.filled-star) {
  color: #4b5563 !important;
}
:host-context(body.theme-dark) .view-flow .ratings-info-btn {
  color: #ffc107 !important;
}
:host-context(body.theme-dark) .view-flow .review-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .view-flow .review-card .reviewer-name {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .view-flow .review-card .review-date,
:host-context(body.theme-dark) .view-flow .review-card .verified-badge {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .view-flow .review-card .review-card-title {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .view-flow .review-card .review-card-body {
  color: #cbd5e1 !important;
}
@media (max-width: 767px) {
  :host-context(body.theme-dark) .view-flow .rating-star-icon.filled-star,
  :host-context(body.theme-dark) .view-flow .rating-star-icon.partial-star,
  :host-context(body.theme-dark) .view-flow .review-star-icon.filled-star {
    color: #ffc107 !important;
  }
  :host-context(body.theme-dark) .view-flow .rating-star-icon:not(.filled-star):not(.partial-star),
  :host-context(body.theme-dark) .view-flow .rating-star-icon.star-empty-overlay,
  :host-context(body.theme-dark) .view-flow .review-star-icon:not(.filled-star) {
    color: #4b5563 !important;
  }
}

/* ── Skeleton loader: dark-mode overrides ─────────────────────────────────── */
:host-context(body.theme-dark) .skeleton-viewflow-container {
  --skeleton-gradient: linear-gradient(
    110deg,
    #334155 8%,
    #64748b 18%,
    #334155 33%
  );
  background: #0a0c10 !important;
  /* Card panels */
  /* Flow header bar */
  /* Right sidebar: step navigation buttons */
  /* Right sidebar: transparent containers */
  /* All shimmer elements: high-contrast gradient so they are clearly visible */
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-card {
  background: #1e293b !important;
  box-shadow: none !important;
  border: 1px solid rgba(148, 163, 184, 0.15) !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-flow-header {
  background: #1e293b !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
  /* Info panel strip */
  /* Individual badge pills */
  /* Toggle thumb – keep it visible against the dark track */
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-flow-header.skeleton-info-panel {
  background: #243040 !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-flow-header .info-badge {
  background: #334155 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-flow-header .autoplay-toggle .toggle-track {
  background: #334155 !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-flow-header .autoplay-toggle .toggle-track .toggle-thumb {
  background: #64748b !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .step-navigation .step-btn,
:host-context(body.theme-dark) .skeleton-viewflow-container .step-navigation .step-btn.skeleton-step-btn {
  background: #334155 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .step-navigation,
:host-context(body.theme-dark) .skeleton-viewflow-container .step-scroll,
:host-context(body.theme-dark) .skeleton-viewflow-container .steps-list,
:host-context(body.theme-dark) .skeleton-viewflow-container .recommendations-section,
:host-context(body.theme-dark) .skeleton-viewflow-container .recommendation-item {
  background: transparent !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-text,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-avatar,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-icon,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-image {
  background-color: #334155 !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-image::after {
  background-color: #334155 !important;
}

.flow-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.sponsored-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: 8px;
}
.sponsored-badge .sponsored-icon {
  font-size: 13px;
  height: 13px;
  width: 13px;
  line-height: 13px;
}

.collab-author-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 13px;
  color: #555;
}
.collab-author-row .collab-label {
  color: #888;
}
.collab-author-row .collab-avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #ddd;
}
.collab-author-row .collab-username {
  font-weight: 600;
  color: #333;
}

.dark-mode .collab-author-row {
  color: #aaa;
}
.dark-mode .collab-author-row .collab-label {
  color: #999;
}
.dark-mode .collab-author-row .collab-username {
  color: #e2e8f0;
}

/* ── Collaborators centred popup ──────────────────────────────────────────── */
.collab-popup-backdrop {
  position: fixed;
  inset: 0;
  z-index: 499;
  background: rgba(0, 0, 0, 0.45);
}

.collab-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 500;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22), 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px 16px 14px;
  width: 300px;
}
.collab-popup .collab-popup-title {
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
  margin-bottom: 10px;
  text-align: center;
}
.collab-popup .collab-popup-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s;
}
.collab-popup .collab-popup-card:hover {
  background: #f5f7fa;
}
.collab-popup .collab-popup-avatar-wrap {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  border: 2px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
}
.collab-popup .collab-popup-pic {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.collab-popup .collab-popup-uname {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

/* Collaborators popup — dark mode */
:host-context(body.theme-dark) .collab-popup {
  background: #1f2937;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.6), 0 2px 10px rgba(0, 0, 0, 0.4);
}
:host-context(body.theme-dark) .collab-popup .collab-popup-title {
  color: #64748b;
  border-bottom-color: rgba(148, 163, 184, 0.15);
}
:host-context(body.theme-dark) .collab-popup .collab-popup-card:hover {
  background: #374151;
}
:host-context(body.theme-dark) .collab-popup .collab-popup-avatar-wrap {
  border-color: #374151;
  background: #111827;
}
:host-context(body.theme-dark) .collab-popup .collab-popup-uname {
  color: #e2e8f0;
}

.view-flow.embed-mode {
  padding-top: 0;
}
.view-flow.embed-mode .container1 {
  max-width: 100%;
  padding: 0 12px 12px;
}
.view-flow.embed-mode.embed-locked .flow-main-grid {
  grid-template-columns: minmax(0, 1fr);
}

/* Standalone embed route: host the compact preview player and let it fill the iframe */
.viewflow-embed-standalone {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
}
.viewflow-embed-standalone app-embed-preview {
  width: 100%;
}
.viewflow-embed-standalone ::ng-deep .embed-preview {
  max-width: 100%;
}

::ng-deep .access-menu .access-menu-current {
  margin-left: auto;
  font-size: 11px;
  font-weight: 600;
  color: #1976d2;
}

.flow-access-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px 3px 6px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
  line-height: 1.2;
}
.flow-access-badge mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.flow-access-badge em {
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.65);
}
.flow-access-badge.kind-public {
  color: #0f766e !important;
  background: #ccfbf1;
}
.flow-access-badge.kind-private {
  color: #9a3412 !important;
  background: #ffedd5;
}
.flow-access-badge.kind-private-link {
  color: #1d4ed8 !important;
  background: #dbeafe;
}
.flow-access-badge.kind-restricted {
  color: #6d28d9 !important;
  background: #ede9fe;
}

body.theme-dark .view-flow .flow-access-badge.kind-public,
body.theme-dark .view-flow .channel-meta .flow-access-badge.kind-public,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-public,
body.theme-dark .view-flow .flow-access-badge.kind-public mat-icon,
body.theme-dark .view-flow .channel-meta .flow-access-badge.kind-public mat-icon,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-public mat-icon {
  color: #ccfbf1 !important;
}

body.theme-dark .view-flow .flow-access-badge.kind-public,
body.theme-dark .view-flow .channel-meta .flow-access-badge.kind-public,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-public {
  background: #0f766e !important;
}

body.theme-dark .view-flow .flow-access-badge.kind-private,
body.theme-dark .view-flow .channel-meta .flow-access-badge.kind-private,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-private,
body.theme-dark .view-flow .flow-access-badge.kind-private mat-icon,
body.theme-dark .view-flow .channel-meta .flow-access-badge.kind-private mat-icon,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-private mat-icon {
  color: #ffedd5 !important;
}

body.theme-dark .view-flow .flow-access-badge.kind-private,
body.theme-dark .view-flow .channel-meta .flow-access-badge.kind-private,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-private {
  background: #9a3412 !important;
}

body.theme-dark .view-flow .flow-access-badge.kind-private-link,
body.theme-dark .view-flow .channel-meta .flow-access-badge.kind-private-link,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-private-link,
body.theme-dark .view-flow .flow-access-badge.kind-private-link mat-icon,
body.theme-dark .view-flow .channel-meta .flow-access-badge.kind-private-link mat-icon,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-private-link mat-icon {
  color: #dbeafe !important;
}

body.theme-dark .view-flow .flow-access-badge.kind-private-link,
body.theme-dark .view-flow .channel-meta .flow-access-badge.kind-private-link,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-private-link {
  background: #1d4ed8 !important;
}

body.theme-dark .view-flow .flow-access-badge.kind-restricted,
body.theme-dark .view-flow .channel-meta .flow-access-badge.kind-restricted,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-restricted,
body.theme-dark .view-flow .flow-access-badge.kind-restricted mat-icon,
body.theme-dark .view-flow .channel-meta .flow-access-badge.kind-restricted mat-icon,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-restricted mat-icon {
  color: #ede9fe !important;
}

body.theme-dark .view-flow .flow-access-badge.kind-restricted,
body.theme-dark .view-flow .channel-meta .flow-access-badge.kind-restricted,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-restricted {
  background: #6d28d9 !important;
}

body.theme-dark .view-flow .flow-access-badge em,
body.theme-dark .view-flow .channel-meta .flow-access-badge em,
body.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge em {
  color: inherit !important;
  background: rgba(15, 23, 42, 0.45) !important;
}

body.theme-dark ::ng-deep .access-menu .access-menu-current {
  color: #7ec8f0 !important;
}

.clickarrow button.guide-finish-btn,
.view-flow .viewflow-step .clickarrow button.guide-finish-btn {
  pointer-events: all;
  margin-left: auto;
  margin-right: 0;
  width: auto;
  height: 44px;
  padding: 0 18px;
  border: none;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #5ea1d8;
  color: #fff;
  font-family: "Raleway";
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  transition: background 0.2s ease, transform 0.2s ease;
}
.clickarrow button.guide-finish-btn mat-icon,
.view-flow .viewflow-step .clickarrow button.guide-finish-btn mat-icon {
  flex: 0 0 auto;
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.clickarrow button.guide-finish-btn:hover,
.view-flow .viewflow-step .clickarrow button.guide-finish-btn:hover {
  background: #4a8fc4;
  transform: translateY(-1px);
}

.view-flow .viewflow-step .clickarrow button.guide-finish-btn {
  height: 48px;
  line-height: 1;
}
@media (max-width: 992px) {
  .view-flow .viewflow-step .clickarrow button.guide-finish-btn {
    height: 42px;
  }
}

.view-flow .step-header-main .step-questions-chip {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  margin-left: 4px;
  border: 1px solid #5ea1d8;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.1);
  color: #1d67a3;
  font-family: "Raleway", sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease;
}
.view-flow .step-header-main .step-questions-chip mat-icon {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
}
.view-flow .step-header-main .step-questions-chip:hover {
  background: rgba(94, 161, 216, 0.18);
}
.view-flow .step-header-main .step-questions-chip:focus-visible {
  outline: 2px solid #5ea1d8;
  outline-offset: 2px;
}

:host-context(body.theme-dark) .view-flow .step-header-main .step-questions-chip {
  background: rgba(94, 161, 216, 0.15);
  color: #93c5fd;
}

/* Follow, Purchase and Task mode share one size so the stacked column lines up. */
.view-flow .channel-actions > button.follow-btn,
.view-flow .channel-actions > button.purchase-btn {
  box-sizing: border-box;
  min-width: 140px;
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: "Raleway", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}
.view-flow .channel-actions > button.purchase-btn {
  width: auto;
}
.view-flow .channel-actions mat-icon {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
}
.view-flow .channel-actions .btn-spinner {
  margin-right: 0;
}
.view-flow .channel-actions > button.follow-btn.task-mode-btn:not(.following) {
  background: transparent !important;
  color: #1d67a3 !important;
  border: 1px solid #5ea1d8 !important;
}
.view-flow .channel-actions > button.follow-btn.task-mode-btn:not(.following):hover {
  background: rgba(94, 161, 216, 0.1) !important;
}
@media (max-width: 768px) {
  .view-flow .channel-actions > button.follow-btn,
  .view-flow .channel-actions > button.purchase-btn {
    min-width: 120px;
    height: 36px;
    font-size: 13px;
  }
}

:host-context(body.theme-dark) .view-flow .channel-actions > button.follow-btn.task-mode-btn:not(.following) {
  background: transparent !important;
  color: #93c5fd !important;
  border: 1px solid #5ea1d8 !important;
}
:host-context(body.theme-dark) .view-flow .channel-actions > button.follow-btn.task-mode-btn:not(.following):hover {
  background: rgba(94, 161, 216, 0.15) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/viewflow/viewflow.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,YAAA;EACA,WAAA;AAEF;;AACA;EACE,mBAAA;EACA,6BAAA;AAEF;;AACA;;;;;;4EAAA;AAQA,+DAAA;AACA;EACE,wBAAA;EACA,iCAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;AACF;;AAEA,gDAAA;AACA;EACE,yBAAA;EACA,2BAAA,EAAA,gDAAA;AACF;;AAEA,gEAAA;AACA;EACE,yBAAA;EACA,wBAAA;EACA,oBAAA,EAAA,wDAAA;EACA,2BAAA;EACA,6BAAA;EACA,+BAAA;AACF;;AAEA,8CAAA;AACA;;;;EAIE,4BAAA;AACF;;AAEA,+DAAA;AACA;EACE,2BAAA;EACA,4BAAA;AACF;;AAEA,iEAAA;AACA;EACE,gBAAA;EACA,gBAAA;AACF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AAAF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;AAAJ;AAGE;EACE,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADJ;AAIE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EAAA,kBAAA;AAFJ;AAII;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAFN;AAME;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAJJ;AAMI;EACE,gBAAA;EACA,cAAA;AAJN;AAOI;EACE,+GAAA;EAEA,eAAA;EACA,qBAAA;EACA,cAAA;AANN;AAUE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AARJ;AAUI;EACE,WAAA;AARN;;AAaA;EACE;IACE,aAAA;EAVF;EAYE;IACE,0BAAA;EAVJ;EAaE;IACE,mBAAA;EAXJ;EAcE;IACE,eAAA;IACA,iBAAA;EAZJ;EAcI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAZN;EAgBE;IACE,QAAA;IACA,UAAA;EAdJ;AACF;AAkBA;EAwBE,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EAyoGA,kCAAA;AA/qGF;AAYE;EACE,yBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAVJ;AAYI;EACE,yBAAA;EACA,aAAA;AAVN;AAaI;EAEE,yBAAA;AAZN;AAsBE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,YAAA;AApBJ;AAsBI;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AApBN;AAsBM;EACE,OAAA;EACA,aAAA;AApBR;AAsBQ;EACE,OAAA;EACA,wBAAA;AApBV;AAsBU;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AApBZ;AAwBQ;EACE,OAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAtBV;AAwBU;EACE,8BAAA;EACA,0BAAA;EACA,oCAAA;AAtBZ;AAyBU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAvBZ;AAyBY;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAvBd;AAyBc;EACE,WAAA;EACA,kBAAA;EACA,cAAA;AAvBhB;AA0BkB;EACE,qCAAA;EACA,2BAAA;AAxBpB;AA0BoB;EACE,qCAAA;EACA,eAAA;AAxBtB;AA+BY;EACE,kBAAA;AA7Bd;AAgCY;EACE,OAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;AA9Bd;AAgCc;EACE,2BAAA;EACA,cAAA;AA9BhB;AAkCY;EACE,sBAAA;AAhCd;AAoCc;EACE,iBAAA;AAlChB;AAsCY;EACE,kBAAA;EACA,eAAA;AApCd;AAwCU;EACE,eAAA;EACA,kBAAA;EACA,aAAA;AAtCZ;AAwCY;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EAEA,kBAAA;AAvCd;AAwCc;EACE,YAAA;EACA,2BAAA;AAtChB;AAwCgB;EACE,eAAA;EACA,WAAA;EACA,iDAAA;EACA,kBAAA;AAtClB;AAyCgB;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AAvClB;AAmDY;EACE,OAAA;EACA,iBAAA;AAjDd;AAyDI;EACE,WAAA;EACA,UAAA;EACA,SAAA;AAvDN;AAyDM;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AAvDR;AAyDQ;EATF;IAUI,iBAAA;IACA,cAAA;IACA,kBAAA;EAtDR;AACF;AAwDQ;EAfF;IAgBI,0BAAA;IACA,SAAA;IACA,aAAA;IACA,uBAAA;EArDR;AACF;AAuDQ;EAtBF;IAuBI,aAAA;IACA,SAAA;EApDR;AACF;AAyDI;EACE,YAAA;EAEA,0BAAA;AAxDN;AA0DM;EACE,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AAxDR;AA0DQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AAxDV;AA0DU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAxDZ;AA0DY;EACE,YAAA;EACA,4DAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EAAA,sBAAA;AAxDd;AA0Dc;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAxDhB;AA4DY;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA1Dd;AA8DU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AA5DZ;AA8DY;EACE,cAAA;EACA,iBAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,6BAAA;EACA,aAAA;AA5Dd;AA8Dc;EACE,YAAA;AA5DhB;AA+Dc;EAGE,aAAA;EACA,YAAA;AA/DhB;AAkEc;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iCAAA;AAhEhB;AAkEgB;EACE,mBAAA;AAhElB;AAoEc;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,wCAAA;AAlEhB;AAoEgB;EACE,2BAAA;AAlElB;AAoEkB;EACE,cAAA;AAlEpB;AAuEc;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AArEhB;AAyEY;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAvEd;AAyEc;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAvEhB;AA+EQ;EACE,mBAAA;AA7EV;AAiFM;EAEE,SAAA,EAAA,wCAAA;EACA,UAAA,EAAA,yBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,8BAAA;EACA,oBAAA;EA6CA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,cAAA;AA7HR;AA+EQ;EACE,iBAAA;AA7EV;AAgFQ;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AA9EV;AAgFU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AA9EZ;AAiFU;EACE,WAAA;AA/EZ;AAkFU;EACE,mBAAA;AAhFZ;AAoFQ;EApDF;IAqDI,gBAAA;IACA,uCAAA;IACA,gCAAA;IACA,kBAAA;IACA,gBAAA;EAjFR;AACF;AAuFQ;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,6BAAA;EACA,aAAA;AArFV;AAuFU;EACE,YAAA;AArFZ;AAwFU;EAGE,aAAA;EACA,YAAA;AAxFZ;AA2FU;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iCAAA;EACA,iBAAA;AAzFZ;AA2FY;EACE,mBAAA;AAzFd;AA6FU;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,wCAAA;AA3FZ;AA6FY;EACE,2BAAA;AA3Fd;AA6Fc;EACE,cAAA;AA3FhB;AAgGU;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AA9FZ;AAiGU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AA/FZ;AAmGQ;EACE,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,oBAAA;EACA,mBAAA;AAjGV;AAoGQ;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,kCAAA;EACA,OAAA;EACA,YAAA;EACA,2BAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAlGV;AAuGM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,mBAAA;EAOA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,cAAA;AA5GR;AA+FQ;EAVF;IAWI,mBAAA;IACA,kBAAA;IACA,gBAAA;EA5FR;AACF;AAuGQ;EACE,WAAA;AArGV;AAwGQ;EACE,mBAAA;EACA,kBAAA;AAtGV;AAyGQ;EACE,gBAAA;EACA,kBAAA;AAvGV;AAyGU;EACE,gBAAA;AAvGZ;AA2GQ;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAzGV;AA2GU;EACE,mBAAA;EACA,qBAAA;AAzGZ;AA4GU;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;AA1GZ;AA4GY;;;EAGE,cAAA;EACA,2BAAA;EACA,uBAAA;AA1Gd;AA8GU;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AA5GZ;AA8GY;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA5Gd;AA+GY;EACE,cAAA;AA7Gd;AAgHY;EACE,oCAAA;EACA,cAAA;AA9Gd;AAkHU;EACE,cAAA;AAhHZ;AAkHY;EACE,cAAA;AAhHd;AAmHY;EACE,qCAAA;EACA,cAAA;AAjHd;AAqHU;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,2BAAA;EACA,uBAAA;AAnHZ;AAsHU;EACE,kCAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,uBAAA;AApHZ;AAuHU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;EACA,2BAAA;EACA,uBAAA;AArHZ;AAuHY;EAZF;IAaI,aAAA;EApHZ;AACF;AAwHQ;EAtKF;IAuKI,QAAA;IACA,kBAAA;EArHR;EAuHQ;IACE,eAAA;IACA,iBAAA;IACA,kCAAA;EArHV;EAuHU;IACE,eAAA;EArHZ;AACF;AA2HM;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAzHR;AA2HQ;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAzHV;AA2HU;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAzHZ;AA4HU;EACE,WAAA;EACA,YAAA;AA1HZ;AA8HQ;EACE,aAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AA5HV;AA+HQ;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AA7HV;AA+HU;;EAEE,mBAAA;EACA,+BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,0CAAA;EACA,SAAA;AA7HZ;AA+HY;;EACE,8BAAA;EACA,2BAAA;AA5Hd;AA+HY;;;EAEE,aAAA;AA5Hd;AA+HY;;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AA5Hd;AAgIU;EACE,kBAAA;EACA,cAAA;AA9HZ;AAiIU;EACE,iBAAA;EACA,eAAA;AA/HZ;AAqII;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,mBAAA;AApIN;AAsIM;EAPF;IAQI,eAAA;IACA,uBAAA;IACA,gBAAA;IACA,gBAAA;IACA,gCAAA;EAnIN;AACF;AAqIQ;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AAnIV;AAqIU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AAnIZ;AAqIY;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAnId;AAuIU;EACE,cAAA;AArIZ;AAwIU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AAtIZ;AAwIY;EACE,cAAA;AAtId;AA0IU;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAxIZ;AA4IQ;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AA1IV;AA4IU;EACE,+GAAA;EAEA,eAAA;EACA,qBAAA;EACA,cAAA;AA3IZ;AA8IU;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA5IZ;AA8IY;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA5Id;AAiJQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;AA/IV;AAiJU;EACE,WAAA;AA/IZ;AAkJU;EACE,8BAAA;EACA,kBAAA;AAhJZ;AAmJU;EACE,8BAAA;AAjJZ;AAoJU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AAlJZ;AAoJY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AAlJd;AAoJc;EACE,mBAAA;AAlJhB;AAsJc;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AApJhB;AAuJc;EACE,mBAAA;EACA,cAAA;AArJhB;AAuJgB;EACE,mBAAA;AArJlB;AAwJgB;EACE,cAAA;AAtJlB;AAyJgB;EACE,cAAA;AAvJlB;AA2Jc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAzJhB;AA6Jc;EACE,yBAAA;AA3JhB;AA8Jc;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA5JhB;AA+Jc;EACE,SAAA;AA7JhB;AAqKI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,mBAAA;AApKN;AAsKM;EAPF;IAQI,eAAA;IACA,uBAAA;IACA,gBAAA;IACA,gBAAA;IACA,gCAAA;EAnKN;AACF;AAqKQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAnKV;AAqKU;EALF;IAMI,SAAA;IACA,uBAAA;EAlKV;AACF;AAoKU;EACE,cAAA;EACA,aAAA;EACA,mBAAA;AAlKZ;AAqKU;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAnKZ;AAqKY;EACE,kBAAA;EACA,UAAA;AAnKd;AAqKc;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAnKhB;AAqKgB;EANF;IAOI,WAAA;IACA,YAAA;EAlKhB;AACF;AAqKc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAnKhB;AAqKgB;EANF;IAOI,eAAA;IACA,WAAA;IACA,YAAA;EAlKhB;AACF;AAsKY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AApKd;AAsKc;EAXF;IAYI,WAAA;IACA,YAAA;IACA,iBAAA;EAnKd;AACF;AAsKY;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AApKd;AAsKc;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AApKhB;AAuKc;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AArKhB;AAwKc;EAhCF;IAiCI,WAAA;IACA,YAAA;IACA,iBAAA;EArKd;EAuKc;IACE,WAAA;IACA,YAAA;EArKhB;AACF;AAyKY;EACE,eAAA;AAvKd;AA2KU;EACE,OAAA;EACA,YAAA;EACA,eAAA;AAzKZ;AA2KY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EAkBA,WAAA;AA1Ld;AA0Kc;EACE,eAAA;AAxKhB;AAyKgB;EAAU,0BAAA;AAtK1B;AAyKc;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAvKhB;AA0Kc;EACE,gBAAA;EACA,eAAA;AAxKhB;AAyKgB;EAAU,0BAAA;AAtK1B;AA0Kc;EA3BF;IA4BI,eAAA;IACA,kBAAA;EAvKd;AACF;AAyKc;EACE,cAAA;AAvKhB;AA2KY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAzKd;AA2Kc;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;AAzKhB;AA4Kc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AA1KhB;AA6Kc;EACE,cAAA;AA3KhB;AA8Kc;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA5KhB;AA8KgB;EACE,0BAAA;AA5KlB;AAgLc;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AA9KhB;AAiLc;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AA/KhB;AAiLgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA/KlB;AAkLgB;EACE,mBAAA;AAhLlB;AAoLc;EA3EF;IA4EI,QAAA;IACA,eAAA;IACA,eAAA;IACA,mBAAA;EAjLd;EAmLc;IACE,QAAA;IACA,eAAA;EAjLhB;EAoLc;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAlLhB;AACF;AAuLU;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;AArLZ;AAuLY;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AArLd;AAuLc;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AArLhB;AAuLgB;EACE,mCAAA;AArLlB;AAyLc;EACE,mBAAA;EACA,cAAA;AAvLhB;AAyLgB;EACE,mBAAA;AAvLlB;AA4LY;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,WAAA;EACA,kBAAA;AA1Ld;AA4Lc;EACE,mBAAA;AA1LhB;AAiMQ;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AA/LV;AAiMU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA/LZ;AAkMU;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAhMZ;AAkMY;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;AAhMd;AAkMc;EACE,mBAAA;EACA,qBAAA;AAhMhB;AAmMc;EACE,YAAA;EACA,mBAAA;AAjMhB;AAoMc;EACE,cAAA;AAlMhB;AAoMgB;EACE,mBAAA;EACA,qBAAA;AAlMlB;AAsMc;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AApMhB;AAuMc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AArMhB;AAwMc;EACE,OAAA;AAtMhB;AA0MY;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAxMd;AA0Mc;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;AAxMhB;AA0MgB;EACE,kBAAA;EACA,eAAA;AAxMlB;AA+MU;EACE;IACE,eAAA;IACA,mBAAA;EA7MZ;EAgNU;IACE,QAAA;EA9MZ;EAgNY;IACE,kBAAA;IACA,eAAA;EA9Md;EAgNc;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA9MhB;EAmNc;IACE,iBAAA;EAjNhB;EAmNgB;IACE,iBAAA;IACA,eAAA;EAjNlB;AACF;AA0NI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,mBAAA;AAzNN;AA2NM;EAPF;IAQI,mBAAA;IACA,mBAAA;IACA,gBAAA;EAxNN;AACF;AA0NQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;AAxNV;AA0NU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;AAxNZ;AA0NY;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AAxNd;AA0Nc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AAxNhB;AA2Nc;EApBF;IAqBI,eAAA;EAxNd;EA0Nc;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAxNhB;AACF;AA8NQ;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;AA5NV;AA8NU;EACE,gBAAA;AA5NZ;AA+NU;EACE,gBAAA;AA7NZ;AA+NY;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AA7Nd;AA+Nc;EACE,0BAAA;AA7NhB;AAmOQ;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAjOV;AAmOU;EACE,cAAA;AAjOZ;AAuOM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AArOR;AAuOQ;EANF;IAOI,mBAAA;IACA,mBAAA;IACA,gBAAA;EApOR;AACF;AAsOQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AApOV;AAsOU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;AApOZ;AAsOY;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AApOd;AAyOQ;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAvOV;AAyOU;EACE,UAAA;AAvOZ;AAyOU;EACE,mBAAA;EACA,kBAAA;AAvOZ;AA2OQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,4BAAA;AAzOV;AA2OU;EACE,mBAAA;AAzOZ;AA4OU;EACE,cAAA;AA1OZ;AA8OQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AA5OV;AA8OU;EACE,cAAA;AA5OZ;AAgPQ;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA9OV;AAiPQ;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;AA/OV;AAiPU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AA/OZ;AAkPU;EACE,0BAAA;AAhPZ;AAsPM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AApPR;AAsPQ;EATF;IAUI,mBAAA;IACA,mBAAA;EAnPR;AACF;AAqPQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAnPV;AAsPQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AApPV;AAuPQ;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;AArPV;AAuPU;EACE,mBAAA;AArPZ;AAyPQ;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvPV;AAyPU;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAvPZ;AA2PQ;EACE,YAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAzPV;AA4PQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AA1PV;AA6PQ;;EAEE,eAAA;EACA,cAAA;AA3PV;AAgQM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,mBAAA;AA/PR;AAiQQ;EAPF;IAQI,eAAA;IACA,uBAAA;IACA,gBAAA;IACA,gBAAA;EA9PR;AACF;AAgQQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA9PV;AAiQQ;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AA/PV;AAiQU;EACE,cAAA;AA/PZ;AAiQY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA/Pd;AAkQY;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAhQd;AAoQU;EACE,OAAA;EACA,kBAAA;AAlQZ;AAoQY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAlQd;AAqQY;EACE,OAAA;EACA,cAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;AAnQd;AAqQc;EACE,aAAA;EACA,4BAAA;AAnQhB;AAsQc;EACE,cAAA;AApQhB;AAwQY;EACE,cAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AAtQd;AAwQc;EACE,mBAAA;EACA,cAAA;AAtQhB;AAyQc;EACE,WAAA;EACA,mBAAA;AAvQhB;AA0Qc;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxQhB;AA8QQ;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AA5QV;AA8QU;EACE,SAAA;EACA,eAAA;EACA,cAAA;AA5QZ;AA8QY;EACE,cAAA;EACA,eAAA;EACA,qBAAA;AA5Qd;AA8Qc;EACE,0BAAA;AA5QhB;AAkRQ;EACE,gBAAA;AAhRV;AAkRU;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;AAhRZ;AAkRY;EACE,mBAAA;AAhRd;AAmRY;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAjRd;AAmRc;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAjRhB;AAmRgB;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAjRlB;AAoRgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAlRlB;AAqRgB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AAnRlB;AAuRc;EACE,eAAA;EACA,cAAA;EACA,kCAAA;AArRhB;AAyRY;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;AAvRd;AA0RY;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA,EAAA,YAAA;EACA,qBAAA;AAxRd;AA0Rc;EACE,WAAA;AAxRhB;AA2Rc;EACE,8BAAA;EACA,kBAAA;AAzRhB;AA4Rc;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA,EAAA,uCAAA;AA1RhB;AA4RgB;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,sBAAA;AA1RlB;AA6RgB;EACE,eAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AA3RlB;AA8RgB;EACE,mBAAA;AA5RlB;AA+RgB;EACE,cAAA;AA7RlB;AA+RkB;EACE,cAAA;AA7RpB;AAiSgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/RlB;AAoSY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;AAlSd;AAoSc;EACE,OAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kCAAA;AAlShB;AAoSgB;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AAlSlB;AAqSgB;EACE,cAAA;AAnSlB;AAuSc;EACE,cAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;AArShB;AAuSgB;EACE,mBAAA;EACA,sBAAA;AArSlB;AAwSgB;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;AAtSlB;AA2SY;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;AAzSd;AA2Sc;EACE,eAAA;AAzShB;AA6SoB;;EAEE,WAAA;EACA,YAAA;AA3StB;AA8SoB;EACE,eAAA;AA5StB;AAiTgB;EACE,eAAA;AA/SlB;AAsTQ;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,kCAAA;AApTV;AAuTQ;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;AArTV;AAuTU;EACE,yBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AArTZ;AAuTY;EACE,yBAAA;EACA,qCAAA;EACA,YAAA;AArTd;AAwTY;EACE,yBAAA;AAtTd;AAyTY;EACE,yBAAA;AAvTd;AA2TU;EACE,SAAA;EACA,eAAA;AAzTZ;AAgUI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA,EAAA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AA9TN;AAgUM;EAVF;IAWI,WAAA;IACA,eAAA;IACA,eAAA;EA7TN;AACF;AA+TM;EACE,mBAAA;EACA,cAAA,EAAA,6CAAA;EACA,aAAA,EAAA,+BAAA;AA7TR;AA+TQ;EACE,gFAAA;EACA;;;;;;;;;;;;;;GAAA;EAeA,6EAAA;EACA,uEAAA;EAGA,iDAAA;EAMA,6CAAA;EAKA,4DAAA;EASA,2DAAA;EAQA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAvVV;AAwTU;EAtBF;IAuBI,qBAAA;EArTV;AACF;AAyTU;EA5BF;IA6BI,yCAAA;EAtTV;AACF;AAyTU;EACE,+DAAA;AAvTZ;AAyTY;EAHF;IAII,qBAAA;EAtTZ;AACF;AA0TU;EACE,+DAAA;AAxTZ;AA0TY;EAHF;IAII,qBAAA;EAvTZ;AACF;AA+TU;EACE,UAAA;AA7TZ;AAgUU;EACE,mBAAA;EACA,kBAAA;AA9TZ;AAiUU;EACE,gBAAA;EACA,kBAAA;AA/TZ;AAiUY;EACE,gBAAA;AA/Td;AAoUQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;EAkHA;;0EAAA;AAjbV;AAkUU;EAGE,4BAAA;EAAA,uBAAA;EACA,YAAA;EAEA,gBAAA;AAnUZ;AAsUU;EACE,mDAAA;EACA,kBAAA,EAAA,iCAAA;EACA,uBAAA,EAAA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA,EAAA,0CAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA,EAAA,kBAAA;AApUZ;AAsUY;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AApUd;AAuUY;EACE,mBAAA;EACA,qBAAA;AArUd;AAwUY;EACE,wEAAA;EACA,8BAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;EACA,2BAAA;AAtUd;AAwUc;;EAEE,yBAAA;AAtUhB;AAyUc;EACE,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;AAvUhB;AA2UY;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;AAzUd;AA4UY;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA,EAAA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;AA1Ud;AA6UY;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,gBAAA;AA3Ud;AA6Uc;EACE,SAAA;AA3UhB;AAmVU;EACE,cAAA;EACA,WAAA;AAjVZ;AAoVU;EACE,aAAA;EACA,oBAAA;EACA,WAAA;EACA,QAAA;AAlVZ;AAqVU;EACE,OAAA;EACA,WAAA;EACA,YAAA;AAnVZ;AAsVU;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;AApVZ;AAsVY;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApVd;AAuVY;EACE,cAAA;AArVd;AAwVY;EACE,mBAAA;EACA,qBAAA;AAtVd;AA0VU;EACE,qBAAA;EACA,mBAAA;AAxVZ;AA2VU;EACE,8BAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;EACA,2BAAA;EACA,qDAAA;EACA,4BAAA;EACA,6BAAA;AAzVZ;AA2VY;;EAEE,yBAAA;AAzVd;AA4VY;EACE,8BAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;AA1Vd;AA8VU;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;AA5VZ;AA+VU;EACE,yBAAA;EACA,0BAAA;AA7VZ;AAkWM;EACE,cAAA,EAAA,6CAAA;EACA,cAAA,EAAA,8DAAA;EACA,6BAAA,EAAA,qBAAA;EACA,sBAAA,EAAA,mCAAA;EACA,WAAA,EAAA,sBAAA;AAhWR;AAkWQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAhWV;AAmWQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAjWV;AAoWQ;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AAlWV;AAoWU;EACE,mBAAA;AAlWZ;AAqWU;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAnWZ;AAqWY;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AAnWd;AAuWU;EACE,OAAA;EACA,YAAA;AArWZ;AAuWY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AArWd;AAwWY;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAtWd;AAwWc;EACE,cAAA;AAtWhB;AAyWc;EACE,cAAA;AAvWhB;AA0Wc;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAxWhB;AA2Wc;EACE,eAAA;AAzWhB;AA0WgB;EAAU,0BAAA;AAvW1B;AA0Wc;EACE,gBAAA;EACA,eAAA;AAxWhB;AAyWgB;EAAU,0BAAA;AAtW1B;AA0WY;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAxWd;AA+WM;EACE;IACE,wBAAA;EA7WR;AACF;AAkXI;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AAhXN;AAkXM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAhXR;AAmXM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AAjXR;AAoXM;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;AAlXR;AAoXQ;EACE,mBAAA;AAlXV;AAqXQ;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAnXV;AAqXU;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AAnXZ;AAuXQ;EACE,OAAA;EACA,YAAA;AArXV;AAuXU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AArXZ;AAwXU;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAtXZ;AAwXY;EACE,cAAA;AAtXd;AAyXY;EACE,cAAA;AAvXd;AA0XY;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAxXd;AA2XY;EACE,eAAA;AAzXd;AA0Xc;EAAU,0BAAA;AAvXxB;AA0XY;EACE,gBAAA;EACA,eAAA;AAxXd;AAyXc;EAAU,0BAAA;AAtXxB;AA0XU;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAxXZ;AA8XM;EA7GF;IA8GI,wBAAA;EA3XN;AACF;AA8XI;EACE,wBAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;AA5XN;AA+XM;EACE,kBAAA;EACA,iCAAA;EACA,2BAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;AA7XR;AA+XQ;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,OAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;EACA,2BAAA;AA7XV;AA+XU;EACE,UAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AA7XZ;AAgYU;EACE,iBAAA;EACA,mBAAA;AA9XZ;AAiYU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EAEA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAhYZ;AAkYY;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,qBAAA;EAEA,WAAA;AAjYd;AAsYQ;EACE,aAAA;EACA,mBAAA;AApYV;AAsYU;EACE,OAAA;AApYZ;AAsYY;EACE,2BAAA;AApYd;AAuYY;EACE,sBAAA;EACA,eAAA;AArYd;AAyYU;EACE,aAAA;EACA,mBAAA;AAvYZ;AAyYY;EACE,aAAA;EACA,mBAAA;AAvYd;AA6YM;EACE,gBAAA;EACA,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,mBAAA;AA3YR;AA6YQ;EACE,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AA3YV;AA8YU;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;AA5YZ;AAgZQ;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EAEA,kBAAA;EACA,gBAAA;AA/YV;AAiZU;EAEE,0BAAA;EACA,YAAA;EACA,iBAAA;EAEA,gBAAA;EACA,sBAAA;AAjZZ;AAoZU;EACE,kCAAA;EACA,2BAAA;EACA,sBAAA;AAlZZ;AA6bE;EACE;IACE,UAAA,EAAA,8BAAA;EA3bJ;AACF;AA8bE;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AA5bJ;AA8bI;;EAEE,mBAAA;EACA,+BAAA;EACA,sBAAA;EACA,0CAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,qDAAA;AA5bN;AA8bM;;EACE,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;AA3bR;AA8bM;;EACE,+BAAA;EACA,2BAAA;AA3bR;AA+bI;EACE,kBAAA;EACA,cAAA;AA7bN;AAgcI;EACE,iBAAA;EACA,eAAA;AA9bN;AA8cE;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EAGA,wBAAA;EACA,mBAAA;EACA,kBAAA;AA9cJ;AAgdI;EAEE,eAAA;EACA,6BAAA;AA/cN;AAkdI;EACE,4BAAA;EACA,uBAAA;EAAA,kBAAA;EACA,2BAAA;AAhdN;AAmdI;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAjdN;AAodQ;EACE,wBAAA;AAldV;AAudQ;EACE,uBAAA;AArdV;AA2dE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAzdJ;AA2dI;EACE,OAAA;EACA,eAAA;EACA,WAAA;AAzdN;AA4dI;EACE,gBAAA;AA1dN;AAsfE;;EAGE,8BAAA;EACA,eAAA;EACA,aAAA;AArfJ;AAwfE;EACE,WAAA;AAtfJ;AAyfE;EACE,0BAAA;EACA,iBAAA;AAvfJ;AA0fE;EACE,iBAAA;EAEA,WAAA;EAEA,eAAA;EACA,mBAAA;AA1fJ;AA6fE;EACE,mBAAA;EACA,YAAA;AA3fJ;AA8fE;EACE,mBAAA;AA5fJ;AA8fI;EACE,yBAAA;AA5fN;AAggBE;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;AA9fJ;AAigBE;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AA/fJ;AAkgBE;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAhgBJ;AAwgBI;EACE,OAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;AAtgBN;AAqhBM;EACE,oBAAA;AAnhBR;AA6hBQ;EACE,iBAAA;EACA,gBAAA;AA3hBV;AAuiBE;EACE,OAAA;AAriBJ;AAwiBE;EACE,eAAA;AAtiBJ;AAyiBE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAviBJ;AA0iBE;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAxiBJ;AA2iBE;EACE,iBAAA;AAziBJ;AA4iBE;EACE,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iDAAA;EACA,gBAAA;AA1iBJ;AA6iBE;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AA3iBJ;AA8iBE;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,oBAAA;EACA,YAAA;AA5iBJ;AA+iBE;EAEE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EAEA,kBAAA;AA/iBJ;AAijBI;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,iDAAA;AA/iBN;AAkjBI;EACE,iBAAA;AAhjBN;AAkjBM;EACE,aAAA;AAhjBR;AAqjBE;EACE,gBAAA;AAnjBJ;AA6jBE;EAEE,0BAAA;EAEA,gBAAA;EACA,sBAAA;AA7jBJ;AAgkBE;EACE,wBAAA;AA9jBJ;AAikBE;EACE,cAAA;EACA,eAAA;EACA,eAAA;AA/jBJ;AAkkBE;EACE,yBAAA;EACA,qCAAA;EACA,eAAA;AAhkBJ;AAkkBI;EACE,yBAAA;AAhkBN;;AAqkBA;EACE,aAAA;AAlkBF;;AAqkBA;EACE,yBAAA;EACA,2BAAA;AAlkBF;AAokBE;EACE,yBAAA;AAlkBJ;;AAukBE;EACE,yBAAA;AApkBJ;;AAwkBA;EACE;IACE,aAAA;IACA,sBAAA;IACA,SAAA;IACA,aAAA;IACA,mBAAA;EArkBF;EAwkBA;IACE,gBAAA;IACA,SAAA;IACA,UAAA;IACA,mBAAA;IACA,4HAAA;IAMA,kCAAA;YAAA,0BAAA;EA3kBF;EA8kBA;IACE,eAAA;IACA,aAAA;IACA,gBAAA;IACA,SAAA;EA5kBF;EA8kBE;IACE,cAAA;EA5kBJ;EAglBA;IACE,aAAA;EA9kBF;EAilBA;IACE,mBAAA;IACA,mBAAA;IAEA,gBAAA;IACA,wBAAA;EAhlBF;EAmlBA;IACE,gBAAA;EAjlBF;EAolBA;;IAEE,WAAA;IACA,cAAA;IACA,iBAAA;IACA,iBAAA;EAllBF;EAqlBA;IACE,WAAA;IACA,iBAAA;IACA,gBAAA;IACA,SAAA;EAnlBF;EAslBA;IACE,uBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EAplBF;EAulBA;IACE,eAAA;IACA,gBAAA;IACA,SAAA;IACA,cAAA;EArlBF;EAwlBA;IACE,cAAA;IACA,gBAAA;EAtlBF;EAwlBE;IACE,mBAAA;EAtlBJ;EA0lBA;IACE,aAAA;IACA,SAAA;IACA,sBAAA;EAxlBF;EA2lBA;IACE,gBAAA;IACA,mBAAA;IACA,gBAAA;EAzlBF;EA2lBE;;IAEE,WAAA;IACA,aAAA;IACA,iBAAA;IACA,cAAA;EAzlBJ;EA6lBA;IACE,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EA3lBF;EA8lBA;IACE,aAAA;IACA,8BAAA;IACA,uBAAA;IACA,SAAA;EA5lBF;EA8lBE;IACE,SAAA;IACA,eAAA;IACA,cAAA;IACA,gBAAA;EA5lBJ;EA8lBI;IACE,eAAA;IACA,gBAAA;IACA,cAAA;EA5lBN;EAimBA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EA/lBF;EAkmBA;IACE,cAAA;IACA,gBAAA;IACA,eAAA;EAhmBF;EAkmBE;IACE,mBAAA;EAhmBJ;EAomBA;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,cAAA;EAlmBF;EAomBE;IACE,eAAA;IACA,YAAA;IACA,WAAA;EAlmBJ;EAsmBA;IACE,sBAAA;IACA,cAAA;IACA,gBAAA;IACA,UAAA;EApmBF;EAumBA;IACE,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EArmBF;EAumBE;IACE,aAAA;IACA,mBAAA;IACA,SAAA;IACA,eAAA;IACA,gCAAA;EArmBJ;EAumBI;IACE,mBAAA;EArmBN;EAwmBI;IACE,iBAAA;EAtmBN;EA2mBA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,iBAAA;EAzmBF;AACF;AA4mBA,wEAAA;AACA;EACE;;;;;GAAA;EAMA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AA1mBF;AA4mBE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,YAAA;AA1mBJ;AA4mBI;EACE,WAAA;EACA,UAAA;EACA,SAAA;AA1mBN;AA4mBM;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AA1mBR;AA4mBQ;EARF;IASI,iBAAA;IACA,cAAA;IACA,kBAAA;EAzmBR;AACF;AA2mBQ;EAdF;IAeI,0BAAA;IACA,SAAA;IACA,aAAA;EAxmBR;AACF;AA0mBQ;EApBF;IAqBI,aAAA;IACA,SAAA;EAvmBR;AACF;AA4mBE;;;;EAIE,0CAAA;EACA,0BAAA;EACA,yFAAA;EAEA,yBAAA;AA3mBJ;AA8mBE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AA5mBJ;AA8mBI;EACE,YAAA;EACA,UAAA;AA5mBN;AA+mBI;EACE,YAAA;EACA,UAAA;AA7mBN;AAgnBI;EACE,YAAA;EACA,WAAA;AA9mBN;AAinBI;EACE,UAAA;AA/mBN;AAknBI;EACE,YAAA;EACA,WAAA;EACA,aAAA;AAhnBN;AAknBM;EACE,UAAA;AAhnBR;AAonBI;EACE,YAAA;EACA,WAAA;EACA,SAAA;AAlnBN;AAqnBI;EACE,YAAA;EACA,UAAA;AAnnBN;AAsnBI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;AApnBN;AAwnBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAtnBJ;AAwnBI;EACE,WAAA;EACA,YAAA;AAtnBN;AA0nBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAxnBJ;AA0nBI;EACE,WAAA;EACA,YAAA;AAxnBN;AA2nBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAznBN;AA4nBI;EACE,WAAA;EACA,YAAA;AA1nBN;AA8nBE;EACE,WAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA5nBJ;AA8nBI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,0BAAA;EACA,yFAAA;EAEA,yBAAA;AA7nBN;AAgoBI;EACE,sBAAA;AA9nBN;AAioBI;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AA/nBN;AAmoBE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;AAjoBJ;AAooBE;EACE,mBAAA;EACA,gCAAA;EACA,qBAAA;EACA,kBAAA;EACA,uCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,8BAAA;AAloBJ;AAooBI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kCAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;AAloBN;AAqoBI;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;AAnoBN;AAqoBM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;AAnoBR;AAqoBQ;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;AAnoBV;AAqoBU;EACE,WAAA;EACA,YAAA;AAnoBZ;AAyoBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAvoBN;AAyoBM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;AAvoBR;AAyoBQ;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAvoBV;AA0oBQ;EACE,kCAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AAxoBV;AA4oBM;EA7CF;IA8CI,QAAA;IACA,kBAAA;EAzoBN;EA2oBM;IACE,eAAA;IACA,iBAAA;EAzoBR;EA2oBQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAzoBV;AACF;AA+oBE;EACE,kCAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;AA7oBJ;AA+oBI;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;AA7oBN;AA+oBM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AA7oBR;AAkpBE;EACE,mBAAA;AAhpBJ;AAkpBI;EACE,mBAAA;AAhpBN;AAkpBM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhpBR;AAkpBQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAhpBV;AAmpBQ;EACE,OAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAjpBV;AAopBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAlpBV;AAupBI;EACE,gBAAA;EACA,oBAAA;AArpBN;AAupBM;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AArpBR;AAupBQ;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AArpBV;AAupBU;EACE,WAAA;EACA,YAAA;EACA,eAAA;AArpBZ;AAwpBU;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAtpBZ;AA2pBM;EAhCF;IAiCI,gBAAA;IACA,kBAAA;IACA,yBAAA;EAxpBN;EA0pBM;IACE,SAAA;EAxpBR;AACF;AA6pBE;EACE,mBAAA;AA3pBJ;AA6pBI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AA3pBN;AA6pBM;EACE,cAAA;AA3pBR;AA6pBQ;EACE,WAAA;EACA,YAAA;AA3pBV;AA+pBM;EACE,OAAA;EACA,YAAA;AA7pBR;AA+pBQ;EACE,YAAA;EACA,UAAA;EACA,kBAAA;AA7pBV;AAgqBQ;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AA9pBV;AAgqBU;EACE,YAAA;EACA,WAAA;EACA,SAAA;AA9pBZ;AAmqBM;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAjqBR;AAmqBQ;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;AAjqBV;AAuqBI;EACE,8BAAA;EACA,qBAAA;EACA,sBAAA;EACA,0BAAA;EACA,iCAAA;EACA,yBAAA;EACA,8BAAA;EACA,qBAAA;AArqBN;AAwqBM;EACE,sBAAA;AAtqBR;AA0qBM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAxqBR;AA0qBQ;EANF;IAOI,mBAAA;IACA,qBAAA;IACA,8BAAA;EAvqBR;AACF;AA0qBU;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;AAxqBZ;AA2qBU;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAzqBZ;AA6qBQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AA3qBV;AA6qBU;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,yCAAA;AA3qBZ;AA6qBY;EACE,mBAAA;EACA,qBAAA;AA3qBd;AA+qBU;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,6CAAA;AA7qBZ;AA+qBY;EACE,YAAA;EACA,2BAAA;EACA,6CAAA;AA7qBd;AAgrBY;EACE,YAAA;EACA,mBAAA;AA9qBd;AAqrBM;EACE,wBAAA;EACA,qCAAA;EACA,oBAAA;EACA,8BAAA;EACA,sBAAA;EACA,0BAAA;EACA,iCAAA;EACA,8BAAA;EACA,qBAAA;AAnrBR;AAqrBQ;EAXF;IAYI,yCAAA;IACA,wBAAA;EAlrBR;AACF;AAqrBQ;EACE,wBAAA;EACA,2BAAA;EACA,8BAAA;EACA,mDAAA;EACA,oCAAA;EACA,yBAAA;EACA,8BAAA;EACA,qBAAA;EACA,sBAAA;EACA,iCAAA;AAnrBV;AAqrBU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAnrBZ;AAqrBY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAnrBd;AAurBc;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AArrBhB;AAurBgB;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AArrBlB;AAurBkB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AArrBpB;AAurBoB;EACE,cAAA;AArrBtB;AAwrBoB;EACE,cAAA;AAtrBtB;AAyrBoB;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;AAvrBtB;AA6rBc;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA3rBhB;AAgsBU;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA9rBZ;AAgsBY;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AA9rBd;AAgsBc;EACE,WAAA;EACA,cAAA;EACA,cAAA;AA9rBhB;AAisBc;EACE,OAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AA/rBhB;AAisBgB;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;AA/rBlB;AAmsBc;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAjsBhB;AAssBU;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AApsBZ;AAssBY;EACE,0BAAA;AApsBd;AAusBY;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArsBd;AA2sBM;EACE,6BAAA;EACA,uBAAA;EACA,qEAAA;EACA,wBAAA;EACA,8BAAA;EACA,oCAAA;EACA,mDAAA;EACA,2BAAA;EACA,yBAAA;EACA,8BAAA;EACA,qBAAA;EACA,sBAAA;EACA,iCAAA;AAzsBR;AA2sBU;EACE,kBAAA;EACA,WAAA;AAzsBZ;AA2sBY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAzsBd;AA2sBc;EACE,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAzsBhB;AA2sBgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzsBlB;AA6sBc;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA3sBhB;AA+sBY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA7sBd;AAgtBY;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AA9sBd;AAgtBc;EALF;IAMI,8BAAA;EA7sBd;AACF;AAgtBgB;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AA9sBlB;AAitBgB;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA/sBlB;AAitBkB;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AA/sBpB;AAitBoB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA/sBtB;AAktBoB;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhtBtB;AAktBsB;EACE,cAAA;AAhtBxB;AAotBoB;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAltBtB;AAotBsB;EACE,cAAA;AAltBxB;AAstBoB;EACE,2BAAA;EACA,wCAAA;AAptBtB;AA4tBU;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AA1tBZ;AAguBM;EACE,mBAAA;AA9tBR;AAguBQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA9tBV;AAguBU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA9tBZ;AAiuBU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;AA/tBZ;AAiuBY;EACE,0BAAA;AA/tBd;AAkuBY;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhuBd;AAquBQ;EACE,aAAA;EACA,qCAAA;EACA,oCAAA;EACA,SAAA;AAnuBV;AAquBU;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AAnuBZ;AAquBY;EACE,sBAAA;AAnuBd;AAquBc;EACE,UAAA;AAnuBhB;AAuuBY;EACE,mBAAA;EACA,gBAAA;AAruBd;AAwuBY;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAtuBd;AAyuBY;EACE,kBAAA;EACA,QAAA;EACA,8BAAA;EACA,UAAA;EACA,wBAAA;AAvuBd;AA2uBc;EACE,kBAAA;EACA,QAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAzuBhB;AA2uBgB;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AAzuBlB;AAkvBM;EACE,eAAA;AAhvBR;AAkvBQ;EAHF;IAII,eAAA;EA/uBR;AACF;AAivBQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA/uBV;AAivBU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA/uBZ;AAkvBU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAhvBZ;AAkvBY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAhvBd;AAmvBY;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAjvBd;AAmvBc;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAjvBhB;AAuvBQ;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArvBV;AAuvBU;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wCAAA;EACA,oBAAA;AArvBZ;AAuvBY;EACE,wCAAA;AArvBd;AAwvBY;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;AAtvBd;AAwvBc;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAtvBhB;AAwvBgB;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAtvBlB;AA0vBkB;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAxvBpB;AA2vBkB;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAzvBpB;AA2vBoB;EACE,aAAA;EACA,QAAA;AAzvBtB;AA2vBsB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAzvBxB;AA2vBwB;EACE,cAAA;AAzvB1B;AA8vBoB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AA5vBtB;AAkwBc;EACE,eAAA;EACA,cAAA;AAhwBhB;AAowBY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAlwBd;AAqwBY;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAnwBd;AAswBY;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AApwBd;AAswBc;;EAEE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AApwBhB;AAwwBY;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAtwBd;AAwwBc;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAtwBhB;AAwwBgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAtwBlB;AAywBgB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAvwBlB;AA2wBc;EACE,mBAAA;AAzwBhB;AA2wBgB;EACE,gBAAA;AAzwBlB;AA4wBgB;EACE,kBAAA;AA1wBlB;AA4wBkB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA1wBpB;AA8wBgB;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AA5wBlB;AA+wBgB;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AA7wBlB;AA+wBkB;;EAEE,eAAA;EACA,iBAAA;EACA,mBAAA;AA7wBpB;AAmxBY;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAjxBd;AAmxBc;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAjxBhB;AAmxBgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAjxBlB;AAoxBgB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAlxBlB;AAsxBc;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AApxBhB;AAuxBc;EACE,eAAA;EACA,cAAA;AArxBhB;AAyxBY;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAvxBd;AAyxBc;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AAvxBhB;AAyxBgB;EACE,mBAAA;EACA,qBAAA;AAvxBlB;AA0xBgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxxBlB;AA4xBc;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,sBAAA;AA1xBhB;AA4xBgB;EACE,cAAA;AA1xBlB;AAiyBQ;EACE,kBAAA;EACA,iBAAA;AA/xBV;AAiyBU;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AA/xBZ;AAiyBY;EACE,YAAA;EACA,2BAAA;AA/xBd;AAuyBE;EACE,mBAAA;AAryBJ;AAuyBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAryBN;AAuyBM;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;AAryBR;AA0yBM;EACE,YAAA;EACA,aAAA;AAxyBR;AA8yBE;EACE,mBAAA;AA5yBJ;AA8yBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AA5yBN;AA+yBI;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AA7yBN;AAizBI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AA/yBN;AAizBM;EACE,cAAA;AA/yBR;AAizBQ;EACE,WAAA;EACA,YAAA;AA/yBV;AAmzBM;EACE,OAAA;AAjzBR;AAmzBQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;AAjzBV;AAozBQ;EACE,eAAA;EACA,eAAA;AAlzBV;AAwzBM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,gCAAA;AAtzBR;AAwzBQ;EACE,mBAAA;AAtzBV;AAyzBQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAvzBV;AAyzBU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAvzBZ;AAyzBY;EACE,WAAA;EACA,YAAA;AAvzBd;AA0zBY;EACE,YAAA;EACA,YAAA;EACA,SAAA;AAxzBd;AA4zBU;EACE,YAAA;EACA,WAAA;EACA,SAAA;AA1zBZ;AA8zBQ;EACE,YAAA;EACA,WAAA;EACA,aAAA;AA5zBV;AA+zBQ;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA7zBV;AA+zBU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;AA7zBZ;AAm0BI;EACE,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAj0BN;AAo0BI;EACE,WAAA;AAl0BN;AAq0BI;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAn0BN;AAs0BI;EACE,yBAAA;AAp0BN;AAw0BE;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AAt0BJ;AAw0BI;EAPF;IAQI,aAAA;EAr0BJ;AACF;AAw0BI;EACE,kCAAA;EACA,8BAAA;EACA,0BAAA;EACA,8BAAA;EACA,wBAAA;EACA,sCAAA;EACA,8BAAA;EACA,sBAAA;EACA,8BAAA;EACA,qBAAA;AAt0BN;AAw0BM;EACE,wBAAA;EACA,iCAAA;EACA,mBAAA;EACA,sBAAA;AAt0BR;AAw0BQ;EACE,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,oCAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,6BAAA;EACA,yBAAA;EACA,iCAAA;EACA,8BAAA;EACA,qBAAA;AAt0BV;AAw0BU;EACE,uBAAA;EACA,2BAAA;EACA,oCAAA;EACA,uEAAA;EACA,6BAAA;EACA,sCAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,sCAAA;EAAA,iCAAA;EACA,iCAAA;AAt0BZ;AAw0BY;EACE,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,8BAAA;AAt0Bd;AA00BU;EACE,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;AAx0BZ;AA40BQ;EACE,0BAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;AA10BV;AA40BU;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA10BZ;AAk1BQ;EACE,oCAAA;EACA,8BAAA;AAh1BV;AAu1BI;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,qCAAA;AAr1BN;AAu1BM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAr1BR;AAu1BQ;EACE,OAAA;AAr1BV;AA01BQ;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,mBAAA;AAx1BV;AA01BU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAx1BZ;AA21BU;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAz1BZ;AA61BQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AA31BV;AA61BU;EACE,YAAA;EACA,4DAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EAAA,sBAAA;AA31BZ;AA61BY;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA31Bd;AA+1BU;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA71BZ;AAm2BI;EACE,mBAAA;AAj2BN;AAm2BM;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAj2BR;AAo2BM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAl2BR;AAq2BM;EACE,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AAn2BR;AAq2BQ;EACE,WAAA;EACA,YAAA;EACA,SAAA;AAn2BV;AAs2BQ;EACE,OAAA;EACA,YAAA;EACA,SAAA;AAp2BV;AAy2BI;EACE,gBAAA;AAv2BN;AAy2BM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAv2BR;AA02BM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAx2BR;AA22BM;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,oBAAA;AAz2BR;AA22BQ;EACE,cAAA;AAz2BV;AA22BU;EACE,YAAA;EACA,YAAA;EACA,iBAAA;AAz2BZ;AA62BQ;EACE,OAAA;EACA,YAAA;AA32BV;AA62BU;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AA32BZ;AA82BU;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AA52BZ;AA82BY;EACE,YAAA;EACA,WAAA;EACA,SAAA;AA52Bd;AAo3BE;EACE,gBAAA;EACA,mBAAA;AAl3BJ;AAo3BI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAl3BN;AAq3BI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAn3BN;AAs3BI;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;AAp3BN;AAs3BM;EACE,mBAAA;AAp3BR;AAu3BM;EACE,cAAA;AAr3BR;AAu3BQ;EACE,YAAA;EACA,YAAA;EACA,iBAAA;AAr3BV;AAy3BM;EACE,OAAA;EACA,YAAA;AAv3BR;AAy3BQ;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAv3BV;AA03BQ;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AAx3BV;AA03BU;EACE,YAAA;EACA,WAAA;EACA,SAAA;AAx3BZ;AAm4BM;EACI,qCAAA;EACA,iBAAA;EACA,qBAAA;AAj4BV;AAq4BU;EACE,8BAAA;EACA,oBAAA;AAn4BZ;AAs4BU;EACE,qBAAA;EACA,8BAAA;AAp4BZ;AAs4BY;EACE,0BAAA;AAp4Bd;AAw4BU;EACE,oBAAA;AAt4BZ;AAy4BU;EACE,gBAAA;EACA,kBAAA;EACA,oCAAA;AAv4BZ;AA64BI;EACE,wBAAA;AA34BN;;AAg5BA;EACE;IACE,4BAAA;EA74BF;EA+4BA;IACE,2BAAA;EA74BF;AACF;AAg5BA;EACE;IACE,UAAA;EA94BF;EAg5BA;IACE,aAAA;EA94BF;EAg5BA;IACE,UAAA;EA94BF;AACF;AAi5BA,2CAAA;AAEE;EACE;;;;;GAAA;EAMA,8BAAA;AAh5BJ;AAk5BI;;;;EAIE,oCAAA;AAh5BN;AAm5BI;EACE,oCAAA;AAj5BN;AAo5BI;;EAEE,8BAAA;EACA,iDAAA;EACA,2BAAA;AAl5BN;AAq5BI;;;;;;;;EAQE,8BAAA;AAn5BN;AAs5BI;;EAEE,gDAAA;AAp5BN;;AAy5BA;EACE,YAAA;EAEA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAx5BF;;AA25BA;EACE,YAAA;EAEA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AA15BF;;AA65BA;EACE,UAAA;EACA,aAAA;AA15BF;;AA65BA;EACE,oDAAA;AA15BF;;AA65BA;EACE,yBAAA;EACA,0BAAA;AA15BF;;AA65BA;EACE,UAAA;EACA,aAAA;AA15BF;;AA65BA;EACE,oDAAA;AA15BF;;AA65BA;EACE,yBAAA;EACA,0BAAA;AA15BF;;AA65BA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;AA15BF;;AAo6BA;EACE,aAAA;EACA,gBAAA;AAj6BF;;AAo6BA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;AAj6BF;;AAo6BA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAj6BF;;AAo6BA;EACE,iCAAA;EACA,sCAAA;AAj6BF;;AAo6BA;EACE,eAAA;AAj6BF;;AAo6BA;EAGI;IACE,0BAAA;EAn6BJ;AACF;AAw6BA;EAEI;IACE,aAAA;IACA,sBAAA;IACA,sBAAA;EAv6BJ;EAy6BI;IACE,sBAAA;EAv6BN;EA26BM;IACE,sBAAA;IACA,QAAA;EAz6BR;EA26BQ;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;EAz6BV;EA46BQ;IACE,YAAA;EA16BV;EA86Bc;IACE,eAAA;EA56BhB;EAi7BU;IACE,aAAA;IAEA,gBAAA;EAh7BZ;EAk7BY;IACE,gBAAA;EAh7Bd;EAo7BgB;IACE,eAAA;EAl7BlB;EAw7Bc;IACE,4BAAA;EAt7BhB;EA67BM;IACE,iBAAA;EA37BR;EAg8BE;IACE,sBAAA;IACA,WAAA;IACA,mBAAA;EA97BJ;EAg8BI;IACE,iBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EA97BN;EAm8BY;IACE,2BAAA;EAj8Bd;EAs8BQ;IACE,aAAA;IACA,sBAAA;IACA,UAAA;IACA,cAAA;EAp8BV;EAs8BU;IACE,kBAAA;EAp8BZ;EAm9BE;IACE,WAAA;IACA,qBAAA;EAj9BJ;EAm9BI;IACE,gBAAA;IACA,gBAAA;IACA,kCAAA;IACA,oBAAA;EAj9BN;EAm9BM;IACE,oBAAA;IAEA,kBAAA;EAl9BR;EAs9BI;IACE,YAAA;IACA,gBAAA;IACA,WAAA;EAp9BN;EAu9BI;IACE,aAAA;IACA,8BAAA;IACA,mBAAA;EAr9BN;EAu9BM;IACE,WAAA;IACA,YAAA;EAr9BR;EAm+BQ;IACE,kBAAA;IACA,cAAA;EAj+BV;EAo+BQ;IACE,iBAAA;IACA,eAAA;EAl+BV;EAw+BE;IACE,iBAAA;EAt+BJ;EA4+BI;IACE,sBAAA;IACA,2BAAA;IACA,0BAAA;EA1+BN;EA4+BM;IACE,WAAA;IACA,yBAAA;EA1+BR;EA8+BI;IACE,sBAAA;EA5+BN;EAi/BA;IACE,WAAA;IACA,WAAA;EA/+BF;EAk/BA;IACE,6BAAA;IACA,sCAAA;EAh/BF;AACF;AAm/BA,6BAAA;AACA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAj/BF;AAm/BE;EACE,UAAA;EACA,aAAA;AAj/BJ;AAo/BE;EACE,oDAAA;AAl/BJ;AAq/BE;EACE,yBAAA;EACA,0BAAA;AAn/BJ;;AAu/BA;EACE,mBAAA;EACA,WAAA;AAp/BF;AAs/BE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;AAp/BJ;AAs/BI;EACE,2BAAA;EACA,0BAAA;EACA,UAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAp/BN;AAu/BI;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AAr/BN;AAu/BM;EACE,UAAA;EACA,yBAAA;AAr/BR;AAu/BQ;EACE,gBAAA;AAr/BV;AAy/BM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,iDAAA;AAv/BR;;AA0gCE;EACE,cAAA;AAvgCJ;;AA4gCE;;EAEE,aAAA;AAzgCJ;;AA6gCA;EAIQ;IACE,mBAAA;EA7gCR;EAihCQ;IACE,kBAAA;IACA,eAAA;EA/gCV;EAkhCY;IACE,kBAAA;EAhhCd;EAohCc;IACE,6BAAA;EAlhChB;EAyhCc;IACE,0BAAA;EAvhChB;EA+hCI;IACE,WAAA;IAGA,iBAAA;EA/hCN;EAkiCQ;IACE,iBAAA;EAhiCV;EAuiCQ;IACE,oBAAA;IAEA,kBAAA;EAtiCV;EA0iCM;IACE,oBAAA;IACA,aAAA;IACA,8BAAA;IACA,mBAAA;EAxiCR;EA0iCQ;IACE,WAAA;IACA,YAAA;EAxiCV;EA0iCU;IACE,kBAAA;IACA,cAAA;EAxiCZ;EA2iCU;IACE,iBAAA;IACA,eAAA;EAziCZ;AACF;AAijCA;EAGM;IACE,oBAAA;IACA,aAAA;IACA,8BAAA;IACA,mBAAA;EAjjCN;EAmjCM;IACE,WAAA;IACA,YAAA;EAjjCR;EAmjCQ;IACE,kBAAA;IACA,cAAA;EAjjCV;EAojCQ;IACE,iBAAA;IACA,eAAA;EAljCV;AACF;AAyjCA;EACE;IAQE,0BAAA;EA9jCF;EAkkCE;IACE,eAAA;EAhkCJ;EAokCA;IACE,oBAAA;IACA,aAAA;IACA,8BAAA;IACA,mBAAA;EAlkCF;EAokCE;IACE,WAAA;IACA,YAAA;EAlkCJ;EAokCI;IACE,kBAAA;IACA,cAAA;EAlkCN;EAqkCI;IACE,iBAAA;IACA,eAAA;EAnkCN;EAwkCA;IACE,WAAA;IACA,gBAAA;EAtkCF;EAykCA;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,kBAAA;EAvkCF;EAykCE;IACE,6BAAA;IACA,SAAA;EAvkCJ;EA2kCI;IACE,aAAA;IACA,mBAAA;EAzkCN;EAolCE;;IAEE,cAAA;EAllCJ;EAulCE;IACE,wBAAA;EArlCJ;EA0lCE;IACE,wBAAA;EAxlCJ;EA4lCA;IACE,0BAAA;IACA,sBAAA;EA1lCF;EA6lCA;IACE,aAAA;IACA,WAAA;EA3lCF;EA8lCA;IACE,iBAAA;EA5lCF;EA+lCA;IACE,iBAAA;EA7lCF;EAomCA;IACE,iBAAA;EAlmCF;EAqmCA;IACE,cAAA;EAnmCF;EAsmCA;IACE,YAAA;IACA,iBAAA;EApmCF;AACF;AAumCA;EACE,2BAAA;EACA,8BAAA;EAEA,sBAAA;EACA,sBAAA;EACA,0BAAA;EACA,6BAAA;AAtmCF;;AAymCA;EACE;IACE,uBAAA;EAtmCF;AACF;AAymCA;EACE,eAAA;EAGA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EAEA,gBAAA;AA1mCF;AA4mCE;EACE,aAAA;EACA,kBAAA;EACA,kCAAA;EACA,4BAAA;EACA,OAAA;EACA,kBAAA;EACA,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AA1mCJ;AA4mCI;EACE,gBAAA;EACA,UAAA;EACA,0BAAA;AA1mCN;AA6mCI;EACE,gBAAA;EACA,UAAA;EACA,0BAAA;AA3mCN;AA8mCI;;;;EAIE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;AA5mCN;AAgnCI;EACE,0BAAA;AA9mCN;AAinCI;;EAEE,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AA/mCN;AAknCI;EACE,kBAAA;AAhnCN;AAmnCI;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;AAjnCN;AAonCI;EACE,OAAA;EACA,yBAAA;EACA,8BAAA;AAlnCN;AAqnCI;EACE,yBAAA;AAnnCN;AAunCE;EACE,UAAA;EACA,aAAA;AArnCJ;AAwnCE;EACE,oDAAA;AAtnCJ;AAynCE;EACE,yBAAA;EACA,0BAAA;AAvnCJ;;AA2nCA;EACE,kBAAA;EACA,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAxnCF;AA0nCE;EACE,0BAAA;AAxnCJ;AA4nCE;EACE,0BAAA;AA1nCJ;AA6nCE;EACE,UAAA;EACA,wBAAA;AA3nCJ;AA6nCI;EACE,UAAA;AA3nCN;AA8nCI;EACE,UAAA;AA5nCN;AA+nCI;EAEE,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AA9nCN;AAgoCM;EACE,OAAA;EACA,UAAA;EACA,qCAAA;EACA,2BAAA;AA9nCR;AAioCM;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;AA/nCR;;AAuoCI;EACE,qBAAA;AApoCN;AA6oCA;EACE,eAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AA3oCF;AA6oCE;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;AA3oCJ;;AA+oCA,yBAAA;AAGI;EACE,2BAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;AA9oCN;AAgpCM;EACE,qBAAA;AA9oCR;AAgpCQ;EACE,2BAAA;AA9oCV;AAgpCU;EACE,mCAAA;EACA,iBAAA;EACA,uBAAA;AA9oCZ;AAipCU;EACE,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA/oCZ;AAkpCU;EACE,aAAA;AAhpCZ;AAkpCY;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;AAhpCd;;AAypCA;EACE,aAAA;EACA,yBAAA;AAtpCF;;AAypCA;EAIQ;IACE,qBAAA;EAzpCR;EA4pCU;IACE,aAAA;IACA,mBAAA;EA1pCZ;EA4pCY;IACE,sBAAA;EA1pCd;EA6pCY;IACE,sBAAA;EA3pCd;EA8pCY;IACE,4BAAA;EA5pCd;AACF;AAqqCA;EAIQ;IACE,qBAAA;EAtqCR;EAyqCU;IACE,aAAA;IACA,mBAAA;EAvqCZ;EAyqCY;IACE,sBAAA;EAvqCd;EA0qCY;IACE,sBAAA;EAxqCd;EA2qCY;IACE,4BAAA;EAzqCd;AACF;AA4rCE;EACE,6BAAA;EACA,4BAAA;AA1rCJ;AA6rCE;EACE,6BAAA;AA3rCJ;;AA+rCA;EACE,cAAA;AA5rCF;;AAwsCA;EACE,wBAAA;EACA,2BAAA;AArsCF;;AAwsCA;EACE,WAAA;AArsCF;;AAwsCA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,cAAA;AArsCF;;AAwsCA;EACE,kBAAA;EAGA,qBAAA;EACA,qFAAA;AAvsCF;;AA0sCA;;;EAGE,0BAAA;AAvsCF;;AA0sCA;EACE,0BAAA;AAvsCF;;AA8sCA;EACE,aAAA;AA3sCF;;AA8sCA;EACE,aAAA;EACA,mBAAA;AA3sCF;;AA8sCA;EACE,mBAAA;AA3sCF;;AA8sCA;EACE,YAAA;EAEA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;AA5sCF;;AAgtCE;EACE,qBAAA;AA7sCJ;AAgtCE;EACE,YAAA;EACA,gBAAA;AA9sCJ;AAutCE;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AArtCJ;AAutCI;EACE,WAAA;AArtCN;AAwtCI;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAttCN;AAwtCM;EACE,uBAAA;AAttCR;AA2tCI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AAztCN;AA2tCM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAztCR;AA4tCM;EACE,iBAAA;EACA,uBAAA;EACA,WAAA;AA1tCR;AA8tCI;EACE,WAAA;EACA,wBAAA;EACA,6BAAA;AA5tCN;AA+tCI;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;AA7tCN;;AAkuCA;EAEI;IACE,qBAAA;IACA,iBAAA;EAhuCJ;EAmuCE;IACE,yBAAA;IACA,qBAAA;IACA,qBAAA;EAjuCJ;EAuuCE;IACE,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,iBAAA;IACA,mBAAA;EAruCJ;EAuuCI;IACE,WAAA;EAruCN;EAwuCI;IACE,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EAtuCN;EAyuCI;IACE,0BAAA;IACA,sBAAA;IACA,aAAA;IACA,mBAAA;IACA,0BAAA;EAvuCN;EAyuCM;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;EAvuCR;EA0uCM;IACE,iBAAA;IACA,uBAAA;IACA,WAAA;EAxuCR;EA4uCI;IACE,WAAA;IACA,wBAAA;IACA,6BAAA;EA1uCN;EA6uCI;IACE,aAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EA3uCN;AACF;AAgvCA;EAEI;IACE,qBAAA;IACA,iBAAA;EA/uCJ;EAkvCE;IACE,yBAAA;IACA,qBAAA;IACA,qBAAA;EAhvCJ;EAsvCE;IACE,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,iBAAA;IACA,mBAAA;EApvCJ;EAsvCI;IACE,WAAA;EApvCN;EAuvCI;IACE,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EArvCN;EAwvCI;IACE,0BAAA;IACA,sBAAA;IACA,aAAA;IACA,mBAAA;EAtvCN;EAwvCM;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;EAtvCR;EAyvCM;IACE,iBAAA;IACA,uBAAA;IACA,WAAA;EAvvCR;EA2vCI;IACE,WAAA;IACA,wBAAA;IACA,6BAAA;EAzvCN;EA4vCI;IACE,aAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EA1vCN;EA+vCA;IACE,kBAAA;EA7vCF;AACF;AAgwCA;EAEI;IACE,qBAAA;IACA,iBAAA;EA/vCJ;EAkwCE;IACE,2BAAA;IACA,uBAAA;IACA,UAAA;EAhwCJ;EA0wCE;IACE,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;EAxwCJ;EA0wCI;IACE,WAAA;EAxwCN;EA2wCI;IACE,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EAzwCN;EA4wCI;IACE,WAAA;IACA,aAAA;IACA,mBAAA;EA1wCN;EA4wCM;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;EA1wCR;EA6wCM;IACE,iBAAA;IACA,uBAAA;IACA,WAAA;EA3wCR;EA8wCM;IACE,0BAAA;IACA,sBAAA;EA5wCR;EAgxCI;IACE,WAAA;IACA,wBAAA;IACA,6BAAA;EA9wCN;EAixCI;IACE,aAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EA/wCN;EAoxCA;IACE,kBAAA;EAlxCF;AACF;AAqxCA;EAEI;IACE,qBAAA;IACA,iBAAA;EApxCJ;EAuxCE;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;EArxCJ;EA+xCE;IACE,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;EA7xCJ;EA+xCI;IACE,WAAA;EA7xCN;EAgyCI;IACE,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EA9xCN;EAiyCI;IACE,WAAA;IACA,aAAA;IACA,mBAAA;EA/xCN;EAiyCM;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;EA/xCR;EAkyCM;IACE,iBAAA;IACA,uBAAA;IACA,WAAA;EAhyCR;EAmyCM;IACE,0BAAA;IACA,sBAAA;EAjyCR;EAqyCI;IACE,WAAA;IACA,wBAAA;IACA,6BAAA;EAnyCN;EAsyCI;IACE,aAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EApyCN;EAyyCA;IACE,iBAAA;EAvyCF;AACF;AAuzCA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;AArzCF;AAuzCE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AArzCJ;;AA6zCE;EACE,OAAA;AA1zCJ;;AA8zCA,oCAAA;AAGI;EACE,2BAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;AA7zCN;AA+zCM;EACE,qBAAA;AA7zCR;AA+zCQ;EACE,2BAAA;AA7zCV;AA+zCU;EACE,mCAAA;EACA,iBAAA;EACA,uBAAA;AA7zCZ;AAg0CU;EACE,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA9zCZ;AAi0CU;EACE,aAAA;AA/zCZ;AAi0CY;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;AA/zCd;;AAw0CA;EAIQ;IACE,qBAAA;EAx0CR;EA20CU;IACE,aAAA;IACA,mBAAA;EAz0CZ;EA20CY;IACE,sBAAA;EAz0Cd;EA40CY;IACE,sBAAA;EA10Cd;EA60CY;IACE,4BAAA;EA30Cd;AACF;AAo1CA;EAIQ;IACE,qBAAA;EAr1CR;EAw1CU;IACE,aAAA;IACA,mBAAA;EAt1CZ;EAw1CY;IACE,sBAAA;EAt1Cd;EAy1CY;IACE,sBAAA;EAv1Cd;EA01CY;IACE,4BAAA;EAx1Cd;AACF;AAi2CA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AA/1CF;AAi2CE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA/1CJ;;AAq2CI;EACE,aAAA;AAl2CN;AAo2CM;EACE,sCAAA;AAl2CR;;AA62CE;EACE,OAAA;EACA,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;AA12CJ;;AAg3CI;EACE,2BAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;AA72CN;AA+2CM;EACE,qBAAA;AA72CR;AA+2CQ;EACE,2BAAA;AA72CV;AA+2CU;EACE,mCAAA;EACA,iBAAA;EACA,uBAAA;AA72CZ;AAg3CU;EACE,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA92CZ;AAi3CU;EACE,aAAA;AA/2CZ;AAi3CY;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;AA/2Cd;;AAw3CA;EAIQ;IACE,qBAAA;EAx3CR;EA23CU;IACE,aAAA;IACA,mBAAA;EAz3CZ;EA23CY;IACE,sBAAA;EAz3Cd;EA43CY;IACE,sBAAA;EA13Cd;EA63CY;IACE,4BAAA;EA33Cd;AACF;AAo4CA;EAIQ;IACE,qBAAA;EAr4CR;EAw4CU;IACE,aAAA;IACA,mBAAA;EAt4CZ;EAw4CY;IACE,sBAAA;EAt4Cd;EAy4CY;IACE,sBAAA;EAv4Cd;EA04CY;IACE,4BAAA;EAx4Cd;AACF;AAi5CA;EACE;IACE,sBAAA;EA/4CF;EAk5CA;IACE,sBAAA;IACA,2BAAA;EAh5CF;EAm5CA;IACE,YAAA;IACA,iBAAA;EAj5CF;AACF;AAo5CA;EACE;IACE,YAAA;IACA,WAAA;IACA,2BAAA;IACA,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,sBAAA;EAl5CF;EAo5CE;IACE,YAAA;IACA,gCAAA;EAl5CJ;EAo5CI;IACE,WAAA;EAl5CN;EAu5CA;IACE,kBAAA;IACA,UAAA;EAr5CF;AACF;AA+5CA;EACE,0BAAA;EACA,qCAAA;EACA,iBAAA;AA75CF;;AAg6CA;EACE,0BAAA;EACA,sBAAA;AA75CF;;AAg6CA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AA75CF;AA+5CE;EACE,aAAA;AA75CJ;AAg6CE;EACE,WAAA;EACA,cAAA;EACA,mBAAA;AA95CJ;AAi6CE;EACE,aAAA;EACA,eAAA;EACA,WAAA;AA/5CJ;AAi6CI;EACE,sCAAA;EACA,kBAAA;AA/5CN;;AAo6CA;EACE,cAAA;EACA,WAAA;EACA,cAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;AAj6CF;AAm6CE;EACE,sCAAA;AAj6CJ;AAm6CI;EACE,cAAA;AAj6CN;;AAs6CA;EACE,mBAAA;AAn6CF;;AAs6CA;EACE,uBAAA;EACA,kBAAA;EAEA,YAAA;EAEA,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,sCAAA;EACA,qCAAA;AAn6CF;;AAs6CA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAn6CF;AAq6CE;EACE,sBAAA;AAn6CJ;;AAu6CA;EACE,qBAAA;AAp6CF;;AAg7CA;EACE;IACE,oCAAA;IACA,4BAAA;EA76CF;EA+6CE;IACE,0BAAA;EA76CJ;EAi7CA;IACE,8BAAA;EA/6CF;EAk7CA;IACE,2BAAA;EAh7CF;AACF;AA07CE;EACE,kBAAA;AAx7CJ;AA07CI;EACE,kBAAA;AAx7CN;;AA67CA,iBAAA;AACA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA,EAAA,mCAAA;EACA,eAAA;EAEA,iBAAA;EAEA,8BAAA;EACA,kBAAA;EACA,mBAAA;AA57CF;AA87CE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AA57CJ;AA+7CE;EACE,iBAAA;EACA,WAAA;AA77CJ;AAg8CM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AA97CR;AAm8CQ;EACE,WAAA;AAj8CV;AAq8CM;EACE,WAAA;EACA,mBAAA;AAn8CR;AAq8CQ;EACE,sBAAA;EACA,0BAAA;EACA,8BAAA;AAn8CV;AAs8CQ;EACE,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;AAp8CV;AAw8CM;EACE,mBAAA;AAt8CR;AAy8CM;EACE,aAAA;EACA,eAAA;AAv8CR;AAy8CQ;EACE,WAAA;EACA,2BAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,kCAAA;AAv8CV;AAy8CU;EACE,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AAv8CZ;AAy8CY;EACE,sBAAA;AAv8Cd;AA+8CE;EACE,WAAA;EAEA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,OAAA;EACA,mBAAA;AA98CJ;AAg9CI;EACE,WAAA;AA98CN;AAk9CE;EACE,mBAAA;EACA,iBAAA;EACA,WAAA;AAh9CJ;AAk9CI;;EAEE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2CAAA;AAh9CN;AAk9CM;;EACE,sBAAA;AA/8CR;AAk9CM;;EACE,WAAA;EACA,+BAAA;EAEA,4BAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AAh9CR;AAo9CI;EACE,aAAA;EACA,yBAAA;EACA,YAAA;AAl9CN;AAo9CM;EACE,aAAA;AAl9CR;AAu9CE;EACE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA,EAAA,gDAAA;AAr9CJ;AAu9CI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,OAAA;EACA,kBAAA;AAr9CN;AAu9CM;EACE,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,aAAA,EAAA,qCAAA;AAr9CR;AAw9CM;EACE,kBAAA;EACA,aAAA,EAAA,uCAAA;AAt9CR;AA29CI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAz9CN;AA89CE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AA59CJ;AA89CI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA59CN;AA+9CI;EACE,SAAA;EACA,eAAA;EACA,cAAA;AA79CN;;AAk+CA;EAKE,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAn+CF;;AAw+CA;EACE,gBAAA;EACA,UAAA;EACA,aAAA,EAAA,qCAAA;EAGA,aAAA;EACA,WAAA;EACA,aAAA;AAv+CF;;AA0+CA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAv+CF;AAy+CE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAv+CJ;AA6+CE;EAtBF;IAuBI,aAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;EA1+CF;EA4+CE;IACE,WAAA;IACA,YAAA;EA1+CJ;AACF;;AA8+CA;EACE,aAAA;AA3+CF;;AA8+CA;EACE,iBAAA;AA3+CF;AA6+CE;EAEE,uBAAA;AA5+CJ;AA++CE;EACE,iBAAA;AA7+CJ;;AAi/CA;EACE;IACE,aAAA;IACA,eAAA;IACA,WAAA;IACA,UAAA;IACA,aAAA;IACA,aAAA;IACA,qBAAA;IACA,gBAAA;IACA,sBAAA;IACA,iDAAA;IACA,yBAAA;IACA,gCAAA;IACA,eAAA;IACA,WAAA;IACA,sBAAA;IACA,wBAAA,EAAA,mCAAA;IACA,eAAA;IACA,gBAAA;IACA,8CAAA;IACA,gBAAA;IACA,kCAAA;IACA,sBAAA;IACA,SAAA;IACA,gBAAA;EA9+CF;EAg/CE;IACE,wBAAA;IACA,8BAAA;IACA,2BAAA;IACA,oBAAA;IACA,sBAAA;IACA,wBAAA,EAAA,gDAAA;IACA,8BAAA;IACA,4BAAA;IACA,uBAAA;IACA,yBAAA;EA9+CJ;EAg/CI;IACE,wBAAA;IACA,8BAAA;IACA,sBAAA;IACA,6BAAA;IACA,wBAAA,EAAA,8CAAA;EA9+CN;EAg/CM;IACE,yBAAA;IACA,8BAAA;IACA,sBAAA;IACA,wBAAA,EAAA,iCAAA;IACA,6BAAA,EAAA,gDAAA;IACA,oBAAA;IACA,uBAAA;IACA,6BAAA;EA9+CR;EAi/CM;IACE,wBAAA,EAAA,uCAAA;IACA,6BAAA;EA/+CR;AACF;AAq/CA;EACE,aAAA;EACA,SAAA;AAn/CF;;AAs/CA,0BAAA;AACA;EACE,WAAA;AAn/CF;;AAw/CA;EACE,mBAAA;EACA,kBAAA;AAr/CF;;AAw/CA;EACE,iBAAA;EAEA,YAAA;EACA,eAAA;AAt/CF;;AAy/CA;EAEE,0CAAA;AAv/CF;;AA0/CA,wBAAA;AACA;EACE,WAAA;EACA,kBAAA;AAv/CF;;AA0/CA;EACE,mBAAA;AAv/CF;;AA0/CA;;EAEE,cAAA;EACA,gBAAA;EACA,kBAAA;AAv/CF;;AA2/CE;EACE,WAAA;AAx/CJ;AA2/CE;EACE,WAAA;AAz/CJ;;AA6/CA;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AA1/CF;;AA6/CA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AA1/CF;AA4/CE;EACE,mBAAA;AA1/CJ;;AA+/CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;AA5/CF;;AA+/CA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AA5/CF;AA+/CI;EACE,sBAAA;AA7/CN;AA8/CM;EACE,aAAA;AA5/CR;AA8/CM;EACE,eAAA;AA5/CR;AA+/CI;EACE,wBAAA;EACA,sBAAA;EACA,sBAAA;AA7/CN;AAigDI;EACE,sBAAA;AA//CN;AAggDM;EACE,eAAA;AA9/CR;AAggDM;EACE,eAAA;AA9/CR;AAigDI;EACE,wBAAA;EACA,sBAAA;EACA,sBAAA;AA//CN;;AAmgDA;;EAGE,sBAAA;EACA,sBAAA;EACA,sCAAA;AAjgDF;;AAogDA;EACE,wBAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AAjgDF;;AAogDA;EACE,gDAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,wCAAA;EACA,mCAAA;EACA,oCAAA;EACA,qBAAA;EACA,WAAA;EACA,qCAAA;AAjgDF;;AAogDA;;EAEE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;AAjgDF;;AAogDA;EACE;IACE,uBAAA;IACA,oBAAA;IACA,qBAAA;IACA,mBAAA;EAjgDF;EAmgDE;;;;IAIE,uBAAA;IACA,2BAAA;IACA,oBAAA;IACA,qBAAA;EAjgDJ;EAqgDI;IACE,wBAAA;IACA,oBAAA;IACA,2BAAA;EAngDN;EAwgDI;IACE,qCAAA;IACA,iBAAA;EAtgDN;EA0gDM;IACE,8BAAA;IACA,oBAAA;EAxgDR;EA2gDM;IACE,qBAAA;IACA,8BAAA;EAzgDR;EA2gDQ;IACE,0BAAA;EAzgDV;EA6gDM;IACE,oBAAA;EA3gDR;EA8gDM;IACE,gBAAA;IACA,kBAAA;IACA,oCAAA;EA5gDR;EA8gDQ;IACE,4BAAA;IACA,mBAAA;IACA,kBAAA;EA5gDV;EA+gDQ;IACE,cAAA;IACA,gBAAA;IACA,4BAAA;IACA,mBAAA;IACA,8BAAA;EA7gDV;EA+gDU;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;EA7gDZ;EAghDU;IACE,0BAAA;IACA,gBAAA;EA9gDZ;EAihDU;IACE,wBAAA;EA/gDZ;EAmhDQ;IACE,WAAA;EAjhDV;EAohDQ;IACE,8BAAA;IACA,kBAAA;EAlhDV;EAshDM;;;;;IAKE,wBAAA;IACA,oBAAA;IACA,2BAAA;EAphDR;EAuhDM;IACE,2BAAA;IACA,yBAAA;IACA,mBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;EArhDR;EAwhDM;IACE,oBAAA;IACA,2BAAA;EAthDR;EAwhDQ;IACE,sBAAA;IACA,0BAAA;IACA,oBAAA;EAthDV;EAyhDQ;IACE,wBAAA;IACA,oBAAA;EAvhDV;EA4hDI;IACE,wBAAA;EA1hDN;AACF;AA+hDA,4FAAA;AACA;EAGM;IACE,qCAAA;EA/hDN;EAmiDE;IACE,sBAAA;IACA,0BAAA;IACA,0BAAA;EAjiDJ;EAmiDI;IACE,wBAAA;EAjiDN;EAqiDE;IACE,yBAAA;EAniDJ;AACF;AAuiDA;EACE,YAAA;EACA,mBAAA;AAriDF;;AAwiDA;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,2CAAA;EACA,sBAAA;AAriDF;;AAwiDA;EACE;IACE,yBAAA;EAriDF;AACF;AAwiDA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAtiDF;;AAyiDA;EACE,aAAA;EACA,iBAAA;AAtiDF;;AAyiDA;EACE,aAAA;EACA,mBAAA,EAAA,mCAAA;EACA,QAAA,EAAA,2BAAA;EACA,WAAA;AAtiDF;AAuiDE;EACE,6BAAA;AAriDJ;AAuiDE;EACE,8BAAA;AAriDJ;;AAyiDA;EACE,eAAA,EAAA,0BAAA;EACA,iBAAA,EAAA,yCAAA;EACA,gBAAA,EAAA,4CAAA;AAtiDF;;AAyiDA;EACE,eAAA,EAAA,oCAAA;EACA,eAAA,EAAA,0BAAA;EACA,iBAAA,EAAA,2BAAA;AAtiDF;;AAyiDA;EACE,aAAA;EACA,mBAAA,EAAA,+BAAA;EACA,8BAAA,EAAA,iCAAA;EACA,WAAA,EAAA,sBAAA;EACA,gBAAA;AAtiDF;;AAyiDA;EACE,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA,EAAA,8BAAA;EACA,QAAA,EAAA,wCAAA;AAtiDF;;AA0iDA;EACE,aAAA;EACA,eAAA,EAAA,qBAAA;EACA,iBAAA,EAAA,oCAAA;AAviDF;;AA0iDA;EACE,eAAA,EAAA,kCAAA;EACA,YAAA,EAAA,wCAAA;EACA,mBAAA,EAAA,yCAAA;EACA,cAAA,EAAA,8DAAA;AAviDF;;AA0iDA;EACE,eAAA,EAAA,oBAAA;EACA,eAAA,EAAA,0BAAA;EACA,sBAAA,EAAA,oBAAA;AAviDF;;AA0iDA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AAviDF;AAyiDE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AAviDJ;AA2iDE;EACE;IACE,eAAA;EAziDJ;AACF;;AA6iDA,sCAAA;AACA;EACE,yBAAA;AA1iDF;;AA6iDA;EACE,yBAAA;AA1iDF;;AA6iDA;;EAEE,yBAAA;AA1iDF;;AA6iDA;EACE,yBAAA;AA1iDF;;AA6iDA;EACE,gBAAA,EAAA,uCAAA;EACA,YAAA,EAAA,0CAAA;EACA,uBAAA,EAAA,iDAAA;EACA,eAAA,EAAA,wDAAA;AA1iDF;;AA6iDA,+EAAA;AACA;EACE,gBAAA,EAAA,uCAAA;EACA,YAAA,EAAA,oCAAA;EACA,uBAAA,EAAA,6BAAA;EACA,eAAA,EAAA,+CAAA;AA1iDF;;AA6iDA,uDAAA;AACA;EACE,gBAAA,EAAA,oCAAA;EACA,YAAA,EAAA,mBAAA;EACA,uBAAA,EAAA,6BAAA;AA1iDF;;AA8iDA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AA3iDF;AA8iDI;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA5iDN;AA+iDI;EACE,eAAA;EACA,yBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;AA7iDN;AA+iDM;EACE,oCAAA;EACA,sBAAA;EACA,wCAAA;AA7iDR;AAgjDM;EACE,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,2BAAA;AA9iDR;AAgjDQ;EACE,UAAA;EACA,oDAAA;AA9iDV;AAijDQ;EACE,yBAAA;AA/iDV;;AAsjDA,iEAAA;AACA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAnjDF;;AAsjDA;EACE,aAAA;EACA,wCAAA;EACA,mCAAA;EACA,mBAAA;EACA,mBAAA;AAnjDF;;AAsjDA,iDAAA;AACA;EA8GE,gEAAA;EA+CA;sCAAA;EAkCA,2CAAA;EASA,mFAAA;EAeA,mDAAA;EAyBA,qEAAA;EAUA;;;;IAAA;EAwDA;4EAAA;AAv1DF;AAsiDE;;;;;;;;;;;;;;;;;;;;EAoBE,8BAAA;EACA,yBAAA;EACA,kDAAA;AApiDJ;AAuiDE;;;;;;;EAOE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAriDJ;AAwiDE;EACE,8BAAA;EACA,yBAAA;AAtiDJ;AAyiDE;;EAEE,8BAAA;EACA,yBAAA;AAviDJ;AA0iDE;;;;;;;;;;;;;;;;EAgBE,yBAAA;AAxiDJ;AA2iDE;EAAyB,yBAAA;AAxiD3B;AAyiDE;EAA4B,yBAAA;AAtiD9B;AAsiDyD;EAAU,0BAAA;AAniDnE;AAoiDE;EAAsC,yBAAA;AAjiDxC;AAiiDmE;EAAU,0BAAA;AA9hD7E;AA+hD+B;EAAU,0BAAA;AA5hDzC;AA8hDE;;EAEE,yBAAA;AA5hDJ;AA+hDE;EACE,yBAAA;AA7hDJ;AAgiDE;EACE,yBAAA;AA9hDJ;AAgiDI;EACE,yBAAA;AA9hDN;AAkiDE;EACE,8BAAA;AAhiDJ;AAkiDI;EACE,8BAAA;AAhiDN;AAqiDE;EACE,8BAAA;EACA,mDAAA;AAniDJ;AAuiDE;;EAEE,yBAAA;AAriDJ;AAyiDE;;;EAGE,yBAAA;AAviDJ;AA0iDE;EACE,8BAAA;AAxiDJ;AA2iDE;EACE,8BAAA;EACA,yBAAA;AAziDJ;AA4iDE;EACE,yBAAA;AA1iDJ;AA6iDE;;EAEE,yBAAA;AA3iDJ;AA8iDE;EACE,+CAAA;EACA,yBAAA;AA5iDJ;AA+iDE;;;;EAIE,yBAAA;AA7iDJ;AAgjDE;EACE,8BAAA;AA9iDJ;AAijDE;;EAEE,8BAAA;EACA,yBAAA;AA/iDJ;AAqjDE;;;EAGE,yBAAA;AAnjDJ;AAsjDE;EACE,yBAAA;AApjDJ;AAujDE;;;EAGE,yBAAA;AArjDJ;AAwjDE;;;EAGE,yBAAA;AAtjDJ;AAyjDE;EACE,8BAAA;EACA,sDAAA;AAvjDJ;AA0jDE;EACE,8BAAA;AAxjDJ;AA4jDE;EACE,yBAAA;AA1jDJ;AA6jDE;EACE,yBAAA;AA3jDJ;AA+jDE;EACE,yBAAA;AA7jDJ;AAgkDE;EACE,yBAAA;AA9jDJ;AAikDE;;EAEE,qBAAA;EACA,uBAAA;AA/jDJ;AAmkDE;EACE,qBAAA;EACA,gCAAA;AAjkDJ;AAokDE;EACE,WAAA;AAlkDJ;AAqkDE;EACE,mBAAA;EACA,mBAAA;AAnkDJ;AAskDE;EACE,6DAAA;EACA,mBAAA;EACA,yBAAA;AApkDJ;AAukDE;EACE,6DAAA;AArkDJ;AAykDE;;EAEE,gDAAA;AAvkDJ;AA0kDE;EACE,gDAAA;AAxkDJ;AAglDE;;;;EAIE,8BAAA;EACA,yBAAA;AA9kDJ;AAilDE;;;EAGE,yBAAA;AA/kDJ;AAklDE;EACE,yBAAA;AAhlDJ;AAmlDE;;EAEE,8BAAA;EACA,yDAAA;EACA,yBAAA;AAjlDJ;AAolDE;;EAEE,yBAAA;AAllDJ;AAqlDE;;;;EAIE,yBAAA;AAnlDJ;AAslDE;;EAEE,yBAAA;AAplDJ;AAulDE;;EAEE,yBAAA;AArlDJ;AAwlDE;EACE,kDAAA;AAtlDJ;AA2lDE;EACE;IACE,8BAAA;EAzlDJ;EA4lDE;;;;IAIE,kCAAA;EA1lDJ;EA6lDE;;;;;;;IAOE,8BAAA;EA3lDJ;EA8lDE;IACE,8BAAA;EA5lDJ;EA+lDE;;IAEE,8BAAA;EA7lDJ;EAgmDE;IACE,8BAAA;IACA,sDAAA;EA9lDJ;EAimDE;;IAEE,yBAAA;EA/lDJ;EAkmDE;;;IAGE,yBAAA;EAhmDJ;EAmmDE;IACE,kCAAA;EAjmDJ;EAomDE;IACE,8BAAA;IACA,sDAAA;IACA,yBAAA;EAlmDJ;EAqmDE;;;;;;;;;IASE,yBAAA;EAnmDJ;AACF;;AAwmDA,6CAAA;AACA;EAME,4CAAA;EASA,uBAAA;EAqBA,yEAAA;EA0BA,uCAAA;EAMA,yCAAA;EAwBA;yEAAA;EAMA,gEAAA;EAsCA;+EAAA;EAOA,0DAAA;EAKA,6CAAA;EAMA,8CAAA;EAWA,4FAAA;EAcA,6EAAA;EAMA,+EAAA;EAYA,8CAAA;EAoDA;;;8EAAA;EAKA,kBAAA;EAOA,mCAAA;EAQA,0EAAA;EAOA,6DAAA;EAOA,oCAAA;EAOA,wCAAA;EAOA,qCAAA;EAMA,iCAAA;EAMA,wCAAA;EAcA;2EAAA;EAOA;gFAAA;EASA;iDAAA;EAOA,2EAAA;EAMA;0EAAA;EAgBA;4DAAA;EAOA;gDAAA;EAOA;kFAAA;EAcA,8EAAA;EAEA,yDAAA;EAwBA,sFAAA;EAOA,wDAAA;EAOA,4CAAA;EAKA,iBAAA;EAuBA,wEAAA;AAjgEF;AAkjDE;EACE,8BAAA;EACA,yBAAA;AAhjDJ;AAojDE;;;;EAIE,kCAAA;EACA,2BAAA;AAljDJ;AAsjDE;;;;;;;;;;;;;;;;EAgBE,8BAAA;EACA,kDAAA;AApjDJ;AAwjDE;;;EAGE,kCAAA;EACA,2BAAA;AAtjDJ;AAyjDE;EACE,8BAAA;AAvjDJ;AA0jDE;;EAEE,yBAAA;AAxjDJ;AA2jDE;;EAEE,yBAAA;AAzjDJ;AA4jDE;EACE,8BAAA;AA1jDJ;AA8jDE;;EAEE,8BAAA;AA5jDJ;AAgkDE;;;;;;;;;;;;;;;;;;;;EAoBE,yBAAA;AA9jDJ;AAmkDE;EACE,yBAAA;AAjkDJ;AAqkDE;;EAEE,yBAAA;AAnkDJ;AAqkDE;EACE,8BAAA;AAnkDJ;AAskDE;;EAEE,yBAAA;AApkDJ;AAskDE;EACE,8BAAA;AApkDJ;AAukDE;;EAEE,yBAAA;AArkDJ;AAukDE;EACE,8BAAA;AArkDJ;AAwkDE;;EAEE,yBAAA;AAtkDJ;AAwkDE;EACE,8BAAA;AAtkDJ;AAykDE;EACE,yBAAA;EACA,6CAAA;AAvkDJ;AA4kDE;;EAEE,yBAAA;AA1kDJ;AA8kDE;EACE,yBAAA;AA5kDJ;AAglDE;;EAEE,yBAAA;AA9kDJ;AAklDE;;EAEE,yBAAA;AAhlDJ;AAmlDE;;EAEE,yBAAA;AAjlDJ;AAqlDE;EACE,8BAAA;EACA,yBAAA;AAnlDJ;AAslDE;EACE,yBAAA;AAplDJ;AAulDE;EACE,8BAAA;AArlDJ;AAylDE;EACE,yBAAA;EACA,8BAAA;AAvlDJ;AA2lDE;;;EAGE,yBAAA;EACA,6BAAA;AAzlDJ;AA4lDE;EACE,yBAAA;AA1lDJ;AA8lDE;;EAEE,8BAAA;EACA,kDAAA;AA5lDJ;AA+lDE;;EAEE,yBAAA;AA7lDJ;AAgmDE;;EAEE,oCAAA;EACA,yBAAA;AA9lDJ;AAgmDI;;EACE,yBAAA;AA7lDN;AAimDE;;EAEE,yBAAA;AA/lDJ;AAkmDE;;;;EAIE,yBAAA;AAhmDJ;AAmmDE;;;;EAIE,yBAAA;AAjmDJ;AAomDE;;EAEE,yBAAA;EACA,gDAAA;AAlmDJ;AAqmDE;;EAEE,yBAAA;AAnmDJ;AA4mDE;EACE,8BAAA;EACA,kDAAA;EACA,2BAAA;AA1mDJ;AA8mDE;;;EAGE,oCAAA;EACA,8BAAA;AA5mDJ;AAgnDE;;EAEE,oCAAA;EACA,8BAAA;AA9mDJ;AAknDE;;;EAGE,uEAAA;AAhnDJ;AAonDE;;;EAGE,yBAAA;AAlnDJ;AAsnDE;;;EAGE,yBAAA;AApnDJ;AAwnDE;;EAEE,yBAAA;AAtnDJ;AA0nDE;EACE,oCAAA;EACA,yBAAA;AAxnDJ;AA4nDE;;EAEE,yBAAA;AA1nDJ;AA6nDE;EACE,yBAAA;AA3nDJ;AA8nDE;EACE,yBAAA;AA5nDJ;AAioDE;;EAEE,yBAAA;AA/nDJ;AAooDE;;;;EAIE,yBAAA;AAloDJ;AAuoDE;;EAEE,yBAAA;AAroDJ;AAyoDE;;EAEE,yBAAA;AAvoDJ;AA4oDE;;EAEE,uDAAA;EACA,oCAAA;EACA,kDAAA;AA1oDJ;AA6oDE;;;;EAIE,yBAAA;AA3oDJ;AAgpDE;;EAEE,yBAAA;AA9oDJ;AAmpDE;;EAEE,yBAAA;AAjpDJ;AAspDE;EACE,8BAAA;EACA,yBAAA;EACA,uBAAA;AAppDJ;AAupDE;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AArpDJ;AA2pDE;EACE,8BAAA;EACA,iDAAA;EACA,mDAAA;AAzpDJ;AA4pDE;EACE,yBAAA;AA1pDJ;AA6pDE;EACE,yBAAA;AA3pDJ;AA8pDE;;EAEE,yBAAA;AA5pDJ;AA+pDE;EACE,8BAAA;AA7pDJ;AAiqDE;;;EAGE,yBAAA;AA/pDJ;AAmqDE;;;EAGE,yBAAA;AAjqDJ;AAqqDE;EACE,yBAAA;AAnqDJ;AAuqDE;EACE,8BAAA;EACA,iDAAA;AArqDJ;AAwqDE;EACE,yBAAA;AAtqDJ;AAyqDE;;EAEE,yBAAA;AAvqDJ;AA0qDE;EACE,yBAAA;AAxqDJ;AA2qDE;EACE,yBAAA;AAzqDJ;AA6qDE;EACE;;;IAGE,yBAAA;EA3qDJ;EA8qDE;;;IAGE,yBAAA;EA5qDJ;AACF;;AAgrDA,gFAAA;AAEE;EACE;;;;;GAAA;EAMA,8BAAA;EAEA,gBAAA;EAOA,oBAAA;EA4BA,2CAAA;EAOA,0CAAA;EASA,6EAAA;AA9tDJ;AA4qDI;EACE,8BAAA;EACA,2BAAA;EACA,sDAAA;AA1qDN;AA8qDI;EACE,8BAAA;EACA,wDAAA;EAEA,qBAAA;EAKA,2BAAA;EAOA,0DAAA;AAvrDN;AA4qDM;EACE,8BAAA;AA1qDR;AA8qDM;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AA5qDR;AAgrDM;EACE,8BAAA;AA9qDR;AAgrDQ;EACE,8BAAA;EACA,2BAAA;AA9qDV;AAorDI;;EAEE,8BAAA;EACA,iDAAA;AAlrDN;AAsrDI;;;;;EAKE,kCAAA;AAprDN;AAwrDI;;;;EAIE,oCAAA;AAtrDN;AAyrDI;EACE,oCAAA;AAvrDN;;AA8rDA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AA3rDF;;AA8rDA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA3rDF;AA6rDE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AA3rDJ;;AA+rDA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AA5rDF;AA8rDE;EACE,WAAA;AA5rDJ;AA+rDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AA7rDJ;AAgsDE;EACE,gBAAA;EACA,WAAA;AA9rDJ;;AAosDE;EACE,WAAA;AAjsDJ;AAmsDI;EAAgB,WAAA;AAhsDpB;AAisDI;EAAmB,cAAA;AA9rDvB;;AAksDA,gFAAA;AAEA;EACE,eAAA;EACA,QAAA;EACA,YAAA;EACA,+BAAA;AAhsDF;;AAmsDA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yEAAA;EACA,uBAAA;EACA,YAAA;AAhsDF;AAksDE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;AAhsDJ;AAmsDE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;AAjsDJ;AAmsDI;EACE,mBAAA;AAjsDN;AAqsDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAnsDJ;AAssDE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AApsDJ;AAusDE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AArsDJ;;AAysDA,oCAAA;AAEE;EACE,mBAAA;EACA,wEAAA;AAvsDJ;AAysDI;EACE,cAAA;EACA,8CAAA;AAvsDN;AA0sDI;EACE,mBAAA;AAxsDN;AA2sDI;EACE,qBAAA;EACA,mBAAA;AAzsDN;AA4sDI;EACE,cAAA;AA1sDN;;AA+sDA;EACE,cAAA;AA5sDF;AA8sDE;EACE,eAAA;EACA,oBAAA;AA5sDJ;AAgtDI;EACE,qCAAA;AA9sDN;;AAmtDA,uFAAA;AACA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;AAhtDF;AAktDE;EACE,WAAA;AAhtDJ;AAmtDE;EACE,eAAA;AAjtDJ;;AAqtDA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAltDF;;AAqtDA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAltDF;AAotDE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAltDJ;AAqtDE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,qCAAA;AAntDJ;AAstDE;EACE,yBAAA;EACA,mBAAA;AAptDJ;AAutDE;EACE,yBAAA;EACA,mBAAA;AArtDJ;AAwtDE;EACE,yBAAA;EACA,mBAAA;AAttDJ;AAytDE;EACE,yBAAA;EACA,mBAAA;AAvtDJ;;AA2tDA;;;;;;EAME,yBAAA;AAxtDF;;AA2tDA;;;EAGE,8BAAA;AAxtDF;;AA2tDA;;;;;;EAME,yBAAA;AAxtDF;;AA2tDA;;;EAGE,8BAAA;AAxtDF;;AA2tDA;;;;;;EAME,yBAAA;AAxtDF;;AA2tDA;;;EAGE,8BAAA;AAxtDF;;AA2tDA;;;;;;EAME,yBAAA;AAxtDF;;AA2tDA;;;EAGE,8BAAA;AAxtDF;;AA2tDA;;;EAGE,yBAAA;EACA,6CAAA;AAxtDF;;AA2tDA;EACE,yBAAA;AAxtDF;;AA2tDA;;EAEE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,qDAAA;AAxtDF;AA0tDE;;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAvtDJ;AA0tDE;;EACE,mBAAA;EACA,2BAAA;AAvtDJ;;AA2tDA;EACE,YAAA;EACA,cAAA;AAxtDF;AA0tDE;EAJF;IAKI,YAAA;EAvtDF;AACF;;AA0tDA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mCAAA;EACA,cAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iCAAA;AAvtDF;AAytDE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAvtDJ;AA0tDE;EACE,oCAAA;AAxtDJ;AA2tDE;EACE,0BAAA;EACA,mBAAA;AAztDJ;;AA6tDA;EACE,oCAAA;EACA,cAAA;AA1tDF;;AA6tDA,kFAAA;AAEE;;EAEE,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA3tDJ;AA8tDE;EACE,WAAA;AA5tDJ;AA+tDE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AA7tDJ;AAguDE;EACE,eAAA;AA9tDJ;AAiuDE;EACE,kCAAA;EACA,yBAAA;EACA,oCAAA;AA/tDJ;AAiuDI;EACE,8CAAA;AA/tDN;AAmuDE;EACE;;IAEE,gBAAA;IACA,YAAA;IACA,eAAA;EAjuDJ;AACF;;AAquDA;EACE,kCAAA;EACA,yBAAA;EACA,oCAAA;AAluDF;AAouDE;EACE,+CAAA;AAluDJ","sourcesContent":["* {\n  padding: 0px;\n  margin: 0px;\n}\n\nbody {\n  background: #efeeee;\n  counter-reset: my-sec-counter;\n}\n\n/* ── Preview dialog scroll ────────────────────────────────────────────────\n   Strategy: surface = fixed 80vh clip (overflow:hidden in styles.scss).\n   view-flow fills surface with flex-column; header is shrink-0;\n   container1 is the ONE scrollable element (flex:1; overflow-y:auto).\n   This guarantees the scrollbar is always visible whenever content\n   overflows — even for short flows.\n   ─────────────────────────────────────────────────────────────────────── */\n\n/* view-flow fills the surface height exactly via flex-column */\n.view-flow.dialog-scroll-wrapper.preview-mode {\n  display: flex !important;\n  flex-direction: column !important;\n  height: 100% !important;\n  max-height: none !important;\n  overflow: hidden !important;\n}\n\n/* Sticky header — fixed height, never shrinks */\n.view-flow.dialog-scroll-wrapper.preview-mode .preview-dialog-header {\n  flex-shrink: 0 !important;\n  position: static !important; /* no sticky needed — header is pinned by flex */\n}\n\n/* container1 — THE scroll host, consumes all remaining height */\n.view-flow.dialog-scroll-wrapper.preview-mode .container1 {\n  flex: 1 1 auto !important;\n  min-height: 0 !important;\n  height: 0 !important; /* forces flex child to not exceed its flex allocation */\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  padding-bottom: 64px !important;\n}\n\n/* Inner layout wrappers — no overflow traps */\n.view-flow.dialog-scroll-wrapper.preview-mode .flow-layout-container,\n.view-flow.dialog-scroll-wrapper.preview-mode .flow-main-grid,\n.view-flow.dialog-scroll-wrapper.preview-mode .flow-main-content,\n.view-flow.dialog-scroll-wrapper.preview-mode .flow-sidebar {\n  overflow: visible !important;\n}\n\n/* Always show full description — no 60px collapse in preview */\n.view-flow.dialog-scroll-wrapper.preview-mode .description-content {\n  max-height: none !important;\n  overflow: visible !important;\n}\n\n/* Fallback for dialog-scroll-wrapper used outside preview-mode */\n.dialog-scroll-wrapper:not(.preview-mode) {\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n// Preview dialog header - matches version history panel style\n.preview-dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #ffffff;\n  position: sticky;\n  top: 0;\n  z-index: 20;\n\n  .header-content {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    flex: 1;\n    min-width: 0;\n    padding-right: 48px;\n  }\n\n  h2 {\n    margin: 0;\n    font-size: 20px !important;\n    font-weight: 600;\n    color: #212427;\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .version-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 12px;\n    background-color: #5ea1d8;\n    color: #fff;\n    border-radius: 4px;\n    font-size: 13px;\n    font-weight: 500;\n    width: fit-content;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      color: #fff;\n    }\n  }\n\n  .preview-unique-code {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 8px;\n    margin-top: 2px;\n    font-size: 13px;\n    color: #666;\n    max-width: 100%;\n\n    .preview-unique-code-label {\n      font-weight: 600;\n      color: #212427;\n    }\n\n    .preview-unique-code-value {\n      font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,\n        \"Liberation Mono\", \"Courier New\", monospace;\n      font-size: 12px;\n      word-break: break-all;\n      color: #212427;\n    }\n  }\n\n  .close-button {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    color: #666;\n\n    mat-icon {\n      color: #666;\n    }\n  }\n}\n\n@media (max-width: 640px) {\n  .preview-dialog-header {\n    padding: 16px;\n\n    h2 {\n      font-size: 18px !important;\n    }\n\n    .header-content {\n      padding-right: 40px;\n    }\n\n    .version-badge {\n      font-size: 12px;\n      padding: 3px 10px;\n\n      mat-icon {\n        font-size: 14px;\n        width: 14px;\n        height: 14px;\n      }\n    }\n\n    .close-button {\n      top: 8px;\n      right: 8px;\n    }\n  }\n}\n\n.view-flow {\n  // Global style for View Build link (ensure visible pink hyperlink)\n  .view-build-link {\n    color: #e91e63 !important; // Flowchest pink\n    text-decoration: underline !important;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer !important;\n    transition: all 0.2s ease;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n\n    &:hover {\n      color: #c2185b !important;\n      opacity: 0.85;\n    }\n\n    &:active,\n    &:visited {\n      color: #e91e63 !important;\n    }\n  }\n\n  background: #efeeee;\n  min-height: 100vh;\n  padding-top: 0;\n  width: 100%;\n  overflow-x: hidden;\n\n  .container1 {\n    max-width: 100%;\n    width: 100%;\n    margin: 0px auto;\n    background: transparent;\n    padding-bottom: 30px;\n    padding: 0px;\n\n    .user-sec {\n      display: flex;\n      padding: 20px 24px;\n      background: #fff;\n      border: 1px solid #ddd;\n      box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n      margin: 0px;\n      border-radius: 0;\n      position: relative;\n      border-left: none;\n      border-right: none;\n\n      .user-details {\n        flex: 1;\n        display: flex;\n\n        .user-ico {\n          flex: 1;\n          display: none !important;\n\n          img {\n            width: 180px !important;\n            height: 180px;\n            border-radius: 100%;\n            object-fit: cover;\n            max-width: 200px;\n          }\n        }\n\n        .ico-details {\n          flex: 4;\n          padding-left: 0px;\n          display: flex;\n          flex-direction: column;\n\n          p {\n            margin-bottom: 20px !important;\n            margin-top: 0px !important;\n            justify-content: flex-end !important;\n          }\n\n          .profilepic {\n            display: flex;\n            align-items: center;\n            margin-bottom: 20px;\n            flex-wrap: wrap;\n\n            .profinner {\n              max-width: 500px;\n              width: 100%;\n              display: flex;\n              align-items: center;\n              flex-wrap: wrap;\n\n              & > div {\n                width: auto;\n                margin-right: 20px;\n                display: block;\n\n                &:last-child {\n                  span {\n                    color: rgba(0, 0, 0, 0.54) !important;\n                    font-weight: 400 !important;\n\n                    .mat-icon {\n                      color: rgba(0, 0, 0, 0.54) !important;\n                      font-size: 18px;\n                    }\n                  }\n                }\n              }\n            }\n\n            .u-ico {\n              margin-right: 15px;\n            }\n\n            .qrcode {\n              flex: 1;\n              display: flex;\n              justify-content: flex-end;\n              align-items: flex-end;\n\n              span {\n                font-weight: 400 !important;\n                color: #212427;\n              }\n            }\n\n            p {\n              margin: 0px !important;\n            }\n\n            & > div {\n              &:last-child {\n                margin-right: 0px;\n              }\n            }\n\n            img {\n              border-radius: 50%;\n              cursor: pointer;\n            }\n          }\n\n          .like {\n            max-width: 100%;\n            margin-bottom: 0px;\n            display: flex;\n\n            ul {\n              max-width: 500px;\n              width: 100%;\n              display: flex;\n\n              margin-left: -17px;\n              li {\n                height: 100%;\n                justify-content: flex-start;\n\n                i {\n                  font-size: 25px;\n                  color: gray;\n                  text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n                  margin-bottom: 5px;\n                }\n\n                span {\n                  font-size: 10px;                  \n                  font-weight: 600;\n                  text-align: center;\n                  color: #212427 !important;\n                  padding: 0px !important;\n                  min-height: 30px;\n                  margin-left: 0px;\n                }\n\n                // &:last-child{\n                //   display: none;\n                // }\n                // &:nth-last-child(2){\n                //   display: none;\n                // }\n              }\n            }\n\n            div {\n              flex: 1;\n              text-align: right;\n            }\n          }\n        }\n      }\n    }\n\n    // Flow-style layout container\n    .flow-layout-container {\n      width: 100%;\n      padding: 0;\n      margin: 0;\n\n      .flow-main-grid {\n        display: grid;\n        grid-template-columns: minmax(0, 1fr) 402px;\n        gap: 24px;\n        max-width: 100%;\n        margin: 0;\n        padding: 16px 24px;\n        background: #f6f7f9;\n\n        @media (min-width: 1920px) {\n          max-width: 1920px;\n          margin: 0 auto;\n          padding: 24px 48px;\n        }\n\n        @media (max-width: 1024px) {\n          grid-template-columns: 1fr;\n          gap: 16px;\n          padding: 16px;\n          background: transparent;\n        }\n\n        @media (max-width: 768px) {\n          padding: 12px;\n          gap: 12px;\n        }\n      }\n    }\n\n    // Main content area (left column)\n    .flow-main-content {\n      min-width: 0; // Prevents grid overflow\n\n      /* Sticky Flow Title Bar */\n      // Completion Progress Card (Mobile)\n      .completion-progress-card-mobile {\n        background: transparent;\n        border-radius: 12px;\n        margin: 3px 0 4px 0;\n        padding: 0;\n        box-sizing: border-box;\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n\n        .completion-progress-content-mobile {\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n          width: 100%;\n\n          .completion-progress-bar-mobile {\n            width: 100%;\n            height: 24px;\n            background: #e0e0e0;\n            border-radius: 4px;\n            overflow: hidden;\n            position: relative;\n            display: flex;\n            align-items: center;\n          \n            .completion-progress-fill-mobile {\n              height: 100%;\n              background: linear-gradient(90deg, #5ea1d8 0%, #6bb3e8 100%);\n              border-radius: 4px;\n              transition: width 0.3s ease;\n              position: relative;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              min-width: fit-content;\n\n              .progress-bar-percentage-mobile {\n                color: white;\n                font-size: 12px;\n                font-weight: 600;\n                padding: 0 8px;\n                white-space: nowrap;\n              }\n            }\n\n            .progress-bar-percentage-empty-mobile {\n              position: absolute;\n              left: 8px;\n              top: 50%;\n              transform: translateY(-50%);\n              color: #606060;\n              font-size: 12px;\n              font-weight: 600;\n            }\n          }\n\n          .progress-step-row-mobile {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            width: 100%;\n            padding: 0 16px;\n            box-sizing: border-box;\n\n            .autoplay-toggle-mobile {\n              flex-shrink: 0;\n              margin-left: auto;\n              padding: 0;\n              display: inline-flex;\n              align-items: center;\n              border: none;\n              background: transparent;\n              cursor: pointer;\n              border-radius: 999px;\n              transition: opacity 0.2s ease;\n              outline: none;\n\n              &:hover {\n                opacity: 0.9;\n              }\n\n              &:focus,\n              &:focus-visible,\n              &:active {\n                outline: none;\n                border: none;\n              }\n\n              .toggle-track {\n                position: relative;\n                width: 60px;\n                height: 28px;\n                border-radius: 28px;\n                background: #dadce0;\n                display: inline-block;\n                transition: background 0.25s ease;\n\n                &.active {\n                  background: #e83e8c;\n                }\n              }\n\n              .toggle-thumb {\n                position: absolute;\n                top: 2px;\n                left: 2px;\n                width: 24px;\n                height: 24px;\n                border-radius: 50%;\n                background: #ffffff;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                transition: transform 0.25s ease;\n                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n\n                &.active {\n                  transform: translateX(32px);\n\n                  .thumb-icon {\n                    color: #5ea1d8;\n                  }\n                }\n              }\n\n              .thumb-icon {\n                font-size: 16px;\n                color: #5ea1d8;\n                line-height: 1;\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                width: 16px;\n                height: 16px;\n                margin: 0;\n                padding: 0;\n              }\n            }\n\n            .progress-step-info-mobile {\n              font-size: 12px;\n              color: #606060;\n              line-height: 1.2;\n              text-align: left;\n\n              .completion-code-badge {\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                margin-left: 8px;\n                padding: 2px 8px;\n                border-radius: 999px;\n                background-color: #f0f4fa;\n                color: #3b4a60;\n                font-size: 10px;\n                font-weight: 600;\n              }\n            }\n          }\n        }\n      }\n\n      .completion-progress-card-mobile.restarted {\n        .completion-progress-bar-mobile {\n          background: #e3f2fd;\n        }\n      }\n\n      .flow-title-sticky {\n        // position: relative;\n        top: 88px; /* mobile: below header + filters/tabs */\n        z-index: 0; /* always below sidebar */\n        background: #ffffff;\n        border-radius: 16px;\n        ////box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n        padding: 16px;\n        margin-bottom: 16px;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        pointer-events: auto;\n\n        .dialog-close-button {\n          margin-right: 8px;\n        }\n\n        .version-history-button {\n          display: inline-flex;\n          align-items: center;\n          gap: 4px;\n          padding: 4px 12px;\n          background: #5ea1d8;\n          color: #fff;\n          border-radius: 6px;\n          font-size: 13px;\n          font-weight: 500;\n          min-width: auto;\n          height: auto;\n          line-height: 1.4;\n          cursor: pointer;\n          transition: background-color 0.2s ease;\n\n          mat-icon {\n            font-size: 16px;\n            width: 16px;\n            height: 16px;\n            color: #fff;\n          }\n\n          span {\n            color: #fff;\n          }\n\n          &:hover {\n            background: #4a90c6;\n          }\n        }\n\n        @media (max-width: 1024px) {\n          border-radius: 0;\n          box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);\n          border-bottom: 1px solid #e0e0e0;\n          padding: 8px 0 0 0;\n          margin-bottom: 0;\n        }\n        flex-direction: row;\n        writing-mode: horizontal-tb;\n        text-orientation: mixed;\n        direction: ltr;\n\n        .autoplay-toggle {\n          margin-left: auto;\n          display: inline-flex;\n          align-items: center;\n          gap: 8px;\n          padding: 4px 10px 4px 4px;\n          border: none;\n          background: transparent;\n          cursor: pointer;\n          border-radius: 999px;\n          transition: opacity 0.2s ease;\n          outline: none;\n\n          &:hover {\n            opacity: 0.9;\n          }\n\n          &:focus,\n          &:focus-visible,\n          &:active {\n            outline: none;\n            border: none;\n          }\n\n          .toggle-track {\n            position: relative;\n            width: 60px;\n            height: 28px;\n            border-radius: 28px;\n            background: #dadce0;\n            display: inline-block;\n            transition: background 0.25s ease;\n            margin-right: 4px;\n\n            &.active {\n              background: #e83e8c;\n            }\n          }\n\n          .toggle-thumb {\n            position: absolute;\n            top: 2px;\n            left: 2px;\n            width: 24px;\n            height: 24px;\n            border-radius: 50%;\n            background: #ffffff;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            transition: transform 0.25s ease;\n            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n\n            &.active {\n              transform: translateX(32px);\n\n              .thumb-icon {\n                color: #5ea1d8;\n              }\n            }\n          }\n\n          .thumb-icon {\n            font-size: 16px;\n            color: #5ea1d8;\n            line-height: 1;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            width: 16px;\n            height: 16px;\n            margin: 0;\n            padding: 0;\n          }\n\n          .toggle-label {\n            font-size: 12px;\n            font-weight: 600;\n            color: #202124;\n            text-transform: uppercase;\n            letter-spacing: 0.04em;\n          }\n        }\n\n        .autoplay-tooltip-mobile {\n          margin-top: 4px;\n          padding: 6px 10px;\n          background: rgba(0, 0, 0, 0.85);\n          color: #ffffff;\n          border-radius: 8px;\n          font-size: 12px;\n          line-height: 1.4;\n          max-width: 240px;\n          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);\n          display: inline-flex;\n          align-items: center;\n        }\n\n        .video-title-sticky {\n          font-size: 20px;\n          font-weight: 600;\n          line-height: 1.3;\n          color: #0f0f0f;\n          margin: 0;\n          font-family: \"Raleway\", sans-serif;\n          flex: 1;\n          min-width: 0;\n          writing-mode: horizontal-tb;\n          text-orientation: mixed;\n          direction: ltr;\n          transform: none;\n        }\n      }\n\n      // Flow Info Panel\n      .flow-info-panel {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        padding: 12px 16px;\n        background: #ffffff;\n        border-radius: 16px;\n       //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n        margin-bottom: 16px;\n\n        @media (max-width: 1024px) {\n          background: #f9f9f9;\n          border-radius: 8px;\n          box-shadow: none;\n        }\n        overflow-x: auto;\n        overflow-y: hidden;\n        -webkit-overflow-scrolling: touch;\n        scrollbar-width: thin;\n        scrollbar-color: #888 #f1f1f1;\n        flex-direction: row;\n        writing-mode: horizontal-tb;\n        text-orientation: mixed;\n        direction: ltr;\n\n        &::-webkit-scrollbar {\n          height: 6px;\n        }\n\n        &::-webkit-scrollbar-track {\n          background: #f1f1f1;\n          border-radius: 3px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n          background: #888;\n          border-radius: 3px;\n\n          &:hover {\n            background: #555;\n          }\n        }\n\n        .info-badge {\n          display: inline-flex;\n          align-items: center;\n          gap: 6px;\n          font-size: 13px;\n          font-weight: 500;\n          font-family: \"Raleway\", sans-serif;\n          color: #0f0f0f;\n          background: white;\n          border: 1px solid #e0e0e0;\n          border-radius: 16px;\n          padding: 4px 12px;\n          cursor: pointer;\n          transition: all 0.2s;\n          white-space: nowrap;\n          flex-shrink: 0;\n          min-width: fit-content;\n          writing-mode: horizontal-tb;\n          text-orientation: mixed;\n          direction: ltr;\n          transform: none;\n\n          &:hover {\n            background: #f5f5f5;\n            border-color: #5ea1d8;\n          }\n\n          &.active {\n            background: #5ea1d8;\n            color: #0f0f0f;\n            border-color: #5ea1d8;\n            writing-mode: horizontal-tb;\n            text-orientation: mixed;\n            transform: none;\n\n            .info-icon,\n            .info-label,\n            .info-step-title {\n              color: #0f0f0f;\n              writing-mode: horizontal-tb;\n              text-orientation: mixed;\n            }\n          }\n\n          .info-badge-bookmark-btn {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n            width: 22px;\n            height: 22px;\n            margin-left: 2px;\n            padding: 0;\n            border: none;\n            border-radius: 4px;\n            background: transparent;\n            color: #666666;\n            cursor: pointer;\n            line-height: 1;\n\n            mat-icon {\n              font-size: 16px;\n              width: 16px;\n              height: 16px;\n            }\n\n            mat-icon.bookmarked {\n              color: #5ea1d8;\n            }\n\n            &:hover {\n              background: rgba(94, 161, 216, 0.12);\n              color: #5ea1d8;\n            }\n          }\n\n          &.active .info-badge-bookmark-btn {\n            color: #0f0f0f;\n\n            mat-icon.bookmarked {\n              color: #ffffff;\n            }\n\n            &:hover {\n              background: rgba(255, 255, 255, 0.25);\n              color: #ffffff;\n            }\n          }\n\n          .info-icon {\n            font-size: 14px;\n            flex-shrink: 0;\n            line-height: 1;\n            writing-mode: horizontal-tb;\n            text-orientation: mixed;\n          }\n\n          .info-label {\n            font-family: \"Raleway\", sans-serif;\n            flex-shrink: 0;\n            font-size: 13px;\n            writing-mode: horizontal-tb;\n            text-orientation: mixed;\n          }\n\n          .info-step-title {\n            font-size: 11px;\n            color: #606060;\n            margin-left: 4px;\n            max-width: 120px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            font-family: \"Raleway\", sans-serif;\n            writing-mode: horizontal-tb;\n            text-orientation: mixed;\n\n            @media (max-width: 768px) {\n              display: none;\n            }\n          }\n        }\n\n        @media (max-width: 768px) {\n          gap: 6px;\n          padding: 10px 12px;\n\n          .info-badge {\n            font-size: 12px;\n            padding: 3px 10px;\n            font-family: \"Raleway\", sans-serif;\n\n            .info-icon {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n\n      // Video Player Section\n      .video-player-section {\n        background: #000;\n        border-radius: 12px;\n        overflow: hidden;\n        margin-bottom: 16px;\n        position: relative;\n\n        .img-wrap {\n          width: 100%;\n          position: relative;\n          padding-bottom: 56.25%; // Standard 16:9 video aspect ratio\n          height: 0;\n          overflow: hidden;\n          background: #000;\n\n          img,\n          video {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            object-fit: contain; // Maintains video aspect ratio\n            background: #000;\n          }\n\n          .main-video-player {\n            width: 100%;\n            height: 100%;\n          }\n        }\n\n        .item {\n          padding: 20px;\n          background: #fff;\n          width: 100%;\n          min-height: 400px;\n        }\n\n        .clickarrow {\n          position: absolute;\n          top: 50%;\n          left: 0;\n          right: 0;\n          transform: translateY(-50%);\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          padding: 0 16px;\n          pointer-events: none;\n\n          .owl-prev,\n          .owl-next {\n            pointer-events: all;\n            background: rgba(0, 0, 0, 0.65);\n            color: white;\n            border: none;\n            border-radius: 50%;\n            width: 48px;\n            height: 48px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            transition: background 0.2s, transform 0.2s;\n            font-size: 26px;\n            font-weight: bold;\n            padding: 0;\n            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n            margin: 0;\n\n            &:hover:not(:disabled) {\n              background: rgba(0, 0, 0, 0.8);\n              transform: translateY(-1px);\n            }\n\n            &:disabled,\n            &[hidden] {\n              display: none;\n            }\n\n            span {\n              font-size: 30px;\n              line-height: 1;\n              font-weight: bold;\n            }\n          }\n\n          .owl-prev {\n            margin-right: auto;\n            margin-left: 0;\n          }\n\n          .owl-next {\n            margin-left: auto;\n            margin-right: 0;\n          }\n        }\n      }\n\n    // Video Metadata Section\n    .video-metadata {\n      padding: 16px;\n      background: #ffffff;\n      border-radius: 16px;\n     //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n      margin-bottom: 16px;\n\n      @media (max-width: 1024px) {\n        padding: 16px 0;\n        background: transparent;\n        border-radius: 0;\n        box-shadow: none;\n        border-bottom: 1px solid #e0e0e0;\n      }\n\n        .step-header {\n          display: flex;\n          align-items: flex-start;\n          gap: 16px;\n          margin-bottom: 12px;\n          flex-wrap: wrap;\n          justify-content: space-between;\n\n          .step-header-main {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            flex: 1;\n            min-width: 0;\n\n            span.safety-step-icon {\n              color: #d32f2f;\n              font-size: 22px;\n              line-height: 1;\n              width: 22px;\n              height: 22px;\n              display: inline-flex;\n              align-items: center;\n              justify-content: center;\n              flex-shrink: 0;\n              cursor: default;\n              user-select: none;\n            }\n          }\n\n          .s-num {\n            flex-shrink: 0;\n          }\n\n          .video-title {\n            font-size: 20px;\n            font-weight: 500;\n            line-height: 28px;\n            color: #0f0f0f;\n            margin: 0;\n            flex: 1;\n            min-width: 0;\n\n            &.video-title--active-step {\n              color: #0f0f0f;\n            }\n          }\n\n          .share-icon {\n            cursor: pointer;\n            color: #606060;\n            flex-shrink: 0;\n          }\n        }\n\n        .flow-unique-code {\n          display: flex;\n          flex-wrap: wrap;\n          align-items: center;\n          gap: 10px;\n          margin: 0 0 10px;\n          font-size: 13px;\n          color: #666666;\n          max-width: 100%;\n\n          .flow-unique-code-value {\n            font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,\n              \"Liberation Mono\", \"Courier New\", monospace;\n            font-size: 12px;\n            word-break: break-all;\n            color: #5ea1d8;\n          }\n\n          .flow-category-badge {\n            display: inline-flex;\n            align-items: center;\n            gap: 4px;\n            padding: 2px 8px;\n            border-radius: 999px;\n            background: #eef4fb;\n            color: #1d67a3;\n            font-size: 12px;\n            font-weight: 500;\n            white-space: nowrap;\n\n            mat-icon {\n              font-size: 14px;\n              width: 14px;\n              height: 14px;\n            }\n          }\n        }\n\n        .video-actions-bar {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          overflow-x: auto;\n          overflow-y: hidden;\n          -webkit-overflow-scrolling: touch;\n\n          &::-webkit-scrollbar {\n            height: 6px;\n          }\n\n          &::-webkit-scrollbar-thumb {\n            background: rgba(0, 0, 0, 0.2);\n            border-radius: 4px;\n          }\n\n          &::-webkit-scrollbar-thumb:hover {\n            background: rgba(0, 0, 0, 0.3);\n          }\n\n          .action-buttons {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            flex-wrap: nowrap;\n            width: max-content;\n\n            .action-item {\n              display: flex;\n              align-items: center;\n              gap: 8px;\n              padding: 8px 16px;\n              border-radius: 18px;\n              cursor: pointer;\n              transition: background 0.2s;\n              background: #f2f2f2;\n              flex: 0 0 auto;\n\n              &:hover:not(.disabled) {\n                background: #e5e5e5;\n              }\n            }\n\n              &.disabled {\n                opacity: 0.5;\n                cursor: not-allowed;\n                pointer-events: none;\n              }\n\n              &.delete-action {\n                background: #ffebee;\n                color: #d32f2f;\n\n                &:hover {\n                  background: #ffcdd2;\n                }\n\n                mat-icon {\n                  color: #d32f2f;\n                }\n\n                span {\n                  color: #d32f2f;\n                }\n              }\n\n              mat-icon {\n                font-size: 20px;\n                width: 20px;\n                height: 20px;\n                color: #000000;\n              }\n\n              // Bookmark icon - show flowchest blue when saved\n              mat-icon[style*=\"#5ea1d8\"] {\n                color: #5ea1d8 !important;\n              }\n\n              span {\n                font-size: 14px;\n                font-weight: 500;\n                color: #212427;\n              }\n\n              mat-slide-toggle {\n                margin: 0;\n              }\n            }\n          }\n        }\n      }\n\n    // Channel Info Section\n    .channel-info-section {\n      padding: 16px;\n      background: #ffffff;\n      border-radius: 16px;\n     //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n      margin-bottom: 16px;\n\n      @media (max-width: 1024px) {\n        padding: 16px 0;\n        background: transparent;\n        border-radius: 0;\n        box-shadow: none;\n        border-bottom: 1px solid #e0e0e0;\n      }\n\n        .channel-header {\n          display: flex;\n          align-items: center;\n          gap: 16px;\n\n          @media (max-width: 768px) {\n            gap: 12px;\n            align-items: flex-start;\n          }\n\n          .avatar-stack-wrap {\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n          }\n\n          .avatar-stack {\n            position: relative;\n            display: flex;\n            align-items: center;\n            flex-shrink: 0;\n            cursor: pointer;\n\n            .video-avatar {\n              position: relative;\n              z-index: 1;\n\n              .channel-avatar-img {\n                width: 48px;\n                height: 48px;\n                border-radius: 50%;\n                object-fit: cover;\n\n                @media (max-width: 768px) {\n                  width: 40px;\n                  height: 40px;\n                }\n              }\n\n              .channel-avatar-icon {\n                font-size: 48px;\n                width: 48px;\n                height: 48px;\n                color: #606060;\n\n                @media (max-width: 768px) {\n                  font-size: 40px;\n                  width: 40px;\n                  height: 40px;\n                }\n              }\n            }\n\n            .collab-avatar-overlap {\n              width: 26px;\n              height: 26px;\n              border-radius: 50%;\n              object-fit: cover;\n              margin-left: -10px;\n              border: 2px solid #fff;\n              z-index: 2;\n              position: relative;\n              flex-shrink: 0;\n\n              @media (max-width: 768px) {\n                width: 22px;\n                height: 22px;\n                margin-left: -8px;\n              }\n            }\n\n            .collab-avatar-extra {\n              position: relative;\n              width: 26px;\n              height: 26px;\n              margin-left: -10px;\n              z-index: 3;\n              flex-shrink: 0;\n              cursor: pointer;\n\n              .collab-extra-img {\n                width: 26px;\n                height: 26px;\n                border-radius: 50%;\n                object-fit: cover;\n                border: 2px solid #fff;\n                display: block;\n              }\n\n              .collab-extra-badge {\n                position: absolute;\n                bottom: -3px;\n                right: -4px;\n                background: #3b82f6;\n                color: #fff;\n                font-size: 7px;\n                font-weight: 700;\n                border-radius: 8px;\n                padding: 1px 3px;\n                line-height: 1.2;\n                white-space: nowrap;\n              }\n\n              @media (max-width: 768px) {\n                width: 22px;\n                height: 22px;\n                margin-left: -8px;\n\n                .collab-extra-img {\n                  width: 22px;\n                  height: 22px;\n                }\n              }\n            }\n\n            &.collab-stack-clickable {\n              cursor: pointer;\n            }\n          }\n\n          .channel-details {\n            flex: 1;\n            min-width: 0;\n            max-width: 100%;\n\n            .channel-name {\n              font-size: 16px;\n              font-weight: 500;\n              color: #0f0f0f;\n              margin-bottom: 4px;\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n\n              .owner-name-link {\n                cursor: pointer;\n                &:hover { text-decoration: underline; }\n              }\n\n              .collab-sep {\n                color: #888;\n                font-weight: 400;\n                font-size: 13px;\n              }\n\n              .collab-coname {\n                font-weight: 500;\n                cursor: pointer;\n                &:hover { text-decoration: underline; }\n              }\n              width: 100%;\n\n              @media (max-width: 768px) {\n                font-size: 15px;\n                margin-bottom: 6px;\n              }\n\n              &:hover {\n                color: #606060;\n              }\n            }\n\n            .channel-meta {\n              display: flex;\n              align-items: center;\n              gap: 8px;\n              flex-wrap: wrap;\n              font-size: 14px;\n              color: #606060;\n              line-height: 1.4;\n              margin-top: 2px;\n\n              span {\n                display: inline-flex;\n                align-items: center;\n                gap: 4px;\n                white-space: nowrap;\n                line-height: 1.4;\n              }\n\n              mat-icon {\n                font-size: 16px;\n                width: 16px;\n                height: 16px;\n                display: inline-flex;\n                align-items: center;\n                vertical-align: middle;\n                margin: 0;\n                flex-shrink: 0;\n              }\n\n              .textbodycolor {\n                color: #606060;\n              }\n\n              .price-tag {\n                color: #e83e8c;\n                cursor: pointer;\n                font-weight: 500;\n\n                &:hover {\n                  text-decoration: underline;\n                }\n              }\n\n              .purchased-tag {\n                color: #606060;\n                background: #f2f2f2;\n                padding: 2px 8px;\n                border-radius: 4px;\n              }\n\n              .version-tag {\n                display: inline-flex;\n                align-items: center;\n                gap: 4px;\n                color: #5ea1d8;\n                background: #f0f0f0;\n                padding: 3px 10px;\n                border-radius: 4px;\n                font-size: 12px;\n                font-weight: 500;\n                cursor: pointer;\n                transition: background-color 0.2s ease;\n\n                mat-icon {\n                  font-size: 14px;\n                  width: 14px;\n                  height: 14px;\n                  color: #5ea1d8;\n                }\n\n                &:hover {\n                  background: #e5e5e5;\n                }\n              }\n\n              @media (max-width: 768px) {\n                gap: 8px;\n                font-size: 13px;\n                flex-wrap: wrap;\n                align-items: center;\n\n                span {\n                  gap: 3px;\n                  font-size: 13px;\n                }\n\n                mat-icon {\n                  font-size: 14px;\n                  width: 14px;\n                  height: 14px;\n                }\n              }\n            }\n          }\n\n          .channel-actions {\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n            flex-shrink: 0;\n            align-items: flex-end;\n\n            .follow-btn {\n              padding: 8px 16px;\n              border-radius: 6px;\n              border: none;\n              font-size: 14px;\n              font-family: \"Raleway\", sans-serif;\n              font-weight: 600;\n              cursor: pointer;\n              transition: all 0.2s ease;\n              white-space: nowrap;\n              text-align: center;\n              display: inline-flex;\n              align-items: center;\n              gap: 8px;\n\n              &.following {\n                background: #f0f0f0;\n                color: #5ea1d8;\n                border: 1px solid #5ea1d8;\n\n                &:hover {\n                  background: rgba(94, 161, 216, 0.1);\n                }\n              }\n\n              &:not(.following) {\n                background: #5ea1d8;\n                color: #ffffff;\n\n                &:hover {\n                  background: #4a8fc4;\n                }\n              }\n            }\n\n            .purchase-btn {\n              padding: 10px 16px;\n              border-radius: 18px;\n              border: none;\n              background: #e83e8c;\n              color: white;\n              font-size: 14px;\n              font-weight: 500;\n              cursor: pointer;\n              transition: background 0.2s;\n              width: 100%;\n              text-align: center;\n\n              &:hover {\n                background: #d0307a;\n              }\n            }\n          }\n        }\n\n        // Actions List Section (within channel-info-section)\n        .actions-list-section {\n          margin-top: 16px;\n          padding-top: 16px;\n          border-top: 1px solid #e0e0e0;\n\n          .actions-list-title {\n            font-size: 18px;\n            font-weight: 500;\n            color: #0f0f0f;\n            margin-bottom: 12px;\n          }\n\n          .actions-list {\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n\n            .action-list-item {\n              display: flex;\n              align-items: center;\n              gap: 12px;\n              padding: 12px 16px;\n              background: white;\n              border: 1px solid #e0e0e0;\n              border-radius: 8px;\n              cursor: pointer;\n              transition: all 0.2s;\n              font-size: 14px;\n              color: #0f0f0f;\n              text-align: left;\n              width: 100%;\n\n              &:hover:not(.disabled):not(.action-list-header) {\n                background: #f5f5f5;\n                border-color: #5ea1d8;\n              }\n\n              &.disabled {\n                opacity: 0.5;\n                cursor: not-allowed;\n              }\n\n              &.delete-action {\n                color: #d32f2f;\n\n                &:hover:not(.disabled) {\n                  background: #ffebee;\n                  border-color: #d32f2f;\n                }\n              }\n\n              &.action-list-header {\n                font-weight: 500;\n                background: #f5f5f5;\n                cursor: default;\n                margin-bottom: 4px;\n              }\n\n              mat-icon {\n                font-size: 20px;\n                width: 20px;\n                height: 20px;\n                color: #606060;\n              }\n\n              span {\n                flex: 1;\n              }\n            }\n\n            .edit-access-section {\n              display: flex;\n              flex-direction: column;\n              gap: 4px;\n\n              .access-options {\n                display: flex;\n                flex-direction: column;\n                gap: 4px;\n                margin-left: 32px;\n\n                .access-option {\n                  padding: 10px 16px;\n                  font-size: 13px;\n                }\n              }\n            }\n          }\n\n          // Mobile responsive styles\n          @media (max-width: 768px) {\n            .actions-list-title {\n              font-size: 16px;\n              margin-bottom: 10px;\n            }\n\n            .actions-list {\n              gap: 6px;\n\n              .action-list-item {\n                padding: 10px 12px;\n                font-size: 13px;\n\n                mat-icon {\n                  font-size: 18px;\n                  width: 18px;\n                  height: 18px;\n                }\n              }\n\n              .edit-access-section {\n                .access-options {\n                  margin-left: 24px;\n\n                  .access-option {\n                    padding: 8px 12px;\n                    font-size: 12px;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n    // Description Section\n    .description-section {\n      padding: 16px;\n      background: #ffffff;\n      border-radius: 16px;\n     //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n      margin-bottom: 16px;\n\n      @media (max-width: 1024px) {\n        background: #f9f9f9;\n        border-radius: 12px;\n        box-shadow: none;\n      }\n\n        .description-header {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          margin-bottom: -16px !important;\n          position: relative;\n\n          h3 {\n            font-size: 16px;\n            font-weight: 500;\n            color: #0f0f0f;\n            margin: 0;\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            flex: 1;\n\n            .duration-timer {\n              display: inline-flex;\n              align-items: center;\n              gap: 4px;\n              font-size: 14px;\n              color: #606060;\n              white-space: nowrap;\n              margin-left: auto;\n\n              mat-icon {\n                font-size: 16px;\n                width: 16px;\n                height: 16px;\n                display: inline-flex;\n                align-items: center;\n                vertical-align: middle;\n                margin: 0;\n                flex-shrink: 0;\n              }\n\n              @media (max-width: 768px) {\n                font-size: 13px;\n\n                mat-icon {\n                  font-size: 14px;\n                  width: 14px;\n                  height: 14px;\n                }\n              }\n            }\n          }\n        }\n\n        .description-content {\n          font-size: 14px;\n          line-height: 20px;\n          color: #0f0f0f;\n          max-height: 60px;\n          overflow: hidden;\n          transition: max-height 0.3s ease;\n\n          &.expanded {\n            max-height: none;\n          }\n\n          .supporting-docs-link {\n            margin-top: 12px;\n\n            a {\n              color: #5ea1d8;\n              text-decoration: none;\n              font-weight: 500;\n\n              &:hover {\n                text-decoration: underline;\n              }\n            }\n          }\n        }\n\n        .expand-description-btn {\n          margin-top: 8px;\n          background: none;\n          border: none;\n          color: #606060;\n          font-size: 14px;\n          font-weight: 500;\n          cursor: pointer;\n          padding: 0;\n\n          &:hover {\n            color: #0f0f0f;\n          }\n        }\n      }\n\n      // Supporting Documents Section\n      .supporting-docs-section {\n        padding: 16px;\n        background: #ffffff;\n        border-radius: 16px;\n        margin-bottom: 16px;\n\n        @media (max-width: 1024px) {\n          background: #f9f9f9;\n          border-radius: 12px;\n          box-shadow: none;\n        }\n\n        .supporting-docs-header {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          margin-bottom: 12px;\n\n          h3 {\n            font-size: 16px;\n            font-weight: 500;\n            color: #0f0f0f;\n            margin: 0;\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            flex: 1;\n\n            .supporting-docs-icon {\n              font-size: 18px;\n              width: 18px;\n              height: 18px;\n              line-height: 18px;\n              color: #606060;\n            }\n          }\n        }\n\n        .supporting-docs-scroll {\n          max-height: 220px;\n          overflow-y: auto;\n          display: flex;\n          flex-direction: column;\n          gap: 4px;\n          padding-right: 4px;\n\n          &::-webkit-scrollbar {\n            width: 4px;\n          }\n          &::-webkit-scrollbar-thumb {\n            background: #d0d0d0;\n            border-radius: 4px;\n          }\n        }\n\n        .supporting-doc-item {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          padding: 8px 10px;\n          border-radius: 8px;\n          cursor: pointer;\n          font-size: 14px;\n          color: #0f0f0f;\n          transition: background 0.15s;\n\n          &:hover {\n            background: #f2f2f2;\n          }\n\n          &--link {\n            color: #5ea1d8;\n          }\n        }\n\n        .supporting-doc-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n          line-height: 18px;\n          flex-shrink: 0;\n          color: #606060;\n\n          &--link {\n            color: #5ea1d8;\n          }\n        }\n\n        .supporting-doc-name {\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        .supportingdoc {\n          display: inline-flex;\n          align-items: center;\n          gap: 4px;\n          color: #5ea1d8;\n          font-size: 14px;\n          font-weight: 500;\n          text-decoration: none;\n          padding: 6px 0;\n          cursor: pointer;\n\n          mat-icon {\n            font-size: 18px;\n            width: 18px;\n            height: 18px;\n            line-height: 18px;\n            vertical-align: middle;\n          }\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n\n      // Featured in blogs — left column, above Customer Feedback\n      .featured-in-blogs-section {\n        padding: 16px;\n        background: #ffffff;\n        border-radius: 16px;\n        margin-bottom: 16px;\n        width: 100%;\n        box-sizing: border-box;\n        border-top: none;\n\n        @media (max-width: 1024px) {\n          background: #f9f9f9;\n          border-radius: 12px;\n        }\n\n        h2 {\n          font-size: 16px;\n          font-weight: 500;\n          color: #0f0f0f;\n          margin: 0 0 12px;\n        }\n\n        .recommendations-list {\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n        }\n\n        .recommendation-item {\n          display: flex;\n          gap: 10px;\n          cursor: pointer;\n          padding: 8px;\n          border-radius: 8px;\n          transition: background 0.15s;\n          overflow: hidden;\n\n          &:hover {\n            background: #f2f2f2;\n          }\n        }\n\n        .recommendation-thumbnail {\n          width: 96px;\n          height: 54px;\n          flex-shrink: 0;\n          border-radius: 6px;\n          overflow: hidden;\n          background: #e5e7eb;\n\n          img,\n          video {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            display: block;\n          }\n        }\n\n        .recommendation-info {\n          min-width: 0;\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          gap: 4px;\n        }\n\n        .recommendation-title {\n          margin: 0;\n          font-size: 14px;\n          font-weight: 600;\n          color: #0f0f0f;\n          line-height: 1.35;\n        }\n\n        .recommendation-meta,\n        .recommendation-creator {\n          font-size: 12px;\n          color: #606060;\n        }\n      }\n\n      // Comments Section\n      .comments-section {\n        padding: 16px;\n        background: #ffffff;\n        border-radius: 16px;\n       //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n        margin-bottom: 16px;\n\n        @media (max-width: 1024px) {\n          padding: 16px 0;\n          background: transparent;\n          border-radius: 0;\n          box-shadow: none;\n        }\n\n        h3 {\n          font-size: 16px;\n          font-weight: 500;\n          color: #0f0f0f;\n          margin-bottom: 24px;\n        }\n\n        .comment-input-section {\n          display: flex;\n          gap: 16px;\n          margin-bottom: 32px;\n\n          .comment-avatar {\n            flex-shrink: 0;\n\n            img {\n              width: 40px;\n              height: 40px;\n              border-radius: 50%;\n              object-fit: cover;\n            }\n\n            .material-icons {\n              font-size: 40px;\n              width: 40px;\n              height: 40px;\n              color: #606060;\n            }\n          }\n\n          .comment-form-wrapper {\n            flex: 1;\n            position: relative;\n\n            form {\n              display: flex;\n              align-items: center;\n              gap: 8px;\n            }\n\n            .comment-input {\n              flex: 1;\n              padding: 8px 0;\n              border: none;\n              border-bottom: 1px solid #e0e0e0;\n              font-size: 14px;\n              color: #0f0f0f;\n              background: transparent;\n\n              &:focus {\n                outline: none;\n                border-bottom-color: #5ea1d8;\n              }\n\n              &::placeholder {\n                color: #909090;\n              }\n            }\n\n            .comment-send-btn {\n              flex-shrink: 0;\n              background: transparent;\n              border: none;\n              color: #5ea1d8;\n              cursor: pointer;\n              padding: 8px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              border-radius: 50%;\n              transition: all 0.2s;\n\n              &:hover:not(:disabled) {\n                background: #f0f0f0;\n                color: #4a8fc4;\n              }\n\n              &:disabled {\n                color: #ccc;\n                cursor: not-allowed;\n              }\n\n              mat-icon {\n                font-size: 20px;\n                width: 20px;\n                height: 20px;\n              }\n            }\n          }\n        }\n\n        .comment-login-prompt {\n          padding: 16px;\n          background: #f9f9f9;\n          border-radius: 8px;\n          text-align: center;\n\n          p {\n            margin: 0;\n            font-size: 14px;\n            color: #606060;\n\n            a {\n              color: #5ea1d8;\n              cursor: pointer;\n              text-decoration: none;\n\n              &:hover {\n                text-decoration: underline;\n              }\n            }\n          }\n        }\n\n        .comments-list {\n          margin-top: 24px;\n\n          .comment-item {\n            display: flex;\n            flex-direction: column;\n            padding: 16px 0;\n            border-bottom: 1px solid #e0e0e0;\n\n            &:last-child {\n              border-bottom: none;\n            }\n\n            .comment-header {\n              display: flex;\n              align-items: center;\n              justify-content: space-between;\n              margin-bottom: 8px;\n\n              .comment-author {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n\n                .comment-avatar-img {\n                  width: 40px;\n                  height: 40px;\n                  border-radius: 50%;\n                  object-fit: cover;\n                }\n\n                .comment-avatar-icon {\n                  font-size: 40px;\n                  width: 40px;\n                  height: 40px;\n                  color: #606060;\n                }\n\n                .comment-author-name {\n                  font-size: 14px;\n                  font-weight: 500;\n                  color: #0f0f0f;\n                  font-family: \"Raleway\", sans-serif;\n                }\n              }\n\n              .comment-date {\n                font-size: 12px;\n                color: #606060;\n                font-family: \"Raleway\", sans-serif;\n              }\n            }\n\n            .comment-text {\n              font-size: 14px;\n              line-height: 20px;\n              color: #0f0f0f;\n              margin-bottom: 8px;\n              font-family: \"Raleway\", sans-serif;\n            }\n\n            .comment-actions {\n              display: flex;\n              align-items: center;\n              gap: 16px;\n              flex-wrap: nowrap;\n              overflow-x: auto;\n              overflow-y: hidden;\n              -ms-overflow-style: none; /* IE/Edge */\n              scrollbar-width: thin;\n\n              &::-webkit-scrollbar {\n                height: 4px;\n              }\n\n              &::-webkit-scrollbar-thumb {\n                background: rgba(0, 0, 0, 0.2);\n                border-radius: 4px;\n              }\n\n              .comment-action-btn {\n                display: flex;\n                align-items: center;\n                gap: 4px;\n                flex: 0 0 auto;\n                background: none;\n                border: none;\n                color: #606060;\n                cursor: pointer;\n                font-size: 14px;\n                font-family: \"Raleway\", sans-serif;\n                padding: 4px 8px;\n                border-radius: 18px;\n                transition: background 0.2s;\n                height: auto;\n                min-height: 28px; /* Consistent height for icon + count */\n\n                mat-icon {\n                  font-size: 18px !important;\n                  width: 18px !important;\n                  height: 18px !important;\n                  line-height: 18px !important;\n                  display: inline-flex !important;\n                  align-items: center !important;\n                  justify-content: center !important;\n                  vertical-align: middle;\n                }\n\n                .like-count {\n                  font-size: 12px;\n                  line-height: 18px;\n                  height: 18px;\n                  display: inline-flex;\n                  align-items: center;\n                  vertical-align: middle;\n                  margin: 0;\n                  padding: 0;\n                }\n\n                &:hover {\n                  background: #f5f5f5;\n                }\n\n                &.liked {\n                  color: #ff4d4d;\n\n                  mat-icon {\n                    color: #ff4d4d;\n                  }\n                }\n\n                mat-icon {\n                  font-size: 18px;\n                  width: 18px;\n                  height: 18px;\n                }\n              }\n            }\n\n            .reply-form {\n              display: flex;\n              align-items: center;\n              gap: 8px;\n              margin-top: 12px;\n              padding: 8px 0;\n\n              .reply-input {\n                flex: 1;\n                padding: 8px 12px;\n                border: 1px solid #e0e0e0;\n                border-radius: 20px;\n                font-size: 14px;\n                color: #0f0f0f;\n                background: #f9f9f9;\n                font-family: \"Raleway\", sans-serif;\n\n                &:focus {\n                  outline: none;\n                  border-color: #5ea1d8;\n                  background: #fff;\n                }\n\n                &::placeholder {\n                  color: #909090;\n                }\n              }\n\n              .reply-send-btn {\n                flex-shrink: 0;\n                background: #5ea1d8;\n                border: none;\n                color: white;\n                cursor: pointer;\n                padding: 8px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                border-radius: 50%;\n                width: 36px;\n                height: 36px;\n                transition: all 0.2s;\n                font-size: 20px;\n\n                &:hover:not(:disabled) {\n                  background: #4a8fc4;\n                  transform: scale(1.05);\n                }\n\n                &:disabled {\n                  background: #ccc;\n                  cursor: not-allowed;\n                  transform: none;\n                }\n              }\n            }\n\n            .child-comments {\n              margin-left: 56px;\n              margin-top: 16px;\n              padding-left: 16px;\n              border-left: 2px solid #e0e0e0;\n\n              .child-comment {\n                padding: 12px 0;\n\n                .comment-header {\n                  .comment-author {\n                    .comment-avatar-img,\n                    .comment-avatar-icon {\n                      width: 32px;\n                      height: 32px;\n                    }\n\n                    .comment-author-name {\n                      font-size: 13px;\n                    }\n                  }\n                }\n\n                .comment-text {\n                  font-size: 13px;\n                }\n              }\n            }\n          }\n        }\n\n        .no-comments {\n          padding: 32px;\n          text-align: center;\n          color: #606060;\n          font-family: \"Raleway\", sans-serif;\n        }\n\n        .view-build-section {\n          margin-top: 24px;\n          padding-top: 16px;\n          border-top: 1px solid #e0e0e0;\n          text-align: center;\n\n          .view-build-link {\n            color: #e91e63 !important;\n            text-decoration: underline !important;\n            font-size: 14px;\n            font-weight: 500;\n            cursor: pointer !important;\n            transition: all 0.2s ease;\n            display: inline-flex;\n            align-items: center;\n            gap: 6px;\n\n            &:hover {\n              color: #c2185b !important;\n              text-decoration: underline !important;\n              opacity: 0.8;\n            }\n\n            &:active {\n              color: #ad1457 !important;\n            }\n\n            &:visited {\n              color: #e91e63 !important;\n            }\n          }\n\n          p {\n            margin: 0;\n            font-size: 14px;\n          }\n        }\n      }\n    }\n\n    // Sidebar (Right Column)\n    .flow-sidebar {\n      width: 402px;\n      min-width: 402px;\n      max-width: 402px;\n      position: relative;\n      z-index: 10; /* ensure sidebar stays above sticky title */\n      overflow-x: hidden;\n      display: flex;\n      flex-direction: column;\n\n      @media (max-width: 1024px) {\n        width: 100%;\n        min-width: 100%;\n        max-width: 100%;\n      }\n\n      .step-navigation {\n        margin-bottom: 24px;\n        flex: 0 0 auto; /* Don't shrink, but allow growth if needed */\n        min-height: 0; /* Allow flex child to shrink */\n\n        .step-scroll {\n          /* Match video player section height - video uses 16:9 (56.25% padding-bottom) */\n          /* Video width calculation:\n             When left sidebar is OPEN:\n               - Main content has margin-left: 240px, so effective viewport: 100vw - 240px\n               - Grid padding: 24px left + 24px right = 48px\n               - Right sidebar: 402px\n               - Grid gap: 24px\n               - Video width (1fr): (100vw - 240px - 48px - 402px - 24px)\n             When left sidebar is CLOSED:\n               - No margin-left, so viewport: 100vw\n               - Grid padding: 48px\n               - Right sidebar: 402px\n               - Grid gap: 24px\n               - Video width (1fr): (100vw - 48px - 402px - 24px)\n             Video height = width * 0.5625 (16:9 aspect ratio)\n          */\n          /* Default: when left sidebar is open - extend slightly beyond video height */\n          max-height: calc(\n            (100vw - 240px - 48px - 402px - 24px) * 0.5625 + 80px\n          );\n          /* For larger screens with max-width constraint */\n          @media (min-width: 1920px) {\n            max-height: calc(\n              (1920px - 240px - 96px - 402px - 24px) * 0.5625 + 80px\n            );\n          }\n          /* Tablet/mobile: single column, full width */\n          @media (max-width: 1024px) {\n            max-height: calc((100vw - 32px) * 0.5625);\n          }\n\n          /* When left sidebar is collapsed (closed), no margin-left */\n          ::ng-deep .flow-main-content.sidebar-collapsed & {\n            max-height: calc((100vw - 48px - 402px - 24px) * 0.5625 + 80px);\n\n            @media (min-width: 1920px) {\n              max-height: calc((1920px - 96px - 402px - 24px) * 0.5625 + 80px);\n            }\n          }\n\n          /* Fallback using :host-context if ::ng-deep doesn't work */\n          :host-context(.flow-main-content.sidebar-collapsed) & {\n            max-height: calc((100vw - 48px - 402px - 24px) * 0.5625 + 80px);\n\n            @media (min-width: 1920px) {\n              max-height: calc((1920px - 96px - 402px - 24px) * 0.5625 + 80px);\n            }\n          }\n          overflow-y: auto;\n          overflow-x: hidden;\n          display: block;\n          width: 100%;\n          padding-right: 8px;\n\n          &::-webkit-scrollbar {\n            width: 8px;\n          }\n\n          &::-webkit-scrollbar-track {\n            background: #f1f1f1;\n            border-radius: 4px;\n          }\n\n          &::-webkit-scrollbar-thumb {\n            background: #888;\n            border-radius: 4px;\n\n            &:hover {\n              background: #555;\n            }\n          }\n        }\n\n        .steps-list {\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n          width: 100%;\n          align-items: stretch;\n          \n          // Maintain consistent height until cover page/video is shown\n          &.cover-not-shown {\n            // Ensure the list maintains its full height until cover is displayed\n            // This prevents the list from collapsing or changing size before the cover is shown\n            min-height: fit-content;\n            height: auto;\n            // Prevent any height transitions that might cause layout shifts\n            transition: none;\n          }\n\n          .step-btn {\n            /* Dynamic spacing: scales with current font-size */\n            padding-block: 1em; /* top & bottom scale with text */\n            padding-inline: 1.125em; /* left & right ~18px at 16px base */\n            border: 1px solid #e0e0e0;\n            border-radius: 6px;\n            background: white;\n            cursor: pointer;\n            font-size: 13px;\n            font-weight: 500;\n            color: #0f0f0f;\n            text-align: left;\n            transition: all 0.2s;\n            display: flex;\n            flex-direction: row;\n            align-items: flex-start;\n            gap: 8px;\n            width: 100%;\n            height: auto; /* allow dynamic height based on content */\n            min-height: auto;\n            white-space: normal;\n            word-break: break-word;\n            overflow: visible; /* show all text */\n\n            .step-text-block {\n              display: flex;\n              flex-direction: column;\n              gap: 4px;\n              flex: 1 1 auto;\n              min-width: 0;\n            }\n\n            &:hover:not(.active) {\n              background: #f9f9f9;\n              border-color: #c0c0c0;\n            }\n\n            &.active {\n              /* Selected step: Flowchest blue with black text - no transition delay */\n              background: #5ea1d8 !important;\n              color: #0f0f0f !important;\n              border: none !important;\n              border-top: none !important;\n              border-left: none !important;\n              border-right: none !important;\n              border-bottom: none !important;\n              outline: none !important;\n              box-shadow: none !important;\n              transition: none !important;\n\n              .step-number,\n              .step-title-text {\n                color: #0f0f0f !important;\n              }\n\n              &:hover {\n                border: none !important;\n                border-top: none !important;\n                border-left: none !important;\n                border-right: none !important;\n                border-bottom: none !important;\n                outline: none !important;\n                box-shadow: none !important;\n              }\n            }\n\n            .step-number {\n              display: flex;\n              font-size: 13px;\n              font-weight: 600;\n              font-family: \"Raleway\", sans-serif;\n              flex-shrink: 0;\n            }\n\n            .step-title-text {\n              font-size: 13px;\n              font-weight: 400;\n              font-family: \"Raleway\", sans-serif;\n              line-height: 1.4;\n              word-wrap: break-word;\n              overflow: visible; /* show all text */\n              text-overflow: clip;\n              display: block;\n              -webkit-line-clamp: initial;\n              line-clamp: initial;\n              -webkit-box-orient: initial;\n              flex: 1 1 auto;\n              white-space: normal;\n            }\n\n            .step-description {\n              font-size: 13px;\n              font-weight: 400;\n              font-family: \"Open Sans\", sans-serif;\n              line-height: 1.4;\n\n              :where(p, span, div) {\n                margin: 0;\n              }\n            }\n          }\n\n          /* Expansion-panel behavior WITHOUT changing existing button styling:\n             - keep `.step-btn` look as-is\n             - when selected, only change header background and add a body below */\n          .step-panel {\n            display: block;\n            width: 100%;\n          }\n\n          .step-header-row {\n            display: flex;\n            align-items: stretch;\n            width: 100%;\n            gap: 4px;\n          }\n\n          .step-panel .step-btn {\n            flex: 1;\n            width: auto;\n            min-width: 0;\n          }\n\n          .step-bookmark-btn {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n            width: 36px;\n            border: 1px solid #e0e0e0;\n            border-radius: 6px;\n            background: #ffffff;\n            color: #666666;\n            cursor: pointer;\n            padding: 0;\n\n            mat-icon {\n              font-size: 20px;\n              width: 20px;\n              height: 20px;\n            }\n\n            mat-icon.bookmarked {\n              color: #5ea1d8;\n            }\n\n            &:hover {\n              background: #f5f8fb;\n              border-color: #5ea1d8;\n            }\n          }\n\n          .step-panel.active .step-header-row .step-bookmark-btn {\n            border-color: #5ea1d8;\n            background: #ffffff;\n          }\n\n          .step-panel.active .step-btn {\n            background: #5ea1d8 !important;\n            color: #0f0f0f !important;\n            border: none !important;\n            border-top: none !important;\n            border-left: none !important;\n            border-right: none !important;\n            border-bottom: none !important;\n            outline: none !important;\n            box-shadow: none !important;\n            transition: none !important;\n            /* Attach body to header (like mat-expansion-panel) */\n            border-bottom-left-radius: 0;\n            border-bottom-right-radius: 0;\n\n            .step-number,\n            .step-title-text {\n              color: #0f0f0f !important;\n            }\n\n            &:hover {\n              background: #5ea1d8 !important;\n              border: none !important;\n              border-top: none !important;\n              border-left: none !important;\n              border-right: none !important;\n              border-bottom: none !important;\n              outline: none !important;\n              box-shadow: none !important;\n            }\n          }\n\n          .step-panel-body {\n            border: 1px solid #e0e0e0;\n            border-top: 0;\n            border-bottom-left-radius: 6px;\n            border-bottom-right-radius: 6px;\n            background: #ffffff;\n            padding: 12px;\n            margin-top: 0;\n            width: 100%;\n            box-sizing: border-box;\n          }\n\n          .step-panel.active .step-panel-body {\n            border-top-left-radius: 0;\n            border-top-right-radius: 0;\n          }\n        }\n      }\n\n      .recommendations-section {\n        flex: 0 0 auto; /* Keep recommendations visible below steps */\n        padding-top: 0; /* Will be set dynamically by JavaScript to align with title */\n        border-top: 1px solid #e0e0e0; /* Visual separator */\n        align-self: flex-start; /* Prevent being pushed to bottom */\n        width: 100%; /* Ensure full width */\n\n        h2 {\n          font-size: 16px;\n          font-weight: 500;\n          color: #0f0f0f;\n          margin-bottom: 16px;\n        }\n\n        .recommendations-list {\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n          overflow-x: hidden;\n        }\n\n        .recommendation-item {\n          display: flex;\n          gap: 8px;\n          cursor: pointer;\n          padding: 8px;\n          border-radius: 8px;\n          transition: background 0.2s;\n          overflow: hidden;\n\n          &:hover {\n            background: #f9f9f9;\n          }\n\n          .recommendation-thumbnail {\n            flex-shrink: 0;\n            width: 168px;\n            height: 94px;\n            border-radius: 4px;\n            overflow: hidden;\n            background: #000;\n\n            img,\n            video {\n              width: 100%;\n              height: 100%;\n              object-fit: cover;\n            }\n          }\n\n          .recommendation-info {\n            flex: 1;\n            min-width: 0;\n\n            .recommendation-title {\n              font-size: 16px;\n              font-weight: 500;\n              color: #0f0f0f;\n              margin: 0 0 4px 0;\n              line-height: 20px;\n              white-space: normal;\n              word-break: break-word;\n              overflow: hidden;\n            }\n\n            .recommendation-meta {\n              display: flex;\n              flex-direction: column;\n              gap: 2px;\n              font-size: 12px;\n              color: #606060;\n              flex-wrap: wrap;\n\n              .recommendation-creator {\n                color: #606060;\n              }\n\n              .recommendation-id {\n                color: #909090;\n              }\n\n              .collab-sep {\n                color: #888;\n                font-weight: 400;\n                font-size: 11px;\n              }\n\n              .rec-owner-name {\n                cursor: pointer;\n                &:hover { text-decoration: underline; }\n              }\n\n              .collab-coname {\n                font-weight: 500;\n                cursor: pointer;\n                &:hover { text-decoration: underline; }\n              }\n            }\n\n            .recommendation-price {\n              display: block;\n              margin-top: 4px;\n              font-size: 14px;\n              font-weight: 500;\n              color: #e83e8c;\n            }\n          }\n        }\n      }\n\n      // Hide recommendations section in sidebar on mobile\n      @media (max-width: 1024px) {\n        .recommendations-section {\n          display: none !important;\n        }\n      }\n    }\n\n    // Mobile Recommendations Section (in main content after comments)\n    .recommendations-section-mobile {\n      margin-top: 24px;\n      padding-top: 24px;\n      border-top: 1px solid #e0e0e0;\n\n      h2 {\n        font-size: 18px;\n        font-weight: 500;\n        color: #0f0f0f;\n        margin-bottom: 16px;\n      }\n\n      .recommendations-list {\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n        overflow-x: hidden;\n      }\n\n      .recommendation-item {\n        display: flex;\n        gap: 12px;\n        cursor: pointer;\n        padding: 12px;\n        border-radius: 8px;\n        transition: background 0.2s;\n        overflow: hidden;\n        background: #f9f9f9;\n\n        &:hover {\n          background: #f0f0f0;\n        }\n\n        .recommendation-thumbnail {\n          flex-shrink: 0;\n          width: 168px;\n          height: 94px;\n          border-radius: 4px;\n          overflow: hidden;\n          background: #000;\n\n          img,\n          video {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n          }\n        }\n\n        .recommendation-info {\n          flex: 1;\n          min-width: 0;\n\n          .recommendation-title {\n            font-size: 16px;\n            font-weight: 500;\n            color: #0f0f0f;\n            margin: 0 0 4px 0;\n            line-height: 20px;\n            white-space: normal;\n            word-break: break-word;\n            overflow: hidden;\n          }\n\n          .recommendation-meta {\n            display: flex;\n            flex-direction: column;\n            gap: 2px;\n            font-size: 12px;\n            color: #606060;\n            flex-wrap: wrap;\n\n            .recommendation-creator {\n              color: #606060;\n            }\n\n            .recommendation-id {\n              color: #909090;\n            }\n\n            .collab-sep {\n              color: #888;\n              font-weight: 400;\n              font-size: 11px;\n            }\n\n            .rec-owner-name {\n              cursor: pointer;\n              &:hover { text-decoration: underline; }\n            }\n\n            .collab-coname {\n              font-weight: 500;\n              cursor: pointer;\n              &:hover { text-decoration: underline; }\n            }\n          }\n\n          .recommendation-price {\n            display: block;\n            margin-top: 4px;\n            font-size: 14px;\n            font-weight: 500;\n            color: #e83e8c;\n          }\n        }\n      }\n\n      // Hide on desktop\n      @media (min-width: 1025px) {\n        display: none !important;\n      }\n    }\n\n    .viewflow-step {\n      width: calc(100% - 40px);\n      display: flex;\n      padding: 20px 20px;\n      padding: 20px 10px 20px;\n      border: 1px solid #ddd;\n      box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n      position: relative;\n      border-radius: 10px;\n      flex-wrap: wrap;\n      display: flex;\n      background: #fff;\n      margin: 10px 20px 10px 20px;\n\n      //min-height: 300px;\n      .des-item {\n        border-radius: 0px;\n        border-right: 1px solid lightgray;\n        max-width: calc(50% - 20px);\n        padding-right: 10px;\n        flex-basis: calc(50% - 20px);\n        margin-right: 10px;\n        display: flex;\n        flex-direction: column;\n        position: relative;\n        z-index: 2;\n\n        .des {\n          box-shadow: none;\n          border: 0px;\n          padding: 0px 0px;\n          flex: 1;\n          border: 1px solid #ddd;\n          border: 0px !important;\n          margin-bottom: 0px;\n          border-radius: 0px;\n          padding: 0px 0px;\n          display: flex;\n          flex-direction: column;\n          box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);\n          box-shadow: none !important;\n\n          & > div {\n            flex: none;\n            color: #212427;\n            display: flex;\n            flex-wrap: wrap;\n          }\n\n          p {\n            max-height: 287px;\n            padding-right: 10px;\n          }\n\n          .s-num {\n            font-size: 16px;\n            width: 30px;\n            height: 30px;\n            color: #fff;\n            border: 0px solid #f3f3f3;\n            border-radius: 50%;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: space-around;\n            // box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);          \n            font-weight: 600;\n            margin-top: 0px;\n            margin-bottom: 20px;\n            position: relative;\n            z-index: 2;\n\n            &:before {\n              content: \"\";\n              width: 100%;\n              height: 100%;\n              border-radius: 50%;\n              left: 0px;\n              top: 0px;\n              position: absolute;\n              background: lightgray;\n              // border:1px solid #70bfe2;\n              z-index: -1;\n            }\n          }\n        }\n\n        .btm-btn {\n          display: flex;\n          align-items: center;\n\n          & > div {\n            flex: 1;\n\n            &:first-child {\n              justify-content: flex-start;\n            }\n\n            &:last-child {\n              justify-content: right;\n              text-align: end;\n            }\n          }\n\n          .lock {\n            display: flex;\n            align-items: center;            \n\n            & > span {\n              display: flex;\n              align-items: center;\n            }\n          }\n        }\n      }\n\n      .step-sec {\n        box-shadow: none;\n        border: 0px;\n        padding: 0px 0px 0px 0px;\n        margin-left: 10px;\n        width: 50%;\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        border-radius: 40px;\n\n        .progressbar {\n          border: 2px solid lightgray;\n          margin-bottom: 20px;\n          background: #fff;\n          border-radius: 10px;\n          padding: 5px;\n\n          // box-shadow:0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n          .w3-round {\n            height: 7px;\n            background: #5ea1d8;\n            background: lightgrey;\n          }\n        }\n\n        .img-wrap {\n          flex: 1;\n          display: flex;\n          align-items: center;\n          // max-height: 382px;\n          position: relative;\n          overflow: hidden;\n\n          img {\n            // width:auto !important;\n            max-width: 100% !important;\n            height: 100%;\n            object-fit: cover;\n            //max-height: 436px !important;\n            margin: 0px auto;\n            width: 100% !important;\n          }\n\n          & + .item {\n            width: calc(100% - 0px) !important;\n            margin: 17px 0px !important;\n            border: 0px !important;\n          }\n        }\n\n        // &:before{\n        //   content:\"‹\";\n\n        // background: #fafafa !important;\n        //     box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n        //     width: 35px;\n        //     height: 35px;\n        //     border-radius: 50%;\n        //     display:flex;\n        //     align-items: center;\n        //     justify-content: center;\n        //     outline:none;\n        //   position:absolute;\n        // left:-49px;\n        // top: calc(50% - 20px);\n        // font-size:35px;\n\n        // }\n        // &:after{\n        //   content:\"›\";\n\n        // background: #fafafa !important;\n        //     box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n        //     width: 35px;\n        //     height: 35px;\n        //     border-radius: 50%;\n        //     display:flex;\n        //     align-items: center;\n        //     justify-content: center;\n        //     outline:none;\n        //   position:absolute;\n        // right:-49px;\n        // top: calc(50% - 20px);\n        // font-size:35px;\n\n        // }\n      }\n    }\n\n  @media (min-width: 993px) {\n    .flow-title-sticky {\n      top: 112px; /* desktop: header + filters */\n    }\n  }\n\n  .clickarrow {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    transform: translateY(-50%);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 16px;\n    pointer-events: none;\n\n    button.owl-prev,\n    button.owl-next {\n      pointer-events: all;\n      background: rgba(0, 0, 0, 0.65);\n      color: #fff !important;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n      width: 48px;\n      height: 48px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      outline: none;\n      border: none;\n      cursor: pointer;\n      transition: background 0.2s ease, transform 0.2s ease;\n\n      span {\n        font-size: 30px;\n        line-height: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin: 0;\n        font-weight: 600 !important;\n        color: inherit;\n      }\n\n      &:hover:not(:disabled) {\n        background: rgba(0, 0, 0, 0.85);\n        transform: translateY(-1px);\n      }\n    }\n\n    button.owl-prev {\n      margin-right: auto;\n      margin-left: 0;\n    }\n\n    button.owl-next {\n      margin-left: auto;\n      margin-right: 0;\n    }\n  }\n\n  // .flowbycat {\n  //   height: 100%;\n  //   display: table;\n  //   text-align: center;\n  // }\n  // header {\n  //   width: 100%;\n  //   height: 100px;\n  //   background: #fff;\n  //   border-bottom: 2px solid #5ea1d8;\n  // }\n\n  .partOfBundle {\n    padding: 0px 20px 20px;\n    background: #fff;\n    background: transparent;\n    // border: 1px solid #ddd;\n    // box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    margin: 0px 20px 0px 0px;\n    border-radius: 10px;\n    overflow-x: scroll;\n\n    h2 {\n      // position: absolute;\n      margin-top: 0px;\n      margin-bottom: 0px !important;\n    }\n\n    .row {\n      flex-wrap: nowrap !important;\n      width: fit-content;\n      margin-top: 10px !important;\n    }\n\n    .item {\n      background: #fff;\n      margin-left: 0px;\n      width: 170px !important;\n      padding: 10px;\n      margin-right: 10px;\n      position: relative;\n\n      & > div:first-child {\n        img {\n          height: 150px !important;\n        }\n      }\n\n      & > div:last-child {\n        p {\n          height: 25px !important;\n        }\n      }\n    }\n  }\n\n  .qr-ico {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    height: 100%;\n    position: absolute;\n    right: 20px;\n\n    i {\n      flex: 1;\n      font-size: 25px;\n      color: grey;\n    }\n\n    p {\n      font-weight: 600;\n    }\n  }\n\n  // .social-ico {\n  //   max-width: 275px;\n  //   margin-top: 20px;\n  // }\n  // .social-ico ul li .fa {\n  //   font-size: 27px;\n  //   color: gray;\n  //   text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n  //   margin-bottom: 5px;\n  //   font-size: 30px;\n  // }\n  // .social-ico ul li .fa.fa-facebook-square {\n  //   color: #4266b2;\n  // }\n\n  // .social-ico ul li .fa.fa-twitter-square {\n  //   color: #55aded;\n  // }\n  // .social-ico ul li .fa.fa-linkedin-square {\n  //   color: #007ab9;\n  // }\n  // .social-ico ul li .fa.fa-xing-square {\n  //   color: #f96678;\n  // }\n  .material-icons,\n  .align-items-center {\n    // color: #212427 !important;\n    font-weight: normal !important;\n    cursor: pointer;\n    display: flex;\n  }\n\n  img {\n    width: 100%;\n  }\n\n  p { \n    font-size: 12px !important;\n    line-height: 20px;\n  }\n\n  button {\n    padding: 3px 10px;\n    // background: #5ea1d8;\n    border: 0px;\n    // color: #fff;\n    font-size: 15px;\n    border-radius: 15px;\n  }\n\n  button.active {\n    background: #5ea1d8;\n    color: white;\n  }\n\n  h2 { \n    margin-bottom: 20px;\n\n    a {\n      color: #212427 !important;\n    }\n  }\n\n  h3 { \n    margin-bottom: 20px;\n    font-size: 16px;\n    font-weight: bold;\n  }\n\n  ul {\n    display: flex;\n    list-style: none;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n  }\n\n  li {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n\n    span {\n      // margin-left: 0px;\n    }\n  }\n\n  .like {\n    .qrcode {\n      flex: 1;\n      display: flex;\n      align-items: flex-end;\n      justify-content: flex-end;\n    }\n  }\n\n  /*description wrapper starts here*/\n  .description-wrapper {\n    // display: flex;\n    // background: #fff;\n    // margin: 10px 20px 10px 20px;\n    .des-item {\n      // flex-basis: calc(50% - 20px);\n      // // max-width: 3;\n      // margin-right: 10px;\n      // display: flex;\n      // flex-direction: column;\n      .des {\n        /*max-height:200px;*/\n        // flex: 1;\n        // border: 1px solid #ddd;\n        // margin-bottom: 0px;\n\n        // border-radius: 0px;\n        // padding: 40px 20px;\n        // display: flex;\n        // flex-direction: column;\n        // box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n        p {\n          max-height: 100px;\n          overflow-y: auto;\n        }\n      }\n    }\n  }\n\n  // .des-item .des > div {\n  //   flex: 1;\n  //   display: flex;\n  //   align-items: flex-start;\n  //   margin-top: 20px;\n  // }\n  .des-item .des > div span {\n    flex: 1;    \n  }\n\n  .des-item .des > div span.material-icons.ng-star-inserted {\n    max-width: 30px;\n  }\n\n  .des-item .des > div span:first-child {\n    align-items: flex-start;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  .des-item .des > div span:last-child {\n    text-align: flex-end;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  .des-item .des > div span i {\n    margin-right: 5px;\n  }\n\n  .des-item .item {\n    flex: 1;\n    border: 1px solid #ddd;\n    border-radius: 40px;\n    padding: 40px 20px;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    margin-top: 20px;\n  }\n\n  .des-item .item .list {\n    display: flex;\n    /* padding: 20px 0px; */\n    max-height: 150px;\n    overflow-y: auto;\n    align-items: flex-start;\n  }\n\n  .des-item .item .list ul {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    margin: 0px 0px 20px;\n    padding: 5px;\n  }\n\n  .des-item .item .list ul li {\n    \n    font-size: 14px;\n    line-height: 28px;\n    word-break: break-all;\n    position: relative;\n\n    padding-left: 17px;\n\n    &:before {\n      content: \"\";\n      width: 8px;\n      height: 8px;\n      background: grey;\n      position: absolute;\n      left: 0px;\n      top: 10px;\n      border-radius: 50%;\n      box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    }\n\n    &:first-child {\n      padding-left: 0px;\n\n      &:before {\n        display: none;\n      }\n    }\n  }\n\n  .des-item .item .list ul li:first-child {\n    font-weight: 600;\n  }\n\n  // .step-sec {\n  //   flex: 1;\n  //   padding: 40px;\n  //   border: 1px solid #ddd;\n  //   border-radius: 40px;\n  // }\n\n  video {\n    // width:auto !important;\n    max-width: 100% !important;\n    //max-height: 300px !important;\n    margin: 0px auto;\n    width: 100% !important;\n  }\n\n  &:empty {\n    display: none !important;\n  }\n\n  .comment-guidelines-helper {\n    color: #606060;\n    font-size: 13px;\n    margin-top: 6px;\n  }\n\n  .comment-guidelines-link {\n    color: #1976d2 !important;\n    text-decoration: underline !important;\n    cursor: pointer;\n\n    &:hover {\n      color: #1565c0 !important;\n    }\n  }\n}\n\n.toggled-view {\n  padding: 20px;\n}\n\n.favorite-toggle-icon {\n  color: #000000 !important;\n  transition: color 0.2s ease;\n\n  &.liked {\n    color: #ff4d4d !important;\n  }\n}\n\n.action-item .favorite-toggle-icon {\n  &.liked {\n    color: #ff4d4d !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .mobile-stacked-view {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    padding: 20px;\n    background: #f6f7f9;\n  }\n\n  .mobile-top-panel {\n    position: sticky;\n    top: 76px;\n    z-index: 3;\n    padding: 12px 0 4px;\n    background: linear-gradient(\n      180deg,\n      rgba(246, 247, 249, 0.98) 0%,\n      rgba(246, 247, 249, 0.9) 60%,\n      rgba(246, 247, 249, 0) 100%\n    );\n    backdrop-filter: blur(8px);\n  }\n\n  .mobile-info-panel {\n    padding: 0 12px;\n    display: flex;\n    overflow-x: auto;\n    gap: 12px;\n\n    .info-badge {\n      flex: 0 0 auto;\n    }\n  }\n\n  .mobile-info-panel::-webkit-scrollbar {\n    display: none;\n  }\n\n  .mobile-section {\n    background: #ffffff;\n    border-radius: 16px;\n   //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n    overflow: hidden;\n    scroll-margin-top: 140px;\n  }\n\n  .mobile-media {\n    background: #000;\n  }\n\n  .mobile-media img,\n  .mobile-media video {\n    width: 100%;\n    display: block;\n    max-height: 260px;\n    object-fit: cover;\n  }\n\n  .mobile-media-video {\n    width: 100%;\n    max-height: 260px;\n    background: #000;\n    border: 0;\n  }\n\n  .mobile-section-body {\n    padding: 20px 20px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .mobile-section-title {\n    font-size: 20px;\n    font-weight: 600;\n    margin: 0;\n    color: #1f2f46;\n  }\n\n  .mobile-section-description {\n    color: #4a5568;\n    line-height: 1.6;\n\n    p {\n      margin-bottom: 12px;\n    }\n  }\n\n  .mobile-step-card {\n    display: flex;\n    gap: 16px;\n    flex-direction: column;\n  }\n\n  .mobile-step-media {\n    background: #000;\n    border-radius: 12px;\n    overflow: hidden;\n\n    img,\n    video {\n      width: 100%;\n      height: 200px;\n      object-fit: cover;\n      display: block;\n    }\n  }\n\n  .mobile-step-content {\n    margin-top: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .mobile-step-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n\n    h3 {\n      margin: 0;\n      font-size: 18px;\n      color: #1f2f46;\n      font-weight: 600;\n\n      span {\n        font-size: 16px;\n        font-weight: 500;\n        color: #5a6a85;\n      }\n    }\n  }\n\n  .mobile-share-btn {\n    height: 32px;\n    width: 32px;\n    min-width: 32px;\n  }\n\n  .mobile-step-description {\n    color: #4a5568;\n    line-height: 1.6;\n    font-size: 15px;\n\n    p {\n      margin-bottom: 10px;\n    }\n  }\n\n  .mobile-meta-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #5ea1d8;\n\n    mat-icon {\n      font-size: 18px;\n      height: 18px;\n      width: 18px;\n    }\n  }\n\n  .mobile-supporting-doc {\n    align-self: flex-start;\n    color: #5ea1d8;\n    font-weight: 500;\n    padding: 0;\n  }\n\n  .mobile-items-list {\n    margin-top: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    .example-box {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 12px 0;\n      border-bottom: 1px solid #edf2f7;\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      mat-checkbox {\n        margin-left: auto;\n      }\n    }\n  }\n\n  .mobile-item-thumb {\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n}\n\n/* Skeleton Loader Styles for View Flow - Matches Exact Page Structure */\n.skeleton-viewflow-container {\n  --skeleton-gradient: linear-gradient(\n    110deg,\n    #f6f7f8 8%,\n    #eceef1 18%,\n    #f6f7f8 33%\n  );\n  background: #efeeee;\n  min-height: 100vh;\n  padding-top: 0;\n  width: 100%;\n  overflow-x: hidden;\n  pointer-events: none;\n\n  .container1 {\n    max-width: 100%;\n    width: 100%;\n    margin: 0px auto;\n    background: transparent;\n    padding-bottom: 30px;\n    padding: 0px;\n\n    .flow-layout-container {\n      width: 100%;\n      padding: 0;\n      margin: 0;\n\n      .flow-main-grid {\n        display: grid;\n        grid-template-columns: minmax(0, 1fr) 402px;\n        gap: 24px;\n        max-width: 100%;\n        margin: 0;\n        padding: 16px 24px;\n\n        @media (min-width: 1920px) {\n          max-width: 1920px;\n          margin: 0 auto;\n          padding: 24px 48px;\n        }\n\n        @media (max-width: 1024px) {\n          grid-template-columns: 1fr;\n          gap: 16px;\n          padding: 16px;\n        }\n\n        @media (max-width: 768px) {\n          padding: 12px;\n          gap: 12px;\n        }\n      }\n    }\n  }\n\n  .skeleton-text,\n  .skeleton-avatar,\n  .skeleton-icon,\n  .skeleton-image {\n    background-image: var(--skeleton-gradient);\n    background-size: 220% 100%;\n    animation: skeleton-shimmer 1.35s linear infinite,\n      skeleton-pulse 2s ease-in-out infinite;\n    background-color: #e0e0e0;\n  }\n\n  .skeleton-text {\n    border-radius: 4px;\n    height: 16px;\n    margin: 6px 0;\n    display: block;\n\n    &.skeleton-title {\n      height: 24px;\n      width: 60%;\n    }\n\n    &.skeleton-subtitle {\n      height: 16px;\n      width: 40%;\n    }\n\n    &.skeleton-badge-text {\n      height: 14px;\n      width: 80px;\n    }\n\n    &.short {\n      width: 40%;\n    }\n\n    &.skeleton-description {\n      height: 14px;\n      width: 100%;\n      margin: 8px 0;\n\n      &.short {\n        width: 70%;\n      }\n    }\n\n    &.skeleton-action-text {\n      height: 14px;\n      width: 60px;\n      margin: 0;\n    }\n\n    &.skeleton-small {\n      height: 12px;\n      width: 50%;\n    }\n\n    &.skeleton-follow {\n      width: 120px;\n      height: 32px;\n      border-radius: 16px;\n      margin: 0;\n    }\n  }\n\n  .skeleton-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    margin-right: 10px;\n    flex-shrink: 0;\n\n    &.skeleton-channel-avatar {\n      width: 48px;\n      height: 48px;\n    }\n  }\n\n  .skeleton-icon {\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    margin-right: 8px;\n    flex-shrink: 0;\n\n    &.small {\n      width: 18px;\n      height: 18px;\n    }\n\n    &.skeleton-share-icon {\n      width: 20px;\n      height: 20px;\n      margin-left: auto;\n      margin-right: 0;\n    }\n\n    &.thumb-icon {\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  .skeleton-image {\n    width: 100%;\n    height: 0;\n    padding-bottom: 56.25%; // 16:9 aspect ratio\n    border-radius: 12px;\n    position: relative;\n    overflow: hidden;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-image: var(--skeleton-gradient);\n      background-size: 220% 100%;\n      animation: skeleton-shimmer 1.35s linear infinite,\n        skeleton-pulse 2s ease-in-out infinite;\n      background-color: #e0e0e0;\n    }\n\n    &.large {\n      padding-bottom: 56.25%; // Maintain 16:9 aspect ratio\n    }\n\n    &.small {\n      width: 120px;\n      height: 72px;\n      padding-bottom: 0;\n      border-radius: 12px;\n      flex-shrink: 0;\n    }\n  }\n\n  .skeleton-card {\n    background: #fff;\n    border-radius: 12px;\n    padding: 16px 20px;\n    margin-bottom: 16px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  }\n\n  .skeleton-flow-header {\n    background: #ffffff;\n    border-bottom: 1px solid #e0e0e0;\n    padding: 16px 0 8px 0;\n    margin-bottom: 8px;\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);\n    border-radius: 0;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    .video-title-sticky {\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 1.3;\n      margin: 4px;\n      font-family: \"Raleway\", sans-serif;\n      flex: 1;\n      min-width: 0;\n      height: 28px;\n      width: 60%;\n    }\n\n    .autoplay-toggle {\n      margin-left: auto;\n      display: inline-flex;\n      align-items: center;\n      gap: 8px;\n      padding: 4px 10px 4px 4px;\n      border: none;\n      background: transparent;\n      border-radius: 999px;\n      cursor: default;\n      pointer-events: none;\n\n      .toggle-track {\n        position: relative;\n        width: 60px;\n        height: 28px;\n        border-radius: 28px;\n        background: #dadce0;\n        display: inline-block;\n        margin-right: 4px;\n\n        .toggle-thumb {\n          position: absolute;\n          top: 2px;\n          left: 2px;\n          width: 24px;\n          height: 24px;\n          border-radius: 50%;\n          background: #ffffff;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n\n          .thumb-icon {\n            width: 16px;\n            height: 16px;\n          }\n        }\n      }\n    }\n\n    &.skeleton-info-panel {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding: 12px 16px;\n      background: #f9f9f9;\n      border-radius: 8px;\n      margin-bottom: 16px;\n      overflow-x: auto;\n      overflow-y: hidden;\n      border-radius: 8px;\n\n      .info-badge {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        font-size: 13px;\n        font-weight: 500;\n        font-family: \"Raleway\", sans-serif;\n        background: white;\n        border: 1px solid #e0e0e0;\n        border-radius: 16px;\n        padding: 4px 12px;\n        white-space: nowrap;\n        flex-shrink: 0;\n        min-width: fit-content;\n\n        .info-icon {\n          font-size: 14px;\n          flex-shrink: 0;\n          line-height: 1;\n          width: 14px;\n          height: 14px;\n        }\n\n        .info-label {\n          font-family: \"Raleway\", sans-serif;\n          flex-shrink: 0;\n          font-size: 13px;\n          width: 60px;\n          height: 14px;\n          margin: 0;\n        }\n      }\n\n      @media (max-width: 768px) {\n        gap: 6px;\n        padding: 10px 12px;\n\n        .info-badge {\n          font-size: 12px;\n          padding: 3px 10px;\n\n          .info-icon {\n            font-size: 12px;\n            width: 12px;\n            height: 12px;\n          }\n        }\n      }\n    }\n  }\n\n  .video-player-section {\n    background: transparent !important;\n    border-radius: 12px;\n    overflow: hidden;\n    margin-bottom: 16px;\n    position: relative;\n    padding: 0 !important;\n    box-shadow: none !important;\n\n    .img-wrap {\n      width: 100%;\n      position: relative;\n      padding-bottom: 56.25%; // 16:9 aspect ratio\n      height: 0;\n      overflow: hidden;\n      background: transparent;\n\n      .skeleton-image {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        padding-bottom: 0;\n        border-radius: 12px;\n      }\n    }\n  }\n\n  .video-metadata {\n    margin-bottom: 16px;\n\n    .step-header {\n      margin-bottom: 16px;\n\n      .step-header-main {\n        display: flex;\n        align-items: center;\n        gap: 14px;\n\n        .s-num {\n          width: 44px;\n          height: 44px;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 18px;\n          font-weight: 600;\n          flex-shrink: 0;\n        }\n\n        .video-title {\n          flex: 1;\n          height: 28px;\n          margin: 0;\n          border-radius: 8px;\n          font-size: 20px;\n          font-weight: 600;\n          line-height: 1.3;\n        }\n\n        .share-icon {\n          width: 20px;\n          height: 20px;\n          margin-left: auto;\n          margin-right: 0;\n        }\n      }\n    }\n\n    .video-actions-bar {\n      margin-top: 20px;\n      padding-bottom: 12px;\n\n      .action-buttons {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 16px;\n        align-items: center;\n\n        .skeleton-action-item {\n          display: inline-flex;\n          align-items: center;\n          gap: 8px;\n          padding: 6px 0;\n          min-width: 80px;\n\n          mat-icon {\n            width: 24px;\n            height: 24px;\n            font-size: 24px;\n          }\n\n          span {\n            font-size: 14px;\n            height: 16px;\n            width: 60px;\n            margin: 0;\n          }\n        }\n      }\n\n      @media (max-width: 768px) {\n        overflow-x: auto;\n        overflow-y: hidden;\n        padding: 0 16px 12px 16px;\n\n        .action-buttons {\n          gap: 12px;\n        }\n      }\n    }\n  }\n\n  .channel-info-section {\n    margin-bottom: 16px;\n\n    .channel-header {\n      display: flex;\n      align-items: flex-start;\n      gap: 16px;\n      margin-bottom: 12px;\n\n      .channel-avatar {\n        flex-shrink: 0;\n\n        .skeleton-avatar {\n          width: 48px;\n          height: 48px;\n        }\n      }\n\n      .channel-details {\n        flex: 1;\n        min-width: 0;\n\n        .channel-name {\n          height: 20px;\n          width: 40%;\n          margin-bottom: 8px;\n        }\n\n        .channel-meta {\n          display: flex;\n          flex-wrap: wrap;\n          gap: 12px;\n          align-items: center;\n\n          span {\n            height: 16px;\n            width: 80px;\n            margin: 0;\n          }\n        }\n      }\n\n      .channel-actions {\n        display: flex;\n        gap: 8px;\n        flex-shrink: 0;\n\n        .follow-btn {\n          width: 120px;\n          height: 36px;\n          border-radius: 18px;\n          margin: 0;\n        }\n      }\n    }\n\n    // Modern Customer Feedback Section (Reference Style)\n    .customer-feedback-section {\n      margin-bottom: 48px !important;\n      padding: 0 !important;\n      width: 100% !important;\n      max-width: 100% !important;\n      box-sizing: border-box !important;\n      display: block !important;\n      visibility: visible !important;\n      opacity: 1 !important;\n      \n      // Force all child elements to inherit display\n      * {\n        box-sizing: border-box;\n      }\n\n      // Header Section\n      .feedback-header {\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n        margin-bottom: 48px;\n\n        @media (min-width: 768px) {\n          flex-direction: row;\n          align-items: flex-end;\n          justify-content: space-between;\n        }\n\n        .feedback-header-left {\n          .feedback-title {\n            font-size: 36px;\n            font-weight: 800;\n            line-height: 1.2;\n            margin: 0 0 8px 0;\n            color: #0f172a;\n            letter-spacing: -0.02em;\n          }\n\n          .feedback-subtitle {\n            font-size: 18px;\n            color: #64748b;\n            margin: 0;\n            line-height: 1.5;\n          }\n        }\n\n        .feedback-header-actions {\n          display: flex;\n          align-items: center;\n          gap: 16px;\n          flex-shrink: 0;\n\n          .feedback-btn-secondary {\n            padding: 12px 24px;\n            background: #fff;\n            border: 1px solid #e2e8f0;\n            border-radius: 12px;\n            font-weight: 600;\n            font-size: 14px;\n            color: #0f172a;\n            cursor: pointer;\n            transition: all 0.2s;\n            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n            &:hover {\n              background: #f8fafc;\n              border-color: #cbd5e1;\n            }\n          }\n\n          .feedback-btn-primary {\n            padding: 12px 24px;\n            background: #f59e0b;\n            border: none;\n            border-radius: 12px;\n            font-weight: 600;\n            font-size: 14px;\n            color: #fff;\n            cursor: pointer;\n            transition: all 0.2s;\n            box-shadow: 0 4px 6px rgba(245, 158, 11, 0.2);\n\n            &:hover:not(:disabled) {\n              opacity: 0.9;\n              transform: translateY(-1px);\n              box-shadow: 0 6px 8px rgba(245, 158, 11, 0.3);\n            }\n\n            &:disabled {\n              opacity: 0.5;\n              cursor: not-allowed;\n            }\n          }\n        }\n      }\n\n      // Summary Grid (Two Columns)\n      .feedback-summary-grid {\n        display: grid !important;\n        grid-template-columns: 1fr !important;\n        gap: 32px !important;\n        margin-bottom: 64px !important;\n        width: 100% !important;\n        max-width: 100% !important;\n        box-sizing: border-box !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n\n        @media (min-width: 1024px) {\n          grid-template-columns: 1fr 2fr !important;\n          display: grid !important;\n        }\n\n        // Left: Rating Summary Card\n        .rating-summary-card {\n          padding: 32px !important;\n          background: #fff !important;\n          border-radius: 20px !important;\n          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\n          border: 1px solid #f1f5f9 !important;\n          display: block !important;\n          visibility: visible !important;\n          opacity: 1 !important;\n          width: 100% !important;\n          box-sizing: border-box !important;\n\n          .rating-display-header {\n            display: flex;\n            align-items: center;\n            gap: 16px;\n            margin-bottom: 24px;\n\n            .rating-number {\n              font-size: 60px;\n              font-weight: 800;\n              color: #0f172a;\n              line-height: 1;\n            }\n\n            .rating-stars-group {\n              .rating-stars {\n                display: flex;\n                gap: 2px;\n                margin-bottom: 4px;\n\n                .star-wrapper {\n                  position: relative;\n                  display: inline-block;\n                  width: 24px;\n                  height: 24px;\n                  line-height: 0;\n\n                  .rating-star-icon {\n                    font-size: 24px;\n                    width: 24px;\n                    height: 24px;\n                    color: #cbd5e1;\n                    line-height: 1;\n                    display: block;\n                    position: relative;\n\n                    &.filled-star {\n                      color: #f59e0b;\n                    }\n\n                    &.partial-star {\n                      color: #f59e0b;\n                    }\n\n                    &.star-empty-overlay {\n                      position: absolute;\n                      top: 0;\n                      left: 0;\n                      color: #cbd5e1;\n                      z-index: 1;\n                      pointer-events: none;\n                    }\n                  }\n                }\n              }\n\n              .rating-count-text {\n                font-size: 14px;\n                font-weight: 500;\n                color: #64748b;\n                margin: 0;\n              }\n            }\n          }\n\n          .rating-distribution-list {\n            display: flex;\n            flex-direction: column;\n            gap: 16px;\n\n            .rating-bar-item {\n              display: flex;\n              align-items: center;\n              gap: 16px;\n              font-size: 14px;\n              font-weight: 500;\n\n              .rating-label {\n                width: 48px;\n                color: #475569;\n                flex-shrink: 0;\n              }\n\n              .rating-bar-bg {\n                flex: 1;\n                height: 10px;\n                background: #f1f5f9;\n                border-radius: 9999px;\n                overflow: hidden;\n\n                .rating-bar-progress {\n                  height: 100%;\n                  background: #f59e0b;\n                  border-radius: 9999px;\n                  transition: width 0.3s ease;\n                }\n              }\n\n              .rating-percent {\n                width: 32px;\n                text-align: right;\n                color: #64748b;\n                flex-shrink: 0;\n              }\n            }\n          }\n\n          .ratings-info-btn {\n            width: 100%;\n            margin-top: 32px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 8px;\n            padding: 0;\n            background: none;\n            border: none;\n            color: #f59e0b;\n            font-weight: 700;\n            font-size: 14px;\n            cursor: pointer;\n            transition: all 0.2s;\n\n            &:hover {\n              text-decoration: underline;\n            }\n\n            mat-icon {\n              font-size: 18px;\n              width: 18px;\n              height: 18px;\n            }\n          }\n        }\n\n      // Right: AI Highlights Card\n      .ai-highlights-card {\n        position: relative !important;\n        height: 100% !important;\n        background: linear-gradient(135deg, #eef2ff 0%, #fff 100%) !important;\n        padding: 32px !important;\n        border-radius: 20px !important;\n        border: 1px solid #c7d2fe !important;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\n        overflow: hidden !important;\n        display: block !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n        width: 100% !important;\n        box-sizing: border-box !important;\n\n          .ai-highlights-content {\n            position: relative;\n            z-index: 10;\n\n            .ai-highlights-header {\n              display: flex;\n              align-items: center;\n              gap: 8px;\n              margin-bottom: 24px;\n\n              .ai-icon-wrapper {\n                padding: 8px;\n                background: #4f46e5;\n                color: #fff;\n                border-radius: 8px;\n\n                .ai-icon {\n                  font-size: 20px;\n                  width: 20px;\n                  height: 20px;\n                }\n              }\n\n              .ai-highlights-title {\n                font-size: 24px;\n                font-weight: 700;\n                color: #0f172a;\n                margin: 0;\n              }\n            }\n\n            .ai-summary-text {\n              color: #334155;\n              font-size: 18px;\n              line-height: 1.7;\n              margin: 0 0 32px 0;\n            }\n\n            .ai-tags-grid {\n              display: grid;\n              grid-template-columns: 1fr;\n              gap: 16px;\n\n              @media (min-width: 768px) {\n                grid-template-columns: 1fr 1fr;\n              }\n\n              .ai-tags-column {\n                .ai-tags-label {\n                  font-size: 12px;\n                  font-weight: 700;\n                  text-transform: uppercase;\n                  letter-spacing: 0.05em;\n                  color: #94a3b8;\n                  margin: 0 0 12px 0;\n                }\n\n                .ai-tags-list {\n                  display: flex;\n                  flex-wrap: wrap;\n                  gap: 8px;\n\n                  .ai-tag {\n                    display: inline-flex;\n                    align-items: center;\n                    padding: 6px 12px;\n                    border-radius: 9999px;\n                    font-size: 14px;\n                    font-weight: 600;\n                    border: 1px solid;\n                    cursor: pointer;\n                    transition: all 0.2s;\n\n                    .tag-icon {\n                      font-size: 16px;\n                      width: 16px;\n                      height: 16px;\n                      margin-right: 6px;\n                    }\n\n                    &.positive {\n                      background: #d1fae5;\n                      color: #065f46;\n                      border-color: #a7f3d0;\n\n                      .tag-icon {\n                        color: #059669;\n                      }\n                    }\n\n                    &.negative {\n                      background: #fee2e2;\n                      color: #991b1b;\n                      border-color: #fecaca;\n\n                      .tag-icon {\n                        color: #dc2626;\n                      }\n                    }\n\n                    &:hover {\n                      transform: translateY(-1px);\n                      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          .ai-gradient-bg {\n            position: absolute;\n            top: -96px;\n            right: -96px;\n            width: 256px;\n            height: 256px;\n            background: rgba(79, 70, 229, 0.1);\n            border-radius: 50%;\n            filter: blur(100px);\n            z-index: 1;\n          }\n        }\n      }\n\n      // Reviews with Images Section\n      .reviews-images-section {\n        margin-bottom: 64px;\n\n        .reviews-images-header {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          margin-bottom: 24px;\n\n          .reviews-images-title {\n            font-size: 24px;\n            font-weight: 800;\n            color: #0f172a;\n            margin: 0;\n          }\n\n          .see-all-photos-link {\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            color: #f59e0b;\n            font-weight: 700;\n            font-size: 14px;\n            text-decoration: none;\n            cursor: pointer;\n            transition: all 0.2s;\n\n            &:hover {\n              text-decoration: underline;\n            }\n\n            mat-icon {\n              font-size: 18px;\n              width: 18px;\n              height: 18px;\n            }\n          }\n        }\n\n        .masonry-grid {\n          display: grid;\n          grid-template-columns: repeat(4, 1fr);\n          grid-template-rows: repeat(2, 200px);\n          gap: 16px;\n\n          .masonry-item {\n            position: relative;\n            overflow: hidden;\n            border-radius: 20px;\n            cursor: pointer;\n            transition: transform 0.5s;\n\n            &:hover {\n              transform: scale(1.05);\n\n              .masonry-overlay {\n                opacity: 1;\n              }\n            }\n\n            &.masonry-item-large {\n              grid-column: span 2;\n              grid-row: span 2;\n            }\n\n            .masonry-image {\n              width: 100%;\n              height: 100%;\n              object-fit: cover;\n            }\n\n            .masonry-overlay {\n              position: absolute;\n              inset: 0;\n              background: rgba(0, 0, 0, 0.2);\n              opacity: 0;\n              transition: opacity 0.3s;\n            }\n\n            &.masonry-item-more {\n              .masonry-more-overlay {\n                position: absolute;\n                inset: 0;\n                background: rgba(15, 23, 42, 0.6);\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                z-index: 10;\n\n                .masonry-more-text {\n                  color: #fff;\n                  font-size: 24px;\n                  font-weight: 700;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      // Top Reviews Section\n      .top-reviews-section {\n        padding: 0 16px;\n\n        @media (max-width: 768px) {\n          padding: 0 12px;\n        }\n\n        .top-reviews-header {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          margin-bottom: 32px;\n\n          .top-reviews-title {\n            font-size: 24px;\n            font-weight: 800;\n            color: #0f172a;\n            margin: 0;\n          }\n\n          .top-reviews-sort {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n\n            .sort-label {\n              font-size: 14px;\n              font-weight: 600;\n              color: #64748b;\n            }\n\n            .sort-select {\n              background: #fff;\n              border: 1px solid #e2e8f0;\n              border-radius: 8px;\n              padding: 8px 12px;\n              font-size: 14px;\n              font-weight: 600;\n              color: #0f172a;\n              cursor: pointer;\n\n              &:focus {\n                outline: none;\n                border-color: #f59e0b;\n                box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);\n              }\n            }\n          }\n        }\n\n        .top-reviews-list {\n          display: flex;\n          flex-direction: column;\n          gap: 24px;\n\n          .review-card {\n            padding: 32px;\n            background: #fff;\n            border-radius: 20px;\n            border: 1px solid #f1f5f9;\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n            transition: all 0.2s;\n\n            &:hover {\n              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n            }\n\n            .review-card-header {\n              display: flex;\n              align-items: flex-start;\n              justify-content: space-between;\n              margin-bottom: 24px;\n\n              .reviewer-info-group {\n                display: flex;\n                align-items: center;\n                gap: 16px;\n\n                .reviewer-avatar-circle {\n                  width: 48px;\n                  height: 48px;\n                  border-radius: 50%;\n                  display: flex;\n                  align-items: center;\n                  justify-content: center;\n                  font-weight: 700;\n                  font-size: 18px;\n                  color: #4f46e5;\n                }\n\n                .reviewer-details {\n                  .reviewer-name {\n                    font-weight: 700;\n                    font-size: 18px;\n                    color: #0f172a;\n                    margin: 0 0 4px 0;\n                  }\n\n                  .reviewer-rating-group {\n                    display: flex;\n                    align-items: center;\n                    gap: 8px;\n\n                    .review-stars {\n                      display: flex;\n                      gap: 2px;\n\n                      .review-star-icon {\n                        font-size: 16px;\n                        width: 16px;\n                        height: 16px;\n                        color: #cbd5e1;\n\n                        &.filled-star {\n                          color: #f59e0b;\n                        }\n                      }\n                    }\n\n                    .verified-badge {\n                      font-size: 12px;\n                      font-weight: 700;\n                      color: #94a3b8;\n                      text-transform: uppercase;\n                      letter-spacing: 0.05em;\n                    }\n                  }\n                }\n              }\n\n              .review-date {\n                font-size: 14px;\n                color: #94a3b8;\n              }\n            }\n\n            .review-card-title {\n              font-size: 20px;\n              font-weight: 700;\n              color: #0f172a;\n              margin: 0 0 12px 0;\n            }\n\n            .review-card-text {\n              color: #475569;\n              line-height: 1.7;\n              margin: 0 0 24px 0;\n            }\n\n            .review-card-media {\n              margin: 24px 0;\n              border-radius: 8px;\n              overflow: hidden;\n              max-width: 300px;\n\n              .review-media-image,\n              .review-media-video {\n                max-width: 100%;\n                max-height: 300px;\n                object-fit: contain;\n                border-radius: 8px;\n              }\n            }\n\n            .review-issues-section {\n              margin-top: 24px;\n              padding: 16px;\n              background: #fff7ed;\n              border-left: 3px solid #f59e0b;\n              border-radius: 8px;\n\n              .issues-header {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                margin-bottom: 12px;\n\n                .issues-icon {\n                  font-size: 20px;\n                  width: 20px;\n                  height: 20px;\n                  color: #f59e0b;\n                }\n\n                strong {\n                  font-size: 14px;\n                  font-weight: 700;\n                  color: #0f172a;\n                }\n              }\n\n              .issue-item {\n                margin-bottom: 16px;\n\n                &:last-child {\n                  margin-bottom: 0;\n                }\n\n                .issue-header {\n                  margin-bottom: 8px;\n\n                  strong {\n                    font-size: 13px;\n                    font-weight: 700;\n                    color: #0f172a;\n                  }\n                }\n\n                .issue-description {\n                  font-size: 13px;\n                  color: #475569;\n                  line-height: 1.5;\n                  margin: 0 0 8px 0;\n                }\n\n                .issue-media {\n                  margin: 12px 0;\n                  border-radius: 8px;\n                  overflow: hidden;\n\n                  img,\n                  video {\n                    max-width: 100%;\n                    max-height: 200px;\n                    object-fit: contain;\n                  }\n                }\n              }\n            }\n\n            .creator-response-box {\n              margin-top: 24px;\n              padding: 16px;\n              background: #eff6ff;\n              border-left: 3px solid #3b82f6;\n              border-radius: 8px;\n\n              .response-header {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                margin-bottom: 8px;\n\n                .response-icon {\n                  font-size: 18px;\n                  width: 18px;\n                  height: 18px;\n                  color: #3b82f6;\n                }\n\n                strong {\n                  font-size: 13px;\n                  font-weight: 700;\n                  color: #1e40af;\n                }\n              }\n\n              .response-text {\n                font-size: 13px;\n                color: #1e40af;\n                line-height: 1.5;\n                margin: 0 0 4px 0;\n              }\n\n              .response-date {\n                font-size: 12px;\n                color: #64748b;\n              }\n            }\n\n            .review-card-actions {\n              display: flex;\n              align-items: center;\n              gap: 24px;\n              margin-top: 24px;\n\n              .helpful-btn {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                padding: 8px 16px;\n                border: 1px solid #e2e8f0;\n                border-radius: 8px;\n                background: #fff;\n                font-weight: 700;\n                font-size: 14px;\n                color: #0f172a;\n                cursor: pointer;\n                transition: all 0.2s;\n\n                &:hover {\n                  background: #f8fafc;\n                  border-color: #cbd5e1;\n                }\n\n                mat-icon {\n                  font-size: 18px;\n                  width: 18px;\n                  height: 18px;\n                }\n              }\n\n              .report-btn {\n                font-size: 14px;\n                font-weight: 700;\n                color: #94a3b8;\n                background: none;\n                border: none;\n                cursor: pointer;\n                padding: 0;\n                transition: color 0.2s;\n\n                &:hover {\n                  color: #475569;\n                }\n              }\n            }\n          }\n        }\n\n        .load-more-section {\n          text-align: center;\n          padding-top: 32px;\n\n          .load-more-btn {\n            padding: 16px 32px;\n            background: #0f172a;\n            color: #fff;\n            border: none;\n            border-radius: 12px;\n            font-weight: 700;\n            font-size: 14px;\n            cursor: pointer;\n            transition: all 0.2s;\n\n            &:hover {\n              opacity: 0.9;\n              transform: translateY(-1px);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .description-section {\n    margin-bottom: 16px;\n\n    .description-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: 12px;\n\n      h3 {\n        font-size: 16px;\n        font-weight: 600;\n        height: 20px;\n        width: 120px;\n        margin: 0;\n      }\n    }\n\n    .description-content {\n      .skeleton-text {\n        height: 16px;\n        margin: 8px 0;\n      }\n    }\n  }\n\n\n  .comments-section {\n    margin-bottom: 16px;\n\n    .comments-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 16px;\n    }\n\n    h3 {\n      font-size: 16px;\n      font-weight: 600;\n      height: 24px;\n      width: 150px;\n      margin-bottom: 16px;\n    }\n\n\n    .comment-input-section {\n      display: flex;\n      align-items: flex-start;\n      gap: 12px;\n      margin-bottom: 24px;\n\n      .comment-avatar {\n        flex-shrink: 0;\n\n        .skeleton-avatar {\n          width: 40px;\n          height: 40px;\n        }\n      }\n\n      .comment-form-wrapper {\n        flex: 1;\n\n        .comment-input {\n          width: 100%;\n          height: 40px;\n          border-radius: 20px;\n          margin: 0;\n        }\n\n        .comment-guidelines-helper {\n          font-size: 13px;\n          margin-top: 6px;\n        }\n      }\n    }\n\n    .comments-list {\n      .comment-item {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        padding: 16px 0;\n        border-bottom: 1px solid #f0f0f0;\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        .comment-header {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          margin-bottom: 8px;\n\n          .comment-author {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n\n            .comment-avatar-img {\n              width: 32px;\n              height: 32px;\n            }\n\n            .comment-author-name {\n              height: 16px;\n              width: 100px;\n              margin: 0;\n            }\n          }\n\n          .comment-date {\n            height: 14px;\n            width: 80px;\n            margin: 0;\n          }\n        }\n\n        .comment-text {\n          height: 16px;\n          width: 100%;\n          margin: 8px 0;\n        }\n\n        .comment-actions {\n          display: flex;\n          gap: 8px;\n          margin-top: 8px;\n\n          .comment-action-btn {\n            width: 32px;\n            height: 32px;\n            border-radius: 50%;\n            border: none;\n            background: transparent;\n            cursor: default;\n            pointer-events: none;\n          }\n        }\n      }\n    }\n\n    .leave-review-inline {\n      margin-top: 12px;\n      padding-top: 8px;\n      border-top: 1px solid #e0e0e0;\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 8px;\n      font-size: 12px;\n    }\n\n    .leave-review-text {\n      color: #555;\n    }\n\n    .leave-review-button {\n      border: 1px solid #5ea1d8;\n      background-color: #ffffff;\n      color: #5ea1d8;\n      border-radius: 999px;\n      padding: 4px 10px;\n      font-size: 12px;\n      font-weight: 600;\n      cursor: pointer;\n    }\n\n    .leave-review-button:hover {\n      background-color: #e3f1fb;\n    }\n  }\n\n  .flow-sidebar {\n    width: 402px;\n    min-width: 402px;\n    max-width: 402px;\n    position: relative;\n    align-self: flex-start;\n\n    @media (max-width: 1024px) {\n      display: none;\n    }\n\n    // Completion Progress Card (Desktop)\n    .completion-progress-card-desktop {\n      background: transparent !important;\n      border-radius: 12px !important; \n      margin: 4px 4px !important;\n      margin-bottom: 16px !important;\n      display: flex !important;\n      justify-content: flex-start !important;\n      align-items: center !important;\n      width: 100% !important;\n      visibility: visible !important;\n      opacity: 1 !important;\n\n      .completion-progress-content-desktop {\n        display: flex !important;\n        flex-direction: column !important;\n        gap: 8px !important;\n        width: 100% !important;\n\n        .completion-progress-bar-desktop {\n          width: 100% !important;\n          height: 24px !important;\n          min-height: 24px !important;\n          max-height: 24px !important;\n          background-color: #e0e0e0 !important;\n          background: #e0e0e0 !important;\n          border-radius: 4px !important;\n          overflow: hidden !important;\n          position: relative !important;\n          display: block !important;\n          box-sizing: border-box !important;\n          visibility: visible !important;\n          opacity: 1 !important;\n\n          .completion-progress-fill-desktop {\n            height: 24px !important;\n            min-height: 24px !important;\n            background-color: #5ea1d8 !important;\n            background: linear-gradient(90deg, #5ea1d8 0%, #6bb3e8 100%) !important;\n            border-radius: 4px !important;\n            transition: width 0.3s ease !important;\n            position: relative !important;\n            display: flex !important;\n            align-items: center !important;\n            justify-content: center !important;\n            min-width: fit-content !important;\n            box-sizing: border-box !important;\n\n            .progress-bar-percentage-desktop {\n              color: white !important;\n              font-size: 12px !important;\n              font-weight: 600 !important;\n              padding: 0 8px !important;\n              white-space: nowrap !important;\n            }\n          }\n\n          .progress-bar-percentage-empty-desktop {\n            position: absolute !important;\n            left: 8px !important;\n            top: 50% !important;\n            transform: translateY(-50%) !important;\n            color: #606060 !important;\n            font-size: 12px !important;\n            font-weight: 600 !important;\n          }\n        }\n\n        .progress-step-info-desktop {\n          font-size: 12px !important;\n          color: #606060 !important;\n          line-height: 1.2 !important;\n          text-align: left !important;\n\n          .completion-code-badge {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            margin-left: 8px;\n            padding: 2px 8px;\n            border-radius: 999px;\n            background-color: #f0f4fa;\n            color: #3b4a60;\n            font-size: 11px;\n            font-weight: 600;\n          }\n        }\n      }\n\n      // When user has restarted the flow after completing it once or revisits a step,\n      // show a softer blue track behind the progress fill.\n      &.restarted {\n        .completion-progress-bar-desktop {\n          background-color: #e3f2fd !important;\n          background: #e3f2fd !important;\n        }\n      }\n    }\n\n\n    // Completion Progress Card (Desktop)\n    .completion-progress-card {\n      background: #fff;\n      border-radius: 12px;\n      padding: 16px;\n      margin-bottom: 24px;\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n      border: 1px solid rgba(0, 0, 0, 0.05);\n\n      .completion-progress-header {\n        display: flex;\n        align-items: center;\n        margin-bottom: 12px;\n        font-weight: 600;\n        font-size: 14px;\n        color: #0f0f0f;\n\n        .completion-progress-title {\n          flex: 1;\n        }\n      }\n\n      .completion-progress-content {\n        .completion-progress-top {\n          display: flex;\n          align-items: baseline;\n          gap: 8px;\n          margin-bottom: 12px;\n\n          .completion-percentage {\n            font-size: 32px;\n            font-weight: 700;\n            color: #4caf50;\n            line-height: 1;\n          }\n\n          .completion-stats {\n            font-size: 13px;\n            color: #606060;\n            align-self: center;\n          }\n        }\n\n        .completion-progress-bar {\n          width: 100%;\n          height: 24px;\n          background: #e0e0e0;\n          border-radius: 4px;\n          overflow: hidden;\n          position: relative;\n          display: flex;\n          align-items: center;\n\n          .completion-progress-fill {\n            height: 100%;\n            background: linear-gradient(90deg, #4caf50 0%, #66bb6a 100%);\n            border-radius: 4px;\n            transition: width 0.3s ease;\n            position: relative;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            min-width: fit-content;\n\n            .progress-bar-percentage {\n              color: white;\n              font-size: 12px;\n              font-weight: 600;\n              padding: 0 8px;\n              white-space: nowrap;\n            }\n          }\n\n          .progress-bar-percentage-empty {\n            position: absolute;\n            left: 8px;\n            top: 50%;\n            transform: translateY(-50%);\n            color: #606060;\n            font-size: 12px;\n            font-weight: 600;\n          }\n        }\n      }\n    }\n\n    .step-navigation {\n      margin-bottom: 24px;\n\n      .step-scroll {\n        max-height: 320px;\n        overflow-y: auto;\n        overflow-x: hidden;\n        padding-right: 8px;\n      }\n\n      .steps-list {\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n      }\n\n      .step-btn {\n        border: none;\n        background: rgba(240, 240, 240, 0.8);\n        padding: 10px 16px;\n        border-radius: 999px;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        cursor: default;\n        pointer-events: none;\n        width: 100%;\n\n        .skeleton-icon {\n          width: 20px;\n          height: 20px;\n          margin: 0;\n        }\n\n        .skeleton-step-pill {\n          flex: 1;\n          height: 16px;\n          margin: 0;\n        }\n      }\n    }\n\n    .recommendations-section {\n      margin-top: 24px;\n\n      h2 {\n        font-size: 16px;\n        font-weight: 600;\n        margin-bottom: 16px;\n        height: 24px;\n        width: 180px;\n      }\n\n      .recommendations-list {\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n      }\n\n      .recommendation-item {\n        display: flex;\n        gap: 12px;\n        cursor: default;\n        pointer-events: none;\n\n        .recommendation-thumbnail {\n          flex-shrink: 0;\n\n          .skeleton-image {\n            width: 120px;\n            height: 72px;\n            padding-bottom: 0;\n          }\n        }\n\n        .recommendation-info {\n          flex: 1;\n          min-width: 0;\n\n          .recommendation-title {\n            height: 16px;\n            width: 100%;\n            margin-bottom: 8px;\n          }\n\n          .recommendation-meta {\n            display: flex;\n            gap: 8px;\n            margin-bottom: 4px;\n\n            span {\n              height: 12px;\n              width: 60px;\n              margin: 0;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .recommendations-section-mobile {\n    margin-top: 24px;\n    margin-bottom: 16px;\n\n    h2 {\n      font-size: 18px;\n      font-weight: 600;\n      margin-bottom: 16px;\n      height: 24px;\n      width: 200px;\n    }\n\n    .recommendations-list {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n    }\n\n    .recommendation-item {\n      display: flex;\n      gap: 12px;\n      padding: 12px 0;\n      border-bottom: 1px solid #f0f0f0;\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      .recommendation-thumbnail {\n        flex-shrink: 0;\n\n        .skeleton-image {\n          width: 120px;\n          height: 72px;\n          padding-bottom: 0;\n        }\n      }\n\n      .recommendation-info {\n        flex: 1;\n        min-width: 0;\n\n        .recommendation-title {\n          height: 16px;\n          width: 100%;\n          margin-bottom: 8px;\n        }\n\n        .recommendation-meta {\n          display: flex;\n          gap: 8px;\n          margin-bottom: 4px;\n\n          span {\n            height: 12px;\n            width: 60px;\n            margin: 0;\n          }\n        }\n      }\n    }\n  }\n\n  // Mobile specific styles\n  &.mobile {\n    .container1 {\n    .flow-layout-container {\n      .flow-main-grid {\n          grid-template-columns: 1fr !important;\n          gap: 0 !important;\n          padding: 0 !important;\n        }\n\n        .flow-main-content {\n          .flow-title-sticky {\n            padding: 8px 16px 0 !important;\n            margin: 0 !important;\n          }\n\n          .completion-progress-card-mobile {\n            padding: 0 !important;\n            margin: 3px 0 4px 0 !important;\n\n            .progress-step-row-mobile {\n              padding: 0 16px !important;\n            }\n          }\n\n          .video-title-sticky {\n            margin: 0 !important;\n          }\n\n          .video-actions-bar {\n            overflow-x: auto;\n            overflow-y: hidden;\n            padding: 0 16px 12px 16px !important;\n          }\n        }\n      }\n    }\n\n    .flow-sidebar {\n      display: none !important;\n    }\n  }\n}\n\n@keyframes skeleton-shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n@keyframes skeleton-pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.65;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n/* Dark mode skeleton palette (view-flow) */\n:host-context(body.theme-dark) {\n  .skeleton-viewflow-container {\n    --skeleton-gradient: linear-gradient(\n      110deg,\n      #1f2937 8%,\n      #334155 18%,\n      #1f2937 33%\n    );\n    background: #0a0c10 !important;\n\n    .skeleton-text,\n    .skeleton-avatar,\n    .skeleton-icon,\n    .skeleton-image {\n      background-color: #1f2937 !important;\n    }\n\n    .skeleton-image::after {\n      background-color: #1f2937 !important;\n    }\n\n    .skeleton-card,\n    .skeleton-flow-header {\n      background: #111827 !important;\n      border-color: rgba(148, 163, 184, 0.2) !important;\n      box-shadow: none !important;\n    }\n\n    .video-player-section,\n    .video-player-section .img-wrap,\n    .video-player-section .img-wrap img,\n    .video-player-section .img-wrap video,\n    .mobile-media,\n    .mobile-media img,\n    .mobile-media video,\n    .mobile-media-video {\n      background: #020617 !important;\n    }\n\n    .info-badge,\n    .skeleton-pill {\n      background: rgba(148, 163, 184, 0.16) !important;\n    }\n  }\n}\n\n.step-sec .img-wrap:after {\n  content: \"›\";\n\n  background: #fafafa !important;\n  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n    0 1px 18px 0 rgb(0 0 0 / 12%);\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  position: absolute;\n  right: -49px;\n  top: calc(50% - 20px);\n  font-size: 35px;\n  margin-top: -8px;\n  display: none;\n}\n\n.step-sec .img-wrap:before {\n  content: \"‹\";\n\n  background: #fafafa !important;\n  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n    0 1px 18px 0 rgb(0 0 0 / 12%);\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  position: absolute;\n  left: -49px;\n  top: calc(50% - 20px);\n  font-size: 35px;\n  margin-top: -8px;\n  display: none;\n}\n\n.des-item .des p::-webkit-scrollbar {\n  width: 4px;\n  height: 100px;\n}\n\n.des-item .des p::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n.des-item .des p::-webkit-scrollbar-thumb {\n  background-color: #5ea1d8;\n  outline: 1px solid #5ea1d8;\n}\n\n.des-item .item .list::-webkit-scrollbar {\n  width: 4px;\n  height: 100px;\n}\n\n.des-item .item .list::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n.des-item .item .list::-webkit-scrollbar-thumb {\n  background-color: #5ea1d8;\n  outline: 1px solid #5ea1d8;\n}\n\n.step-sec {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n}\n\n// .progressbar {\n//   flex: 1;\n//   display: table;\n//   align-items: center;\n//   height:30px;\n//   background:#fff;\n// }\n.progressbar ul {\n  display: flex;\n  flex-basis: 100%;\n}\n\n.progressbar ul li {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n\n.progressbar ul li a {\n  width: 20px;\n  height: 20px;\n  background: #5ea1d8;\n  border-radius: 50%;\n  color: #fff;\n  text-decoration: none;\n  text-align: center;\n  font-size: 12px;  \n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.progressbar ul li a:before {\n  counter-increment: my-sec-counter;\n  content: \"\" counter(my-sec-counter) \"\";\n}\n\nimg {\n  max-width: 100%;\n}\n\n@media only screen and (max-width: 1025px) and (min-width: 320px) {\n  .view-flow {\n    // background:#fff;\n    h2 {\n      font-size: 22px !important;\n      // word-break: break-all;\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 320px) {\n  .view-flow {\n    .container1 {\n      display: flex;\n      flex-direction: column;\n      padding: 0px 15px 20px;\n\n      .user-sec {\n        flex-direction: column;\n\n        // margin:0px;\n        // padding: 0rem 0px 2rem;\n        .user-details {\n          flex-direction: column;\n          order: 2;\n\n          .user-ico {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n\n          .ico-details {\n            padding: 0px;\n\n            .profilepic {\n              & > div {\n                p {\n                  font-size: 14px;\n                }\n              }\n            }\n\n            .like {\n              display: flex;\n              // flex-direction: column;\n              margin-left: 0px;\n\n              ul {\n                margin-left: 0px;\n\n                // max-width: 100%;\n                li {\n                  i {\n                    font-size: 20px;\n                  }\n                }\n              }\n\n              .qrcode {\n                span {\n                  margin-right: 0px !important;\n                }\n              }\n            }\n          }\n        }\n\n        .qr-code {\n          padding: 10px 0px;\n        }\n      }\n    }\n\n    .description-wrapper {\n      flex-direction: column;\n      margin: 0px;\n      margin-bottom: 20px;\n\n      .des-item {\n        margin-right: 0px;\n        margin-bottom: 20px;\n        flex-basis: 100%;\n        max-width: unset;\n        border-right: 0px;\n        padding-right: 0px;\n\n        .des {\n          & > div {\n            span {\n              &:first-child {\n                justify-content: flex-start;\n              }\n            }\n          }\n\n          .timer-wrap {\n            display: flex;\n            flex-direction: column;\n            flex: none;\n            color: #212427;\n\n            > * {\n              margin-right: 10px;\n            }\n          }\n        }\n      }\n\n      .step-sec {\n        .img-wrap {\n          img {\n            //max-height: 300px !important;\n          }\n        }\n      }\n    }\n\n    .viewflow-step {\n      width: 100%;\n      margin: 0px auto 20px;\n\n      .des-item {\n        flex-basis: 100%;\n        max-width: unset;\n        border-bottom: 2px solid lightgrey;\n        padding-bottom: 20px;\n\n        .des {\n          padding-bottom: 20px;\n          // border-bottom:1px solid lightgray;\n          border-radius: 0px;\n        }\n      }\n\n      .step-sec {\n        padding: 0px;\n        margin-left: 0px;\n        width: 100%;\n      }\n\n      .clickarrow {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        button {\n          width: 25px;\n          height: 25px;\n\n          &.owl-prev {\n            // left: -20px;\n            // background:transparent !important;\n            // box-shadow: none !important;\n          }\n\n          &.owl-next {\n            // right: -20px;\n            // background:transparent !important;\n            // box-shadow: none !important;\n          }\n\n          &.owl-prev {\n            margin-right: auto;\n            margin-left: 0;\n          }\n\n          &.owl-next {\n            margin-left: auto;\n            margin-right: 0;\n          }\n        }\n      }\n    }\n\n    .ico-details .profilepic {\n      flex-wrap: nowrap;\n    }\n  }\n\n  .view-flow .container1 .user-sec .user-details .ico-details {\n    .profilepic {\n      .profinner {\n        width: 100% !important;\n        flex-basis: 100% !important;\n        max-width: 100% !important;\n\n        & + .qrcode {\n          width: 100%;\n          justify-content: flex-end;\n        }\n      }\n\n      & + .like-list {\n        flex-direction: column;\n      }\n    }\n  }\n\n  .view-flow .container1 .viewflow-step .step-sec {\n    width: 100%;\n    margin: 0px;\n  }\n\n  .supportingdoc {\n    position: relative !important;\n    padding: 10px 10px 10px 0px !important;\n  }\n}\n\n/*table struture starts here*/\n.table-wrap {\n  max-height: 260px;\n  overflow-y: auto;\n  padding-right: 7px;\n\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n  }\n\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n  }\n}\n\ntable {\n  padding-right: 20px;\n  width: 100%;\n\n  tr {\n    display: flex;\n    width: 100%;\n    flex-flow: row wrap;\n    justify-content: space-between;\n\n    th {      \n      font-weight: 600 !important;\n      font-size: 16px !important;\n      width: 48%;\n      word-break: break-all;\n      margin-bottom: 15px;\n      line-height: 25px;\n    }\n\n    td {\n      width: 100%;\n      word-break: break-all;\n      margin-bottom: 15px;      \n      font-weight: 400;\n      line-height: 25px;\n      font-size: 13px;\n      position: relative;\n      padding-left: 15px;\n      display: flex;\n\n      & > span {\n        width: 48%;\n        overflow-wrap: break-word;\n\n        &:first-child {\n          margin-right: 4%;\n        }\n      }\n\n      &:before {\n        content: \"\";\n        width: 8px;\n        height: 8px;\n        background: grey;\n        position: absolute;\n        left: 0px;\n        top: 8px;\n        border-radius: 50%;\n        box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n      }\n\n      // &:nth-child(even){\n      //   &:before{\n      //     display: none;\n      //   }\n      // }\n    }\n  }\n}\n\n// .cdk-overlay-pane .mat-menu-panel{\n//   left:-250px !important;\n//   top:-19px !important;\n\n// }\n\n.like-list {\n  .fashion-btn {\n    display: block;\n  }\n}\n\n.qr-code {\n  .lock,\n  .fashion-btn {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 461px) {\n  .view-flow {\n    .container1 {\n      .user-sec {\n        .user-details {\n          flex-direction: row;\n\n          // margin-bottom:30px;\n          // padding-left:15px;\n          .ico-details {\n            padding-left: 15px;\n            max-width: 100%;\n\n            .like {\n              ul {\n                margin-left: -15px;\n              }\n\n              .qrcode {\n                span {\n                  margin-right: 15px !important;\n                }\n              }\n            }\n\n            .profilepic {\n              & > div {\n                p {\n                  font-size: 14px !important;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .description-wrapper {\n        width: auto;\n        // max-width:80%;\n        // max-width:calc(100% - 50px);\n        margin: 10px 20px;\n\n        .step-sec {\n          .img-wrap {\n            max-height: unset;\n          }\n        }\n      }\n\n      .viewflow-step {\n        .des-item {\n          .des {\n            padding-bottom: 20px;\n            // border-bottom:1px solid lightgray;\n            border-radius: 0px;\n          }\n        }\n\n        .clickarrow {\n          padding: 12px 16px 0;\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n\n          button {\n            width: 44px;\n            height: 44px;\n\n            &.owl-prev {\n              margin-right: auto;\n              margin-left: 0;\n            }\n\n            &.owl-next {\n              margin-left: auto;\n              margin-right: 0;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 768px) {\n  .view-flow {\n    .viewflow-step {\n      .clickarrow {\n        padding: 12px 20px 0;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        button {\n          width: 42px;\n          height: 42px;\n\n          &.owl-prev {\n            margin-right: auto;\n            margin-left: 0;\n          }\n\n          &.owl-next {\n            margin-left: auto;\n            margin-right: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 460px) and (min-width: 320px) {\n  .view-flow\n    .container1\n    .user-sec\n    .user-details\n    .ico-details\n    .profilepic\n    > div\n    p {\n    font-size: 11px !important;\n  }\n\n  .ico-details .profilepic > div:last-child {\n    span {\n      font-size: 11px;\n    }\n  }\n\n  .view-flow .viewflow-step .clickarrow {\n    padding: 12px 12px 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    button {\n      width: 40px;\n      height: 40px;\n\n      &.owl-prev {\n        margin-right: auto;\n        margin-left: 0;\n      }\n\n      &.owl-next {\n        margin-left: auto;\n        margin-right: 0;\n      }\n    }\n  }\n\n  .view-flow .viewflow-step {\n    width: auto;\n    margin: 10px 0px;\n  }\n\n  .qr-code {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n\n    .priceIcon-wp {\n      position: relative !important;\n      top: -2px;\n    }\n\n    .lock {\n      > span {\n        display: flex;\n        align-items: center;\n      }\n    }\n\n    .qr-ico {\n      // width: 24px;\n      // background: gray;\n      // display: block;\n      // height: 35px;\n    }\n\n    .lock,\n    .fashion-btn {\n      display: block;\n    }\n  }\n\n  .profilepic {\n    .lock {\n      display: none !important;\n    }\n  }\n\n  .like-list {\n    .fashion-btn {\n      display: none !important;\n    }\n  }\n\n  .view-flow h2 span {\n    font-size: 20px !important;\n    word-break: break-word;\n  }\n\n  .view-flow .container1 .user-sec {\n    padding: 10px;\n    margin: 0px;\n  }\n\n  .ico-details .profilepic .profinner > div {\n    margin-right: 5px;\n  }\n\n  .ico-details .profilepic > div {\n    margin-right: 0px;\n  }\n\n  .like li:last-child {\n    // display: none !important;\n  }\n\n  .viewflow-step .des-item .des p {\n    max-height: 133px;\n  }\n\n  .view-flow .container1 .user-sec .user-details .ico-details .like ul li span {\n    font-size: 9px;\n  }\n\n  .partOfBundle {\n    padding: 0px;\n    margin-right: 5px;\n  }\n}\n\nbutton.common {\n  padding: 3px 6px !important;\n  background: #5ea1d8 !important;\n  // background: pink !important;\n  border: 0px !important;\n  color: #fff !important;\n  font-size: 13px !important;\n  border-radius: 5px !important;\n}\n\n@media (max-width: 500px) {\n  .ico-details .profilepic .qrcode {\n    justify-content: center;\n  }\n}\n\n.example-list {\n  max-width: 100%;\n  // border: solid 1px #ccc;\n  // min-height: 246px;\n  height: auto;\n  display: flex;\n  background: white;\n  flex-direction: column;\n  // border-radius: 4px;\n  overflow-y: auto;\n\n  .example-box {\n    display: flex;\n    padding: 15px 10px;\n    border-bottom: 1px solid lightgrey;\n    background: white !important;\n    flex: 1;\n    padding: 15px 10px;\n    border-bottom: solid 1px lightgray;\n    color: rgba(0, 0, 0, 0.87);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    cursor: default; // Changed from move to default - items are not draggable in view mode\n    background: white;\n    font-size: 14px;\n\n    .item-name {\n      text-align: left;\n      width: 70%;\n      cursor: default !important; // Remove cursor pointer on item name\n    }\n\n    .item-value {\n      text-align: left;\n      width: 30%;\n      cursor: default !important; // Remove cursor pointer on quantity\n    }\n\n    .item-name,\n    .item-delete,\n    .item-reorder,\n    .item-value {\n      text-align: left;\n      padding: 5px;\n      font-size: 14px;\n      font-weight: 400 !important;\n      overflow-wrap: break-word;\n    }\n    \n    // Remove cursor pointer from non-clickable spans (item name and quantity)\n    span:not(a) {\n      cursor: default !important;\n    }\n\n    .item-delete,\n    .item-reorder {\n      float: right;\n      cursor: pointer;\n      font-size: 20px;\n      width: 10%;\n    }\n\n    &:last-child {\n      border-bottom: 0px;\n    }\n\n    img {\n      border-bottom: 0px;\n      width: 40px !important;\n      max-width: 40px;\n      height: 40px !important;\n      object-fit: cover;\n    }\n\n    & > * {\n      flex: 1;\n      color: #212427 !important;\n      font-weight: normal !important;\n    }\n\n    a {\n      color: #007bff !important;\n    }\n  }\n\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n  }\n\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n  }\n}\n\n.example-box {\n  padding: 15px 10px;\n  border-bottom: solid 1px lightgray;\n  color: rgba(0, 0, 0, 0.87);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  cursor: default; // Changed from move to default - items are not draggable in view mode\n  background: white;\n  font-size: 14px;\n\n  .item-value {\n    cursor: default !important; // Remove cursor pointer on quantity\n  }\n  \n  // Remove cursor pointer from non-clickable spans\n  span:not(a) {\n    cursor: default !important;\n  }\n\n  & > div {\n    width: 50%;\n    display: flex !important;\n\n    &:first-child {\n      width: 80%;\n    }\n\n    &:last-child {\n      width: 17%;\n    }\n\n    & > span {\n      // width:48%;\n      text-align: left;\n      word-break: keep-all;\n      display: flex;\n      align-items: center;\n\n      &:first-child {\n        flex: 1;\n        width: 50%;\n        color: rgba(0, 0, 0, 0.54) !important;\n        font-weight: 400 !important;\n      }\n\n      &:last-child {\n        width: 50%;\n        text-align: center;\n        display: flex;\n        align-items: center;\n        justify-content: end;\n        white-space: nowrap;\n        color: rgba(0, 0, 0, 0.54) !important;\n        font-weight: 400 !important;\n      }\n    }\n  }\n}\n\n.itemremove {\n  span {\n    &:first-child {\n      width: 90% !important;\n    }\n\n    &:nth-child(2) {\n      // display:none;\n    }\n  }\n}\n\n.img-div-left {\n  position: fixed;\n  z-index: 9999999 !important;\n  height: 100px;\n  width: 100px;\n  overflow: visible;\n  margin: auto;\n  top: 5% !important;\n  left: 0;\n  bottom: 0;\n  right: 0;\n\n  img {\n    width: 100%;\n    height: 100%;\n    position: absolute !important;\n    top: 0% !important;\n  }\n}\n\n/*new design starts here*/\n.viewbundle {\n  .step-sec {\n    & + .row {\n      margin-top: 40px !important;\n      display: flex;\n      justify-content: flex-start;\n      width: 100%;\n\n      & > div {\n        width: 25% !important;\n\n        .item {\n          box-shadow: none !important;\n\n          img {\n            width: calc(100% - 20px) !important;\n            object-fit: cover;\n            margin: 10px !important;\n          }\n\n          p {\n            padding-left: 5px;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            height: 33px !important;\n            white-space: normal;\n            word-break: break-word;\n          }\n\n          .with-icon {\n            display: flex;\n\n            img {\n              width: 30px !important;\n              height: 30px !important;\n              border-radius: 20px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.mat-accent {\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (max-width: 460px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 50% !important;\n\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n\n              & > div {\n                width: 30px !important;\n              }\n\n              img {\n                margin: 0px !important;\n              }\n\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (min-width: 461px) and (max-width: 767px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 33% !important;\n\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n\n              & > div {\n                width: 30px !important;\n              }\n\n              img {\n                margin: 0px !important;\n              }\n\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// .viewbundle {\n//   .img-wrap {\n//     & + .item {\n//       width: calc(100% - 0px) !important;\n//       margin: 17px 0px !important;\n//       border: 0px !important;\n//     }\n//   }\n// }\n.example-list .example-box {\n  .item-name {\n    padding-left: 10px !important;\n    border-right: 1px solid #ddd;\n  }\n\n  .item-value {\n    padding-left: 10px !important;\n  }\n}\n\n.textcolor {\n  color: #5ea1d8;\n}\n\n// .item {\n//   // height: 220px !important;\n//   // background-color: lightgray;\n//   border: solid 1px;\n//   margin: 17px;\n//   width: 170px;\n//   border: solid 0.5px lightgrey;\n// }\n\n.item .img {\n  height: 150px !important;\n  background-color: lightgray;\n}\n\np {\n  margin: 0px;\n}\n\n.zoom {\n  cursor: pointer;\n  width: 100%;\n  height: 70%;\n  transition: transform 0.1s;\n  /* Animation */\n}\n\n.zoom:hover {\n  border-radius: 5px;\n  // -ms-transform: scale(1.2); /* IE 9 */\n  // -webkit-transform: scale(1.5); /* Safari 3-8 */\n  transform: scale(1.1);\n  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */\n}\n\n.owl-carousel .owl-nav button.owl-next,\n.owl-carousel .owl-nav button.owl-prev,\n.owl-carousel button.owl-dot {\n  font-size: 55px !important;\n}\n\n.owl-theme .owl-nav [class*=\"owl-\"] {\n  font-size: 55px !important;\n}\n\nbutton span {\n  // font-size: 55px;\n}\n\n.owl-nav {\n  display: none;\n}\n\n.with-icon {\n  display: flex;\n  align-items: center;\n}\n\n.mat-badge-content {\n  background: #5ea1d8;\n}\n\n.div1 {\n  height: 50px;\n  //border: 1px solid blue;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: white;\n  overflow: hidden;\n  z-index: 100;\n}\n\n.user-pro {\n  .row {\n    justify-content: left;\n  }\n\n  .ng-star-inserted {\n    width: 15.6%;\n    margin-right: 1%;\n    // &:nth-child(6n+6){\n    //   .item{\n    //     margin-right:0px;\n    //   }\n\n    //       }\n  }\n\n  .item {\n    width: 100% !important;\n    overflow: hidden;\n    background: #fff;\n    border: 1px solid #dddddd;\n    margin: 0px;\n    margin-right: 20px;\n    margin-bottom: 20px;\n\n    & > div {\n      margin: 5px;\n    }\n\n    p {\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      height: 33px !important;\n      white-space: normal;\n      word-break: break-word;\n\n      &:last-of-type {\n        height: auto !important;\n        // font-size: 12px !important;\n      }\n    }\n\n    .with-icon {\n      width: 100%;      \n      display: flex;\n      align-items: center;\n\n      > div {\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n        overflow: hidden;\n        display: flex;\n        align-items: center;\n        margin-right: 5px;\n      }\n\n      img {\n        object-fit: cover;\n        height: 40px !important;\n        border: 0px;\n      }\n    }\n\n    .zoom {\n      margin: 5px;\n      width: calc(100% - 10px);\n      background-color: transparent;\n    }\n\n    img {\n      height: 150px;\n      object-fit: cover;\n      width: 100%;\n      border: 1px solid #dddddd;\n    }\n  }\n}\n\n@media only screen and (max-width: 1024px) and (min-width: 993px) {\n  .user-pro {\n    .row {\n      justify-content: left;\n      text-align: start;\n    }\n\n    .ng-star-inserted {\n      max-width: 18% !important;\n      width: 18% !important;\n      margin: 1% !important;\n      // &:nth-child(5n + 5){\n      //   margin-right:0px;\n      // }\n    }\n\n    .item {\n      max-width: 100% !important;\n      width: 100% !important;\n      overflow: hidden;\n      background: #fff;\n      border: 1px solid #dddddd;\n      margin: 0px;\n      margin-right: 0px;\n      margin-bottom: 20px;\n\n      & > div {\n        margin: 5px;\n      }\n\n      p {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        height: 33px !important;\n        white-space: normal;\n        word-break: break-word;\n      }\n\n      .with-icon {\n        max-width: 100% !important;\n        width: 100% !important;        \n        display: flex;\n        align-items: center;\n        max-width: 100% !important;\n\n        > div {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          overflow: hidden;\n          display: flex;\n          align-items: center;\n          margin-right: 5px;\n        }\n\n        img {\n          object-fit: cover;\n          height: 40px !important;\n          border: 0px;\n        }\n      }\n\n      .zoom {\n        margin: 5px;\n        width: calc(100% - 10px);\n        background-color: transparent;\n      }\n\n      img {\n        height: 150px;\n        object-fit: cover;\n        width: 100%;\n        border: 1px solid #dddddd;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 768px) {\n  .user-pro {\n    .row {\n      justify-content: left;\n      text-align: start;\n    }\n\n    .ng-star-inserted {\n      max-width: 23% !important;\n      width: 23% !important;\n      margin: 1% !important;\n      // &:nth-child(4n + 4){\n      //   margin-right:0px;\n      // }\n    }\n\n    .item {\n      max-width: 100% !important;\n      width: 100% !important;\n      overflow: hidden;\n      background: #fff;\n      border: 1px solid #dddddd;\n      margin: 0px;\n      margin-right: 0px;\n      margin-bottom: 20px;\n\n      & > div {\n        margin: 5px;\n      }\n\n      p {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        height: 33px !important;\n        white-space: normal;\n        word-break: break-word;\n      }\n\n      .with-icon {\n        max-width: 100% !important;\n        width: 100% !important;        \n        display: flex;\n        align-items: center;\n\n        > div {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          overflow: hidden;\n          display: flex;\n          align-items: center;\n          margin-right: 5px;\n        }\n\n        img {\n          object-fit: cover;\n          height: 40px !important;\n          border: 0px;\n        }\n      }\n\n      .zoom {\n        margin: 5px;\n        width: calc(100% - 10px);\n        background-color: transparent;\n      }\n\n      img {\n        height: 150px;\n        object-fit: cover;\n        width: 100%;\n        border: 1px solid #dddddd;\n      }\n    }\n  }\n\n  h3 {\n    padding-left: 12px;\n  }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 461px) {\n  .user-pro {\n    .row {\n      justify-content: left;\n      text-align: start;\n    }\n\n    .ng-star-inserted {\n      max-width: 31.3% !important;\n      width: 31.3% !important;\n      margin: 1%;\n      // &:nth-child(3n+3){\n      //   margin-right:0%;\n      //   // .item{\n      //   //   margin-right:0px;\n      //   // }\n\n      //       }\n    }\n\n    .item {\n      max-width: 100% !important;\n      width: 100% !important;\n      overflow: hidden;\n      background: #fff;\n      border: 1px solid #dddddd;\n      margin: 0px;\n      margin-right: 0px;\n      margin-bottom: 0px;\n\n      & > div {\n        margin: 5px;\n      }\n\n      p {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        height: 33px !important;\n        white-space: normal;\n        word-break: break-word;\n      }\n\n      .with-icon {\n        width: 100%;        \n        display: flex;\n        align-items: center;\n\n        > div {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          overflow: hidden;\n          display: flex;\n          align-items: center;\n          margin-right: 5px;\n        }\n\n        img {\n          object-fit: cover;\n          height: 40px !important;\n          border: 0px;\n        }\n\n        &.ng-star-inserted {\n          max-width: 100% !important;\n          width: 100% !important;\n        }\n      }\n\n      .zoom {\n        margin: 5px;\n        width: calc(100% - 10px);\n        background-color: transparent;\n      }\n\n      img {\n        height: 150px;\n        object-fit: cover;\n        width: 100%;\n        border: 1px solid #dddddd;\n      }\n    }\n  }\n\n  h3 {\n    padding-left: 12px;\n  }\n}\n\n@media screen and (max-width: 460px) {\n  .user-pro {\n    .row {\n      justify-content: left;\n      text-align: start;\n    }\n\n    .ng-star-inserted {\n      max-width: 48% !important;\n      width: 48% !important;\n      margin: 1%;\n      // &:nth-child(2n+2){\n      //   margin-right:0px;\n      //   // .item{\n      //   //   margin-right:0px;\n      //   // }\n\n      //       }\n    }\n\n    .item {\n      max-width: 100% !important;\n      width: 100% !important;\n      overflow: hidden;\n      background: #fff;\n      border: 1px solid #dddddd;\n      margin: 0px;\n      margin-right: 0px;\n      margin-bottom: 0px;\n\n      & > div {\n        margin: 5px;\n      }\n\n      p {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        height: 33px !important;\n        white-space: normal;\n        word-break: break-word;\n      }\n\n      .with-icon {\n        width: 100%;        \n        display: flex;\n        align-items: center;\n\n        > div {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          overflow: hidden;\n          display: flex;\n          align-items: center;\n          margin-right: 5px;\n        }\n\n        img {\n          object-fit: cover;\n          height: 40px !important;\n          border: 0px;\n        }\n\n        &.ng-star-inserted {\n          max-width: 100% !important;\n          width: 100% !important;\n        }\n      }\n\n      .zoom {\n        margin: 5px;\n        width: calc(100% - 10px);\n        background-color: transparent;\n      }\n\n      img {\n        height: 150px;\n        object-fit: cover;\n        width: 100%;\n        border: 1px solid #dddddd;\n      }\n    }\n  }\n\n  h3 {\n    padding-left: 7px;\n  }\n}\n\n// .img-div-left{\n//   position: fixed;\n//   z-index: 999;\n//   height: 150px;\n//   width: 150px;\n//   overflow: visible;\n//   margin: auto;\n//   top: 0;\n//   left: 0;\n//   bottom: 0;\n//   right: 0;\n// }\n\n.scroll .item .uni-wrapper .bundleIcon {\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px !important;\n  height: 25px !important;\n  max-width: 25px !important;\n  height: 25px !important;\n\n  img {\n    width: 100% !important;\n    height: 20px !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n\n.uni-wrapper {\n  // display: flex;\n  // width: 100%;\n  // align-items: center;\n  P {\n    flex: 1;\n  }\n}\n\n/*new design starts here new bundle*/\n.viewbundle {\n  .step-sec {\n    & + .row {\n      margin-top: 40px !important;\n      display: flex;\n      justify-content: flex-start;\n      width: 100%;\n\n      & > div {\n        width: 25% !important;\n\n        .item {\n          box-shadow: none !important;\n\n          img {\n            width: calc(100% - 20px) !important;\n            object-fit: cover;\n            margin: 10px !important;\n          }\n\n          p {\n            padding-left: 5px;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            height: 33px !important;\n            white-space: normal;\n            word-break: break-word;\n          }\n\n          .with-icon {\n            display: flex;\n\n            img {\n              width: 30px !important;\n              height: 30px !important;\n              border-radius: 20px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 460px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 50% !important;\n\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n\n              & > div {\n                width: 30px !important;\n              }\n\n              img {\n                margin: 0px !important;\n              }\n\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (min-width: 461px) and (max-width: 767px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 33% !important;\n\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n\n              & > div {\n                width: 30px !important;\n              }\n\n              img {\n                margin: 0px !important;\n              }\n\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.bundleIcons {\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px !important;\n  height: 25px !important;\n  padding-left: 5px;\n\n  img {\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n\n.partOfBundle {\n  .item {\n    .uni-wrapper {\n      display: flex;\n\n      p {\n        justify-content: flex-start !important;\n      }\n    }\n  }\n}\n\n.uni-wrapper {\n  // display: flex;\n  // width: 100%;\n  // align-items: center;\n  // height: 35px;\n  P {\n    flex: 1;\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-start;\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n}\n\n.viewbundle {\n  .step-sec {\n    & + .row {\n      margin-top: 40px !important;\n      display: flex;\n      justify-content: flex-start;\n      width: 100%;\n\n      & > div {\n        width: 25% !important;\n\n        .item {\n          box-shadow: none !important;\n\n          img {\n            width: calc(100% - 20px) !important;\n            object-fit: cover;\n            margin: 10px !important;\n          }\n\n          p {\n            padding-left: 5px;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            height: 33px !important;\n            white-space: normal;\n            word-break: break-word;\n          }\n\n          .with-icon {\n            display: flex;\n\n            img {\n              width: 30px !important;\n              height: 30px !important;\n              border-radius: 20px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 460px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 50% !important;\n\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n\n              & > div {\n                width: 30px !important;\n              }\n\n              img {\n                margin: 0px !important;\n              }\n\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (min-width: 461px) and (max-width: 767px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 33% !important;\n\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n\n              & > div {\n                width: 30px !important;\n              }\n\n              img {\n                margin: 0px !important;\n              }\n\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .view-flow .container1 .user-sec {\n    margin: 0px !important;\n  }\n\n  .view-flow .viewflow-step {\n    width: 100% !important;\n    margin: 10px 0px !important;\n  }\n\n  .partOfBundle {\n    padding: 0px;\n    margin-right: 5px;\n  }\n}\n\n@media (max-width: 992px) {\n  .view-flow .viewflow-step .des-item {\n    padding: 0px;\n    border: 0px;\n    flex-basis: 100% !important;\n    max-width: 100% !important;\n    margin: 0px !important;\n    padding: 0px !important;\n    border: 0px !important;\n\n    .des {\n      padding: 0px;\n      padding: 0px 0px 20px !important;\n\n      p {\n        margin: 0px;\n      }\n    }\n  }\n\n  .view-flow .qr-ico {\n    position: relative;\n    right: 0px;\n  }\n}\n\n// .step-sec{\n//   width:100% !important;\n//   flex-basis: 100% !important;\n//     max-width: 100% !important;\n//     margin-left: 0px !important;\n// }\n\n.font16 {\n  font-size: 14px !important;  \n  color: rgba(0, 0, 0, 0.54) !important;\n  font-weight: bold;\n}\n\n.priceIcon-p .font16 {\n  font-size: 10px !important;\n  color: #fff !important;\n}\n\n.timer-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n\n  br {\n    display: none;\n  }\n\n  h6 {\n    width: 100%;\n    display: block;\n    margin-bottom: 15px;\n  }\n\n  .icon-wrap {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n\n    .textbodycolor {\n      justify-content: flex-start !important;\n      padding-left: 10px;\n    }\n  }\n}\n\n.newdesignadd {\n  display: block;\n  width: 100%;\n  color: #212427;\n  border: 1px solid lightgray;\n  border: 0px !important;\n  padding-left: 0px;\n\n  .item-name {\n    justify-content: flex-start !important;\n\n    a {\n      color: #5ea1d8;\n    }\n  }\n}\n\n.timer-wrap + h6 {\n  margin-bottom: 15px;\n}\n\n.not-draggable {\n  -webkit-user-drag: none;\n  /* Safari/Chrome */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* IE10+ */\n  user-select: none;\n  /* Standard syntax */\n  cursor: default;\n  /* Optional: Change the cursor style */\n  transform: translate(0, 0) !important;\n}\n\n.divscroll {\n  width: 100% !important;\n  display: flex;\n  flex-direction: row;\n  max-height: 100px;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  div {\n    width: 100% !important;\n  }\n}\n\n.view-flow .container1 .viewflow-step .step-sec .img-wrap {\n  flex: none !important;\n}\n\n// .qr-codeadd {\n//   .lock {\n//     display: block !important;\n//     &>span:first-child{\n//       display: none !important;\n//     }\n//   }\n// }\n\n@media (max-width: 767px) {\n  .partOfBundle {\n    padding: 0px 0px 20px 0px !important;\n    margin-right: 0px !important;\n\n    h2 {\n      margin-top: 0px !important;\n    }\n  }\n\n  .view-flow .container1 .viewflow-step {\n    margin-bottom: 10px !important;\n  }\n\n  .view-flow .partOfBundle h2 {\n    margin-top: 15px !important;\n  }\n}\n\n.view-flow\n  .container1\n  .user-sec\n  .user-details\n  .ico-details\n  .profilepic\n  .profinner {\n  div:nth-child(4) {\n    position: relative;\n\n    span {\n      position: relative;\n    }\n  }\n}\n\n/*chatbot design*/\n.chatbot-wrapper {\n  position: fixed;\n  bottom: 0px;\n  right: 20px;\n  padding: 20px;\n  display: none;\n  padding: 20px 0px 0px;\n  background: #fff;\n  border: 1px solid #ddd;\n  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);\n  margin: 0px 20px 0px 20px;\n  border-radius: 10px 10px 0px 0px;\n  max-width: 400px;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: 1002; /* Above translate element (1001) */\n  flex-wrap: wrap;\n  // max-height: 400px;\n  min-height: 400px;\n  // height: 100%;\n  max-height: calc(100% - 120px);\n  overflow-y: hidden;\n  flex-direction: row;\n\n  &:before {\n    content: \"\";\n    width: 100%;\n    height: 31%;\n    height: 124px;\n    background: rgb(94, 161, 216) !important;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    z-index: -1;\n  }\n\n  .chatbot-msg {\n    padding: 0px 20px;\n    width: 100%;\n\n    .chatbot-msgdetails {\n      .flora-close {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        color: #fff;\n        margin-bottom: 15px;\n\n        button {\n        }\n\n        h5 {\n          color: #fff;\n        }\n      }\n\n      .welcome-text {\n        color: #fff;\n        margin-bottom: 15px;\n\n        h2 {\n          color: #fff !important;\n          font-size: 20px !important;\n          margin-bottom: 10px !important;\n        }\n\n        p {\n          color: #fff !important;\n          font-weight: 400 !important;\n          margin: 0px !important;\n          display: -webkit-box;\n          -webkit-line-clamp: 2;\n          -webkit-box-orient: vertical;\n          max-width: 100%;\n          overflow: hidden;\n        }\n      }\n\n      .image {\n        margin-bottom: 20px;\n      }\n\n      .chabot-category {\n        display: flex;\n        flex-wrap: wrap;\n\n        ul {\n          margin: 0px;\n          margin-top: 10px !important;\n          padding: 0px !important;\n          list-style-type: none;\n          display: flex;\n          flex-wrap: wrap;\n          background: transparent !important;\n\n          li {\n            padding: 10px;\n            background: rgb(94, 161, 216) !important;\n            border-radius: 10px;\n            border: 1px solid #ddd;\n            margin: 0px;\n            margin-right: 5px;\n\n            a {\n              color: #fff !important;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .chatbot-btn {\n    width: 100%;\n    // height: 98%;\n    cursor: pointer;\n    margin-bottom: 0px;\n    padding: 0px 0px 0px 20px;\n    display: flex;\n    align-items: end;\n    justify-content: flex-end;\n    flex: 1;\n    margin-bottom: 10px;\n\n    img {\n      width: 80px;\n    }\n  }\n\n  .chatbot-converasation {\n    margin-bottom: 20px;\n    padding: 0px 20px;\n    width: 100%;\n\n    .chat-user,\n    .new-user {\n      max-width: 75%;\n      padding: 10px 10px;\n      background: #f6f6f6;\n      display: inline-flex;\n      justify-content: flex-start;\n      margin-bottom: 20px;\n      align-items: flex-start;\n      position: relative;\n      margin-left: 35px;\n      border-radius: 5px;\n      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);\n\n      p {\n        margin: 0px !important;\n      }\n\n      &:before {\n        content: \"\";\n        background: url(\"../../../assets/icons/chat-bot.png\");\n        // background: url(\"../../../assets/princess-light-skin-tone.png\");\n        background-repeat: no-repeat;\n        background-size: contain;\n        width: 30px;\n        height: 30px;\n        position: absolute;\n        left: -35px;\n        top: 50%;\n        transform: translateY(-50%);\n      }\n    }\n\n    .new-user {\n      display: flex;\n      justify-content: flex-end;\n      float: right;\n\n      &:before {\n        display: none;\n      }\n    }\n  }\n\n  .chatbot-stickyfooter {\n    width: 100%;\n    position: sticky;\n    bottom: 0px;\n    padding: 5px 20px;\n    background: #5ea1d8;\n    display: flex;\n    height: 50px;\n    z-index: 1003; /* Above chatbot wrapper and translate element */\n\n    .input {\n      position: relative;\n      height: 40px;\n      display: flex;\n      align-items: center;\n      flex: 1;\n      margin-right: 10px;\n\n      input {\n        width: 100%;\n        border: 1px solid #000;\n        border-radius: 10px;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        position: absolute;\n        left: 0px;\n        height: 40px;\n        border: 0px;\n        padding-left: 30px;\n        outline: none !important;\n        z-index: 1004; /* Above everything including icons */\n      }\n\n      i {\n        position: absolute;\n        z-index: 1005; /* Above input field for clickability */\n        // left: 6px;\n      }\n    }\n\n    .mic {\n      width: 40px;\n      height: 100%;\n      background: #fff;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  // \"Flow not available\" inline message (shown when flowNotFound is true)\n  .no-flow-available {\n    max-width: 720px;\n    margin: 40px auto;\n    padding: 24px 20px;\n    border-radius: 12px;\n    border: 1px solid #e0e0e0;\n    background: #fafafa;\n    text-align: left;\n\n    h2 {\n      margin: 0 0 8px 0;\n      font-size: 20px;\n      font-weight: 700;\n      color: #212427;\n    }\n\n    p {\n      margin: 0;\n      font-size: 14px;\n      color: #616161;\n    }\n  }\n}\n\n.scroll-div {\n  // height: calc(400px - 72px);\n  // height: 229px;\n  // height: 100%;\n  // height: calc(100% - 104px - 50px);\n  min-height: 224px !important;\n  overflow-y: scroll;\n  padding-bottom: 0px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  // display: inline-block;\n  // justify-content: flex-end;\n}\n\n.sticky-chat {\n  position: sticky;\n  top: -20px;\n  z-index: 1001; /* Above translate but below footer */\n  // background-color: rgb(94, 161, 216);\n  // border-bottom: 2px solid #ccc;\n  padding: 10px;\n  width: 100%;\n  height: 104px;\n}\n\n.sticky-default {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 10000;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  cursor: pointer;\n\n  img {\n    width: 80px;\n    height: 80px;\n    object-fit: contain;\n    display: block;\n  }\n\n  // width: 100px;\n  // height: auto;\n  // On mobile, move chatbot button up to avoid overlap with translate icon\n  @media (max-width: 767px) {\n    bottom: 110px; // Translate button is at bottom: 40px and 50px tall (occupies up to 90px), so position chatbot above it with 20px spacing\n    right: 16px; // Align with translate button's right position\n    width: 64px;\n    height: 64px;\n\n    img {\n      width: 64px;\n      height: 64px;\n    }\n  }\n}\n\n.chatbot-msg {\n  height: 104px;\n}\n\n.scroll-div {\n  max-height: 425px;\n\n  .chatbot-msg {\n    // height: 100%;\n    height: auto !important;\n  }\n\n  .faq-list {\n    padding: 0px 20px;\n  }\n}\n\n@media (max-width: 767px) {\n  .chatbot-wrapper {\n    display:none;\n    position: fixed;\n    bottom: 0px;\n    right: 0px;\n    padding: 20px;\n    display: flex;\n    padding: 20px 0px 0px;\n    background: #fff;\n    border: 1px solid #ddd;\n    box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);\n    margin: 0px 20px 0px 20px;\n    border-radius: 10px 10px 0px 0px;\n    max-width: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    z-index: 1002 !important; /* Above translate element (1001) */\n    flex-wrap: wrap;\n    max-height: 90vh;\n    /* Limits max height but allows it to expand */\n    overflow-y: auto;\n    /* Enables scrolling when needed */\n    flex-direction: column;\n    left: 0px;\n    margin: 0px auto;\n\n    .chatbot-stickyfooter {\n      display: flex !important;\n      visibility: visible !important;\n      position: sticky !important;\n      bottom: 0 !important;\n      width: 100% !important;\n      z-index: 1003 !important; /* Above chatbot wrapper and translate element */\n      background: #5ea1d8 !important;\n      padding: 5px 20px !important;\n      height: 50px !important;\n      flex-shrink: 0 !important;\n\n      .input {\n        display: flex !important;\n        visibility: visible !important;\n        width: 100% !important;\n        position: relative !important;\n        z-index: 1004 !important; /* Ensure input container is above translate */\n\n        input {\n          display: block !important;\n          visibility: visible !important;\n          width: 100% !important;\n          z-index: 1005 !important; /* Input field above everything */\n          position: absolute !important; /* Keep absolute positioning for proper layout */\n          left: 0px !important;\n          height: 40px !important;\n          padding-left: 30px !important;\n        }\n\n        i {\n          z-index: 1006 !important; /* Icons above input for clickability */\n          position: absolute !important;\n        }\n      }\n    }\n  }\n}\n\n.flow-container {\n  display: flex;\n  gap: 20px;\n}\n\n/* Left: Expansion Panel */\n.steps-panel {\n  width: 100%;\n  // border-right: 2px solid #ddd;\n  // padding-right: 10px;\n}\n\nmat-expansion-panel {\n  background: #f8f9fa;\n  margin-bottom: 5px;\n}\n\nmat-expansion-panel-header {\n  font-weight: bold;\n  // background-color: #5ea1d8;;\n  color: white;\n  cursor: pointer;\n}\n\nmat-expansion-panel-header:hover {\n  // background-color: #5ea1d8;\n  background-color: rgba(200, 193, 193, 0.5);\n}\n\n/* Right: Step Content */\n.step-content {\n  width: 100%;\n  padding-left: 10px;\n}\n\n.step-content h3 {\n  margin-bottom: 10px;\n}\n\n.step-content video,\n.step-content img {\n  display: block;\n  margin-top: 10px;\n  border-radius: 5px;\n}\n\n.viewflow-step {\n  .flow-container {\n    width: 100%;\n  }\n\n  .description {\n    width: 100%;\n  }\n}\n\n.viewflow-step .step-scroll {\n  overflow-x: auto; // Ensures horizontal scrolling\n  white-space: nowrap; // Prevents wrapping\n  width: 100%;\n  display: flex; // Ensures the inner content aligns properly\n}\n\n.viewflow-step .steps-list {\n  display: flex;\n  gap: 5px; // Maintain spacing between buttons\n  margin-bottom: 10px;\n\n  button {\n    white-space: nowrap; // Prevents button text from wrapping\n    // margin-bottom: 10px !important;\n  }\n}\n\n.group-header {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  /* Space between icon and text */\n  margin-top: 10px;\n  margin-left: 7px;\n}\n\n.keyword-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: center;\n\n  &.less {\n    span {\n      flex: unset !important;\n      &:nth-child(n + 5) {\n        display: none;\n      }\n      &:nth-last-child(-n + 2) {\n        display: inline;\n      }\n    }\n    .less-btn {\n      display: none !important;\n      width: 100% !important;\n      flex: unset !important;\n    }\n  }\n  &.more {\n    span {\n      flex: unset !important;\n      &:nth-child(n + 5) {\n        display: inline;\n      }\n      &:nth-last-child(-n + 2) {\n        display: inline;\n      }\n    }\n    .more-btn {\n      display: none !important;\n      width: 100% !important;\n      flex: unset !important;\n    }\n  }\n}\n.more-btn,\n.less-btn {\n  // display: none !important;\n  width: 100% !important;\n  flex: unset !important;\n  justify-content: flex-start !important;\n}\n\nspan.showmore {\n  display: flex !important;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n}\n\n.hashtag {\n  font-family: \"Montserrat\", sans-serif !important;\n  font-size: 12px;\n  font-weight: bold;\n  color: #5ea1d8;\n  padding: 2px 6px;\n  /* Reduced padding */\n  border-radius: 12px;\n  /* Optional: Makes it look like a pill */\n  background: rgba(94, 161, 216, 0.1);\n  /* Light background for visibility */\n  display: inline-block;\n  margin: 2px;\n  /* Minimal spacing between hashtags */\n}\n\n.more-btn,\n.less-btn {\n  font-size: 12px;\n  color: #888;\n  cursor: pointer;\n  margin-left: 4px;\n  /* Ensures it stays close to last hashtag */\n}\n\n@media (max-width: 767px) {\n  .view-flow {\n    width: 100vw !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    background: #ffffff;\n\n    .container1,\n    .flow-layout-container,\n    .flow-layout-container .flow-main-grid,\n    .flow-layout-container .flow-main-content {\n      width: 100vw !important;\n      max-width: 100vw !important;\n      margin: 0 !important;\n      padding: 0 !important;\n    }\n\n    .container1 {\n      .user-sec {\n        padding: 16px !important;\n        margin: 0 !important;\n        border-radius: 0 !important;\n      }\n    }\n\n    .flow-layout-container {\n      .flow-main-grid {\n        grid-template-columns: 1fr !important;\n        gap: 0 !important;\n      }\n\n      .flow-main-content {\n        .flow-title-sticky {\n          padding: 8px 16px 0 !important;\n          margin: 0 !important;\n        }\n\n        .completion-progress-card-mobile {\n          padding: 0 !important;\n          margin: 3px 0 4px 0 !important;\n\n          .progress-step-row-mobile {\n            padding: 0 16px !important;\n          }\n        }\n\n        .video-title-sticky {\n          margin: 0 !important;\n        }\n\n        .video-actions-bar {\n          overflow-x: auto;\n          overflow-y: hidden;\n          padding: 0 16px 12px 16px !important;\n\n          .action-buttons {\n            flex-wrap: nowrap !important;\n            gap: 8px !important;\n            width: max-content;\n          }\n\n          .action-item {\n            flex: 0 0 auto;\n            min-width: 100px;\n            padding: 6px 10px !important;\n            gap: 6px !important;\n            border-radius: 14px !important;\n\n            mat-icon {\n              font-size: 18px !important;\n              width: 18px !important;\n              height: 18px !important;\n            }\n\n            span {\n              font-size: 13px !important;\n              font-weight: 500;\n            }\n\n            .desktop-only-access-label {\n              display: none !important;\n            }\n          }\n\n          &::-webkit-scrollbar {\n            height: 4px;\n          }\n\n          &::-webkit-scrollbar-thumb {\n            background: rgba(0, 0, 0, 0.2);\n            border-radius: 4px;\n          }\n        }\n\n        .flow-info-panel,\n        .video-metadata,\n        .channel-info-section,\n        .description-section,\n        .comments-section {\n          padding: 16px !important;\n          margin: 0 !important;\n          border-radius: 0 !important;\n        }\n\n        .access-meta-label {\n          font-weight: 600 !important;\n          color: #1976d2 !important;\n          background: #e8f4fc;\n          border-radius: 999px;\n          padding: 2px 8px;\n          max-width: 100%;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        .video-player-section {\n          margin: 0 !important;\n          border-radius: 0 !important;\n\n          .img-wrap {\n            width: 100% !important;\n            max-width: 100% !important;\n            margin: 0 !important;\n          }\n\n          .item {\n            padding: 16px !important;\n            margin: 0 !important;\n          }\n        }\n      }\n\n      .flow-sidebar {\n        display: none !important;\n      }\n    }\n  }\n}\n\n/* Keep layout usable on common laptop resolutions without manual display scaling changes. */\n@media (max-width: 1366px) {\n  .view-flow {\n    .flow-layout-container {\n      .flow-main-grid {\n        grid-template-columns: 1fr !important;\n      }\n    }\n\n    .flow-sidebar {\n      width: 100% !important;\n      min-width: 100% !important;\n      max-width: 100% !important;\n\n      .recommendations-section {\n        display: none !important;\n      }\n    }\n\n    .recommendations-section-mobile {\n      display: block !important;\n    }\n  }\n}\n\n.follow-btn:disabled {\n  opacity: 0.8;\n  cursor: not-allowed;\n}\n\n.btn-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 6px;\n  animation: follow-spin 0.7s linear infinite;\n  vertical-align: middle;\n}\n\n@keyframes follow-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.carousel {\n  width: 300px;\n  height: 200px;\n  background-color: #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  user-select: none;\n}\n\n.slide {\n  padding: 20px;\n  font-weight: bold;\n}\n\n.step-header {\n  display: flex;\n  align-items: center; /* Vertically center all elements */\n  gap: 8px; /* Space between elements */\n  width: 100%;\n  .s-num {\n    margin-bottom: 0px !important;\n  }\n  .share-icon {\n    align-items: center !important;\n  }\n}\n\n.s-num {\n  font-size: 16px; /* Adjust size as needed */\n  font-weight: bold; /* Optional: make step number stand out */\n  padding: 4px 8px; /* Optional: padding for better appearance */\n}\n\n.share-icon {\n  font-size: 16px; /* Match font size for consistency */\n  cursor: pointer; /* Indicate clickability */\n  margin-left: auto; /* Push icon to the right */\n}\n\nmat-panel-title {\n  display: flex;\n  align-items: center; /* Vertically center elements */\n  justify-content: space-between; /* Push share icon to the right */\n  width: 100%; /* Ensure full width */\n  margin-top: 10px;\n}\n\n.step-info {\n  margin-top: 5px !important;\n  display: flex;\n  align-items: center;\n  align-items: flex-start; /* Align content to the left */\n  gap: 8px; /* Space between step number and title */\n  // flex-direction: column; /* Stack children vertically */\n}\n\n.step-number {\n  display: flex;\n  font-size: 16px; /* Adjust as needed */\n  font-weight: bold; /* Optional: emphasize step number */\n}\n\n.step-title {\n  font-size: 16px; /* Match your h3 or desired size */\n  flex-grow: 1; /* Allow title to take available space */\n  white-space: normal; /* Allow title to wrap to the next line */\n  display: block; /* Ensure it takes the full width and moves to the next line */\n}\n\n.share-icon {\n  font-size: 16px; /* Match text size */\n  cursor: pointer; /* Indicate clickability */\n  vertical-align: middle; /* Align with text */\n}\n\n.copy-link-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  gap: 2px;\n\n  .copy-link-text {\n    font-size: 9px;\n    line-height: 1.2;\n    white-space: nowrap;\n  }\n\n  // Desktop: slightly larger font\n  @media (min-width: 769px) {\n    .copy-link-text {\n      font-size: 10px;\n    }\n  }\n}\n\n/* Default (light theme) tick colors */\n.view-flow .current-step-tick {\n  color: #ffffff !important;\n}\n\n.view-flow .visited-step-tick {\n  color: #5ea1d8 !important;\n}\n\n.view-flow .step-bookmark-icon,\n.view-flow .flow-info-panel .info-badge-bookmark-btn mat-icon.bookmarked {\n  color: #5ea1d8 !important;\n}\n\n.view-flow .flow-info-panel .info-badge.active .info-badge-bookmark-btn mat-icon.bookmarked {\n  color: #ffffff !important;\n}\n\nmat-expansion-panel-header {\n  min-height: 48px; /* Default height, but allows growing */\n  height: auto; /* Allow dynamic height based on content */\n  align-items: flex-start; /* Align content to the top for better wrapping */\n  padding: 0 16px; /* Adjust padding if needed (default Material padding) */\n}\n\n/* Override mat-expansion-panel-header for both collapsed and expanded states */\n:host ::ng-deep mat-expansion-panel-header {\n  min-height: 48px; /* Default height, but allows growing */\n  height: auto; /* Dynamic height based on content */\n  align-items: flex-start; /* Align content to the top */\n  padding: 0 16px; /* Default Material padding, adjust if needed */\n}\n\n/* Ensure expanded state also respects dynamic height */\n:host ::ng-deep .mat-expansion-panel-header.mat-expanded {\n  min-height: 48px; /* Allow growing in expanded state */\n  height: auto; /* Dynamic height */\n  align-items: flex-start; /* Align content to the top */\n}\n\n// Tagged Items Section Styles\n.tagged-items-section {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n\n  ::ng-deep {\n    .mat-mdc-chip-set {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n    }\n\n    .mat-mdc-chip {\n      cursor: pointer;\n      transition: all 0.2s ease;\n      background-color: #e3f2fd !important;\n      color: #1d67a3 !important;\n      position: relative;\n      padding-right: 8px !important;\n\n      &:hover {\n        background-color: #bbdefb !important;\n        transform: scale(1.05);\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      }\n\n      .edit-chip-button {\n        opacity: 0.7;\n        transition: opacity 0.2s ease;\n        color: #1d67a3 !important;\n        padding: 0 !important;\n        margin-left: 4px !important;\n\n        &:hover {\n          opacity: 1;\n          background-color: rgba(29, 103, 163, 0.1) !important;\n        }\n\n        mat-icon {\n          color: #1d67a3 !important;\n        }\n      }\n    }\n  }\n}\n\n/* Version preview: show \"not available\" message in header/body */\n.preview-unavailable {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #b71c1c;\n  font-weight: 600;\n}\n\n.preview-unavailable-body {\n  padding: 16px;\n  border: 1px solid rgba(183, 28, 28, 0.2);\n  background: rgba(183, 28, 28, 0.05);\n  border-radius: 10px;\n  margin-bottom: 16px;\n}\n\n/* Force dark mode for View Flow page internals */\n:host-context(body.theme-dark) {\n  .view-flow,\n  .view-flow .container1,\n  .view-flow .flow-layout-container,\n  .view-flow .flow-main-grid,\n  .view-flow .flow-main-content,\n  .view-flow .video-player-section,\n  .view-flow .video-metadata,\n  .view-flow .channel-info-section,\n  .view-flow .description-section,\n  .view-flow .supporting-docs-section,\n  .view-flow .featured-in-blogs-section,\n  .view-flow .comments-section,\n  .view-flow .flow-sidebar,\n  .view-flow .recommendations-section,\n  .view-flow .step-navigation,\n  .view-flow .step-scroll,\n  .view-flow .steps-list,\n  .view-flow .flow-info-panel,\n  .view-flow .completion-progress-card-desktop,\n  .view-flow .completion-progress-card-mobile {\n    background: #0a0c10 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .view-flow .flow-title-sticky,\n  .view-flow .flow-info-panel,\n  .view-flow .step-panel-body,\n  .view-flow .recommendation-item,\n  .view-flow .comment-item,\n  .view-flow .comment-input,\n  .view-flow .reply-input {\n    background: #111827 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .view-flow .step-btn {\n    background: #111827 !important;\n    color: #ffffff !important;\n  }\n\n  .view-flow .step-btn.active,\n  .view-flow .step-panel.active .step-btn {\n    background: #5ea1d8 !important;\n    color: #ffffff !important;\n  }\n\n  .view-flow h1,\n  .view-flow h2,\n  .view-flow h3,\n  .view-flow h4,\n  .view-flow h5,\n  .view-flow p,\n  .view-flow span,\n  .view-flow label,\n  .view-flow a,\n  .view-flow .channel-name,\n  .view-flow .channel-meta,\n  .view-flow .recommendation-title,\n  .view-flow .recommendation-meta,\n  .view-flow .comment-text,\n  .view-flow .comment-author-name,\n  .view-flow .comment-date {\n    color: #ffffff !important;\n  }\n\n  .view-flow .collab-sep { color: #6b7280 !important; }\n  .view-flow .collab-coname { color: #9ca3af !important; &:hover { text-decoration: underline; } }\n  .view-flow .collab-extra-count-text { color: #6b7280 !important; &:hover { text-decoration: underline; } }\n  .view-flow .rec-owner-name { &:hover { text-decoration: underline; } }\n\n  .view-flow .comment-input::placeholder,\n  .view-flow .reply-input::placeholder {\n    color: #cbd5e1 !important;\n  }\n\n  .view-flow .comment-guidelines-helper {\n    color: #fca5a5 !important;\n  }\n\n  .view-flow .comment-guidelines-link {\n    color: #93c5fd !important;\n\n    &:hover {\n      color: #60a5fa !important;\n    }\n  }\n\n  .view-flow .autoplay-toggle .toggle-track {\n    background: #334155 !important;\n\n    &.active {\n      background: #e83e8c !important;\n    }\n  }\n\n  // Thumb: keep it light so it stands out against the dark track\n  .view-flow .autoplay-toggle .toggle-thumb {\n    background: #f3f4f6 !important;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5) !important;\n  }\n\n  // Icon inside thumb: dark blue so it's visible on the light thumb\n  .view-flow .autoplay-toggle .toggle-thumb .thumb-icon,\n  .view-flow .autoplay-toggle .thumb-icon {\n    color: #1e3a5f !important;\n  }\n\n  /* Requested: keep text black in light/blue boxes on dark mode */\n  .view-flow .flow-info-panel .info-badge,\n  .view-flow .flow-info-panel .info-badge .info-label,\n  .view-flow .flow-info-panel .info-badge .info-step-title {\n    color: #ffffff !important;\n  }\n\n  .view-flow .flow-info-panel .info-badge {\n    background: #111827 !important;\n  }\n\n  .view-flow .flow-info-panel .info-badge.active {\n    background: #1b2437 !important;\n    color: #ffffff !important;\n  }\n\n  .view-flow .flow-info-panel .info-badge-bookmark-btn {\n    color: #9ca3af !important;\n  }\n\n  .view-flow .flow-info-panel .info-badge-bookmark-btn mat-icon.bookmarked,\n  .view-flow .flow-info-panel .info-badge.active .info-badge-bookmark-btn mat-icon.bookmarked {\n    color: #5ea1d8 !important;\n  }\n\n  .view-flow .flow-info-panel .info-badge-bookmark-btn:hover {\n    background: rgba(94, 161, 216, 0.18) !important;\n    color: #5ea1d8 !important;\n  }\n\n  .view-flow .step-navigation .step-btn,\n  .view-flow .step-navigation .step-btn .step-title-text,\n  .view-flow .step-navigation .step-btn .step-number,\n  .view-flow .step-navigation .step-btn mat-icon {\n    color: #ffffff !important;\n  }\n\n  .view-flow .step-navigation .step-btn {\n    background: #111827 !important;\n  }\n\n  .view-flow .step-navigation .step-btn.active,\n  .view-flow .step-navigation .step-panel.active .step-btn {\n    background: #1b2437 !important;\n    color: #ffffff !important;\n  }\n\n  /* Tick icon colors are controlled inline in template per state:\n     current = pink, visited = white */\n\n  .view-flow .video-actions-bar .action-item,\n  .view-flow .video-actions-bar .action-item > span,\n  .view-flow .video-actions-bar .action-item > mat-icon {\n    color: #ffffff !important;\n  }\n\n  .view-flow .flow-unique-code-value {\n    color: #5ea1d8 !important;\n  }\n\n  .view-flow .video-actions-bar .action-item.delete-action,\n  .view-flow .video-actions-bar .action-item.delete-action span,\n  .view-flow .video-actions-bar .action-item.delete-action mat-icon {\n    color: #d32f2f !important;\n  }\n\n  .view-flow .video-actions-bar .action-item .favorite-toggle-icon.liked,\n  .view-flow .video-actions-bar .action-item.liked .favorite-toggle-icon,\n  .view-flow .video-actions-bar .action-item .favorite-toggle-icon.liked mat-icon {\n    color: #ff4d4d !important;\n  }\n\n  .view-flow .video-actions-bar .action-item {\n    background: #111827 !important;\n    border: 1px solid rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .view-flow .video-actions-bar .action-item:hover {\n    background: #1b2437 !important;\n  }\n\n  /* Dark mode tick colors by panel context */\n  .view-flow .step-navigation .current-step-tick {\n    color: #e83e8c !important;\n  }\n\n  .view-flow .step-navigation .visited-step-tick {\n    color: #ffffff !important;\n  }\n\n  /* Keep flow-info-panel ticks in light-mode colors on all viewports in dark mode. */\n  .view-flow .flow-info-panel .current-step-tick {\n    color: #ffffff !important;\n  }\n\n  .view-flow .flow-info-panel .visited-step-tick {\n    color: #5ea1d8 !important;\n  }\n\n  .view-flow .flow-info-panel .current-step-tick,\n  .view-flow .flow-info-panel .visited-step-tick {\n    opacity: 1 !important;\n    filter: none !important;\n  }\n\n  /* Right step-list scrollbar styling in dark mode */\n  .view-flow .step-navigation .step-scroll {\n    scrollbar-width: thin;\n    scrollbar-color: #5ea1d8 #1f2937;\n  }\n\n  .view-flow .step-navigation .step-scroll::-webkit-scrollbar {\n    width: 10px;\n  }\n\n  .view-flow .step-navigation .step-scroll::-webkit-scrollbar-track {\n    background: #1f2937;\n    border-radius: 10px;\n  }\n\n  .view-flow .step-navigation .step-scroll::-webkit-scrollbar-thumb {\n    background: linear-gradient(180deg, #5ea1d8 0%, #e83e8c 100%);\n    border-radius: 10px;\n    border: 2px solid #1f2937;\n  }\n\n  .view-flow .step-navigation .step-scroll::-webkit-scrollbar-thumb:hover {\n    background: linear-gradient(180deg, #4a8fc4 0%, #cf2f79 100%);\n  }\n\n  /* Match dark-mode action-panel scrollbar style used on view-bundle */\n  .view-flow .video-actions-bar::-webkit-scrollbar-thumb,\n  .view-flow .comment-actions::-webkit-scrollbar-thumb {\n    background: rgba(148, 163, 184, 0.55) !important;\n  }\n\n  .view-flow .video-actions-bar::-webkit-scrollbar-thumb:hover {\n    background: rgba(148, 163, 184, 0.75) !important;\n  }\n\n  /*\n   * Items required (#itemsRequired / selectedStepIndex -1): parent\n   * .video-player-section forces color: #fff; .example-list stays white so\n   * group headers (h6) inherit white-on-white. Rows also fight global .view-flow span { color: #fff }.\n   */\n  .view-flow .video-player-section .item,\n  .view-flow .video-player-section .item > div,\n  .view-flow .video-player-section .item-table,\n  .view-flow .video-player-section .example-list {\n    background: #1f2937 !important;\n    color: #e5e7eb !important;\n  }\n\n  .view-flow .video-player-section .example-list h6,\n  .view-flow .video-player-section .example-list .group-header,\n  .view-flow .video-player-section .example-list .group-header b {\n    color: #f1f5f9 !important;\n  }\n\n  .view-flow .video-player-section .example-list .group-header mat-icon {\n    color: #cbd5e1 !important;\n  }\n\n  .view-flow .video-player-section .example-list .example-box,\n  .view-flow .video-player-section .example-box {\n    background: #1f2937 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.28) !important;\n    color: #e5e7eb !important;\n  }\n\n  .view-flow .video-player-section .example-list .example-box > *,\n  .view-flow .video-player-section .example-box > * {\n    color: #e5e7eb !important;\n  }\n\n  .view-flow .video-player-section .example-list .example-box span,\n  .view-flow .video-player-section .example-box span,\n  .view-flow .video-player-section .example-list .example-box .item-value,\n  .view-flow .video-player-section .example-box .item-value {\n    color: #e5e7eb !important;\n  }\n\n  .view-flow .video-player-section .example-list .example-box a,\n  .view-flow .video-player-section .example-box a {\n    color: #93c5fd !important;\n  }\n\n  .view-flow .video-player-section .example-list .example-box.itemremove span,\n  .view-flow .video-player-section .example-box.itemremove span {\n    color: #94a3b8 !important;\n  }\n\n  .view-flow .video-player-section .item-table hr {\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  /* Mobile: base `.view-flow` block forces white page bg on ≤767px.\n     Re-apply dark surfaces so mobile dark mode matches desktop dark mode. */\n  @media (max-width: 767px) {\n    .view-flow {\n      background: #0a0c10 !important;\n    }\n\n    .view-flow .container1,\n    .view-flow .flow-layout-container,\n    .view-flow .flow-main-grid,\n    .view-flow .flow-main-content {\n      background: transparent !important;\n    }\n\n    .view-flow .flow-layout-container .flow-main-content .video-metadata,\n    .view-flow .flow-layout-container .flow-main-content .channel-info-section,\n    .view-flow .flow-layout-container .flow-main-content .description-section,\n    .view-flow .flow-layout-container .flow-main-content .supporting-docs-section,\n    .view-flow .flow-layout-container .flow-main-content .featured-in-blogs-section,\n    .view-flow .flow-layout-container .flow-main-content .flow-info-panel,\n    .view-flow .flow-layout-container .flow-main-content .comments-section {\n      background: #111827 !important;\n    }\n\n    .view-flow .flow-title-sticky {\n      background: #111827 !important;\n    }\n\n    .view-flow .video-player-section,\n    .view-flow .video-player-section .img-wrap {\n      background: #020617 !important;\n    }\n\n    .view-flow .video-actions-bar .action-item {\n      background: #111827 !important;\n      border: 1px solid rgba(148, 163, 184, 0.28) !important;\n    }\n\n    .view-flow .video-actions-bar .action-item > span,\n    .view-flow .video-actions-bar .action-item > mat-icon {\n      color: #ffffff !important;\n    }\n\n    .view-flow .video-actions-bar .action-item.delete-action,\n    .view-flow .video-actions-bar .action-item.delete-action span,\n    .view-flow .video-actions-bar .action-item.delete-action mat-icon {\n      color: #d32f2f !important;\n    }\n\n    .view-flow .recommendations-section-mobile {\n      background: transparent !important;\n    }\n\n    .view-flow .recommendations-section-mobile .recommendation-item {\n      background: #111827 !important;\n      border: 1px solid rgba(148, 163, 184, 0.24) !important;\n      color: #ffffff !important;\n    }\n\n    .view-flow h1,\n    .view-flow h2,\n    .view-flow h3,\n    .view-flow h4,\n    .view-flow h5,\n    .view-flow h6,\n    .view-flow p,\n    .view-flow span,\n    .view-flow label {\n      color: #ffffff !important;\n    }\n\n  }\n}\n\n/* View Flow - section-wise dark mode patch */\n:host-context(body.theme-dark) {\n  .view-flow {\n    background: #0a0c10 !important;\n    color: #ffffff !important;\n  }\n\n  /* Remove unnecessary wrappers backgrounds */\n  .view-flow .container1,\n  .view-flow .flow-layout-container,\n  .view-flow .flow-main-grid,\n  .view-flow .flow-main-content {\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  /* Section-wise cards */\n  .view-flow .flow-title-sticky,\n  .view-flow .flow-info-panel,\n  .view-flow .video-metadata,\n  .view-flow .channel-info-section,\n  .view-flow .description-section,\n  .view-flow .supporting-docs-section,\n  .view-flow .featured-in-blogs-section,\n  .view-flow .comments-section,\n  .view-flow .flow-sidebar,\n  .view-flow .step-navigation,\n  .view-flow .recommendations-section,\n  .view-flow .recommendation-item,\n  .view-flow .comment-item,\n  .view-flow .comment-input,\n  .view-flow .reply-input,\n  .view-flow .step-panel-body {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  /* No bundle state: don't paint a block behind \"Part of bundle(s)\" area */\n  .view-flow .flow-sidebar,\n  .view-flow .recommendations-section:not(.featured-in-blogs-section),\n  .view-flow .recommendations-section-mobile {\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  .view-flow .featured-in-blogs-section {\n    background: #111827 !important;\n  }\n\n  .view-flow .featured-in-blogs-section h2,\n  .view-flow .featured-in-blogs-section .recommendation-title {\n    color: #f8fafc !important;\n  }\n\n  .view-flow .featured-in-blogs-section .recommendation-meta,\n  .view-flow .featured-in-blogs-section .recommendation-creator {\n    color: #94a3b8 !important;\n  }\n\n  .view-flow .featured-in-blogs-section .recommendation-item:hover {\n    background: #1f2937 !important;\n  }\n\n  /* Keep media panel dark but distinct */\n  .view-flow .video-player-section,\n  .view-flow .video-player-section .img-wrap {\n    background: #020617 !important;\n  }\n\n  /* Section headings and text visibility */\n  .view-flow h1,\n  .view-flow h2,\n  .view-flow h3,\n  .view-flow h4,\n  .view-flow h5,\n  .view-flow h6,\n  .view-flow p,\n  .view-flow span,\n  .view-flow label,\n  .view-flow .channel-name,\n  .view-flow .channel-meta,\n  .view-flow .video-title,\n  .view-flow .video-title-sticky,\n  .view-flow .recommendation-title,\n  .view-flow .recommendation-meta,\n  .view-flow .step-title-text,\n  .view-flow .step-description,\n  .view-flow .comment-text,\n  .view-flow .comment-author-name,\n  .view-flow .comment-date {\n    color: #ffffff !important;\n  }\n\n  /* Safety step icon — override the generic span white rule above.\n     Extra selectors raise specificity above .view-flow span !important */\n  .view-flow .video-metadata .step-header-main span.safety-step-icon {\n    color: #ef9a9a !important;\n  }\n\n  /* Access badges — keep kind colors (text + icon) in dark mode */\n  .view-flow .flow-access-badge.kind-public,\n  .view-flow .flow-access-badge.kind-public mat-icon {\n    color: #ccfbf1 !important;\n  }\n  .view-flow .flow-access-badge.kind-public {\n    background: #0f766e !important;\n  }\n\n  .view-flow .flow-access-badge.kind-private,\n  .view-flow .flow-access-badge.kind-private mat-icon {\n    color: #ffedd5 !important;\n  }\n  .view-flow .flow-access-badge.kind-private {\n    background: #9a3412 !important;\n  }\n\n  .view-flow .flow-access-badge.kind-private-link,\n  .view-flow .flow-access-badge.kind-private-link mat-icon {\n    color: #dbeafe !important;\n  }\n  .view-flow .flow-access-badge.kind-private-link {\n    background: #1d4ed8 !important;\n  }\n\n  .view-flow .flow-access-badge.kind-restricted,\n  .view-flow .flow-access-badge.kind-restricted mat-icon {\n    color: #ede9fe !important;\n  }\n  .view-flow .flow-access-badge.kind-restricted {\n    background: #6d28d9 !important;\n  }\n\n  .view-flow .flow-access-badge em {\n    color: inherit !important;\n    background: rgba(15, 23, 42, 0.45) !important;\n  }\n\n  /* Description content: explicit color needed because the div has its own\n     color: #0f0f0f rule that isn't inherited from the parent's dark override */\n  .view-flow .description-section .description-content,\n  .view-flow .description-section .description-content * {\n    color: #e2e8f0 !important;\n  }\n\n  /* Preserve link colours inside description in dark mode */\n  .view-flow .description-section .description-content a {\n    color: #93c5fd !important;\n  }\n\n  /* Description header h3 and duration timer */\n  .view-flow .description-section .description-header h3,\n  .view-flow .description-section .description-header .duration-timer {\n    color: #e2e8f0 !important;\n  }\n\n  /* Supporting docs section — header and link */\n  .view-flow .supporting-docs-section .supporting-docs-header h3,\n  .view-flow .supporting-docs-section .supporting-docs-header h3 .supporting-docs-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .view-flow .supporting-docs-section .supportingdoc,\n  .view-flow .supporting-docs-section .supportingdoc mat-icon {\n    color: #93c5fd !important;\n  }\n\n  /* Version tag: light grey bg becomes invisible against dark sections; use dark blue chip. */\n  .view-flow .version-tag {\n    background: #1e3a5f !important;\n    color: #93c5fd !important;\n  }\n\n  .view-flow .version-tag mat-icon {\n    color: #93c5fd !important;\n  }\n\n  .view-flow .version-tag:hover {\n    background: #243f6a !important;\n  }\n\n  /* Purchased tag: same issue — light grey bg needs a dark surface override. */\n  .view-flow .purchased-tag {\n    color: #cbd5e1 !important;\n    background: #1f2937 !important;\n  }\n\n  /* Copy-link icon (step / items link) — override grey with white in dark mode */\n  .view-flow .copy-link-container .share-icon,\n  .view-flow .copy-link-container .share-icon svg,\n  .view-flow .copy-link-container .share-icon svg path {\n    color: #ffffff !important;\n    fill: currentColor !important;\n  }\n\n  .view-flow .copy-link-container .copy-link-text {\n    color: #ffffff !important;\n  }\n\n  /* Version preview dialog header — dark mode */\n  .view-flow .preview-dialog-header,\n  .preview-dialog-header {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .view-flow .preview-dialog-header h2,\n  .preview-dialog-header h2 {\n    color: #f1f5f9 !important;\n  }\n\n  .view-flow .preview-dialog-header .version-badge,\n  .preview-dialog-header .version-badge {\n    background-color: #1e3a5f !important;\n    color: #93c5fd !important;\n\n    mat-icon {\n      color: #93c5fd !important;\n    }\n  }\n\n  .view-flow .preview-dialog-header .preview-unique-code,\n  .preview-dialog-header .preview-unique-code {\n    color: #94a3b8 !important;\n  }\n\n  .view-flow .preview-dialog-header .preview-unique-code-label,\n  .view-flow .preview-dialog-header .preview-unique-code-value,\n  .preview-dialog-header .preview-unique-code-label,\n  .preview-dialog-header .preview-unique-code-value {\n    color: #e2e8f0 !important;\n  }\n\n  .view-flow .preview-dialog-header .close-button,\n  .view-flow .preview-dialog-header .close-button mat-icon,\n  .preview-dialog-header .close-button,\n  .preview-dialog-header .close-button mat-icon {\n    color: #94a3b8 !important;\n  }\n\n  .view-flow .preview-dialog-header .close-button:hover,\n  .preview-dialog-header .close-button:hover {\n    color: #e2e8f0 !important;\n    background: rgba(148, 163, 184, 0.12) !important;\n  }\n\n  .view-flow .preview-unavailable,\n  .preview-unavailable {\n    color: #f87171 !important;\n  }\n\n  /* ── Progress bar — dark mode ─────────────────────────────────────────────\n     The track uses both CSS classes and [ngStyle] inline bindings.\n     !important beats inline styles, so these overrides cover both paths.\n     ─────────────────────────────────────────────────────────────────────── */\n\n  /* Card wrappers */\n  .view-flow .completion-progress-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n    box-shadow: none !important;\n  }\n\n  /* Progress track (the grey rail) */\n  .view-flow .completion-progress-bar-desktop,\n  .view-flow .completion-progress-bar-mobile,\n  .view-flow .completion-progress-bar {\n    background-color: #1f2937 !important;\n    background: #1f2937 !important;\n  }\n\n  /* Restarted-after-completion — soft blue track becomes a dark blue tint */\n  .view-flow .completion-progress-card-desktop.restarted .completion-progress-bar-desktop,\n  .view-flow .completion-progress-card-mobile.restarted .completion-progress-bar-mobile {\n    background-color: #1e3a5f !important;\n    background: #1e3a5f !important;\n  }\n\n  /* Fill bar — keep the blue gradient, it reads well on dark */\n  .view-flow .completion-progress-fill-desktop,\n  .view-flow .completion-progress-fill-mobile,\n  .view-flow .completion-progress-fill {\n    background: linear-gradient(90deg, #5ea1d8 0%, #6bb3e8 100%) !important;\n  }\n\n  /* Percentage text inside the fill */\n  .view-flow .progress-bar-percentage-desktop,\n  .view-flow .progress-bar-percentage-mobile,\n  .view-flow .progress-bar-percentage {\n    color: #ffffff !important;\n  }\n\n  /* \"0%\" label shown when fill is empty */\n  .view-flow .progress-bar-percentage-empty-desktop,\n  .view-flow .progress-bar-percentage-empty-mobile,\n  .view-flow .progress-bar-percentage-empty {\n    color: #94a3b8 !important;\n  }\n\n  /* \"Step X of Y\" text below the bar */\n  .view-flow .progress-step-info-desktop,\n  .view-flow .progress-step-info-mobile {\n    color: #94a3b8 !important;\n  }\n\n  /* Completion code badge (pill) */\n  .view-flow .completion-code-badge {\n    background-color: #1e3a5f !important;\n    color: #93c5fd !important;\n  }\n\n  /* Sidebar-card variant header + stats */\n  .view-flow .completion-progress-header,\n  .view-flow .completion-progress-title {\n    color: #e5e7eb !important;\n  }\n\n  .view-flow .completion-percentage {\n    color: #4ade80 !important;\n  }\n\n  .view-flow .completion-stats {\n    color: #94a3b8 !important;\n  }\n\n  /* Step navigation sidebar — step title text is explicitly #606060 in light\n     mode; override it here so it is readable on the dark #111827 button. */\n  .view-flow .step-navigation .step-btn .info-step-title,\n  .view-flow .step-navigation .step-btn .info-label {\n    color: #e2e8f0 !important;\n  }\n\n  /* Safety instructions block — keep the red/amber theme in dark mode,\n     matching the light-mode appearance (red border, icon, title + warm text). */\n  .view-flow .step-panel-body .safety-instructions-description,\n  .view-flow .step-panel-body .safety-instructions-description *,\n  .view-flow .flow-main-content .safety-instructions-description,\n  .view-flow .flow-main-content .safety-instructions-description * {\n    color: #ef9a9a !important;\n  }\n\n  /* Inline amber colour used on the main-view safety description (#856404\n     would be unreadable on a dark background). */\n  .view-flow .flow-main-content [style*=\"color: #856404\"],\n  .view-flow .flow-main-content [style*=\"color:#856404\"] {\n    color: #ef9a9a !important;\n  }\n\n  /* Generic dark-text overrides for non-safety elements in the step panel. */\n  .view-flow .step-panel-body [style*=\"color: #333\"],\n  .view-flow .step-panel-body [style*=\"color:#333\"]:not(.safety-instructions-description) {\n    color: #e2e8f0 !important;\n  }\n\n  /* Tagged items chips shown inside the step panel body — Material chip\n     defaults keep a light grey background, making white text invisible. */\n  .view-flow mat-chip-option,\n  .view-flow .mat-mdc-chip.mat-mdc-chip-option {\n    --mdc-chip-elevated-container-color: #1f2937 !important;\n    background-color: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .view-flow mat-chip-option span,\n  .view-flow .mat-mdc-chip.mat-mdc-chip-option span,\n  .view-flow .mat-mdc-chip.mat-mdc-chip-option .mat-mdc-chip-action-label,\n  .view-flow .mat-mdc-chip.mat-mdc-chip-option mat-icon {\n    color: #e2e8f0 !important;\n  }\n\n  /* Mobile step description div (color: #4a5568) is not a span/p so it\n     doesn't get covered by the generic span/p white rule. */\n  .view-flow .mobile-step-description,\n  .view-flow .mobile-step-description * {\n    color: #e2e8f0 !important;\n  }\n\n  /* step-description inner content — [innerHTML] content may carry inline\n     dark colours; override everything inside. */\n  .view-flow .step-panel-body .step-description,\n  .view-flow .step-panel-body .step-description * {\n    color: #e2e8f0 !important;\n  }\n\n  /* Follow button — dark mode: keep non-following state as-is (blue), update\n     following state so light-grey bg doesn't appear washed out on dark surface. */\n  .view-flow .channel-actions .follow-btn:not(.following) {\n    background: #5ea1d8 !important;\n    color: #ffffff !important;\n    border: none !important;\n  }\n\n  .view-flow .channel-actions .follow-btn.following {\n    background: #1e3a5f !important;\n    color: #93c5fd !important;\n    border-color: #5ea1d8 !important;\n  }\n\n  /* ── Rating & Reviews section dark mode ─────────────────────────────────── */\n\n  /* Rating summary card: white background → dark surface */\n  .view-flow .rating-summary-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4) !important;\n  }\n\n  .view-flow .rating-summary-card .rating-number {\n    color: #f1f5f9 !important;\n  }\n\n  .view-flow .rating-summary-card .rating-count-text {\n    color: #94a3b8 !important;\n  }\n\n  .view-flow .rating-summary-card .rating-label,\n  .view-flow .rating-summary-card .rating-percent {\n    color: #94a3b8 !important;\n  }\n\n  .view-flow .rating-summary-card .rating-bar-bg {\n    background: #1f2937 !important;\n  }\n\n  /* Keep golden filled stars in dark mode (overrides .view-flow span { color: #fff }) */\n  .view-flow .rating-star-icon.filled-star,\n  .view-flow .rating-star-icon.partial-star,\n  .view-flow .review-star-icon.filled-star {\n    color: #ffc107 !important;\n  }\n\n  /* Empty/base stars: visible mid-grey instead of white */\n  .view-flow .rating-star-icon:not(.filled-star):not(.partial-star),\n  .view-flow .rating-star-icon.star-empty-overlay,\n  .view-flow .review-star-icon:not(.filled-star) {\n    color: #4b5563 !important;\n  }\n\n  /* \"All ratings\" info button — keep golden */\n  .view-flow .ratings-info-btn {\n    color: #ffc107 !important;\n  }\n\n  /* Review cards */\n  .view-flow .review-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .view-flow .review-card .reviewer-name {\n    color: #f1f5f9 !important;\n  }\n\n  .view-flow .review-card .review-date,\n  .view-flow .review-card .verified-badge {\n    color: #94a3b8 !important;\n  }\n\n  .view-flow .review-card .review-card-title {\n    color: #f1f5f9 !important;\n  }\n\n  .view-flow .review-card .review-card-body {\n    color: #cbd5e1 !important;\n  }\n\n  /* Mobile: also restore golden stars in the media-query override block */\n  @media (max-width: 767px) {\n    .view-flow .rating-star-icon.filled-star,\n    .view-flow .rating-star-icon.partial-star,\n    .view-flow .review-star-icon.filled-star {\n      color: #ffc107 !important;\n    }\n\n    .view-flow .rating-star-icon:not(.filled-star):not(.partial-star),\n    .view-flow .rating-star-icon.star-empty-overlay,\n    .view-flow .review-star-icon:not(.filled-star) {\n      color: #4b5563 !important;\n    }\n  }\n}\n\n/* ── Skeleton loader: dark-mode overrides ─────────────────────────────────── */\n:host-context(body.theme-dark) {\n  .skeleton-viewflow-container {\n    --skeleton-gradient: linear-gradient(\n      110deg,\n      #334155 8%,\n      #64748b 18%,\n      #334155 33%\n    );\n    background: #0a0c10 !important;\n\n    /* Card panels */\n    .skeleton-card {\n      background: #1e293b !important;\n      box-shadow: none !important;\n      border: 1px solid rgba(148, 163, 184, 0.15) !important;\n    }\n\n    /* Flow header bar */\n    .skeleton-flow-header {\n      background: #1e293b !important;\n      border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n\n      /* Info panel strip */\n      &.skeleton-info-panel {\n        background: #243040 !important;\n      }\n\n      /* Individual badge pills */\n      .info-badge {\n        background: #334155 !important;\n        border-color: rgba(148, 163, 184, 0.25) !important;\n        color: #cbd5e1 !important;\n      }\n\n      /* Toggle thumb – keep it visible against the dark track */\n      .autoplay-toggle .toggle-track {\n        background: #334155 !important;\n\n        .toggle-thumb {\n          background: #64748b !important;\n          box-shadow: none !important;\n        }\n      }\n    }\n\n    /* Right sidebar: step navigation buttons */\n    .step-navigation .step-btn,\n    .step-navigation .step-btn.skeleton-step-btn {\n      background: #334155 !important;\n      border-color: rgba(148, 163, 184, 0.2) !important;\n    }\n\n    /* Right sidebar: transparent containers */\n    .step-navigation,\n    .step-scroll,\n    .steps-list,\n    .recommendations-section,\n    .recommendation-item {\n      background: transparent !important;\n    }\n\n    /* All shimmer elements: high-contrast gradient so they are clearly visible */\n    .skeleton-text,\n    .skeleton-avatar,\n    .skeleton-icon,\n    .skeleton-image {\n      background-color: #334155 !important;\n    }\n\n    .skeleton-image::after {\n      background-color: #334155 !important;\n    }\n  }\n}\n\n// ─── Collaboration & Sponsored ────────────────────────────────────────────────\n\n.flow-title-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.sponsored-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n  margin-left: 8px;\n\n  .sponsored-icon {\n    font-size: 13px;\n    height: 13px;\n    width: 13px;\n    line-height: 13px;\n  }\n}\n\n.collab-author-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  font-size: 13px;\n  color: #555;\n\n  .collab-label {\n    color: #888;\n  }\n\n  .collab-avatar {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 1px solid #ddd;\n  }\n\n  .collab-username {\n    font-weight: 600;\n    color: #333;\n  }\n}\n\n// Dark mode overrides\n.dark-mode {\n  .collab-author-row {\n    color: #aaa;\n\n    .collab-label { color: #999; }\n    .collab-username { color: #e2e8f0; }\n  }\n}\n\n/* ── Collaborators centred popup ──────────────────────────────────────────── */\n\n.collab-popup-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 499;\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.collab-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 500;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22), 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px 16px 14px;\n  width: 300px;\n\n  .collab-popup-title {\n    font-size: 11px;\n    font-weight: 700;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #f3f4f6;\n    margin-bottom: 10px;\n    text-align: center;\n  }\n\n  .collab-popup-card {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 10px;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background 0.15s;\n\n    &:hover {\n      background: #f5f7fa;\n    }\n  }\n\n  .collab-popup-avatar-wrap {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n    border: 2px solid #e5e7eb;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f3f4f6;\n  }\n\n  .collab-popup-pic {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n  }\n\n  .collab-popup-uname {\n    font-size: 13px;\n    font-weight: 600;\n    color: #1a1a2e;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n  }\n}\n\n/* Collaborators popup — dark mode */\n:host-context(body.theme-dark) {\n  .collab-popup {\n    background: #1f2937;\n    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.6), 0 2px 10px rgba(0, 0, 0, 0.4);\n\n    .collab-popup-title {\n      color: #64748b;\n      border-bottom-color: rgba(148, 163, 184, 0.15);\n    }\n\n    .collab-popup-card:hover {\n      background: #374151;\n    }\n\n    .collab-popup-avatar-wrap {\n      border-color: #374151;\n      background: #111827;\n    }\n\n    .collab-popup-uname {\n      color: #e2e8f0;\n    }\n  }\n}\n\n.view-flow.embed-mode {\n  padding-top: 0;\n\n  .container1 {\n    max-width: 100%;\n    padding: 0 12px 12px;\n  }\n\n  &.embed-locked {\n    .flow-main-grid {\n      grid-template-columns: minmax(0, 1fr);\n    }\n  }\n}\n\n/* Standalone embed route: host the compact preview player and let it fill the iframe */\n.viewflow-embed-standalone {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  box-sizing: border-box;\n\n  app-embed-preview {\n    width: 100%;\n  }\n\n  ::ng-deep .embed-preview {\n    max-width: 100%;\n  }\n}\n\n::ng-deep .access-menu .access-menu-current {\n  margin-left: auto;\n  font-size: 11px;\n  font-weight: 600;\n  color: #1976d2;\n}\n\n.flow-access-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px 3px 6px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n  line-height: 1.2;\n\n  mat-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n  }\n\n  em {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 10px;\n    padding: 1px 6px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.65);\n  }\n\n  &.kind-public {\n    color: #0f766e !important;\n    background: #ccfbf1;\n  }\n\n  &.kind-private {\n    color: #9a3412 !important;\n    background: #ffedd5;\n  }\n\n  &.kind-private-link {\n    color: #1d4ed8 !important;\n    background: #dbeafe;\n  }\n\n  &.kind-restricted {\n    color: #6d28d9 !important;\n    background: #ede9fe;\n  }\n}\n\nbody.theme-dark .view-flow .flow-access-badge.kind-public,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge.kind-public,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-public,\nbody.theme-dark .view-flow .flow-access-badge.kind-public mat-icon,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge.kind-public mat-icon,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-public mat-icon {\n  color: #ccfbf1 !important;\n}\n\nbody.theme-dark .view-flow .flow-access-badge.kind-public,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge.kind-public,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-public {\n  background: #0f766e !important;\n}\n\nbody.theme-dark .view-flow .flow-access-badge.kind-private,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge.kind-private,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-private,\nbody.theme-dark .view-flow .flow-access-badge.kind-private mat-icon,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge.kind-private mat-icon,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-private mat-icon {\n  color: #ffedd5 !important;\n}\n\nbody.theme-dark .view-flow .flow-access-badge.kind-private,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge.kind-private,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-private {\n  background: #9a3412 !important;\n}\n\nbody.theme-dark .view-flow .flow-access-badge.kind-private-link,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge.kind-private-link,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-private-link,\nbody.theme-dark .view-flow .flow-access-badge.kind-private-link mat-icon,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge.kind-private-link mat-icon,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-private-link mat-icon {\n  color: #dbeafe !important;\n}\n\nbody.theme-dark .view-flow .flow-access-badge.kind-private-link,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge.kind-private-link,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-private-link {\n  background: #1d4ed8 !important;\n}\n\nbody.theme-dark .view-flow .flow-access-badge.kind-restricted,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge.kind-restricted,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-restricted,\nbody.theme-dark .view-flow .flow-access-badge.kind-restricted mat-icon,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge.kind-restricted mat-icon,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-restricted mat-icon {\n  color: #ede9fe !important;\n}\n\nbody.theme-dark .view-flow .flow-access-badge.kind-restricted,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge.kind-restricted,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge.kind-restricted {\n  background: #6d28d9 !important;\n}\n\nbody.theme-dark .view-flow .flow-access-badge em,\nbody.theme-dark .view-flow .channel-meta .flow-access-badge em,\nbody.theme-dark .view-flow .video-actions-bar .action-item .flow-access-badge em {\n  color: inherit !important;\n  background: rgba(15, 23, 42, 0.45) !important;\n}\n\nbody.theme-dark ::ng-deep .access-menu .access-menu-current {\n  color: #7ec8f0 !important;\n}\n\n.clickarrow button.guide-finish-btn,\n.view-flow .viewflow-step .clickarrow button.guide-finish-btn {\n  pointer-events: all;\n  margin-left: auto;\n  margin-right: 0;\n  width: auto;\n  height: 44px;\n  padding: 0 18px;\n  border: none;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #5ea1d8;\n  color: #fff;\n  font-family: \"Raleway\";\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n  transition: background 0.2s ease, transform 0.2s ease;\n\n  mat-icon {\n    flex: 0 0 auto;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n  }\n\n  &:hover {\n    background: #4a8fc4;\n    transform: translateY(-1px);\n  }\n}\n\n.view-flow .viewflow-step .clickarrow button.guide-finish-btn {\n  height: 48px;\n  line-height: 1;\n\n  @media (max-width: 992px) {\n    height: 42px;\n  }\n}\n\n.view-flow .step-header-main .step-questions-chip {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  margin-left: 4px;\n  border: 1px solid #5ea1d8;\n  border-radius: 999px;\n  background: rgba(94, 161, 216, 0.1);\n  color: #1d67a3;\n  font-family: \"Raleway\", sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  mat-icon {\n    flex: 0 0 auto;\n    width: 16px;\n    height: 16px;\n    font-size: 16px;\n    line-height: 16px;\n  }\n\n  &:hover {\n    background: rgba(94, 161, 216, 0.18);\n  }\n\n  &:focus-visible {\n    outline: 2px solid #5ea1d8;\n    outline-offset: 2px;\n  }\n}\n\n:host-context(body.theme-dark) .view-flow .step-header-main .step-questions-chip {\n  background: rgba(94, 161, 216, 0.15);\n  color: #93c5fd;\n}\n\n/* Follow, Purchase and Task mode share one size so the stacked column lines up. */\n.view-flow .channel-actions {\n  > button.follow-btn,\n  > button.purchase-btn {\n    box-sizing: border-box;\n    min-width: 140px;\n    height: 38px;\n    padding: 0 16px;\n    border-radius: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    font-family: \"Raleway\", sans-serif;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1;\n    white-space: nowrap;\n  }\n\n  > button.purchase-btn {\n    width: auto;\n  }\n\n  mat-icon {\n    flex: 0 0 auto;\n    width: 18px;\n    height: 18px;\n    font-size: 18px;\n    line-height: 18px;\n  }\n\n  .btn-spinner {\n    margin-right: 0;\n  }\n\n  > button.follow-btn.task-mode-btn:not(.following) {\n    background: transparent !important;\n    color: #1d67a3 !important;\n    border: 1px solid #5ea1d8 !important;\n\n    &:hover {\n      background: rgba(94, 161, 216, 0.1) !important;\n    }\n  }\n\n  @media (max-width: 768px) {\n    > button.follow-btn,\n    > button.purchase-btn {\n      min-width: 120px;\n      height: 36px;\n      font-size: 13px;\n    }\n  }\n}\n\n:host-context(body.theme-dark) .view-flow .channel-actions > button.follow-btn.task-mode-btn:not(.following) {\n  background: transparent !important;\n  color: #93c5fd !important;\n  border: 1px solid #5ea1d8 !important;\n\n  &:hover {\n    background: rgba(94, 161, 216, 0.15) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
